if (function(a, b) {
    "function" == typeof define && define.amd ? define(b) : "object" == typeof exports ? module.exports = b(require, exports, module) : a.Tether = b();
}(this, function(a, b, c) {
    "use strict";
    function d(a, b) {
        if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
    }
    function e(a) {
        var b = a.getBoundingClientRect(), c = {};
        for (var d in b) c[d] = b[d];
        if (a.ownerDocument !== document) {
            var f = a.ownerDocument.defaultView.frameElement;
            if (f) {
                var g = e(f);
                c.top += g.top, c.bottom += g.top, c.left += g.left, c.right += g.left;
            }
        }
        return c;
    }
    function f(a) {
        var b = getComputedStyle(a) || {}, c = b.position, d = [];
        if ("fixed" === c) return [ a ];
        for (var e = a; (e = e.parentNode) && e && 1 === e.nodeType; ) {
            var f = void 0;
            try {
                f = getComputedStyle(e);
            } catch (a) {}
            if (void 0 === f || null === f) return d.push(e), d;
            var g = f, h = g.overflow, i = g.overflowX;
            /(auto|scroll)/.test(h + g.overflowY + i) && ("absolute" !== c || [ "relative", "absolute", "fixed" ].indexOf(f.position) >= 0) && d.push(e);
        }
        return d.push(a.ownerDocument.body), a.ownerDocument !== document && d.push(a.ownerDocument.defaultView), 
        d;
    }
    function g() {
        z && document.body.removeChild(z), z = null;
    }
    function h(a) {
        var b = void 0;
        a === document ? (b = document, a = document.documentElement) : b = a.ownerDocument;
        var c = b.documentElement, d = e(a), f = C();
        return d.top -= f.top, d.left -= f.left, void 0 === d.width && (d.width = document.body.scrollWidth - d.left - d.right), 
        void 0 === d.height && (d.height = document.body.scrollHeight - d.top - d.bottom), 
        d.top = d.top - c.clientTop, d.left = d.left - c.clientLeft, d.right = b.body.clientWidth - d.width - d.left, 
        d.bottom = b.body.clientHeight - d.height - d.top, d;
    }
    function i(a) {
        return a.offsetParent || document.documentElement;
    }
    function j() {
        if (D) return D;
        var a = document.createElement("div");
        a.style.width = "100%", a.style.height = "200px";
        var b = document.createElement("div");
        k(b.style, {
            position: "absolute",
            top: 0,
            left: 0,
            pointerEvents: "none",
            visibility: "hidden",
            width: "200px",
            height: "150px",
            overflow: "hidden"
        }), b.appendChild(a), document.body.appendChild(b);
        var c = a.offsetWidth;
        b.style.overflow = "scroll";
        var d = a.offsetWidth;
        c === d && (d = b.clientWidth), document.body.removeChild(b);
        var e = c - d;
        return D = {
            width: e,
            height: e
        };
    }
    function k() {
        var a = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0], b = [];
        return Array.prototype.push.apply(b, arguments), b.slice(1).forEach(function(b) {
            if (b) for (var c in b) ({}).hasOwnProperty.call(b, c) && (a[c] = b[c]);
        }), a;
    }
    function l(a, b) {
        if (void 0 !== a.classList) b.split(" ").forEach(function(b) {
            b.trim() && a.classList.remove(b);
        }); else {
            var c = new RegExp("(^| )" + b.split(" ").join("|") + "( |$)", "gi"), d = o(a).replace(c, " ");
            p(a, d);
        }
    }
    function m(a, b) {
        if (void 0 !== a.classList) b.split(" ").forEach(function(b) {
            b.trim() && a.classList.add(b);
        }); else {
            l(a, b);
            var c = o(a) + " " + b;
            p(a, c);
        }
    }
    function n(a, b) {
        if (void 0 !== a.classList) return a.classList.contains(b);
        var c = o(a);
        return new RegExp("(^| )" + b + "( |$)", "gi").test(c);
    }
    function o(a) {
        return a.className instanceof a.ownerDocument.defaultView.SVGAnimatedString ? a.className.baseVal : a.className;
    }
    function p(a, b) {
        a.setAttribute("class", b);
    }
    function q(a, b, c) {
        c.forEach(function(c) {
            -1 === b.indexOf(c) && n(a, c) && l(a, c);
        }), b.forEach(function(b) {
            n(a, b) || m(a, b);
        });
    }
    function d(a, b) {
        if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
    }
    function r(a, b) {
        if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function, not " + typeof b);
        a.prototype = Object.create(b && b.prototype, {
            constructor: {
                value: a,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : a.__proto__ = b);
    }
    function s(a, b) {
        var c = arguments.length <= 2 || void 0 === arguments[2] ? 1 : arguments[2];
        return a + c >= b && b >= a - c;
    }
    function t() {
        return "undefined" != typeof performance && void 0 !== performance.now ? performance.now() : +new Date();
    }
    function u() {
        for (var a = {
            top: 0,
            left: 0
        }, b = arguments.length, c = Array(b), d = 0; b > d; d++) c[d] = arguments[d];
        return c.forEach(function(b) {
            var c = b.top, d = b.left;
            "string" == typeof c && (c = parseFloat(c, 10)), "string" == typeof d && (d = parseFloat(d, 10)), 
            a.top += c, a.left += d;
        }), a;
    }
    function v(a, b) {
        return "string" == typeof a.left && -1 !== a.left.indexOf("%") && (a.left = parseFloat(a.left, 10) / 100 * b.width), 
        "string" == typeof a.top && -1 !== a.top.indexOf("%") && (a.top = parseFloat(a.top, 10) / 100 * b.height), 
        a;
    }
    function w(a, b) {
        return "scrollParent" === b ? b = a.scrollParents[0] : "window" === b && (b = [ pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset ]), 
        b === document && (b = b.documentElement), void 0 !== b.nodeType && function() {
            var a = b, c = h(b), d = c, e = getComputedStyle(b);
            if (b = [ d.left, d.top, c.width + d.left, c.height + d.top ], a.ownerDocument !== document) {
                var f = a.ownerDocument.defaultView;
                b[0] += f.pageXOffset, b[1] += f.pageYOffset, b[2] += f.pageXOffset, b[3] += f.pageYOffset;
            }
            X.forEach(function(a, c) {
                a = a[0].toUpperCase() + a.substr(1), "Top" === a || "Left" === a ? b[c] += parseFloat(e["border" + a + "Width"]) : b[c] -= parseFloat(e["border" + a + "Width"]);
            });
        }(), b;
    }
    var x = function() {
        function a(a, b) {
            for (var c = 0; c < b.length; c++) {
                var d = b[c];
                d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), 
                Object.defineProperty(a, d.key, d);
            }
        }
        return function(b, c, d) {
            return c && a(b.prototype, c), d && a(b, d), b;
        };
    }(), y = void 0;
    void 0 === y && (y = {
        modules: []
    });
    var z = null, A = function() {
        var a = 0;
        return function() {
            return ++a;
        };
    }(), B = {}, C = function() {
        var a = z;
        a || (a = document.createElement("div"), a.setAttribute("data-tether-id", A()), 
        k(a.style, {
            top: 0,
            left: 0,
            position: "absolute"
        }), document.body.appendChild(a), z = a);
        var b = a.getAttribute("data-tether-id");
        return void 0 === B[b] && (B[b] = e(a), F(function() {
            delete B[b];
        })), B[b];
    }, D = null, E = [], F = function(a) {
        E.push(a);
    }, G = function() {
        for (var a = void 0; a = E.pop(); ) a();
    }, H = function() {
        function a() {
            d(this, a);
        }
        return x(a, [ {
            key: "on",
            value: function(a, b, c) {
                var d = !(arguments.length <= 3 || void 0 === arguments[3]) && arguments[3];
                void 0 === this.bindings && (this.bindings = {}), void 0 === this.bindings[a] && (this.bindings[a] = []), 
                this.bindings[a].push({
                    handler: b,
                    ctx: c,
                    once: d
                });
            }
        }, {
            key: "once",
            value: function(a, b, c) {
                this.on(a, b, c, !0);
            }
        }, {
            key: "off",
            value: function(a, b) {
                if (void 0 !== this.bindings && void 0 !== this.bindings[a]) if (void 0 === b) delete this.bindings[a]; else for (var c = 0; c < this.bindings[a].length; ) this.bindings[a][c].handler === b ? this.bindings[a].splice(c, 1) : ++c;
            }
        }, {
            key: "trigger",
            value: function(a) {
                if (void 0 !== this.bindings && this.bindings[a]) {
                    for (var b = 0, c = arguments.length, d = Array(c > 1 ? c - 1 : 0), e = 1; c > e; e++) d[e - 1] = arguments[e];
                    for (;b < this.bindings[a].length; ) {
                        var f = this.bindings[a][b], g = f.handler, h = f.ctx, i = f.once, j = h;
                        void 0 === j && (j = this), g.apply(j, d), i ? this.bindings[a].splice(b, 1) : ++b;
                    }
                }
            }
        } ]), a;
    }();
    y.Utils = {
        getActualBoundingClientRect: e,
        getScrollParents: f,
        getBounds: h,
        getOffsetParent: i,
        extend: k,
        addClass: m,
        removeClass: l,
        hasClass: n,
        updateClasses: q,
        defer: F,
        flush: G,
        uniqueId: A,
        Evented: H,
        getScrollBarSize: j,
        removeUtilElements: g
    };
    var I = function() {
        function a(a, b) {
            var c = [], d = !0, e = !1, f = void 0;
            try {
                for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), 
                !b || c.length !== b); d = !0) ;
            } catch (a) {
                e = !0, f = a;
            } finally {
                try {
                    !d && h.return && h.return();
                } finally {
                    if (e) throw f;
                }
            }
            return c;
        }
        return function(b, c) {
            if (Array.isArray(b)) return b;
            if (Symbol.iterator in Object(b)) return a(b, c);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }(), x = function() {
        function a(a, b) {
            for (var c = 0; c < b.length; c++) {
                var d = b[c];
                d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), 
                Object.defineProperty(a, d.key, d);
            }
        }
        return function(b, c, d) {
            return c && a(b.prototype, c), d && a(b, d), b;
        };
    }(), J = function(a, b, c) {
        for (var d = !0; d; ) {
            var e = a, f = b, g = c;
            d = !1, null === e && (e = Function.prototype);
            var h = Object.getOwnPropertyDescriptor(e, f);
            if (void 0 !== h) {
                if ("value" in h) return h.value;
                var i = h.get;
                if (void 0 === i) return;
                return i.call(g);
            }
            var j = Object.getPrototypeOf(e);
            if (null === j) return;
            a = j, b = f, c = g, d = !0, h = j = void 0;
        }
    };
    if (void 0 === y) throw new Error("You must include the utils.js file before tether.js");
    var K = y.Utils, f = K.getScrollParents, h = K.getBounds, i = K.getOffsetParent, k = K.extend, m = K.addClass, l = K.removeClass, q = K.updateClasses, F = K.defer, G = K.flush, j = K.getScrollBarSize, g = K.removeUtilElements, L = function() {
        if ("undefined" == typeof document) return "";
        for (var a = document.createElement("div"), b = [ "transform", "WebkitTransform", "OTransform", "MozTransform", "msTransform" ], c = 0; c < b.length; ++c) {
            var d = b[c];
            if (void 0 !== a.style[d]) return d;
        }
    }(), M = [], N = function() {
        M.forEach(function(a) {
            a.position(!1);
        }), G();
    };
    !function() {
        var a = null, b = null, c = null, d = function d() {
            return void 0 !== b && b > 16 ? (b = Math.min(b - 16, 250), void (c = setTimeout(d, 250))) : void (void 0 !== a && t() - a < 10 || (null != c && (clearTimeout(c), 
            c = null), a = t(), N(), b = t() - a));
        };
        "undefined" != typeof window && void 0 !== window.addEventListener && [ "resize", "scroll", "touchmove" ].forEach(function(a) {
            window.addEventListener(a, d);
        });
    }();
    var O = {
        center: "center",
        left: "right",
        right: "left"
    }, P = {
        middle: "middle",
        top: "bottom",
        bottom: "top"
    }, Q = {
        top: 0,
        left: 0,
        middle: "50%",
        center: "50%",
        bottom: "100%",
        right: "100%"
    }, R = function(a, b) {
        var c = a.left, d = a.top;
        return "auto" === c && (c = O[b.left]), "auto" === d && (d = P[b.top]), {
            left: c,
            top: d
        };
    }, S = function(a) {
        var b = a.left, c = a.top;
        return void 0 !== Q[a.left] && (b = Q[a.left]), void 0 !== Q[a.top] && (c = Q[a.top]), 
        {
            left: b,
            top: c
        };
    }, T = function(a) {
        var b = a.split(" "), c = I(b, 2);
        return {
            top: c[0],
            left: c[1]
        };
    }, U = T, V = function(a) {
        function b(a) {
            var c = this;
            d(this, b), J(Object.getPrototypeOf(b.prototype), "constructor", this).call(this), 
            this.position = this.position.bind(this), M.push(this), this.history = [], this.setOptions(a, !1), 
            y.modules.forEach(function(a) {
                void 0 !== a.initialize && a.initialize.call(c);
            }), this.position();
        }
        return r(b, a), x(b, [ {
            key: "getClass",
            value: function() {
                var a = arguments.length <= 0 || void 0 === arguments[0] ? "" : arguments[0], b = this.options.classes;
                return void 0 !== b && b[a] ? this.options.classes[a] : this.options.classPrefix ? this.options.classPrefix + "-" + a : a;
            }
        }, {
            key: "setOptions",
            value: function(a) {
                var b = this, c = arguments.length <= 1 || void 0 === arguments[1] || arguments[1], d = {
                    offset: "0 0",
                    targetOffset: "0 0",
                    targetAttachment: "auto auto",
                    classPrefix: "tether"
                };
                this.options = k(d, a);
                var e = this.options, g = e.element, h = e.target, i = e.targetModifier;
                if (this.element = g, this.target = h, this.targetModifier = i, "viewport" === this.target ? (this.target = document.body, 
                this.targetModifier = "visible") : "scroll-handle" === this.target && (this.target = document.body, 
                this.targetModifier = "scroll-handle"), [ "element", "target" ].forEach(function(a) {
                    if (void 0 === b[a]) throw new Error("Tether Error: Both element and target must be defined");
                    void 0 !== b[a].jquery ? b[a] = b[a][0] : "string" == typeof b[a] && (b[a] = document.querySelector(b[a]));
                }), m(this.element, this.getClass("element")), !1 !== this.options.addTargetClasses && m(this.target, this.getClass("target")), 
                !this.options.attachment) throw new Error("Tether Error: You must provide an attachment");
                this.targetAttachment = U(this.options.targetAttachment), this.attachment = U(this.options.attachment), 
                this.offset = T(this.options.offset), this.targetOffset = T(this.options.targetOffset), 
                void 0 !== this.scrollParents && this.disable(), "scroll-handle" === this.targetModifier ? this.scrollParents = [ this.target ] : this.scrollParents = f(this.target), 
                !1 !== this.options.enabled && this.enable(c);
            }
        }, {
            key: "getTargetBounds",
            value: function() {
                if (void 0 === this.targetModifier) return h(this.target);
                if ("visible" === this.targetModifier) {
                    if (this.target === document.body) return {
                        top: pageYOffset,
                        left: pageXOffset,
                        height: innerHeight,
                        width: innerWidth
                    };
                    var a = h(this.target), b = {
                        height: a.height,
                        width: a.width,
                        top: a.top,
                        left: a.left
                    };
                    return b.height = Math.min(b.height, a.height - (pageYOffset - a.top)), b.height = Math.min(b.height, a.height - (a.top + a.height - (pageYOffset + innerHeight))), 
                    b.height = Math.min(innerHeight, b.height), b.height -= 2, b.width = Math.min(b.width, a.width - (pageXOffset - a.left)), 
                    b.width = Math.min(b.width, a.width - (a.left + a.width - (pageXOffset + innerWidth))), 
                    b.width = Math.min(innerWidth, b.width), b.width -= 2, b.top < pageYOffset && (b.top = pageYOffset), 
                    b.left < pageXOffset && (b.left = pageXOffset), b;
                }
                if ("scroll-handle" === this.targetModifier) {
                    var a = void 0, c = this.target;
                    c === document.body ? (c = document.documentElement, a = {
                        left: pageXOffset,
                        top: pageYOffset,
                        height: innerHeight,
                        width: innerWidth
                    }) : a = h(c);
                    var d = getComputedStyle(c), e = c.scrollWidth > c.clientWidth || [ d.overflow, d.overflowX ].indexOf("scroll") >= 0 || this.target !== document.body, f = 0;
                    e && (f = 15);
                    var g = a.height - parseFloat(d.borderTopWidth) - parseFloat(d.borderBottomWidth) - f, b = {
                        width: 15,
                        height: .975 * g * (g / c.scrollHeight),
                        left: a.left + a.width - parseFloat(d.borderLeftWidth) - 15
                    }, i = 0;
                    408 > g && this.target === document.body && (i = -11e-5 * Math.pow(g, 2) - .00727 * g + 22.58), 
                    this.target !== document.body && (b.height = Math.max(b.height, 24));
                    var j = this.target.scrollTop / (c.scrollHeight - g);
                    return b.top = j * (g - b.height - i) + a.top + parseFloat(d.borderTopWidth), this.target === document.body && (b.height = Math.max(b.height, 24)), 
                    b;
                }
            }
        }, {
            key: "clearCache",
            value: function() {
                this._cache = {};
            }
        }, {
            key: "cache",
            value: function(a, b) {
                return void 0 === this._cache && (this._cache = {}), void 0 === this._cache[a] && (this._cache[a] = b.call(this)), 
                this._cache[a];
            }
        }, {
            key: "enable",
            value: function() {
                var a = this, b = arguments.length <= 0 || void 0 === arguments[0] || arguments[0];
                !1 !== this.options.addTargetClasses && m(this.target, this.getClass("enabled")), 
                m(this.element, this.getClass("enabled")), this.enabled = !0, this.scrollParents.forEach(function(b) {
                    b !== a.target.ownerDocument && b.addEventListener("scroll", a.position);
                }), b && this.position();
            }
        }, {
            key: "disable",
            value: function() {
                var a = this;
                l(this.target, this.getClass("enabled")), l(this.element, this.getClass("enabled")), 
                this.enabled = !1, void 0 !== this.scrollParents && this.scrollParents.forEach(function(b) {
                    b.removeEventListener("scroll", a.position);
                });
            }
        }, {
            key: "destroy",
            value: function() {
                var a = this;
                this.disable(), M.forEach(function(b, c) {
                    b === a && M.splice(c, 1);
                }), 0 === M.length && g();
            }
        }, {
            key: "updateAttachClasses",
            value: function(a, b) {
                var c = this;
                a = a || this.attachment, b = b || this.targetAttachment;
                var d = [ "left", "top", "bottom", "right", "middle", "center" ];
                void 0 !== this._addAttachClasses && this._addAttachClasses.length && this._addAttachClasses.splice(0, this._addAttachClasses.length), 
                void 0 === this._addAttachClasses && (this._addAttachClasses = []);
                var e = this._addAttachClasses;
                a.top && e.push(this.getClass("element-attached") + "-" + a.top), a.left && e.push(this.getClass("element-attached") + "-" + a.left), 
                b.top && e.push(this.getClass("target-attached") + "-" + b.top), b.left && e.push(this.getClass("target-attached") + "-" + b.left);
                var f = [];
                d.forEach(function(a) {
                    f.push(c.getClass("element-attached") + "-" + a), f.push(c.getClass("target-attached") + "-" + a);
                }), F(function() {
                    void 0 !== c._addAttachClasses && (q(c.element, c._addAttachClasses, f), !1 !== c.options.addTargetClasses && q(c.target, c._addAttachClasses, f), 
                    delete c._addAttachClasses);
                });
            }
        }, {
            key: "position",
            value: function() {
                var a = this, b = arguments.length <= 0 || void 0 === arguments[0] || arguments[0];
                if (this.enabled) {
                    this.clearCache();
                    var c = R(this.targetAttachment, this.attachment);
                    this.updateAttachClasses(this.attachment, c);
                    var d = this.cache("element-bounds", function() {
                        return h(a.element);
                    }), e = d.width, f = d.height;
                    if (0 === e && 0 === f && void 0 !== this.lastSize) {
                        var g = this.lastSize;
                        e = g.width, f = g.height;
                    } else this.lastSize = {
                        width: e,
                        height: f
                    };
                    var k = this.cache("target-bounds", function() {
                        return a.getTargetBounds();
                    }), l = k, m = v(S(this.attachment), {
                        width: e,
                        height: f
                    }), n = v(S(c), l), o = v(this.offset, {
                        width: e,
                        height: f
                    }), p = v(this.targetOffset, l);
                    m = u(m, o), n = u(n, p);
                    for (var q = k.left + n.left - m.left, r = k.top + n.top - m.top, s = 0; s < y.modules.length; ++s) {
                        var t = y.modules[s], w = t.position.call(this, {
                            left: q,
                            top: r,
                            targetAttachment: c,
                            targetPos: k,
                            elementPos: d,
                            offset: m,
                            targetOffset: n,
                            manualOffset: o,
                            manualTargetOffset: p,
                            scrollbarSize: B,
                            attachment: this.attachment
                        });
                        if (!1 === w) return !1;
                        void 0 !== w && "object" == typeof w && (r = w.top, q = w.left);
                    }
                    var x = {
                        page: {
                            top: r,
                            left: q
                        },
                        viewport: {
                            top: r - pageYOffset,
                            bottom: pageYOffset - r - f + innerHeight,
                            left: q - pageXOffset,
                            right: pageXOffset - q - e + innerWidth
                        }
                    }, z = this.target.ownerDocument, A = z.defaultView, B = void 0;
                    return A.innerHeight > z.documentElement.clientHeight && (B = this.cache("scrollbar-size", j), 
                    x.viewport.bottom -= B.height), A.innerWidth > z.documentElement.clientWidth && (B = this.cache("scrollbar-size", j), 
                    x.viewport.right -= B.width), (-1 === [ "", "static" ].indexOf(z.body.style.position) || -1 === [ "", "static" ].indexOf(z.body.parentElement.style.position)) && (x.page.bottom = z.body.scrollHeight - r - f, 
                    x.page.right = z.body.scrollWidth - q - e), void 0 !== this.options.optimizations && !1 !== this.options.optimizations.moveElement && void 0 === this.targetModifier && function() {
                        var b = a.cache("target-offsetparent", function() {
                            return i(a.target);
                        }), c = a.cache("target-offsetparent-bounds", function() {
                            return h(b);
                        }), d = getComputedStyle(b), e = c, f = {};
                        if ([ "Top", "Left", "Bottom", "Right" ].forEach(function(a) {
                            f[a.toLowerCase()] = parseFloat(d["border" + a + "Width"]);
                        }), c.right = z.body.scrollWidth - c.left - e.width + f.right, c.bottom = z.body.scrollHeight - c.top - e.height + f.bottom, 
                        x.page.top >= c.top + f.top && x.page.bottom >= c.bottom && x.page.left >= c.left + f.left && x.page.right >= c.right) {
                            var g = b.scrollTop, j = b.scrollLeft;
                            x.offset = {
                                top: x.page.top - c.top + g - f.top,
                                left: x.page.left - c.left + j - f.left
                            };
                        }
                    }(), this.move(x), this.history.unshift(x), this.history.length > 3 && this.history.pop(), 
                    b && G(), !0;
                }
            }
        }, {
            key: "move",
            value: function(a) {
                var b = this;
                if (void 0 !== this.element.parentNode) {
                    var c = {};
                    for (var d in a) {
                        c[d] = {};
                        for (var e in a[d]) {
                            for (var f = !1, g = 0; g < this.history.length; ++g) {
                                var h = this.history[g];
                                if (void 0 !== h[d] && !s(h[d][e], a[d][e])) {
                                    f = !0;
                                    break;
                                }
                            }
                            f || (c[d][e] = !0);
                        }
                    }
                    var j = {
                        top: "",
                        left: "",
                        right: "",
                        bottom: ""
                    }, l = function(a, c) {
                        if (!1 !== (void 0 !== b.options.optimizations ? b.options.optimizations.gpu : null)) {
                            var d = void 0, e = void 0;
                            a.top ? (j.top = 0, d = c.top) : (j.bottom = 0, d = -c.bottom), a.left ? (j.left = 0, 
                            e = c.left) : (j.right = 0, e = -c.right), window.matchMedia && (window.matchMedia("only screen and (min-resolution: 1.3dppx)").matches || window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 1.3)").matches || (e = Math.round(e), 
                            d = Math.round(d))), j[L] = "translateX(" + e + "px) translateY(" + d + "px)", "msTransform" !== L && (j[L] += " translateZ(0)");
                        } else a.top ? j.top = c.top + "px" : j.bottom = c.bottom + "px", a.left ? j.left = c.left + "px" : j.right = c.right + "px";
                    }, m = !1;
                    if ((c.page.top || c.page.bottom) && (c.page.left || c.page.right) ? (j.position = "absolute", 
                    l(c.page, a.page)) : (c.viewport.top || c.viewport.bottom) && (c.viewport.left || c.viewport.right) ? (j.position = "fixed", 
                    l(c.viewport, a.viewport)) : void 0 !== c.offset && c.offset.top && c.offset.left ? function() {
                        j.position = "absolute";
                        var d = b.cache("target-offsetparent", function() {
                            return i(b.target);
                        });
                        i(b.element) !== d && F(function() {
                            b.element.parentNode.removeChild(b.element), d.appendChild(b.element);
                        }), l(c.offset, a.offset), m = !0;
                    }() : (j.position = "absolute", l({
                        top: !0,
                        left: !0
                    }, a.page)), !m) {
                        for (var n = !0, o = this.element.parentNode; o && 1 === o.nodeType && "BODY" !== o.tagName; ) {
                            if ("static" !== getComputedStyle(o).position) {
                                n = !1;
                                break;
                            }
                            o = o.parentNode;
                        }
                        n || (this.element.parentNode.removeChild(this.element), this.element.ownerDocument.body.appendChild(this.element));
                    }
                    var p = {}, q = !1;
                    for (var e in j) {
                        var r = j[e];
                        this.element.style[e] !== r && (q = !0, p[e] = r);
                    }
                    q && F(function() {
                        k(b.element.style, p), b.trigger("repositioned");
                    });
                }
            }
        } ]), b;
    }(H);
    V.modules = [], y.position = N;
    var W = k(V, y), I = function() {
        function a(a, b) {
            var c = [], d = !0, e = !1, f = void 0;
            try {
                for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), 
                !b || c.length !== b); d = !0) ;
            } catch (a) {
                e = !0, f = a;
            } finally {
                try {
                    !d && h.return && h.return();
                } finally {
                    if (e) throw f;
                }
            }
            return c;
        }
        return function(b, c) {
            if (Array.isArray(b)) return b;
            if (Symbol.iterator in Object(b)) return a(b, c);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }(), K = y.Utils, h = K.getBounds, k = K.extend, q = K.updateClasses, F = K.defer, X = [ "left", "top", "right", "bottom" ];
    y.modules.push({
        position: function(a) {
            var b = this, c = a.top, d = a.left, e = a.targetAttachment;
            if (!this.options.constraints) return !0;
            var f = this.cache("element-bounds", function() {
                return h(b.element);
            }), g = f.height, i = f.width;
            if (0 === i && 0 === g && void 0 !== this.lastSize) {
                var j = this.lastSize;
                i = j.width, g = j.height;
            }
            var l = this.cache("target-bounds", function() {
                return b.getTargetBounds();
            }), m = l.height, n = l.width, o = [ this.getClass("pinned"), this.getClass("out-of-bounds") ];
            this.options.constraints.forEach(function(a) {
                var b = a.outOfBoundsClass, c = a.pinnedClass;
                b && o.push(b), c && o.push(c);
            }), o.forEach(function(a) {
                [ "left", "top", "right", "bottom" ].forEach(function(b) {
                    o.push(a + "-" + b);
                });
            });
            var p = [], r = k({}, e), s = k({}, this.attachment);
            return this.options.constraints.forEach(function(a) {
                var f = a.to, h = a.attachment, j = a.pin;
                void 0 === h && (h = "");
                var k = void 0, l = void 0;
                if (h.indexOf(" ") >= 0) {
                    var o = h.split(" "), q = I(o, 2);
                    l = q[0], k = q[1];
                } else k = l = h;
                var t = w(b, f);
                ("target" === l || "both" === l) && (c < t[1] && "top" === r.top && (c += m, r.top = "bottom"), 
                c + g > t[3] && "bottom" === r.top && (c -= m, r.top = "top")), "together" === l && ("top" === r.top && ("bottom" === s.top && c < t[1] ? (c += m, 
                r.top = "bottom", c += g, s.top = "top") : "top" === s.top && c + g > t[3] && c - (g - m) >= t[1] && (c -= g - m, 
                r.top = "bottom", s.top = "bottom")), "bottom" === r.top && ("top" === s.top && c + g > t[3] ? (c -= m, 
                r.top = "top", c -= g, s.top = "bottom") : "bottom" === s.top && c < t[1] && c + (2 * g - m) <= t[3] && (c += g - m, 
                r.top = "top", s.top = "top")), "middle" === r.top && (c + g > t[3] && "top" === s.top ? (c -= g, 
                s.top = "bottom") : c < t[1] && "bottom" === s.top && (c += g, s.top = "top"))), 
                ("target" === k || "both" === k) && (d < t[0] && "left" === r.left && (d += n, r.left = "right"), 
                d + i > t[2] && "right" === r.left && (d -= n, r.left = "left")), "together" === k && (d < t[0] && "left" === r.left ? "right" === s.left ? (d += n, 
                r.left = "right", d += i, s.left = "left") : "left" === s.left && (d += n, r.left = "right", 
                d -= i, s.left = "right") : d + i > t[2] && "right" === r.left ? "left" === s.left ? (d -= n, 
                r.left = "left", d -= i, s.left = "right") : "right" === s.left && (d -= n, r.left = "left", 
                d += i, s.left = "left") : "center" === r.left && (d + i > t[2] && "left" === s.left ? (d -= i, 
                s.left = "right") : d < t[0] && "right" === s.left && (d += i, s.left = "left"))), 
                ("element" === l || "both" === l) && (c < t[1] && "bottom" === s.top && (c += g, 
                s.top = "top"), c + g > t[3] && "top" === s.top && (c -= g, s.top = "bottom")), 
                ("element" === k || "both" === k) && (d < t[0] && ("right" === s.left ? (d += i, 
                s.left = "left") : "center" === s.left && (d += i / 2, s.left = "left")), d + i > t[2] && ("left" === s.left ? (d -= i, 
                s.left = "right") : "center" === s.left && (d -= i / 2, s.left = "right"))), "string" == typeof j ? j = j.split(",").map(function(a) {
                    return a.trim();
                }) : !0 === j && (j = [ "top", "left", "right", "bottom" ]), j = j || [];
                var u = [], v = [];
                c < t[1] && (j.indexOf("top") >= 0 ? (c = t[1], u.push("top")) : v.push("top")), 
                c + g > t[3] && (j.indexOf("bottom") >= 0 ? (c = t[3] - g, u.push("bottom")) : v.push("bottom")), 
                d < t[0] && (j.indexOf("left") >= 0 ? (d = t[0], u.push("left")) : v.push("left")), 
                d + i > t[2] && (j.indexOf("right") >= 0 ? (d = t[2] - i, u.push("right")) : v.push("right")), 
                u.length && function() {
                    var a = void 0;
                    a = void 0 !== b.options.pinnedClass ? b.options.pinnedClass : b.getClass("pinned"), 
                    p.push(a), u.forEach(function(b) {
                        p.push(a + "-" + b);
                    });
                }(), v.length && function() {
                    var a = void 0;
                    a = void 0 !== b.options.outOfBoundsClass ? b.options.outOfBoundsClass : b.getClass("out-of-bounds"), 
                    p.push(a), v.forEach(function(b) {
                        p.push(a + "-" + b);
                    });
                }(), (u.indexOf("left") >= 0 || u.indexOf("right") >= 0) && (s.left = r.left = !1), 
                (u.indexOf("top") >= 0 || u.indexOf("bottom") >= 0) && (s.top = r.top = !1), (r.top !== e.top || r.left !== e.left || s.top !== b.attachment.top || s.left !== b.attachment.left) && (b.updateAttachClasses(s, r), 
                b.trigger("update", {
                    attachment: s,
                    targetAttachment: r
                }));
            }), F(function() {
                !1 !== b.options.addTargetClasses && q(b.target, p, o), q(b.element, p, o);
            }), {
                top: c,
                left: d
            };
        }
    });
    var K = y.Utils, h = K.getBounds, q = K.updateClasses, F = K.defer;
    y.modules.push({
        position: function(a) {
            var b = this, c = a.top, d = a.left, e = this.cache("element-bounds", function() {
                return h(b.element);
            }), f = e.height, g = e.width, i = this.getTargetBounds(), j = c + f, k = d + g, l = [];
            c <= i.bottom && j >= i.top && [ "left", "right" ].forEach(function(a) {
                var b = i[a];
                (b === d || b === k) && l.push(a);
            }), d <= i.right && k >= i.left && [ "top", "bottom" ].forEach(function(a) {
                var b = i[a];
                (b === c || b === j) && l.push(a);
            });
            var m = [], n = [], o = [ "left", "top", "right", "bottom" ];
            return m.push(this.getClass("abutted")), o.forEach(function(a) {
                m.push(b.getClass("abutted") + "-" + a);
            }), l.length && n.push(this.getClass("abutted")), l.forEach(function(a) {
                n.push(b.getClass("abutted") + "-" + a);
            }), F(function() {
                !1 !== b.options.addTargetClasses && q(b.target, n, m), q(b.element, n, m);
            }), !0;
        }
    });
    var I = function() {
        function a(a, b) {
            var c = [], d = !0, e = !1, f = void 0;
            try {
                for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), 
                !b || c.length !== b); d = !0) ;
            } catch (a) {
                e = !0, f = a;
            } finally {
                try {
                    !d && h.return && h.return();
                } finally {
                    if (e) throw f;
                }
            }
            return c;
        }
        return function(b, c) {
            if (Array.isArray(b)) return b;
            if (Symbol.iterator in Object(b)) return a(b, c);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    return y.modules.push({
        position: function(a) {
            var b = a.top, c = a.left;
            if (this.options.shift) {
                var d = this.options.shift;
                "function" == typeof this.options.shift && (d = this.options.shift.call(this, {
                    top: b,
                    left: c
                }));
                var e = void 0, f = void 0;
                if ("string" == typeof d) {
                    d = d.split(" "), d[1] = d[1] || d[0];
                    var g = d, h = I(g, 2);
                    e = h[0], f = h[1], e = parseFloat(e, 10), f = parseFloat(f, 10);
                } else e = d.top, f = d.left;
                return b += e, c += f, {
                    top: b,
                    left: c
                };
            }
        }
    }), W;
}), "undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");

+function(a) {
    var b = a.fn.jquery.split(" ")[0].split(".");
    if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1 || b[0] >= 4) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
}(jQuery), function() {
    function a(a, b) {
        if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !b || "object" != typeof b && "function" != typeof b ? a : b;
    }
    function b(a, b) {
        if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function, not " + typeof b);
        a.prototype = Object.create(b && b.prototype, {
            constructor: {
                value: a,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : a.__proto__ = b);
    }
    function c(a, b) {
        if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
    }
    var d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(a) {
        return typeof a;
    } : function(a) {
        return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, e = function() {
        function a(a, b) {
            for (var c = 0; c < b.length; c++) {
                var d = b[c];
                d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), 
                Object.defineProperty(a, d.key, d);
            }
        }
        return function(b, c, d) {
            return c && a(b.prototype, c), d && a(b, d), b;
        };
    }(), f = function(a) {
        function b(a) {
            return {}.toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        }
        function c(a) {
            return (a[0] || a).nodeType;
        }
        function d() {
            return {
                bindType: h.end,
                delegateType: h.end,
                handle: function(b) {
                    if (a(b.target).is(this)) return b.handleObj.handler.apply(this, arguments);
                }
            };
        }
        function e() {
            if (window.QUnit) return !1;
            var a = document.createElement("bootstrap");
            for (var b in j) if (void 0 !== a.style[b]) return {
                end: j[b]
            };
            return !1;
        }
        function f(b) {
            var c = this, d = !1;
            return a(this).one(k.TRANSITION_END, function() {
                d = !0;
            }), setTimeout(function() {
                d || k.triggerTransitionEnd(c);
            }, b), this;
        }
        function g() {
            h = e(), a.fn.emulateTransitionEnd = f, k.supportsTransitionEnd() && (a.event.special[k.TRANSITION_END] = d());
        }
        var h = !1, i = 1e6, j = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, k = {
            TRANSITION_END: "bsTransitionEnd",
            getUID: function(a) {
                do {
                    a += ~~(Math.random() * i);
                } while (document.getElementById(a));
                return a;
            },
            getSelectorFromElement: function(a) {
                var b = a.getAttribute("data-target");
                return b || (b = a.getAttribute("href") || "", b = /^#[a-z]/i.test(b) ? b : null), 
                b;
            },
            reflow: function(a) {
                new Function("bs", "return bs")(a.offsetHeight);
            },
            triggerTransitionEnd: function(b) {
                a(b).trigger(h.end);
            },
            supportsTransitionEnd: function() {
                return Boolean(h);
            },
            typeCheckConfig: function(a, d, e) {
                for (var f in e) if (e.hasOwnProperty(f)) {
                    var g = e[f], h = d[f], i = void 0;
                    if (i = h && c(h) ? "element" : b(h), !new RegExp(g).test(i)) throw new Error(a.toUpperCase() + ': Option "' + f + '" provided type "' + i + '" but expected type "' + g + '".');
                }
            }
        };
        return g(), k;
    }(jQuery), g = (function(a) {
        var b = "alert", d = "4.0.0-alpha.5", g = "bs.alert", h = "." + g, i = ".data-api", j = a.fn[b], k = 150, l = {
            DISMISS: '[data-dismiss="alert"]'
        }, m = {
            CLOSE: "close" + h,
            CLOSED: "closed" + h,
            CLICK_DATA_API: "click" + h + i
        }, n = {
            ALERT: "alert",
            FADE: "fade",
            IN: "in"
        }, o = function() {
            function b(a) {
                c(this, b), this._element = a;
            }
            return b.prototype.close = function(a) {
                a = a || this._element;
                var b = this._getRootElement(a);
                this._triggerCloseEvent(b).isDefaultPrevented() || this._removeElement(b);
            }, b.prototype.dispose = function() {
                a.removeData(this._element, g), this._element = null;
            }, b.prototype._getRootElement = function(b) {
                var c = f.getSelectorFromElement(b), d = !1;
                return c && (d = a(c)[0]), d || (d = a(b).closest("." + n.ALERT)[0]), d;
            }, b.prototype._triggerCloseEvent = function(b) {
                var c = a.Event(m.CLOSE);
                return a(b).trigger(c), c;
            }, b.prototype._removeElement = function(b) {
                return a(b).removeClass(n.IN), f.supportsTransitionEnd() && a(b).hasClass(n.FADE) ? void a(b).one(f.TRANSITION_END, a.proxy(this._destroyElement, this, b)).emulateTransitionEnd(k) : void this._destroyElement(b);
            }, b.prototype._destroyElement = function(b) {
                a(b).detach().trigger(m.CLOSED).remove();
            }, b._jQueryInterface = function(c) {
                return this.each(function() {
                    var d = a(this), e = d.data(g);
                    e || (e = new b(this), d.data(g, e)), "close" === c && e[c](this);
                });
            }, b._handleDismiss = function(a) {
                return function(b) {
                    b && b.preventDefault(), a.close(this);
                };
            }, e(b, null, [ {
                key: "VERSION",
                get: function() {
                    return d;
                }
            } ]), b;
        }();
        a(document).on(m.CLICK_DATA_API, l.DISMISS, o._handleDismiss(new o())), a.fn[b] = o._jQueryInterface, 
        a.fn[b].Constructor = o, a.fn[b].noConflict = function() {
            return a.fn[b] = j, o._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "button", d = "4.0.0-alpha.5", f = "bs.button", g = "." + f, h = ".data-api", i = a.fn[b], j = {
            ACTIVE: "active",
            BUTTON: "btn",
            FOCUS: "focus"
        }, k = {
            DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
            DATA_TOGGLE: '[data-toggle="buttons"]',
            INPUT: "input",
            ACTIVE: ".active",
            BUTTON: ".btn"
        }, l = {
            CLICK_DATA_API: "click" + g + h,
            FOCUS_BLUR_DATA_API: "focus" + g + h + " blur" + g + h
        }, m = function() {
            function b(a) {
                c(this, b), this._element = a;
            }
            return b.prototype.toggle = function() {
                var b = !0, c = a(this._element).closest(k.DATA_TOGGLE)[0];
                if (c) {
                    var d = a(this._element).find(k.INPUT)[0];
                    if (d) {
                        if ("radio" === d.type) if (d.checked && a(this._element).hasClass(j.ACTIVE)) b = !1; else {
                            var e = a(c).find(k.ACTIVE)[0];
                            e && a(e).removeClass(j.ACTIVE);
                        }
                        b && (d.checked = !a(this._element).hasClass(j.ACTIVE), a(this._element).trigger("change")), 
                        d.focus();
                    }
                } else this._element.setAttribute("aria-pressed", !a(this._element).hasClass(j.ACTIVE));
                b && a(this._element).toggleClass(j.ACTIVE);
            }, b.prototype.dispose = function() {
                a.removeData(this._element, f), this._element = null;
            }, b._jQueryInterface = function(c) {
                return this.each(function() {
                    var d = a(this).data(f);
                    d || (d = new b(this), a(this).data(f, d)), "toggle" === c && d[c]();
                });
            }, e(b, null, [ {
                key: "VERSION",
                get: function() {
                    return d;
                }
            } ]), b;
        }();
        a(document).on(l.CLICK_DATA_API, k.DATA_TOGGLE_CARROT, function(b) {
            b.preventDefault();
            var c = b.target;
            a(c).hasClass(j.BUTTON) || (c = a(c).closest(k.BUTTON)), m._jQueryInterface.call(a(c), "toggle");
        }).on(l.FOCUS_BLUR_DATA_API, k.DATA_TOGGLE_CARROT, function(b) {
            var c = a(b.target).closest(k.BUTTON)[0];
            a(c).toggleClass(j.FOCUS, /^focus(in)?$/.test(b.type));
        }), a.fn[b] = m._jQueryInterface, a.fn[b].Constructor = m, a.fn[b].noConflict = function() {
            return a.fn[b] = i, m._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "carousel", g = "4.0.0-alpha.5", h = "bs.carousel", i = "." + h, j = ".data-api", k = a.fn[b], l = 600, m = 37, n = 39, o = {
            interval: 5e3,
            keyboard: !0,
            slide: !1,
            pause: "hover",
            wrap: !0
        }, p = {
            interval: "(number|boolean)",
            keyboard: "boolean",
            slide: "(boolean|string)",
            pause: "(string|boolean)",
            wrap: "boolean"
        }, q = {
            NEXT: "next",
            PREVIOUS: "prev"
        }, r = {
            SLIDE: "slide" + i,
            SLID: "slid" + i,
            KEYDOWN: "keydown" + i,
            MOUSEENTER: "mouseenter" + i,
            MOUSELEAVE: "mouseleave" + i,
            LOAD_DATA_API: "load" + i + j,
            CLICK_DATA_API: "click" + i + j
        }, s = {
            CAROUSEL: "carousel",
            ACTIVE: "active",
            SLIDE: "slide",
            RIGHT: "right",
            LEFT: "left",
            ITEM: "carousel-item"
        }, t = {
            ACTIVE: ".active",
            ACTIVE_ITEM: ".active.carousel-item",
            ITEM: ".carousel-item",
            NEXT_PREV: ".next, .prev",
            INDICATORS: ".carousel-indicators",
            DATA_SLIDE: "[data-slide], [data-slide-to]",
            DATA_RIDE: '[data-ride="carousel"]'
        }, u = function() {
            function j(b, d) {
                c(this, j), this._items = null, this._interval = null, this._activeElement = null, 
                this._isPaused = !1, this._isSliding = !1, this._config = this._getConfig(d), this._element = a(b)[0], 
                this._indicatorsElement = a(this._element).find(t.INDICATORS)[0], this._addEventListeners();
            }
            return j.prototype.next = function() {
                this._isSliding || this._slide(q.NEXT);
            }, j.prototype.nextWhenVisible = function() {
                document.hidden || this.next();
            }, j.prototype.prev = function() {
                this._isSliding || this._slide(q.PREVIOUS);
            }, j.prototype.pause = function(b) {
                b || (this._isPaused = !0), a(this._element).find(t.NEXT_PREV)[0] && f.supportsTransitionEnd() && (f.triggerTransitionEnd(this._element), 
                this.cycle(!0)), clearInterval(this._interval), this._interval = null;
            }, j.prototype.cycle = function(b) {
                b || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), 
                this._config.interval && !this._isPaused && (this._interval = setInterval(a.proxy(document.visibilityState ? this.nextWhenVisible : this.next, this), this._config.interval));
            }, j.prototype.to = function(b) {
                var c = this;
                this._activeElement = a(this._element).find(t.ACTIVE_ITEM)[0];
                var d = this._getItemIndex(this._activeElement);
                if (!(b > this._items.length - 1 || b < 0)) {
                    if (this._isSliding) return void a(this._element).one(r.SLID, function() {
                        return c.to(b);
                    });
                    if (d === b) return this.pause(), void this.cycle();
                    var e = b > d ? q.NEXT : q.PREVIOUS;
                    this._slide(e, this._items[b]);
                }
            }, j.prototype.dispose = function() {
                a(this._element).off(i), a.removeData(this._element, h), this._items = null, this._config = null, 
                this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, 
                this._activeElement = null, this._indicatorsElement = null;
            }, j.prototype._getConfig = function(c) {
                return c = a.extend({}, o, c), f.typeCheckConfig(b, c, p), c;
            }, j.prototype._addEventListeners = function() {
                this._config.keyboard && a(this._element).on(r.KEYDOWN, a.proxy(this._keydown, this)), 
                "hover" !== this._config.pause || "ontouchstart" in document.documentElement || a(this._element).on(r.MOUSEENTER, a.proxy(this.pause, this)).on(r.MOUSELEAVE, a.proxy(this.cycle, this));
            }, j.prototype._keydown = function(a) {
                if (a.preventDefault(), !/input|textarea/i.test(a.target.tagName)) switch (a.which) {
                  case m:
                    this.prev();
                    break;

                  case n:
                    this.next();
                    break;

                  default:
                    return;
                }
            }, j.prototype._getItemIndex = function(b) {
                return this._items = a.makeArray(a(b).parent().find(t.ITEM)), this._items.indexOf(b);
            }, j.prototype._getItemByDirection = function(a, b) {
                var c = a === q.NEXT, d = a === q.PREVIOUS, e = this._getItemIndex(b), f = this._items.length - 1;
                if ((d && 0 === e || c && e === f) && !this._config.wrap) return b;
                var g = a === q.PREVIOUS ? -1 : 1, h = (e + g) % this._items.length;
                return -1 === h ? this._items[this._items.length - 1] : this._items[h];
            }, j.prototype._triggerSlideEvent = function(b, c) {
                var d = a.Event(r.SLIDE, {
                    relatedTarget: b,
                    direction: c
                });
                return a(this._element).trigger(d), d;
            }, j.prototype._setActiveIndicatorElement = function(b) {
                if (this._indicatorsElement) {
                    a(this._indicatorsElement).find(t.ACTIVE).removeClass(s.ACTIVE);
                    var c = this._indicatorsElement.children[this._getItemIndex(b)];
                    c && a(c).addClass(s.ACTIVE);
                }
            }, j.prototype._slide = function(b, c) {
                var d = this, e = a(this._element).find(t.ACTIVE_ITEM)[0], g = c || e && this._getItemByDirection(b, e), h = Boolean(this._interval), i = b === q.NEXT ? s.LEFT : s.RIGHT;
                if (g && a(g).hasClass(s.ACTIVE)) return void (this._isSliding = !1);
                if (!this._triggerSlideEvent(g, i).isDefaultPrevented() && e && g) {
                    this._isSliding = !0, h && this.pause(), this._setActiveIndicatorElement(g);
                    var j = a.Event(r.SLID, {
                        relatedTarget: g,
                        direction: i
                    });
                    f.supportsTransitionEnd() && a(this._element).hasClass(s.SLIDE) ? (a(g).addClass(b), 
                    f.reflow(g), a(e).addClass(i), a(g).addClass(i), a(e).one(f.TRANSITION_END, function() {
                        a(g).removeClass(i).removeClass(b), a(g).addClass(s.ACTIVE), a(e).removeClass(s.ACTIVE).removeClass(b).removeClass(i), 
                        d._isSliding = !1, setTimeout(function() {
                            return a(d._element).trigger(j);
                        }, 0);
                    }).emulateTransitionEnd(l)) : (a(e).removeClass(s.ACTIVE), a(g).addClass(s.ACTIVE), 
                    this._isSliding = !1, a(this._element).trigger(j)), h && this.cycle();
                }
            }, j._jQueryInterface = function(b) {
                return this.each(function() {
                    var c = a(this).data(h), e = a.extend({}, o, a(this).data());
                    "object" === (void 0 === b ? "undefined" : d(b)) && a.extend(e, b);
                    var f = "string" == typeof b ? b : e.slide;
                    if (c || (c = new j(this, e), a(this).data(h, c)), "number" == typeof b) c.to(b); else if ("string" == typeof f) {
                        if (void 0 === c[f]) throw new Error('No method named "' + f + '"');
                        c[f]();
                    } else e.interval && (c.pause(), c.cycle());
                });
            }, j._dataApiClickHandler = function(b) {
                var c = f.getSelectorFromElement(this);
                if (c) {
                    var d = a(c)[0];
                    if (d && a(d).hasClass(s.CAROUSEL)) {
                        var e = a.extend({}, a(d).data(), a(this).data()), g = this.getAttribute("data-slide-to");
                        g && (e.interval = !1), j._jQueryInterface.call(a(d), e), g && a(d).data(h).to(g), 
                        b.preventDefault();
                    }
                }
            }, e(j, null, [ {
                key: "VERSION",
                get: function() {
                    return g;
                }
            }, {
                key: "Default",
                get: function() {
                    return o;
                }
            } ]), j;
        }();
        a(document).on(r.CLICK_DATA_API, t.DATA_SLIDE, u._dataApiClickHandler), a(window).on(r.LOAD_DATA_API, function() {
            a(t.DATA_RIDE).each(function() {
                var b = a(this);
                u._jQueryInterface.call(b, b.data());
            });
        }), a.fn[b] = u._jQueryInterface, a.fn[b].Constructor = u, a.fn[b].noConflict = function() {
            return a.fn[b] = k, u._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "collapse", g = "4.0.0-alpha.5", h = "bs.collapse", i = "." + h, j = ".data-api", k = a.fn[b], l = 600, m = {
            toggle: !0,
            parent: ""
        }, n = {
            toggle: "boolean",
            parent: "string"
        }, o = {
            SHOW: "show" + i,
            SHOWN: "shown" + i,
            HIDE: "hide" + i,
            HIDDEN: "hidden" + i,
            CLICK_DATA_API: "click" + i + j
        }, p = {
            IN: "in",
            COLLAPSE: "collapse",
            COLLAPSING: "collapsing",
            COLLAPSED: "collapsed"
        }, q = {
            WIDTH: "width",
            HEIGHT: "height"
        }, r = {
            ACTIVES: ".card > .in, .card > .collapsing",
            DATA_TOGGLE: '[data-toggle="collapse"]'
        }, s = function() {
            function i(b, d) {
                c(this, i), this._isTransitioning = !1, this._element = b, this._config = this._getConfig(d), 
                this._triggerArray = a.makeArray(a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]')), 
                this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), 
                this._config.toggle && this.toggle();
            }
            return i.prototype.toggle = function() {
                a(this._element).hasClass(p.IN) ? this.hide() : this.show();
            }, i.prototype.show = function() {
                var b = this;
                if (!this._isTransitioning && !a(this._element).hasClass(p.IN)) {
                    var c = void 0, d = void 0;
                    if (this._parent && (c = a.makeArray(a(r.ACTIVES)), c.length || (c = null)), !(c && (d = a(c).data(h)) && d._isTransitioning)) {
                        var e = a.Event(o.SHOW);
                        if (a(this._element).trigger(e), !e.isDefaultPrevented()) {
                            c && (i._jQueryInterface.call(a(c), "hide"), d || a(c).data(h, null));
                            var g = this._getDimension();
                            a(this._element).removeClass(p.COLLAPSE).addClass(p.COLLAPSING), this._element.style[g] = 0, 
                            this._element.setAttribute("aria-expanded", !0), this._triggerArray.length && a(this._triggerArray).removeClass(p.COLLAPSED).attr("aria-expanded", !0), 
                            this.setTransitioning(!0);
                            var j = function() {
                                a(b._element).removeClass(p.COLLAPSING).addClass(p.COLLAPSE).addClass(p.IN), b._element.style[g] = "", 
                                b.setTransitioning(!1), a(b._element).trigger(o.SHOWN);
                            };
                            if (!f.supportsTransitionEnd()) return void j();
                            var k = g[0].toUpperCase() + g.slice(1), m = "scroll" + k;
                            a(this._element).one(f.TRANSITION_END, j).emulateTransitionEnd(l), this._element.style[g] = this._element[m] + "px";
                        }
                    }
                }
            }, i.prototype.hide = function() {
                var b = this;
                if (!this._isTransitioning && a(this._element).hasClass(p.IN)) {
                    var c = a.Event(o.HIDE);
                    if (a(this._element).trigger(c), !c.isDefaultPrevented()) {
                        var d = this._getDimension(), e = d === q.WIDTH ? "offsetWidth" : "offsetHeight";
                        this._element.style[d] = this._element[e] + "px", f.reflow(this._element), a(this._element).addClass(p.COLLAPSING).removeClass(p.COLLAPSE).removeClass(p.IN), 
                        this._element.setAttribute("aria-expanded", !1), this._triggerArray.length && a(this._triggerArray).addClass(p.COLLAPSED).attr("aria-expanded", !1), 
                        this.setTransitioning(!0);
                        var g = function() {
                            b.setTransitioning(!1), a(b._element).removeClass(p.COLLAPSING).addClass(p.COLLAPSE).trigger(o.HIDDEN);
                        };
                        return this._element.style[d] = "", f.supportsTransitionEnd() ? void a(this._element).one(f.TRANSITION_END, g).emulateTransitionEnd(l) : void g();
                    }
                }
            }, i.prototype.setTransitioning = function(a) {
                this._isTransitioning = a;
            }, i.prototype.dispose = function() {
                a.removeData(this._element, h), this._config = null, this._parent = null, this._element = null, 
                this._triggerArray = null, this._isTransitioning = null;
            }, i.prototype._getConfig = function(c) {
                return c = a.extend({}, m, c), c.toggle = Boolean(c.toggle), f.typeCheckConfig(b, c, n), 
                c;
            }, i.prototype._getDimension = function() {
                return a(this._element).hasClass(q.WIDTH) ? q.WIDTH : q.HEIGHT;
            }, i.prototype._getParent = function() {
                var b = this, c = a(this._config.parent)[0], d = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
                return a(c).find(d).each(function(a, c) {
                    b._addAriaAndCollapsedClass(i._getTargetFromElement(c), [ c ]);
                }), c;
            }, i.prototype._addAriaAndCollapsedClass = function(b, c) {
                if (b) {
                    var d = a(b).hasClass(p.IN);
                    b.setAttribute("aria-expanded", d), c.length && a(c).toggleClass(p.COLLAPSED, !d).attr("aria-expanded", d);
                }
            }, i._getTargetFromElement = function(b) {
                var c = f.getSelectorFromElement(b);
                return c ? a(c)[0] : null;
            }, i._jQueryInterface = function(b) {
                return this.each(function() {
                    var c = a(this), e = c.data(h), f = a.extend({}, m, c.data(), "object" === (void 0 === b ? "undefined" : d(b)) && b);
                    if (!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || (e = new i(this, f), 
                    c.data(h, e)), "string" == typeof b) {
                        if (void 0 === e[b]) throw new Error('No method named "' + b + '"');
                        e[b]();
                    }
                });
            }, e(i, null, [ {
                key: "VERSION",
                get: function() {
                    return g;
                }
            }, {
                key: "Default",
                get: function() {
                    return m;
                }
            } ]), i;
        }();
        a(document).on(o.CLICK_DATA_API, r.DATA_TOGGLE, function(b) {
            b.preventDefault();
            var c = s._getTargetFromElement(this), d = a(c).data(h), e = d ? "toggle" : a(this).data();
            s._jQueryInterface.call(a(c), e);
        }), a.fn[b] = s._jQueryInterface, a.fn[b].Constructor = s, a.fn[b].noConflict = function() {
            return a.fn[b] = k, s._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "dropdown", d = "4.0.0-alpha.5", g = "bs.dropdown", h = "." + g, i = ".data-api", j = a.fn[b], k = 27, l = 38, m = 40, n = 3, o = {
            HIDE: "hide" + h,
            HIDDEN: "hidden" + h,
            SHOW: "show" + h,
            SHOWN: "shown" + h,
            CLICK: "click" + h,
            CLICK_DATA_API: "click" + h + i,
            KEYDOWN_DATA_API: "keydown" + h + i
        }, p = {
            BACKDROP: "dropdown-backdrop",
            DISABLED: "disabled",
            OPEN: "open"
        }, q = {
            BACKDROP: ".dropdown-backdrop",
            DATA_TOGGLE: '[data-toggle="dropdown"]',
            FORM_CHILD: ".dropdown form",
            ROLE_MENU: '[role="menu"]',
            ROLE_LISTBOX: '[role="listbox"]',
            NAVBAR_NAV: ".navbar-nav",
            VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, [role="listbox"] li:not(.disabled) a'
        }, r = function() {
            function b(a) {
                c(this, b), this._element = a, this._addEventListeners();
            }
            return b.prototype.toggle = function() {
                if (this.disabled || a(this).hasClass(p.DISABLED)) return !1;
                var c = b._getParentFromElement(this), d = a(c).hasClass(p.OPEN);
                if (b._clearMenus(), d) return !1;
                if ("ontouchstart" in document.documentElement && !a(c).closest(q.NAVBAR_NAV).length) {
                    var e = document.createElement("div");
                    e.className = p.BACKDROP, a(e).insertBefore(this), a(e).on("click", b._clearMenus);
                }
                var f = {
                    relatedTarget: this
                }, g = a.Event(o.SHOW, f);
                return a(c).trigger(g), !g.isDefaultPrevented() && (this.focus(), this.setAttribute("aria-expanded", "true"), 
                a(c).toggleClass(p.OPEN), a(c).trigger(a.Event(o.SHOWN, f)), !1);
            }, b.prototype.dispose = function() {
                a.removeData(this._element, g), a(this._element).off(h), this._element = null;
            }, b.prototype._addEventListeners = function() {
                a(this._element).on(o.CLICK, this.toggle);
            }, b._jQueryInterface = function(c) {
                return this.each(function() {
                    var d = a(this).data(g);
                    if (d || a(this).data(g, d = new b(this)), "string" == typeof c) {
                        if (void 0 === d[c]) throw new Error('No method named "' + c + '"');
                        d[c].call(this);
                    }
                });
            }, b._clearMenus = function(c) {
                if (!c || c.which !== n) {
                    var d = a(q.BACKDROP)[0];
                    d && d.parentNode.removeChild(d);
                    for (var e = a.makeArray(a(q.DATA_TOGGLE)), f = 0; f < e.length; f++) {
                        var g = b._getParentFromElement(e[f]), h = {
                            relatedTarget: e[f]
                        };
                        if (a(g).hasClass(p.OPEN) && !(c && "click" === c.type && /input|textarea/i.test(c.target.tagName) && a.contains(g, c.target))) {
                            var i = a.Event(o.HIDE, h);
                            a(g).trigger(i), i.isDefaultPrevented() || (e[f].setAttribute("aria-expanded", "false"), 
                            a(g).removeClass(p.OPEN).trigger(a.Event(o.HIDDEN, h)));
                        }
                    }
                }
            }, b._getParentFromElement = function(b) {
                var c = void 0, d = f.getSelectorFromElement(b);
                return d && (c = a(d)[0]), c || b.parentNode;
            }, b._dataApiKeydownHandler = function(c) {
                if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName) && (c.preventDefault(), 
                c.stopPropagation(), !this.disabled && !a(this).hasClass(p.DISABLED))) {
                    var d = b._getParentFromElement(this), e = a(d).hasClass(p.OPEN);
                    if (!e && c.which !== k || e && c.which === k) {
                        if (c.which === k) {
                            var f = a(d).find(q.DATA_TOGGLE)[0];
                            a(f).trigger("focus");
                        }
                        return void a(this).trigger("click");
                    }
                    var g = a.makeArray(a(q.VISIBLE_ITEMS));
                    if (g = g.filter(function(a) {
                        return a.offsetWidth || a.offsetHeight;
                    }), g.length) {
                        var h = g.indexOf(c.target);
                        c.which === l && h > 0 && h--, c.which === m && h < g.length - 1 && h++, h < 0 && (h = 0), 
                        g[h].focus();
                    }
                }
            }, e(b, null, [ {
                key: "VERSION",
                get: function() {
                    return d;
                }
            } ]), b;
        }();
        a(document).on(o.KEYDOWN_DATA_API, q.DATA_TOGGLE, r._dataApiKeydownHandler).on(o.KEYDOWN_DATA_API, q.ROLE_MENU, r._dataApiKeydownHandler).on(o.KEYDOWN_DATA_API, q.ROLE_LISTBOX, r._dataApiKeydownHandler).on(o.CLICK_DATA_API, r._clearMenus).on(o.CLICK_DATA_API, q.DATA_TOGGLE, r.prototype.toggle).on(o.CLICK_DATA_API, q.FORM_CHILD, function(a) {
            a.stopPropagation();
        }), a.fn[b] = r._jQueryInterface, a.fn[b].Constructor = r, a.fn[b].noConflict = function() {
            return a.fn[b] = j, r._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "modal", g = "4.0.0-alpha.5", h = "bs.modal", i = "." + h, j = ".data-api", k = a.fn[b], l = 300, m = 150, n = 27, o = {
            backdrop: !0,
            keyboard: !0,
            focus: !0,
            show: !0
        }, p = {
            backdrop: "(boolean|string)",
            keyboard: "boolean",
            focus: "boolean",
            show: "boolean"
        }, q = {
            HIDE: "hide" + i,
            HIDDEN: "hidden" + i,
            SHOW: "show" + i,
            SHOWN: "shown" + i,
            FOCUSIN: "focusin" + i,
            RESIZE: "resize" + i,
            CLICK_DISMISS: "click.dismiss" + i,
            KEYDOWN_DISMISS: "keydown.dismiss" + i,
            MOUSEUP_DISMISS: "mouseup.dismiss" + i,
            MOUSEDOWN_DISMISS: "mousedown.dismiss" + i,
            CLICK_DATA_API: "click" + i + j
        }, r = {
            SCROLLBAR_MEASURER: "modal-scrollbar-measure",
            BACKDROP: "modal-backdrop",
            OPEN: "modal-open",
            FADE: "fade",
            IN: "in"
        }, s = {
            DIALOG: ".modal-dialog",
            DATA_TOGGLE: '[data-toggle="modal"]',
            DATA_DISMISS: '[data-dismiss="modal"]',
            FIXED_CONTENT: ".navbar-fixed-top, .navbar-fixed-bottom, .is-fixed"
        }, t = function() {
            function j(b, d) {
                c(this, j), this._config = this._getConfig(d), this._element = b, this._dialog = a(b).find(s.DIALOG)[0], 
                this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, 
                this._originalBodyPadding = 0, this._scrollbarWidth = 0;
            }
            return j.prototype.toggle = function(a) {
                return this._isShown ? this.hide() : this.show(a);
            }, j.prototype.show = function(b) {
                var c = this, d = a.Event(q.SHOW, {
                    relatedTarget: b
                });
                a(this._element).trigger(d), this._isShown || d.isDefaultPrevented() || (this._isShown = !0, 
                this._checkScrollbar(), this._setScrollbar(), a(document.body).addClass(r.OPEN), 
                this._setEscapeEvent(), this._setResizeEvent(), a(this._element).on(q.CLICK_DISMISS, s.DATA_DISMISS, a.proxy(this.hide, this)), 
                a(this._dialog).on(q.MOUSEDOWN_DISMISS, function() {
                    a(c._element).one(q.MOUSEUP_DISMISS, function(b) {
                        a(b.target).is(c._element) && (c._ignoreBackdropClick = !0);
                    });
                }), this._showBackdrop(a.proxy(this._showElement, this, b)));
            }, j.prototype.hide = function(b) {
                b && b.preventDefault();
                var c = a.Event(q.HIDE);
                a(this._element).trigger(c), this._isShown && !c.isDefaultPrevented() && (this._isShown = !1, 
                this._setEscapeEvent(), this._setResizeEvent(), a(document).off(q.FOCUSIN), a(this._element).removeClass(r.IN), 
                a(this._element).off(q.CLICK_DISMISS), a(this._dialog).off(q.MOUSEDOWN_DISMISS), 
                f.supportsTransitionEnd() && a(this._element).hasClass(r.FADE) ? a(this._element).one(f.TRANSITION_END, a.proxy(this._hideModal, this)).emulateTransitionEnd(l) : this._hideModal());
            }, j.prototype.dispose = function() {
                a.removeData(this._element, h), a(window).off(i), a(document).off(i), a(this._element).off(i), 
                a(this._backdrop).off(i), this._config = null, this._element = null, this._dialog = null, 
                this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, 
                this._originalBodyPadding = null, this._scrollbarWidth = null;
            }, j.prototype._getConfig = function(c) {
                return c = a.extend({}, o, c), f.typeCheckConfig(b, c, p), c;
            }, j.prototype._showElement = function(b) {
                var c = this, d = f.supportsTransitionEnd() && a(this._element).hasClass(r.FADE);
                this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), 
                this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), 
                this._element.scrollTop = 0, d && f.reflow(this._element), a(this._element).addClass(r.IN), 
                this._config.focus && this._enforceFocus();
                var e = a.Event(q.SHOWN, {
                    relatedTarget: b
                }), g = function() {
                    c._config.focus && c._element.focus(), a(c._element).trigger(e);
                };
                d ? a(this._dialog).one(f.TRANSITION_END, g).emulateTransitionEnd(l) : g();
            }, j.prototype._enforceFocus = function() {
                var b = this;
                a(document).off(q.FOCUSIN).on(q.FOCUSIN, function(c) {
                    document === c.target || b._element === c.target || a(b._element).has(c.target).length || b._element.focus();
                });
            }, j.prototype._setEscapeEvent = function() {
                var b = this;
                this._isShown && this._config.keyboard ? a(this._element).on(q.KEYDOWN_DISMISS, function(a) {
                    a.which === n && b.hide();
                }) : this._isShown || a(this._element).off(q.KEYDOWN_DISMISS);
            }, j.prototype._setResizeEvent = function() {
                this._isShown ? a(window).on(q.RESIZE, a.proxy(this._handleUpdate, this)) : a(window).off(q.RESIZE);
            }, j.prototype._hideModal = function() {
                var b = this;
                this._element.style.display = "none", this._element.setAttribute("aria-hidden", "true"), 
                this._showBackdrop(function() {
                    a(document.body).removeClass(r.OPEN), b._resetAdjustments(), b._resetScrollbar(), 
                    a(b._element).trigger(q.HIDDEN);
                });
            }, j.prototype._removeBackdrop = function() {
                this._backdrop && (a(this._backdrop).remove(), this._backdrop = null);
            }, j.prototype._showBackdrop = function(b) {
                var c = this, d = a(this._element).hasClass(r.FADE) ? r.FADE : "";
                if (this._isShown && this._config.backdrop) {
                    var e = f.supportsTransitionEnd() && d;
                    if (this._backdrop = document.createElement("div"), this._backdrop.className = r.BACKDROP, 
                    d && a(this._backdrop).addClass(d), a(this._backdrop).appendTo(document.body), a(this._element).on(q.CLICK_DISMISS, function(a) {
                        return c._ignoreBackdropClick ? void (c._ignoreBackdropClick = !1) : void (a.target === a.currentTarget && ("static" === c._config.backdrop ? c._element.focus() : c.hide()));
                    }), e && f.reflow(this._backdrop), a(this._backdrop).addClass(r.IN), !b) return;
                    if (!e) return void b();
                    a(this._backdrop).one(f.TRANSITION_END, b).emulateTransitionEnd(m);
                } else if (!this._isShown && this._backdrop) {
                    a(this._backdrop).removeClass(r.IN);
                    var g = function() {
                        c._removeBackdrop(), b && b();
                    };
                    f.supportsTransitionEnd() && a(this._element).hasClass(r.FADE) ? a(this._backdrop).one(f.TRANSITION_END, g).emulateTransitionEnd(m) : g();
                } else b && b();
            }, j.prototype._handleUpdate = function() {
                this._adjustDialog();
            }, j.prototype._adjustDialog = function() {
                var a = this._element.scrollHeight > document.documentElement.clientHeight;
                !this._isBodyOverflowing && a && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), 
                this._isBodyOverflowing && !a && (this._element.style.paddingRight = this._scrollbarWidth + "px");
            }, j.prototype._resetAdjustments = function() {
                this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
            }, j.prototype._checkScrollbar = function() {
                this._isBodyOverflowing = document.body.clientWidth < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth();
            }, j.prototype._setScrollbar = function() {
                var b = parseInt(a(s.FIXED_CONTENT).css("padding-right") || 0, 10);
                this._originalBodyPadding = document.body.style.paddingRight || "", this._isBodyOverflowing && (document.body.style.paddingRight = b + this._scrollbarWidth + "px");
            }, j.prototype._resetScrollbar = function() {
                document.body.style.paddingRight = this._originalBodyPadding;
            }, j.prototype._getScrollbarWidth = function() {
                var a = document.createElement("div");
                a.className = r.SCROLLBAR_MEASURER, document.body.appendChild(a);
                var b = a.offsetWidth - a.clientWidth;
                return document.body.removeChild(a), b;
            }, j._jQueryInterface = function(b, c) {
                return this.each(function() {
                    var e = a(this).data(h), f = a.extend({}, j.Default, a(this).data(), "object" === (void 0 === b ? "undefined" : d(b)) && b);
                    if (e || (e = new j(this, f), a(this).data(h, e)), "string" == typeof b) {
                        if (void 0 === e[b]) throw new Error('No method named "' + b + '"');
                        e[b](c);
                    } else f.show && e.show(c);
                });
            }, e(j, null, [ {
                key: "VERSION",
                get: function() {
                    return g;
                }
            }, {
                key: "Default",
                get: function() {
                    return o;
                }
            } ]), j;
        }();
        a(document).on(q.CLICK_DATA_API, s.DATA_TOGGLE, function(b) {
            var c = this, d = void 0, e = f.getSelectorFromElement(this);
            e && (d = a(e)[0]);
            var g = a(d).data(h) ? "toggle" : a.extend({}, a(d).data(), a(this).data());
            "A" === this.tagName && b.preventDefault();
            var i = a(d).one(q.SHOW, function(b) {
                b.isDefaultPrevented() || i.one(q.HIDDEN, function() {
                    a(c).is(":visible") && c.focus();
                });
            });
            t._jQueryInterface.call(a(d), g, this);
        }), a.fn[b] = t._jQueryInterface, a.fn[b].Constructor = t, a.fn[b].noConflict = function() {
            return a.fn[b] = k, t._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "scrollspy", g = "4.0.0-alpha.5", h = "bs.scrollspy", i = "." + h, j = ".data-api", k = a.fn[b], l = {
            offset: 10,
            method: "auto",
            target: ""
        }, m = {
            offset: "number",
            method: "string",
            target: "(string|element)"
        }, n = {
            ACTIVATE: "activate" + i,
            SCROLL: "scroll" + i,
            LOAD_DATA_API: "load" + i + j
        }, o = {
            DROPDOWN_ITEM: "dropdown-item",
            DROPDOWN_MENU: "dropdown-menu",
            NAV_LINK: "nav-link",
            NAV: "nav",
            ACTIVE: "active"
        }, p = {
            DATA_SPY: '[data-spy="scroll"]',
            ACTIVE: ".active",
            LIST_ITEM: ".list-item",
            LI: "li",
            LI_DROPDOWN: "li.dropdown",
            NAV_LINKS: ".nav-link",
            DROPDOWN: ".dropdown",
            DROPDOWN_ITEMS: ".dropdown-item",
            DROPDOWN_TOGGLE: ".dropdown-toggle"
        }, q = {
            OFFSET: "offset",
            POSITION: "position"
        }, r = function() {
            function j(b, d) {
                c(this, j), this._element = b, this._scrollElement = "BODY" === b.tagName ? window : b, 
                this._config = this._getConfig(d), this._selector = this._config.target + " " + p.NAV_LINKS + "," + this._config.target + " " + p.DROPDOWN_ITEMS, 
                this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, 
                a(this._scrollElement).on(n.SCROLL, a.proxy(this._process, this)), this.refresh(), 
                this._process();
            }
            return j.prototype.refresh = function() {
                var b = this, c = this._scrollElement !== this._scrollElement.window ? q.POSITION : q.OFFSET, d = "auto" === this._config.method ? c : this._config.method, e = d === q.POSITION ? this._getScrollTop() : 0;
                this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight(), 
                a.makeArray(a(this._selector)).map(function(b) {
                    var c = void 0, g = f.getSelectorFromElement(b);
                    return g && (c = a(g)[0]), c && (c.offsetWidth || c.offsetHeight) ? [ a(c)[d]().top + e, g ] : null;
                }).filter(function(a) {
                    return a;
                }).sort(function(a, b) {
                    return a[0] - b[0];
                }).forEach(function(a) {
                    b._offsets.push(a[0]), b._targets.push(a[1]);
                });
            }, j.prototype.dispose = function() {
                a.removeData(this._element, h), a(this._scrollElement).off(i), this._element = null, 
                this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, 
                this._targets = null, this._activeTarget = null, this._scrollHeight = null;
            }, j.prototype._getConfig = function(c) {
                if (c = a.extend({}, l, c), "string" != typeof c.target) {
                    var d = a(c.target).attr("id");
                    d || (d = f.getUID(b), a(c.target).attr("id", d)), c.target = "#" + d;
                }
                return f.typeCheckConfig(b, c, m), c;
            }, j.prototype._getScrollTop = function() {
                return this._scrollElement === window ? this._scrollElement.scrollY : this._scrollElement.scrollTop;
            }, j.prototype._getScrollHeight = function() {
                return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            }, j.prototype._process = function() {
                var a = this._getScrollTop() + this._config.offset, b = this._getScrollHeight(), c = this._config.offset + b - this._scrollElement.offsetHeight;
                if (this._scrollHeight !== b && this.refresh(), a >= c) {
                    var d = this._targets[this._targets.length - 1];
                    this._activeTarget !== d && this._activate(d);
                }
                if (this._activeTarget && a < this._offsets[0]) return this._activeTarget = null, 
                void this._clear();
                for (var e = this._offsets.length; e--; ) {
                    this._activeTarget !== this._targets[e] && a >= this._offsets[e] && (void 0 === this._offsets[e + 1] || a < this._offsets[e + 1]) && this._activate(this._targets[e]);
                }
            }, j.prototype._activate = function(b) {
                this._activeTarget = b, this._clear();
                var c = this._selector.split(",");
                c = c.map(function(a) {
                    return a + '[data-target="' + b + '"],' + a + '[href="' + b + '"]';
                });
                var d = a(c.join(","));
                d.hasClass(o.DROPDOWN_ITEM) ? (d.closest(p.DROPDOWN).find(p.DROPDOWN_TOGGLE).addClass(o.ACTIVE), 
                d.addClass(o.ACTIVE)) : d.parents(p.LI).find(p.NAV_LINKS).addClass(o.ACTIVE), a(this._scrollElement).trigger(n.ACTIVATE, {
                    relatedTarget: b
                });
            }, j.prototype._clear = function() {
                a(this._selector).filter(p.ACTIVE).removeClass(o.ACTIVE);
            }, j._jQueryInterface = function(b) {
                return this.each(function() {
                    var c = a(this).data(h), e = "object" === (void 0 === b ? "undefined" : d(b)) && b || null;
                    if (c || (c = new j(this, e), a(this).data(h, c)), "string" == typeof b) {
                        if (void 0 === c[b]) throw new Error('No method named "' + b + '"');
                        c[b]();
                    }
                });
            }, e(j, null, [ {
                key: "VERSION",
                get: function() {
                    return g;
                }
            }, {
                key: "Default",
                get: function() {
                    return l;
                }
            } ]), j;
        }();
        a(window).on(n.LOAD_DATA_API, function() {
            for (var b = a.makeArray(a(p.DATA_SPY)), c = b.length; c--; ) {
                var d = a(b[c]);
                r._jQueryInterface.call(d, d.data());
            }
        }), a.fn[b] = r._jQueryInterface, a.fn[b].Constructor = r, a.fn[b].noConflict = function() {
            return a.fn[b] = k, r._jQueryInterface;
        };
    }(jQuery), function(a) {
        var b = "tab", d = "4.0.0-alpha.5", g = "bs.tab", h = "." + g, i = ".data-api", j = a.fn[b], k = 150, l = {
            HIDE: "hide" + h,
            HIDDEN: "hidden" + h,
            SHOW: "show" + h,
            SHOWN: "shown" + h,
            CLICK_DATA_API: "click" + h + i
        }, m = {
            DROPDOWN_MENU: "dropdown-menu",
            ACTIVE: "active",
            FADE: "fade",
            IN: "in"
        }, n = {
            A: "a",
            LI: "li",
            DROPDOWN: ".dropdown",
            UL: "ul:not(.dropdown-menu)",
            FADE_CHILD: "> .nav-item .fade, > .fade",
            ACTIVE: ".active",
            ACTIVE_CHILD: "> .nav-item > .active, > .active",
            DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"]',
            DROPDOWN_TOGGLE: ".dropdown-toggle",
            DROPDOWN_ACTIVE_CHILD: "> .dropdown-menu .active"
        }, o = function() {
            function b(a) {
                c(this, b), this._element = a;
            }
            return b.prototype.show = function() {
                var b = this;
                if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE || !a(this._element).hasClass(m.ACTIVE)) {
                    var c = void 0, d = void 0, e = a(this._element).closest(n.UL)[0], g = f.getSelectorFromElement(this._element);
                    e && (d = a.makeArray(a(e).find(n.ACTIVE)), d = d[d.length - 1]);
                    var h = a.Event(l.HIDE, {
                        relatedTarget: this._element
                    }), i = a.Event(l.SHOW, {
                        relatedTarget: d
                    });
                    if (d && a(d).trigger(h), a(this._element).trigger(i), !i.isDefaultPrevented() && !h.isDefaultPrevented()) {
                        g && (c = a(g)[0]), this._activate(this._element, e);
                        var j = function() {
                            var c = a.Event(l.HIDDEN, {
                                relatedTarget: b._element
                            }), e = a.Event(l.SHOWN, {
                                relatedTarget: d
                            });
                            a(d).trigger(c), a(b._element).trigger(e);
                        };
                        c ? this._activate(c, c.parentNode, j) : j();
                    }
                }
            }, b.prototype.dispose = function() {
                a.removeClass(this._element, g), this._element = null;
            }, b.prototype._activate = function(b, c, d) {
                var e = a(c).find(n.ACTIVE_CHILD)[0], g = d && f.supportsTransitionEnd() && (e && a(e).hasClass(m.FADE) || Boolean(a(c).find(n.FADE_CHILD)[0])), h = a.proxy(this._transitionComplete, this, b, e, g, d);
                e && g ? a(e).one(f.TRANSITION_END, h).emulateTransitionEnd(k) : h(), e && a(e).removeClass(m.IN);
            }, b.prototype._transitionComplete = function(b, c, d, e) {
                if (c) {
                    a(c).removeClass(m.ACTIVE);
                    var g = a(c).find(n.DROPDOWN_ACTIVE_CHILD)[0];
                    g && a(g).removeClass(m.ACTIVE), c.setAttribute("aria-expanded", !1);
                }
                if (a(b).addClass(m.ACTIVE), b.setAttribute("aria-expanded", !0), d ? (f.reflow(b), 
                a(b).addClass(m.IN)) : a(b).removeClass(m.FADE), b.parentNode && a(b.parentNode).hasClass(m.DROPDOWN_MENU)) {
                    var h = a(b).closest(n.DROPDOWN)[0];
                    h && a(h).find(n.DROPDOWN_TOGGLE).addClass(m.ACTIVE), b.setAttribute("aria-expanded", !0);
                }
                e && e();
            }, b._jQueryInterface = function(c) {
                return this.each(function() {
                    var d = a(this), e = d.data(g);
                    if (e || (e = e = new b(this), d.data(g, e)), "string" == typeof c) {
                        if (void 0 === e[c]) throw new Error('No method named "' + c + '"');
                        e[c]();
                    }
                });
            }, e(b, null, [ {
                key: "VERSION",
                get: function() {
                    return d;
                }
            } ]), b;
        }();
        a(document).on(l.CLICK_DATA_API, n.DATA_TOGGLE, function(b) {
            b.preventDefault(), o._jQueryInterface.call(a(this), "show");
        }), a.fn[b] = o._jQueryInterface, a.fn[b].Constructor = o, a.fn[b].noConflict = function() {
            return a.fn[b] = j, o._jQueryInterface;
        };
    }(jQuery), function(a) {
        if (void 0 === window.Tether) throw new Error("Bootstrap tooltips require Tether (http://tether.io/)");
        var b = "tooltip", g = "4.0.0-alpha.5", h = "bs.tooltip", i = "." + h, j = a.fn[b], k = 150, l = "bs-tether", m = {
            animation: !0,
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: !1,
            selector: !1,
            placement: "top",
            offset: "0 0",
            constraints: []
        }, n = {
            animation: "boolean",
            template: "string",
            title: "(string|element|function)",
            trigger: "string",
            delay: "(number|object)",
            html: "boolean",
            selector: "(string|boolean)",
            placement: "(string|function)",
            offset: "string",
            constraints: "array"
        }, o = {
            TOP: "bottom center",
            RIGHT: "middle left",
            BOTTOM: "top center",
            LEFT: "middle right"
        }, p = {
            IN: "in",
            OUT: "out"
        }, q = {
            HIDE: "hide" + i,
            HIDDEN: "hidden" + i,
            SHOW: "show" + i,
            SHOWN: "shown" + i,
            INSERTED: "inserted" + i,
            CLICK: "click" + i,
            FOCUSIN: "focusin" + i,
            FOCUSOUT: "focusout" + i,
            MOUSEENTER: "mouseenter" + i,
            MOUSELEAVE: "mouseleave" + i
        }, r = {
            FADE: "fade",
            IN: "in"
        }, s = {
            TOOLTIP: ".tooltip",
            TOOLTIP_INNER: ".tooltip-inner"
        }, t = {
            element: !1,
            enabled: !1
        }, u = {
            HOVER: "hover",
            FOCUS: "focus",
            CLICK: "click",
            MANUAL: "manual"
        }, v = function() {
            function j(a, b) {
                c(this, j), this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, 
                this._tether = null, this.element = a, this.config = this._getConfig(b), this.tip = null, 
                this._setListeners();
            }
            return j.prototype.enable = function() {
                this._isEnabled = !0;
            }, j.prototype.disable = function() {
                this._isEnabled = !1;
            }, j.prototype.toggleEnabled = function() {
                this._isEnabled = !this._isEnabled;
            }, j.prototype.toggle = function(b) {
                if (b) {
                    var c = this.constructor.DATA_KEY, d = a(b.currentTarget).data(c);
                    d || (d = new this.constructor(b.currentTarget, this._getDelegateConfig()), a(b.currentTarget).data(c, d)), 
                    d._activeTrigger.click = !d._activeTrigger.click, d._isWithActiveTrigger() ? d._enter(null, d) : d._leave(null, d);
                } else {
                    if (a(this.getTipElement()).hasClass(r.IN)) return void this._leave(null, this);
                    this._enter(null, this);
                }
            }, j.prototype.dispose = function() {
                clearTimeout(this._timeout), this.cleanupTether(), a.removeData(this.element, this.constructor.DATA_KEY), 
                a(this.element).off(this.constructor.EVENT_KEY), this.tip && a(this.tip).remove(), 
                this._isEnabled = null, this._timeout = null, this._hoverState = null, this._activeTrigger = null, 
                this._tether = null, this.element = null, this.config = null, this.tip = null;
            }, j.prototype.show = function() {
                var b = this, c = a.Event(this.constructor.Event.SHOW);
                if (this.isWithContent() && this._isEnabled) {
                    a(this.element).trigger(c);
                    var d = a.contains(this.element.ownerDocument.documentElement, this.element);
                    if (c.isDefaultPrevented() || !d) return;
                    var e = this.getTipElement(), g = f.getUID(this.constructor.NAME);
                    e.setAttribute("id", g), this.element.setAttribute("aria-describedby", g), this.setContent(), 
                    this.config.animation && a(e).addClass(r.FADE);
                    var h = "function" == typeof this.config.placement ? this.config.placement.call(this, e, this.element) : this.config.placement, i = this._getAttachment(h);
                    a(e).data(this.constructor.DATA_KEY, this).appendTo(document.body), a(this.element).trigger(this.constructor.Event.INSERTED), 
                    this._tether = new Tether({
                        attachment: i,
                        element: e,
                        target: this.element,
                        classes: t,
                        classPrefix: l,
                        offset: this.config.offset,
                        constraints: this.config.constraints,
                        addTargetClasses: !1
                    }), f.reflow(e), this._tether.position(), a(e).addClass(r.IN);
                    var k = function() {
                        var c = b._hoverState;
                        b._hoverState = null, a(b.element).trigger(b.constructor.Event.SHOWN), c === p.OUT && b._leave(null, b);
                    };
                    if (f.supportsTransitionEnd() && a(this.tip).hasClass(r.FADE)) return void a(this.tip).one(f.TRANSITION_END, k).emulateTransitionEnd(j._TRANSITION_DURATION);
                    k();
                }
            }, j.prototype.hide = function(b) {
                var c = this, d = this.getTipElement(), e = a.Event(this.constructor.Event.HIDE), g = function() {
                    c._hoverState !== p.IN && d.parentNode && d.parentNode.removeChild(d), c.element.removeAttribute("aria-describedby"), 
                    a(c.element).trigger(c.constructor.Event.HIDDEN), c.cleanupTether(), b && b();
                };
                a(this.element).trigger(e), e.isDefaultPrevented() || (a(d).removeClass(r.IN), f.supportsTransitionEnd() && a(this.tip).hasClass(r.FADE) ? a(d).one(f.TRANSITION_END, g).emulateTransitionEnd(k) : g(), 
                this._hoverState = "");
            }, j.prototype.isWithContent = function() {
                return Boolean(this.getTitle());
            }, j.prototype.getTipElement = function() {
                return this.tip = this.tip || a(this.config.template)[0];
            }, j.prototype.setContent = function() {
                var b = a(this.getTipElement());
                this.setElementContent(b.find(s.TOOLTIP_INNER), this.getTitle()), b.removeClass(r.FADE).removeClass(r.IN), 
                this.cleanupTether();
            }, j.prototype.setElementContent = function(b, c) {
                var e = this.config.html;
                "object" === (void 0 === c ? "undefined" : d(c)) && (c.nodeType || c.jquery) ? e ? a(c).parent().is(b) || b.empty().append(c) : b.text(a(c).text()) : b[e ? "html" : "text"](c);
            }, j.prototype.getTitle = function() {
                var a = this.element.getAttribute("data-original-title");
                return a || (a = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), 
                a;
            }, j.prototype.cleanupTether = function() {
                this._tether && this._tether.destroy();
            }, j.prototype._getAttachment = function(a) {
                return o[a.toUpperCase()];
            }, j.prototype._setListeners = function() {
                var b = this;
                this.config.trigger.split(" ").forEach(function(c) {
                    if ("click" === c) a(b.element).on(b.constructor.Event.CLICK, b.config.selector, a.proxy(b.toggle, b)); else if (c !== u.MANUAL) {
                        var d = c === u.HOVER ? b.constructor.Event.MOUSEENTER : b.constructor.Event.FOCUSIN, e = c === u.HOVER ? b.constructor.Event.MOUSELEAVE : b.constructor.Event.FOCUSOUT;
                        a(b.element).on(d, b.config.selector, a.proxy(b._enter, b)).on(e, b.config.selector, a.proxy(b._leave, b));
                    }
                }), this.config.selector ? this.config = a.extend({}, this.config, {
                    trigger: "manual",
                    selector: ""
                }) : this._fixTitle();
            }, j.prototype._fixTitle = function() {
                var a = d(this.element.getAttribute("data-original-title"));
                (this.element.getAttribute("title") || "string" !== a) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), 
                this.element.setAttribute("title", ""));
            }, j.prototype._enter = function(b, c) {
                var d = this.constructor.DATA_KEY;
                return c = c || a(b.currentTarget).data(d), c || (c = new this.constructor(b.currentTarget, this._getDelegateConfig()), 
                a(b.currentTarget).data(d, c)), b && (c._activeTrigger["focusin" === b.type ? u.FOCUS : u.HOVER] = !0), 
                a(c.getTipElement()).hasClass(r.IN) || c._hoverState === p.IN ? void (c._hoverState = p.IN) : (clearTimeout(c._timeout), 
                c._hoverState = p.IN, c.config.delay && c.config.delay.show ? void (c._timeout = setTimeout(function() {
                    c._hoverState === p.IN && c.show();
                }, c.config.delay.show)) : void c.show());
            }, j.prototype._leave = function(b, c) {
                var d = this.constructor.DATA_KEY;
                if (c = c || a(b.currentTarget).data(d), c || (c = new this.constructor(b.currentTarget, this._getDelegateConfig()), 
                a(b.currentTarget).data(d, c)), b && (c._activeTrigger["focusout" === b.type ? u.FOCUS : u.HOVER] = !1), 
                !c._isWithActiveTrigger()) return clearTimeout(c._timeout), c._hoverState = p.OUT, 
                c.config.delay && c.config.delay.hide ? void (c._timeout = setTimeout(function() {
                    c._hoverState === p.OUT && c.hide();
                }, c.config.delay.hide)) : void c.hide();
            }, j.prototype._isWithActiveTrigger = function() {
                for (var a in this._activeTrigger) if (this._activeTrigger[a]) return !0;
                return !1;
            }, j.prototype._getConfig = function(c) {
                return c = a.extend({}, this.constructor.Default, a(this.element).data(), c), c.delay && "number" == typeof c.delay && (c.delay = {
                    show: c.delay,
                    hide: c.delay
                }), f.typeCheckConfig(b, c, this.constructor.DefaultType), c;
            }, j.prototype._getDelegateConfig = function() {
                var a = {};
                if (this.config) for (var b in this.config) this.constructor.Default[b] !== this.config[b] && (a[b] = this.config[b]);
                return a;
            }, j._jQueryInterface = function(b) {
                return this.each(function() {
                    var c = a(this).data(h), e = "object" === (void 0 === b ? "undefined" : d(b)) ? b : null;
                    if ((c || !/dispose|hide/.test(b)) && (c || (c = new j(this, e), a(this).data(h, c)), 
                    "string" == typeof b)) {
                        if (void 0 === c[b]) throw new Error('No method named "' + b + '"');
                        c[b]();
                    }
                });
            }, e(j, null, [ {
                key: "VERSION",
                get: function() {
                    return g;
                }
            }, {
                key: "Default",
                get: function() {
                    return m;
                }
            }, {
                key: "NAME",
                get: function() {
                    return b;
                }
            }, {
                key: "DATA_KEY",
                get: function() {
                    return h;
                }
            }, {
                key: "Event",
                get: function() {
                    return q;
                }
            }, {
                key: "EVENT_KEY",
                get: function() {
                    return i;
                }
            }, {
                key: "DefaultType",
                get: function() {
                    return n;
                }
            } ]), j;
        }();
        return a.fn[b] = v._jQueryInterface, a.fn[b].Constructor = v, a.fn[b].noConflict = function() {
            return a.fn[b] = j, v._jQueryInterface;
        }, v;
    }(jQuery));
    !function(f) {
        var h = "popover", i = "4.0.0-alpha.5", j = "bs.popover", k = "." + j, l = f.fn[h], m = f.extend({}, g.Default, {
            placement: "right",
            trigger: "click",
            content: "",
            template: '<div class="popover" role="tooltip"><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
        }), n = f.extend({}, g.DefaultType, {
            content: "(string|element|function)"
        }), o = {
            FADE: "fade",
            IN: "in"
        }, p = {
            TITLE: ".popover-title",
            CONTENT: ".popover-content"
        }, q = {
            HIDE: "hide" + k,
            HIDDEN: "hidden" + k,
            SHOW: "show" + k,
            SHOWN: "shown" + k,
            INSERTED: "inserted" + k,
            CLICK: "click" + k,
            FOCUSIN: "focusin" + k,
            FOCUSOUT: "focusout" + k,
            MOUSEENTER: "mouseenter" + k,
            MOUSELEAVE: "mouseleave" + k
        }, r = function(g) {
            function l() {
                return c(this, l), a(this, g.apply(this, arguments));
            }
            return b(l, g), l.prototype.isWithContent = function() {
                return this.getTitle() || this._getContent();
            }, l.prototype.getTipElement = function() {
                return this.tip = this.tip || f(this.config.template)[0];
            }, l.prototype.setContent = function() {
                var a = f(this.getTipElement());
                this.setElementContent(a.find(p.TITLE), this.getTitle()), this.setElementContent(a.find(p.CONTENT), this._getContent()), 
                a.removeClass(o.FADE).removeClass(o.IN), this.cleanupTether();
            }, l.prototype._getContent = function() {
                return this.element.getAttribute("data-content") || ("function" == typeof this.config.content ? this.config.content.call(this.element) : this.config.content);
            }, l._jQueryInterface = function(a) {
                return this.each(function() {
                    var b = f(this).data(j), c = "object" === (void 0 === a ? "undefined" : d(a)) ? a : null;
                    if ((b || !/destroy|hide/.test(a)) && (b || (b = new l(this, c), f(this).data(j, b)), 
                    "string" == typeof a)) {
                        if (void 0 === b[a]) throw new Error('No method named "' + a + '"');
                        b[a]();
                    }
                });
            }, e(l, null, [ {
                key: "VERSION",
                get: function() {
                    return i;
                }
            }, {
                key: "Default",
                get: function() {
                    return m;
                }
            }, {
                key: "NAME",
                get: function() {
                    return h;
                }
            }, {
                key: "DATA_KEY",
                get: function() {
                    return j;
                }
            }, {
                key: "Event",
                get: function() {
                    return q;
                }
            }, {
                key: "EVENT_KEY",
                get: function() {
                    return k;
                }
            }, {
                key: "DefaultType",
                get: function() {
                    return n;
                }
            } ]), l;
        }(g);
        f.fn[h] = r._jQueryInterface, f.fn[h].Constructor = r, f.fn[h].noConflict = function() {
            return f.fn[h] = l, r._jQueryInterface;
        };
    }(jQuery);
}(), function(a, b) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? module.exports = b() : a.EvEmitter = b();
}("undefined" != typeof window ? window : this, function() {
    function a() {}
    var b = a.prototype;
    return b.on = function(a, b) {
        if (a && b) {
            var c = this._events = this._events || {}, d = c[a] = c[a] || [];
            return -1 == d.indexOf(b) && d.push(b), this;
        }
    }, b.once = function(a, b) {
        if (a && b) {
            this.on(a, b);
            var c = this._onceEvents = this._onceEvents || {};
            return (c[a] = c[a] || {})[b] = !0, this;
        }
    }, b.off = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            var d = c.indexOf(b);
            return -1 != d && c.splice(d, 1), this;
        }
    }, b.emitEvent = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            var d = 0, e = c[d];
            b = b || [];
            for (var f = this._onceEvents && this._onceEvents[a]; e; ) {
                var g = f && f[e];
                g && (this.off(a, e), delete f[e]), e.apply(this, b), d += g ? 0 : 1, e = c[d];
            }
            return this;
        }
    }, a;
}), function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define([ "ev-emitter/ev-emitter" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("ev-emitter")) : a.imagesLoaded = b(a, a.EvEmitter);
}(window, function(a, b) {
    function c(a, b) {
        for (var c in b) a[c] = b[c];
        return a;
    }
    function d(a) {
        var b = [];
        if (Array.isArray(a)) b = a; else if ("number" == typeof a.length) for (var c = 0; c < a.length; c++) b.push(a[c]); else b.push(a);
        return b;
    }
    function e(a, b, f) {
        return this instanceof e ? ("string" == typeof a && (a = document.querySelectorAll(a)), 
        this.elements = d(a), this.options = c({}, this.options), "function" == typeof b ? f = b : c(this.options, b), 
        f && this.on("always", f), this.getImages(), h && (this.jqDeferred = new h.Deferred()), 
        void setTimeout(function() {
            this.check();
        }.bind(this))) : new e(a, b, f);
    }
    function f(a) {
        this.img = a;
    }
    function g(a, b) {
        this.url = a, this.element = b, this.img = new Image();
    }
    var h = a.jQuery, i = a.console;
    e.prototype = Object.create(b.prototype), e.prototype.options = {}, e.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this);
    }, e.prototype.addElementImages = function(a) {
        "IMG" == a.nodeName && this.addImage(a), !0 === this.options.background && this.addElementBackgroundImages(a);
        var b = a.nodeType;
        if (b && j[b]) {
            for (var c = a.querySelectorAll("img"), d = 0; d < c.length; d++) {
                var e = c[d];
                this.addImage(e);
            }
            if ("string" == typeof this.options.background) {
                var f = a.querySelectorAll(this.options.background);
                for (d = 0; d < f.length; d++) {
                    var g = f[d];
                    this.addElementBackgroundImages(g);
                }
            }
        }
    };
    var j = {
        1: !0,
        9: !0,
        11: !0
    };
    return e.prototype.addElementBackgroundImages = function(a) {
        var b = getComputedStyle(a);
        if (b) for (var c = /url\((['"])?(.*?)\1\)/gi, d = c.exec(b.backgroundImage); null !== d; ) {
            var e = d && d[2];
            e && this.addBackground(e, a), d = c.exec(b.backgroundImage);
        }
    }, e.prototype.addImage = function(a) {
        var b = new f(a);
        this.images.push(b);
    }, e.prototype.addBackground = function(a, b) {
        var c = new g(a, b);
        this.images.push(c);
    }, e.prototype.check = function() {
        function a(a, c, d) {
            setTimeout(function() {
                b.progress(a, c, d);
            });
        }
        var b = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(b) {
            b.once("progress", a), b.check();
        }) : void this.complete();
    }, e.prototype.progress = function(a, b, c) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !a.isLoaded, this.emitEvent("progress", [ this, a, b ]), 
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, a), this.progressedCount == this.images.length && this.complete(), 
        this.options.debug && i && i.log("progress: " + c, a, b);
    }, e.prototype.complete = function() {
        var a = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(a, [ this ]), this.emitEvent("always", [ this ]), 
        this.jqDeferred) {
            var b = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[b](this);
        }
    }, f.prototype = Object.create(b.prototype), f.prototype.check = function() {
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), 
        this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), 
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        void (this.proxyImage.src = this.img.src));
    }, f.prototype.getIsImageComplete = function() {
        return this.img.complete && void 0 !== this.img.naturalWidth;
    }, f.prototype.confirm = function(a, b) {
        this.isLoaded = a, this.emitEvent("progress", [ this, this.img, b ]);
    }, f.prototype.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a);
    }, f.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents();
    }, f.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents();
    }, f.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), 
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, g.prototype = Object.create(f.prototype), g.prototype.check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), 
        this.unbindEvents());
    }, g.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, g.prototype.confirm = function(a, b) {
        this.isLoaded = a, this.emitEvent("progress", [ this, this.element, b ]);
    }, e.makeJQueryPlugin = function(b) {
        (b = b || a.jQuery) && (h = b, h.fn.imagesLoaded = function(a, b) {
            return new e(this, a, b).jqDeferred.promise(h(this));
        });
    }, e.makeJQueryPlugin(), e;
}), function(a) {
    function b(b, c) {
        var d, e = this, f = window.navigator, g = f.userAgent.toLowerCase();
        e.uid = a.rsModules.uid++, e.ns = ".rs" + e.uid;
        var h, i = document.createElement("div").style, j = [ "webkit", "Moz", "ms", "O" ], k = "", l = 0;
        for (d = 0; d < j.length; d++) h = j[d], !k && h + "Transform" in i && (k = h), 
        h = h.toLowerCase(), window.requestAnimationFrame || (window.requestAnimationFrame = window[h + "RequestAnimationFrame"], 
        window.cancelAnimationFrame = window[h + "CancelAnimationFrame"] || window[h + "CancelRequestAnimationFrame"]);
        window.requestAnimationFrame || (window.requestAnimationFrame = function(a, b) {
            var c = new Date().getTime(), d = Math.max(0, 16 - (c - l)), e = window.setTimeout(function() {
                a(c + d);
            }, d);
            return l = c + d, e;
        }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(a) {
            clearTimeout(a);
        }), e.isIPAD = g.match(/(ipad)/), e.isIOS = e.isIPAD || g.match(/(iphone|ipod)/), 
        d = function(a) {
            return a = /(chrome)[ \/]([\w.]+)/.exec(a) || /(webkit)[ \/]([\w.]+)/.exec(a) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) || /(msie) ([\w.]+)/.exec(a) || 0 > a.indexOf("compatible") && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a) || [], 
            {
                browser: a[1] || "",
                version: a[2] || "0"
            };
        }(g), j = {}, d.browser && (j[d.browser] = !0, j.version = d.version), j.chrome && (j.webkit = !0), 
        e._a = j, e.isAndroid = -1 < g.indexOf("android"), e.slider = a(b), e.ev = a(e), 
        e._b = a(document), e.st = a.extend({}, a.fn.royalSlider.defaults, c), e._c = e.st.transitionSpeed, 
        e._d = 0, !e.st.allowCSS3 || j.webkit && !e.st.allowCSS3OnWebkit || (d = k + (k ? "T" : "t"), 
        e._e = d + "ransform" in i && d + "ransition" in i, e._e && (e._f = k + (k ? "P" : "p") + "erspective" in i)), 
        k = k.toLowerCase(), e._g = "-" + k + "-", e._h = "vertical" !== e.st.slidesOrientation, 
        e._i = e._h ? "left" : "top", e._j = e._h ? "width" : "height", e._k = -1, e._l = "fade" !== e.st.transitionType, 
        e._l || (e.st.sliderDrag = !1, e._m = 10), e._n = "z-index:0; display:none; opacity:0;", 
        e._o = 0, e._p = 0, e._q = 0, a.each(a.rsModules, function(a, b) {
            "uid" !== a && b.call(e);
        }), e.slides = [], e._r = 0, (e.st.slides ? a(e.st.slides) : e.slider.children().detach()).each(function() {
            e._s(this, !0);
        }), e.st.randomizeSlides && e.slides.sort(function() {
            return .5 - Math.random();
        }), e.numSlides = e.slides.length, e._t(), e.st.startSlideId ? e.st.startSlideId > e.numSlides - 1 && (e.st.startSlideId = e.numSlides - 1) : e.st.startSlideId = 0, 
        e._o = e.staticSlideId = e.currSlideId = e._u = e.st.startSlideId, e.currSlide = e.slides[e.currSlideId], 
        e._v = 0, e.pointerMultitouch = !1, e.slider.addClass((e._h ? "rsHor" : "rsVer") + (e._l ? "" : " rsFade")), 
        i = '<div class="rsOverflow"><div class="rsContainer">', e.slidesSpacing = e.st.slidesSpacing, 
        e._w = (e._h ? e.slider.width() : e.slider.height()) + e.st.slidesSpacing, e._x = Boolean(0 < e._y), 
        1 >= e.numSlides && (e._z = !1), e._a1 = e._z && e._l ? 2 === e.numSlides ? 1 : 2 : 0, 
        e._b1 = 6 > e.numSlides ? e.numSlides : 6, e._c1 = 0, e._d1 = 0, e.slidesJQ = [];
        for (d = 0; d < e.numSlides; d++) e.slidesJQ.push(a('<div style="' + (e._l ? "" : d !== e.currSlideId ? e._n : "z-index:0;") + '" class="rsSlide "></div>'));
        e._e1 = i = a(i + "</div></div>");
        var m = e.ns, k = function(a, b, c, d, f) {
            e._j1 = a + b + m, e._k1 = a + c + m, e._l1 = a + d + m, f && (e._m1 = a + f + m);
        };
        d = f.pointerEnabled, e.pointerEnabled = d || f.msPointerEnabled, e.pointerEnabled ? (e.hasTouch = !1, 
        e._n1 = .2, e.pointerMultitouch = Boolean(1 < f[(d ? "m" : "msM") + "axTouchPoints"]), 
        d ? k("pointer", "down", "move", "up", "cancel") : k("MSPointer", "Down", "Move", "Up", "Cancel")) : (e.isIOS ? e._j1 = e._k1 = e._l1 = e._m1 = "" : k("mouse", "down", "move", "up"), 
        "ontouchstart" in window || "createTouch" in document ? (e.hasTouch = !0, e._j1 += " touchstart" + m, 
        e._k1 += " touchmove" + m, e._l1 += " touchend" + m, e._m1 += " touchcancel" + m, 
        e._n1 = .5, e.st.sliderTouch && (e._f1 = !0)) : (e.hasTouch = !1, e._n1 = .2)), 
        e.st.sliderDrag && (e._f1 = !0, j.msie || j.opera ? e._g1 = e._h1 = "move" : j.mozilla ? (e._g1 = "-moz-grab", 
        e._h1 = "-moz-grabbing") : j.webkit && -1 != f.platform.indexOf("Mac") && (e._g1 = "-webkit-grab", 
        e._h1 = "-webkit-grabbing"), e._i1()), e.slider.html(i), e._o1 = e.st.controlsInside ? e._e1 : e.slider, 
        e._p1 = e._e1.children(".rsContainer"), e.pointerEnabled && e._p1.css((d ? "" : "-ms-") + "touch-action", e._h ? "pan-y" : "pan-x"), 
        e._q1 = a('<div class="rsPreloader"></div>'), f = e._p1.children(".rsSlide"), e._r1 = e.slidesJQ[e.currSlideId], 
        e._s1 = 0, e._e ? (e._t1 = "transition-property", e._u1 = "transition-duration", 
        e._v1 = "transition-timing-function", e._w1 = e._x1 = e._g + "transform", e._f ? (j.webkit && !j.chrome && e.slider.addClass("rsWebkit3d"), 
        e._y1 = "translate3d(", e._z1 = "px, ", e._a2 = "px, 0px)") : (e._y1 = "translate(", 
        e._z1 = "px, ", e._a2 = "px)"), e._l ? e._p1[e._g + e._t1] = e._g + "transform" : (j = {}, 
        j[e._g + e._t1] = "opacity", j[e._g + e._u1] = e.st.transitionSpeed + "ms", j[e._g + e._v1] = e.st.css3easeInOut, 
        f.css(j))) : (e._x1 = "left", e._w1 = "top");
        var n;
        a(window).on("resize" + e.ns, function() {
            n && clearTimeout(n), n = setTimeout(function() {
                e.updateSliderSize();
            }, 50);
        }), e.ev.trigger("rsAfterPropsSetup"), e.updateSliderSize(), e.st.keyboardNavEnabled && e._b2(), 
        e.st.arrowsNavHideOnTouch && (e.hasTouch || e.pointerMultitouch) && (e.st.arrowsNav = !1), 
        e.st.arrowsNav && (f = e._o1, a('<div class="rsArrow rsArrowLeft"><div class="rsArrowIcn"></div></div><div class="rsArrow rsArrowRight"><div class="rsArrowIcn"></div></div>').appendTo(f), 
        e._c2 = f.children(".rsArrowLeft").click(function(a) {
            a.preventDefault(), e.prev();
        }), e._d2 = f.children(".rsArrowRight").click(function(a) {
            a.preventDefault(), e.next();
        }), e.st.arrowsNavAutoHide && !e.hasTouch && (e._c2.addClass("rsHidden"), e._d2.addClass("rsHidden"), 
        f.one("mousemove.arrowshover", function() {
            e._c2.removeClass("rsHidden"), e._d2.removeClass("rsHidden");
        }), f.hover(function() {
            e._e2 || (e._c2.removeClass("rsHidden"), e._d2.removeClass("rsHidden"));
        }, function() {
            e._e2 || (e._c2.addClass("rsHidden"), e._d2.addClass("rsHidden"));
        })), e.ev.on("rsOnUpdateNav", function() {
            e._f2();
        }), e._f2()), e._f1 ? e._p1.on(e._j1, function(a) {
            e._g2(a);
        }) : e.dragSuccess = !1;
        var o = [ "rsPlayBtnIcon", "rsPlayBtn", "rsCloseVideoBtn", "rsCloseVideoIcn" ];
        e._p1.click(function(b) {
            if (!e.dragSuccess) {
                var c = a(b.target).attr("class");
                if (-1 !== a.inArray(c, o) && e.toggleVideo()) return !1;
                if (e.st.navigateByClick && !e._h2) {
                    if (a(b.target).closest(".rsNoDrag", e._r1).length) return !0;
                    e._i2(b);
                }
                e.ev.trigger("rsSlideClick", b);
            }
        }).on("click.rs", "a", function(a) {
            if (e.dragSuccess) return !1;
            e._h2 = !0, setTimeout(function() {
                e._h2 = !1;
            }, 3);
        }), e.ev.trigger("rsAfterInit");
    }
    a.rsModules || (a.rsModules = {
        uid: 0
    }), b.prototype = {
        constructor: b,
        _i2: function(a) {
            a = a[this._h ? "pageX" : "pageY"] - this._j2, a >= this._q ? this.next() : 0 > a && this.prev();
        },
        _t: function() {
            var a;
            a = this.st.numImagesToPreload, (this._z = this.st.loop) && (2 === this.numSlides ? (this._z = !1, 
            this.st.loopRewind = !0) : 2 > this.numSlides && (this.st.loopRewind = this._z = !1)), 
            this._z && 0 < a && (4 >= this.numSlides ? a = 1 : this.st.numImagesToPreload > (this.numSlides - 1) / 2 && (a = Math.floor((this.numSlides - 1) / 2))), 
            this._y = a;
        },
        _s: function(b, c) {
            function d(a, b) {
                if (b ? h.images.push(a.attr(b)) : h.images.push(a.text()), i) {
                    i = !1, h.caption = "src" === b ? a.attr("alt") : a.contents(), h.image = h.images[0], 
                    h.videoURL = a.attr("data-rsVideo");
                    var c = a.attr("data-rsw"), d = a.attr("data-rsh");
                    void 0 !== c && !1 !== c && void 0 !== d && !1 !== d ? (h.iW = parseInt(c, 10), 
                    h.iH = parseInt(d, 10)) : g.st.imgWidth && g.st.imgHeight && (h.iW = g.st.imgWidth, 
                    h.iH = g.st.imgHeight);
                }
            }
            var e, f, g = this, h = {}, i = !0;
            if (b = a(b), g._k2 = b, g.ev.trigger("rsBeforeParseNode", [ b, h ]), !h.stopParsing) return b = g._k2, 
            h.id = g._r, h.contentAdded = !1, g._r++, h.images = [], h.isBig = !1, h.hasCover || (b.hasClass("rsImg") ? (f = b, 
            e = !0) : (f = b.find(".rsImg"), f.length && (e = !0)), e ? (h.bigImage = f.eq(0).attr("data-rsBigImg"), 
            f.each(function() {
                var b = a(this);
                b.is("a") ? d(b, "href") : b.is("img") ? d(b, "src") : d(b);
            })) : b.is("img") && (b.addClass("rsImg rsMainSlideImage"), d(b, "src"))), f = b.find(".rsCaption"), 
            f.length && (h.caption = f.remove()), h.content = b, g.ev.trigger("rsAfterParseNode", [ b, h ]), 
            c && g.slides.push(h), 0 === h.images.length && (h.isLoaded = !0, h.isRendered = !1, 
            h.isLoading = !1, h.images = null), h;
        },
        _b2: function() {
            var a, b, c = this, d = function(a) {
                37 === a ? c.prev() : 39 === a && c.next();
            };
            c._b.on("keydown" + c.ns, function(e) {
                c._l2 || 37 !== (b = e.keyCode) && 39 !== b || a || (d(b), a = setInterval(function() {
                    d(b);
                }, 700));
            }).on("keyup" + c.ns, function(b) {
                a && (clearInterval(a), a = null);
            });
        },
        goTo: function(a, b) {
            a !== this.currSlideId && this._m2(a, this.st.transitionSpeed, !0, !b);
        },
        destroy: function(b) {
            this.ev.trigger("rsBeforeDestroy"), this._b.off("keydown" + this.ns + " keyup" + this.ns + " " + this._k1 + " " + this._l1), 
            this._p1.off(this._j1 + " click"), this.slider.data("royalSlider", null), a.removeData(this.slider, "royalSlider"), 
            a(window).off("resize" + this.ns), this.loadingTimeout && clearTimeout(this.loadingTimeout), 
            b && this.slider.remove(), this.ev = this.slider = this.slides = null;
        },
        _n2: function(b, c) {
            function d(c, d, g) {
                c.isAdded ? (e(d, c), f(d, c)) : (g || (g = j.slidesJQ[d]), c.holder ? g = c.holder : (g = j.slidesJQ[d] = a(g), 
                c.holder = g), c.appendOnLoaded = !1, f(d, c, g), e(d, c), j._p2(c, g, b), c.isAdded = !0);
            }
            function e(a, c) {
                c.contentAdded || (j.setItemHtml(c, b), b || (c.contentAdded = !0));
            }
            function f(a, b, c) {
                j._l && (c || (c = j.slidesJQ[a]), c.css(j._i, (a + j._d1 + m) * j._w));
            }
            function g(a) {
                if (k) {
                    if (a > l - 1) return g(a - l);
                    if (0 > a) return g(l + a);
                }
                return a;
            }
            var h, i, j = this, k = j._z, l = j.numSlides;
            if (!isNaN(c)) return g(c);
            var m, n, o = j.currSlideId, p = b ? Math.abs(j._o2 - j.currSlideId) >= j.numSlides - 1 ? 0 : 1 : j._y, q = Math.min(2, p), r = !1, s = !1;
            for (i = o; i < o + 1 + q; i++) if (n = g(i), (h = j.slides[n]) && (!h.isAdded || !h.positionSet)) {
                r = !0;
                break;
            }
            for (i = o - 1; i > o - 1 - q; i--) if (n = g(i), (h = j.slides[n]) && (!h.isAdded || !h.positionSet)) {
                s = !0;
                break;
            }
            if (r) for (i = o; i < o + p + 1; i++) n = g(i), m = Math.floor((j._u - (o - i)) / j.numSlides) * j.numSlides, 
            (h = j.slides[n]) && d(h, n);
            if (s) for (i = o - 1; i > o - 1 - p; i--) n = g(i), m = Math.floor((j._u - (o - i)) / l) * l, 
            (h = j.slides[n]) && d(h, n);
            if (!b) for (q = g(o - p), o = g(o + p), p = q > o ? 0 : q, i = 0; i < l; i++) q > o && i > q - 1 || !(i < p || i > o) || (h = j.slides[i]) && h.holder && (h.holder.detach(), 
            h.isAdded = !1);
        },
        setItemHtml: function(b, c) {
            var d = this, e = function() {
                if (b.images) {
                    if (!b.isLoading) {
                        var c, e;
                        if (b.content.hasClass("rsImg") ? (c = b.content, e = !0) : c = b.content.find(".rsImg:not(img)"), 
                        c && !c.is("img") && c.each(function() {
                            var c = a(this), d = '<img class="rsImg" src="' + (c.is("a") ? c.attr("href") : c.text()) + '" alt="featured image of a collection" />';
                            e ? b.content = a(d) : c.replaceWith(d);
                        }), c = e ? b.content : b.content.find("img.rsImg"), j(), c.eq(0).addClass("rsMainSlideImage"), 
                        b.iW && b.iH && (b.isLoaded || d._q2(b), h()), b.isLoading = !0, b.isBig) a("<img />").on("load.rs error.rs", function(b) {
                            a(this).off("load.rs error.rs"), f([ this ], !0);
                        }).attr("src", b.image); else {
                            b.loaded = [], b.numStartedLoad = 0, c = function(c) {
                                a(this).off("load.rs error.rs"), b.loaded.push(this), b.loaded.length === b.numStartedLoad && f(b.loaded, !1);
                            };
                            for (var g = 0; g < b.images.length; g++) {
                                var i = a("<img />");
                                b.numStartedLoad++, i.on("load.rs error.rs", c).attr("src", b.images[g]);
                            }
                        }
                    }
                } else b.isRendered = !0, b.isLoaded = !0, b.isLoading = !1, h(!0);
            }, f = function(a, c) {
                if (a.length) {
                    var d = a[0];
                    if (c !== b.isBig) (d = b.holder.children()) && 1 < d.length && k(); else if (b.iW && b.iH) g(); else if (b.iW = d.width, 
                    b.iH = d.height, b.iW && b.iH) g(); else {
                        var e = new Image();
                        e.onload = function() {
                            e.width ? (b.iW = e.width, b.iH = e.height, g()) : setTimeout(function() {
                                e.width && (b.iW = e.width, b.iH = e.height), g();
                            }, 1e3);
                        }, e.src = d.src;
                    }
                } else g();
            }, g = function() {
                b.isLoaded = !0, b.isLoading = !1, h(), k(), i();
            }, h = function() {
                if (!b.isAppended && d.ev) {
                    var a = d.st.visibleNearby, e = b.id - d._o;
                    c || b.appendOnLoaded || !d.st.fadeinLoadedSlide || 0 !== e && (!(a || d._r2 || d._l2) || -1 !== e && 1 !== e) || (a = {
                        visibility: "visible",
                        opacity: 0
                    }, a[d._g + "transition"] = "opacity 400ms ease-in-out", b.content.css(a), setTimeout(function() {
                        b.content.css("opacity", 1);
                    }, 16)), b.holder.find(".rsPreloader").length ? b.holder.append(b.content) : b.holder.html(b.content), 
                    b.isAppended = !0, b.isLoaded && (d._q2(b), i()), b.sizeReady || (b.sizeReady = !0, 
                    setTimeout(function() {
                        d.ev.trigger("rsMaybeSizeReady", b);
                    }, 100));
                }
            }, i = function() {
                !b.loadedTriggered && d.ev && (b.isLoaded = b.loadedTriggered = !0, b.holder.trigger("rsAfterContentSet"), 
                d.ev.trigger("rsAfterContentSet", b));
            }, j = function() {
                d.st.usePreloader && b.holder.html(d._q1.clone());
            }, k = function(a) {
                d.st.usePreloader && (a = b.holder.find(".rsPreloader"), a.length && a.remove());
            };
            b.isLoaded ? h() : c ? !d._l && b.images && b.iW && b.iH ? e() : (b.holder.isWaiting = !0, 
            j(), b.holder.slideId = -99) : e();
        },
        _p2: function(a, b, c) {
            this._p1.append(a.holder), a.appendOnLoaded = !1;
        },
        _g2: function(b, c) {
            var d, e = this, f = "touchstart" === b.type;
            if (e._s2 = f, e.ev.trigger("rsDragStart"), a(b.target).closest(".rsNoDrag", e._r1).length) return e.dragSuccess = !1, 
            !0;
            if (!c && e._r2 && (e._t2 = !0, e._u2()), e.dragSuccess = !1, e._l2) f && (e._v2 = !0); else {
                if (f && (e._v2 = !1), e._w2(), f) {
                    var g = b.originalEvent.touches;
                    if (!(g && 0 < g.length)) return;
                    d = g[0], 1 < g.length && (e._v2 = !0);
                } else b.preventDefault(), d = b, e.pointerEnabled && (d = d.originalEvent);
                e._l2 = !0, e._b.on(e._k1, function(a) {
                    e._x2(a, c);
                }).on(e._l1, function(a) {
                    e._y2(a, c);
                }), e._z2 = "", e._a3 = !1, e._b3 = d.pageX, e._c3 = d.pageY, e._d3 = e._v = (c ? e._e3 : e._h) ? d.pageX : d.pageY, 
                e._f3 = 0, e._g3 = 0, e._h3 = c ? e._i3 : e._p, e._j3 = new Date().getTime(), f && e._e1.on(e._m1, function(a) {
                    e._y2(a, c);
                });
            }
        },
        _k3: function(a, b) {
            if (this._l3) {
                var c = this._m3, d = a.pageX - this._b3, e = a.pageY - this._c3, f = this._h3 + d, g = this._h3 + e, h = b ? this._e3 : this._h, f = h ? f : g, g = this._z2;
                this._a3 = !0, this._b3 = a.pageX, this._c3 = a.pageY, "x" === g && 0 !== d ? this._f3 = 0 < d ? 1 : -1 : "y" === g && 0 !== e && (this._g3 = 0 < e ? 1 : -1), 
                g = h ? this._b3 : this._c3, d = h ? d : e, b ? f > this._n3 ? f = this._h3 + d * this._n1 : f < this._o3 && (f = this._h3 + d * this._n1) : this._z || (0 >= this.currSlideId && 0 < g - this._d3 && (f = this._h3 + d * this._n1), 
                this.currSlideId >= this.numSlides - 1 && 0 > g - this._d3 && (f = this._h3 + d * this._n1)), 
                this._h3 = f, 200 < c - this._j3 && (this._j3 = c, this._v = g), b ? this._q3(this._h3) : this._l && this._p3(this._h3);
            }
        },
        _x2: function(a, b) {
            var c, d = this, e = "touchmove" === a.type;
            if (!d._s2 || e) {
                if (e) {
                    if (d._r3) return;
                    var f = a.originalEvent.touches;
                    if (!f) return;
                    if (1 < f.length) return;
                    c = f[0];
                } else c = a, d.pointerEnabled && (c = c.originalEvent);
                if (d._a3 || (d._e && (b ? d._s3 : d._p1).css(d._g + d._u1, "0s"), function a() {
                    d._l2 && (d._t3 = requestAnimationFrame(a), d._u3 && d._k3(d._u3, b));
                }()), d._l3) a.preventDefault(), d._m3 = new Date().getTime(), d._u3 = c; else if (f = b ? d._e3 : d._h, 
                7 < (c = Math.abs(c.pageX - d._b3) - Math.abs(c.pageY - d._c3) - (f ? -7 : 7))) {
                    if (f) a.preventDefault(), d._z2 = "x"; else if (e) return void d._v3(a);
                    d._l3 = !0;
                } else if (-7 > c) {
                    if (f) {
                        if (e) return void d._v3(a);
                    } else a.preventDefault(), d._z2 = "y";
                    d._l3 = !0;
                }
            }
        },
        _v3: function(a, b) {
            this._r3 = !0, this._a3 = this._l2 = !1, this._y2(a);
        },
        _y2: function(b, c) {
            function d(a) {
                return 100 > a ? 100 : 500 < a ? 500 : a;
            }
            function e(a, b) {
                (j._l || c) && (h = (-j._u - j._d1) * j._w, i = Math.abs(j._p - h), j._c = i / b, 
                a && (j._c += 250), j._c = d(j._c), j._x3(h, !1));
            }
            var f, g, h, i, j = this;
            if (f = -1 < b.type.indexOf("touch"), !j._s2 || f) if (j._s2 = !1, j.ev.trigger("rsDragRelease"), 
            j._u3 = null, j._l2 = !1, j._r3 = !1, j._l3 = !1, j._m3 = 0, cancelAnimationFrame(j._t3), 
            j._a3 && (c ? j._q3(j._h3) : j._l && j._p3(j._h3)), j._b.off(j._k1).off(j._l1), 
            f && j._e1.off(j._m1), j._i1(), !j._a3 && !j._v2 && c && j._w3) {
                var k = a(b.target).closest(".rsNavItem");
                k.length && j.goTo(k.index());
            } else {
                if (g = c ? j._e3 : j._h, !j._a3 || "y" === j._z2 && g || "x" === j._z2 && !g) {
                    if (c || !j._t2) return j._t2 = !1, void (j.dragSuccess = !1);
                    if (j._t2 = !1, j.st.navigateByClick) return j._i2(j.pointerEnabled ? b.originalEvent : b), 
                    void (j.dragSuccess = !0);
                    j.dragSuccess = !0;
                } else j.dragSuccess = !0;
                j._t2 = !1, j._z2 = "";
                var l = j.st.minSlideOffset;
                f = f ? b.originalEvent.changedTouches[0] : j.pointerEnabled ? b.originalEvent : b;
                var m = g ? f.pageX : f.pageY, n = j._d3;
                f = j._v;
                var o = j.currSlideId, p = j.numSlides, q = g ? j._f3 : j._g3, r = j._z;
                if (Math.abs(m - n), f = m - f, g = new Date().getTime() - j._j3, g = Math.abs(f) / g, 
                0 === q || 1 >= p) e(!0, g); else {
                    if (!r && !c) if (0 >= o) {
                        if (0 < q) return void e(!0, g);
                    } else if (o >= p - 1 && 0 > q) return void e(!0, g);
                    if (c) {
                        if ((h = j._i3) > j._n3) h = j._n3; else if (h < j._o3) h = j._o3; else {
                            if (m = g * g / .006, k = -j._i3, n = j._y3 - j._z3 + j._i3, 0 < f && m > k ? (k += j._z3 / (15 / (m / g * .003)), 
                            g = g * k / m, m = k) : 0 > f && m > n && (n += j._z3 / (15 / (m / g * .003)), g = g * n / m, 
                            m = n), k = Math.max(Math.round(g / .003), 50), (h += m * (0 > f ? -1 : 1)) > j._n3) return void j._a4(h, k, !0, j._n3, 200);
                            if (h < j._o3) return void j._a4(h, k, !0, j._o3, 200);
                        }
                        j._a4(h, k, !0);
                    } else k = function(a) {
                        var b = Math.floor(a / j._w);
                        return a - b * j._w > l && b++, b;
                    }, n + l < m ? 0 > q ? e(!1, g) : (k = k(m - n), j._m2(j.currSlideId - k, d(Math.abs(j._p - (-j._u - j._d1 + k) * j._w) / g), !1, !0, !0)) : n - l > m ? 0 < q ? e(!1, g) : (k = k(n - m), 
                    j._m2(j.currSlideId + k, d(Math.abs(j._p - (-j._u - j._d1 - k) * j._w) / g), !1, !0, !0)) : e(!1, g);
                }
            }
        },
        _p3: function(a) {
            a = this._p = a, this._e ? this._p1.css(this._x1, this._y1 + (this._h ? a + this._z1 + 0 : 0 + this._z1 + a) + this._a2) : this._p1.css(this._h ? this._x1 : this._w1, a);
        },
        updateSliderSize: function(a) {
            var b, c;
            if (this.st.autoScaleSlider) {
                var d = this.st.autoScaleSliderWidth, e = this.st.autoScaleSliderHeight;
                this.st.autoScaleHeight ? (b = this.slider.width(), b != this.width && (this.slider.css("height", e / d * b), 
                b = this.slider.width()), c = this.slider.height()) : (c = this.slider.height(), 
                c != this.height && (this.slider.css("width", d / e * c), c = this.slider.height()), 
                b = this.slider.width());
            } else b = this.slider.width(), c = this.slider.height();
            if (a || b != this.width || c != this.height) {
                for (this.width = b, this.height = c, this._b4 = b, this._c4 = c, this.ev.trigger("rsBeforeSizeSet"), 
                this.ev.trigger("rsAfterSizePropSet"), this._e1.css({
                    width: this._b4,
                    height: this._c4
                }), this._w = (this._h ? this._b4 : this._c4) + this.st.slidesSpacing, this._d4 = this.st.imageScalePadding, 
                b = 0; b < this.slides.length; b++) a = this.slides[b], a.positionSet = !1, a && a.images && a.isLoaded && (a.isRendered = !1, 
                this._q2(a));
                if (this._e4) for (b = 0; b < this._e4.length; b++) a = this._e4[b], a.holder.css(this._i, (a.id + this._d1) * this._w);
                this._n2(), this._l && (this._e && this._p1.css(this._g + "transition-duration", "0s"), 
                this._p3((-this._u - this._d1) * this._w)), this.ev.trigger("rsOnUpdateNav");
            }
            this._j2 = this._e1.offset(), this._j2 = this._j2[this._i];
        },
        appendSlide: function(b, c) {
            var d = this._s(b);
            (isNaN(c) || c > this.numSlides) && (c = this.numSlides), this.slides.splice(c, 0, d), 
            this.slidesJQ.splice(c, 0, a('<div style="' + (this._l ? "position:absolute;" : this._n) + '" class="rsSlide"></div>')), 
            c < this.currSlideId && this.currSlideId++, this.ev.trigger("rsOnAppendSlide", [ d, c ]), 
            this._f4(c), c === this.currSlideId && this.ev.trigger("rsAfterSlideChange");
        },
        removeSlide: function(a) {
            var b = this.slides[a];
            b && (b.holder && b.holder.remove(), a < this.currSlideId && this.currSlideId--, 
            this.slides.splice(a, 1), this.slidesJQ.splice(a, 1), this.ev.trigger("rsOnRemoveSlide", [ a ]), 
            this._f4(a), a === this.currSlideId && this.ev.trigger("rsAfterSlideChange"));
        },
        _f4: function(a) {
            var b = this;
            for (a = b.numSlides, a = 0 >= b._u ? 0 : Math.floor(b._u / a), b.numSlides = b.slides.length, 
            0 === b.numSlides ? (b.currSlideId = b._d1 = b._u = 0, b.currSlide = b._g4 = null) : b._u = a * b.numSlides + b.currSlideId, 
            a = 0; a < b.numSlides; a++) b.slides[a].id = a;
            b.currSlide = b.slides[b.currSlideId], b._r1 = b.slidesJQ[b.currSlideId], b.currSlideId >= b.numSlides ? b.goTo(b.numSlides - 1) : 0 > b.currSlideId && b.goTo(0), 
            b._t(), b._l && b._z && b._p1.css(b._g + b._u1, "0ms"), b._h4 && clearTimeout(b._h4), 
            b._h4 = setTimeout(function() {
                b._l && b._p3((-b._u - b._d1) * b._w), b._n2(), b._l || b._r1.css({
                    display: "block",
                    opacity: 1
                });
            }, 14), b.ev.trigger("rsOnUpdateNav");
        },
        _i1: function() {
            this._f1 && this._l && (this._g1 ? this._e1.css("cursor", this._g1) : (this._e1.removeClass("grabbing-cursor"), 
            this._e1.addClass("grab-cursor")));
        },
        _w2: function() {
            this._f1 && this._l && (this._h1 ? this._e1.css("cursor", this._h1) : (this._e1.removeClass("grab-cursor"), 
            this._e1.addClass("grabbing-cursor")));
        },
        next: function(a) {
            this._m2("next", this.st.transitionSpeed, !0, !a);
        },
        prev: function(a) {
            this._m2("prev", this.st.transitionSpeed, !0, !a);
        },
        _m2: function(a, b, c, d, e) {
            var f, g, h, i = this;
            if (i.ev.trigger("rsBeforeMove", [ a, d ]), h = "next" === a ? i.currSlideId + 1 : "prev" === a ? i.currSlideId - 1 : a = parseInt(a, 10), 
            !i._z) {
                if (0 > h) return void i._i4("left", !d);
                if (h >= i.numSlides) return void i._i4("right", !d);
            }
            i._r2 && (i._u2(!0), c = !1), g = h - i.currSlideId, h = i._o2 = i.currSlideId;
            var j = i.currSlideId + g;
            d = i._u;
            var k;
            i._z ? (j = i._n2(!1, j), d += g) : d = j, i._o = j, i._g4 = i.slidesJQ[i.currSlideId], 
            i._u = d, i.currSlideId = i._o, i.currSlide = i.slides[i.currSlideId], i._r1 = i.slidesJQ[i.currSlideId];
            var j = i.st.slidesDiff, l = Boolean(0 < g);
            g = Math.abs(g);
            var m = Math.floor(h / i._y), n = Math.floor((h + (l ? j : -j)) / i._y), m = (l ? Math.max(m, n) : Math.min(m, n)) * i._y + (l ? i._y - 1 : 0);
            if (m > i.numSlides - 1 ? m = i.numSlides - 1 : 0 > m && (m = 0), h = l ? m - h : h - m, 
            h > i._y && (h = i._y), g > h + j) for (i._d1 += (g - (h + j)) * (l ? -1 : 1), b *= 1.4, 
            h = 0; h < i.numSlides; h++) i.slides[h].positionSet = !1;
            i._c = b, i._n2(!0), e || (k = !0), f = (-d - i._d1) * i._w, k ? setTimeout(function() {
                i._j4 = !1, i._x3(f, a, !1, c), i.ev.trigger("rsOnUpdateNav");
            }, 0) : (i._x3(f, a, !1, c), i.ev.trigger("rsOnUpdateNav"));
        },
        _f2: function() {
            this.st.arrowsNav && (1 >= this.numSlides ? (this._c2.css("display", "none"), this._d2.css("display", "none")) : (this._c2.css("display", "block"), 
            this._d2.css("display", "block"), this._z || this.st.loopRewind || (0 === this.currSlideId ? this._c2.addClass("rsArrowDisabled") : this._c2.removeClass("rsArrowDisabled"), 
            this.currSlideId === this.numSlides - 1 ? this._d2.addClass("rsArrowDisabled") : this._d2.removeClass("rsArrowDisabled"))));
        },
        _x3: function(b, c, d, e, f) {
            function g() {
                var a;
                h && (a = h.data("rsTimeout")) && (h !== i && h.css({
                    opacity: 0,
                    display: "none",
                    zIndex: 0
                }), clearTimeout(a), h.data("rsTimeout", "")), (a = i.data("rsTimeout")) && (clearTimeout(a), 
                i.data("rsTimeout", ""));
            }
            var h, i, j = this, k = {};
            isNaN(j._c) && (j._c = 400), j._p = j._h3 = b, j.ev.trigger("rsBeforeAnimStart"), 
            j._e ? j._l ? (j._c = parseInt(j._c, 10), d = j._g + j._v1, k[j._g + j._u1] = j._c + "ms", 
            k[d] = e ? a.rsCSS3Easing[j.st.easeInOut] : a.rsCSS3Easing[j.st.easeOut], j._p1.css(k), 
            e || !j.hasTouch ? setTimeout(function() {
                j._p3(b);
            }, 5) : j._p3(b)) : (j._c = j.st.transitionSpeed, h = j._g4, i = j._r1, i.data("rsTimeout") && i.css("opacity", 0), 
            g(), h && h.data("rsTimeout", setTimeout(function() {
                k[j._g + j._u1] = "0ms", k.zIndex = 0, k.display = "none", h.data("rsTimeout", ""), 
                h.css(k), setTimeout(function() {
                    h.css("opacity", 0);
                }, 16);
            }, j._c + 60)), k.display = "block", k.zIndex = j._m, k.opacity = 0, k[j._g + j._u1] = "0ms", 
            k[j._g + j._v1] = a.rsCSS3Easing[j.st.easeInOut], i.css(k), i.data("rsTimeout", setTimeout(function() {
                i.css(j._g + j._u1, j._c + "ms"), i.data("rsTimeout", setTimeout(function() {
                    i.css("opacity", 1), i.data("rsTimeout", "");
                }, 20));
            }, 20))) : j._l ? (k[j._h ? j._x1 : j._w1] = b + "px", j._p1.animate(k, j._c, e ? j.st.easeInOut : j.st.easeOut)) : (h = j._g4, 
            i = j._r1, i.stop(!0, !0).css({
                opacity: 0,
                display: "block",
                zIndex: j._m
            }), j._c = j.st.transitionSpeed, i.animate({
                opacity: 1
            }, j._c, j.st.easeInOut), g(), h && h.data("rsTimeout", setTimeout(function() {
                h.stop(!0, !0).css({
                    opacity: 0,
                    display: "none",
                    zIndex: 0
                });
            }, j._c + 60))), j._r2 = !0, j.loadingTimeout && clearTimeout(j.loadingTimeout), 
            j.loadingTimeout = f ? setTimeout(function() {
                j.loadingTimeout = null, f.call();
            }, j._c + 60) : setTimeout(function() {
                j.loadingTimeout = null, j._k4(c);
            }, j._c + 60);
        },
        _u2: function(a) {
            if (this._r2 = !1, clearTimeout(this.loadingTimeout), this._l) if (this._e) {
                if (!a) {
                    a = this._p;
                    var b = this._h3 = this._l4();
                    this._p1.css(this._g + this._u1, "0ms"), a !== b && this._p3(b);
                }
            } else this._p1.stop(!0), this._p = parseInt(this._p1.css(this._x1), 10); else 20 < this._m ? this._m = 10 : this._m++;
        },
        _l4: function() {
            var a = window.getComputedStyle(this._p1.get(0), null).getPropertyValue(this._g + "transform").replace(/^matrix\(/i, "").split(/, |\)$/g), b = 0 === a[0].indexOf("matrix3d");
            return parseInt(a[this._h ? b ? 12 : 4 : b ? 13 : 5], 10);
        },
        _m4: function(a, b) {
            return this._e ? this._y1 + (b ? a + this._z1 + 0 : 0 + this._z1 + a) + this._a2 : a;
        },
        _k4: function(a) {
            this._l || (this._r1.css("z-index", 0), this._m = 10), this._r2 = !1, this.staticSlideId = this.currSlideId, 
            this._n2(), this._n4 = !1, this.ev.trigger("rsAfterSlideChange");
        },
        _i4: function(a, b) {
            var c = this, d = (-c._u - c._d1) * c._w;
            if (0 !== c.numSlides && !c._r2) if (c.st.loopRewind) c.goTo("left" === a ? c.numSlides - 1 : 0, b); else if (c._l) {
                c._c = 200;
                var e = function() {
                    c._r2 = !1;
                };
                c._x3(d + ("left" === a ? 30 : -30), "", !1, !0, function() {
                    c._r2 = !1, c._x3(d, "", !1, !0, e);
                });
            }
        },
        _q2: function(a, b) {
            if (!a.isRendered) {
                var c, d, e = a.content, f = "rsMainSlideImage", g = this.st.imageAlignCenter, h = this.st.imageScaleMode;
                if (a.videoURL && (f = "rsVideoContainer", "fill" !== h ? c = !0 : (d = e, d.hasClass(f) || (d = d.find("." + f)), 
                d.css({
                    width: "100%",
                    height: "100%"
                }), f = "rsMainSlideImage")), e.hasClass(f) || (e = e.find("." + f)), e) {
                    var i = a.iW, j = a.iH;
                    if (a.isRendered = !0, "none" !== h || g) {
                        f = "fill" !== h ? this._d4 : 0, d = this._b4 - 2 * f;
                        var k, l, m = this._c4 - 2 * f, n = {};
                        "fit-if-smaller" === h && (i > d || j > m) && (h = "fit"), "fill" !== h && "fit" !== h || (k = d / i, 
                        l = m / j, k = "fill" == h ? k > l ? k : l : "fit" == h ? k < l ? k : l : 1, i = Math.ceil(i * k, 10), 
                        j = Math.ceil(j * k, 10)), "none" !== h && (n.width = i, n.height = j, c && e.find(".rsImg").css({
                            width: "100%",
                            height: "100%"
                        })), g && (n.marginLeft = Math.floor((d - i) / 2) + f, n.marginTop = Math.floor((m - j) / 2) + f), 
                        e.css(n);
                    }
                }
            }
        }
    }, a.rsProto = b.prototype, a.fn.royalSlider = function(c) {
        var d = arguments;
        return this.each(function() {
            var e = a(this);
            if ("object" != typeof c && c) {
                if ((e = e.data("royalSlider")) && e[c]) return e[c].apply(e, Array.prototype.slice.call(d, 1));
            } else e.data("royalSlider") || e.data("royalSlider", new b(e, c));
        });
    }, a.fn.royalSlider.defaults = {
        slidesSpacing: 8,
        startSlideId: 0,
        loop: !1,
        loopRewind: !1,
        numImagesToPreload: 4,
        fadeinLoadedSlide: !0,
        slidesOrientation: "horizontal",
        transitionType: "move",
        transitionSpeed: 600,
        controlNavigation: "bullets",
        controlsInside: !0,
        arrowsNav: !0,
        arrowsNavAutoHide: !0,
        navigateByClick: !0,
        randomizeSlides: !1,
        sliderDrag: !0,
        sliderTouch: !0,
        keyboardNavEnabled: !1,
        fadeInAfterLoaded: !0,
        allowCSS3: !0,
        allowCSS3OnWebkit: !0,
        addActiveClass: !1,
        autoHeight: !1,
        easeOut: "easeOutSine",
        easeInOut: "easeInOutSine",
        minSlideOffset: 10,
        imageScaleMode: "fit-if-smaller",
        imageAlignCenter: !0,
        imageScalePadding: 4,
        usePreloader: !0,
        autoScaleSlider: !1,
        autoScaleSliderWidth: 800,
        autoScaleSliderHeight: 400,
        autoScaleHeight: !0,
        arrowsNavHideOnTouch: !1,
        globalCaption: !1,
        slidesDiff: 2
    }, a.rsCSS3Easing = {
        easeOutSine: "cubic-bezier(0.390, 0.575, 0.565, 1.000)",
        easeInOutSine: "cubic-bezier(0.445, 0.050, 0.550, 0.950)"
    }, a.extend(jQuery.easing, {
        easeInOutSine: function(a, b, c, d, e) {
            return -d / 2 * (Math.cos(Math.PI * b / e) - 1) + c;
        },
        easeOutSine: function(a, b, c, d, e) {
            return d * Math.sin(b / e * (Math.PI / 2)) + c;
        },
        easeOutCubic: function(a, b, c, d, e) {
            return d * ((b = b / e - 1) * b * b + 1) + c;
        }
    });
}(jQuery, window), function(a) {
    a.extend(a.rsProto, {
        _i5: function() {
            var b = this;
            "bullets" === b.st.controlNavigation && (b.ev.one("rsAfterPropsSetup", function() {
                b._j5 = !0, b.slider.addClass("rsWithBullets");
                for (var c = '<div class="rsNav rsBullets">', d = 0; d < b.numSlides; d++) c += '<div class="rsNavItem rsBullet"><span></span></div>';
                b._k5 = c = a(c + "</div>"), b._l5 = c.appendTo(b.slider).children(), b._k5.on("click.rs", ".rsNavItem", function(c) {
                    b._m5 || b.goTo(a(this).index());
                });
            }), b.ev.on("rsOnAppendSlide", function(a, c, d) {
                d >= b.numSlides ? b._k5.append('<div class="rsNavItem rsBullet"><span></span></div>') : b._l5.eq(d).before('<div class="rsNavItem rsBullet"><span></span></div>'), 
                b._l5 = b._k5.children();
            }), b.ev.on("rsOnRemoveSlide", function(a, c) {
                var d = b._l5.eq(c);
                d && d.length && (d.remove(), b._l5 = b._k5.children());
            }), b.ev.on("rsOnUpdateNav", function() {
                var a = b.currSlideId;
                b._n5 && b._n5.removeClass("rsNavSelected"), a = b._l5.eq(a), a.addClass("rsNavSelected"), 
                b._n5 = a;
            }));
        }
    }), a.rsModules.bullets = a.rsProto._i5;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _h6: function() {
            var b = this;
            "thumbnails" === b.st.controlNavigation && (b._i6 = {
                drag: !0,
                touch: !0,
                orientation: "horizontal",
                navigation: !0,
                arrows: !0,
                arrowLeft: null,
                arrowRight: null,
                spacing: 4,
                arrowsAutoHide: !1,
                appendSpan: !1,
                transitionSpeed: 600,
                autoCenter: !0,
                fitInViewport: !0,
                firstMargin: !0,
                paddingTop: 0,
                paddingBottom: 0
            }, b.st.thumbs = a.extend({}, b._i6, b.st.thumbs), b._j6 = !0, !1 === b.st.thumbs.firstMargin ? b.st.thumbs.firstMargin = 0 : !0 === b.st.thumbs.firstMargin && (b.st.thumbs.firstMargin = b.st.thumbs.spacing), 
            b.ev.on("rsBeforeParseNode", function(b, c, d) {
                c = a(c), d.thumbnail = c.find(".rsTmb").remove(), d.thumbnail.length ? d.thumbnail = a(document.createElement("div")).append(d.thumbnail).html() : (d.thumbnail = c.attr("data-rsTmb"), 
                d.thumbnail || (d.thumbnail = c.find(".rsImg").attr("data-rsTmb")), d.thumbnail = d.thumbnail ? '<img src="' + d.thumbnail + '"/>' : "");
            }), b.ev.one("rsAfterPropsSetup", function() {
                b._k6();
            }), b._n5 = null, b.ev.on("rsOnUpdateNav", function() {
                var c = a(b._l5[b.currSlideId]);
                c !== b._n5 && (b._n5 && (b._n5.removeClass("rsNavSelected"), b._n5 = null), b._l6 && b._m6(b.currSlideId), 
                b._n5 = c.addClass("rsNavSelected"));
            }), b.ev.on("rsOnAppendSlide", function(a, c, d) {
                a = "<div" + b._n6 + ' class="rsNavItem rsThumb">' + b._o6 + c.thumbnail + "</div>", 
                d >= b.numSlides ? b._s3.append(a) : b._l5.eq(d).before(a), b._l5 = b._s3.children(), 
                b.updateThumbsSize();
            }), b.ev.on("rsOnRemoveSlide", function(a, c) {
                var d = b._l5.eq(c);
                d && (d.remove(), b._l5 = b._s3.children(), b.updateThumbsSize());
            }));
        },
        _k6: function() {
            var b, c, d = this, e = "rsThumbs", f = d.st.thumbs, g = "", h = f.spacing;
            d._j5 = !0, d._e3 = "vertical" !== f.orientation, d._n6 = b = h ? ' style="margin-' + (d._e3 ? "right" : "bottom") + ":" + h + 'px;"' : "", 
            d._i3 = 0, d._p6 = !1, d._m5 = !1, d._l6 = !1, d._q6 = f.arrows && f.navigation, 
            c = d._e3 ? "Hor" : "Ver", d.slider.addClass("rsWithThumbs rsWithThumbs" + c), g += '<div class="rsNav rsThumbs rsThumbs' + c + '"><div class="' + e + 'Container">', 
            d._o6 = f.appendSpan ? '<span class="thumbIco"></span>' : "";
            for (var i = 0; i < d.numSlides; i++) c = d.slides[i], g += "<div" + b + ' class="rsNavItem rsThumb">' + c.thumbnail + d._o6 + "</div>";
            g = a(g + "</div></div>"), b = {}, f.paddingTop && (b[d._e3 ? "paddingTop" : "paddingLeft"] = f.paddingTop), 
            f.paddingBottom && (b[d._e3 ? "paddingBottom" : "paddingRight"] = f.paddingBottom), 
            g.css(b), d._s3 = a(g).find("." + e + "Container"), d._q6 && (e += "Arrow", f.arrowLeft ? d._r6 = f.arrowLeft : (d._r6 = a('<div class="' + e + " " + e + 'Left"><div class="' + e + 'Icn"></div></div>'), 
            g.append(d._r6)), f.arrowRight ? d._s6 = f.arrowRight : (d._s6 = a('<div class="' + e + " " + e + 'Right"><div class="' + e + 'Icn"></div></div>'), 
            g.append(d._s6)), d._r6.click(function() {
                var a = (Math.floor(d._i3 / d._t6) + d._u6) * d._t6 + d._v6;
                d._a4(a > d._n3 ? d._n3 : a);
            }), d._s6.click(function() {
                var a = (Math.floor(d._i3 / d._t6) - d._u6) * d._t6 + d._v6;
                d._a4(a < d._o3 ? d._o3 : a);
            }), f.arrowsAutoHide && !d.hasTouch && (d._r6.css("opacity", 0), d._s6.css("opacity", 0), 
            g.one("mousemove.rsarrowshover", function() {
                d._l6 && (d._r6.css("opacity", 1), d._s6.css("opacity", 1));
            }), g.hover(function() {
                d._l6 && (d._r6.css("opacity", 1), d._s6.css("opacity", 1));
            }, function() {
                d._l6 && (d._r6.css("opacity", 0), d._s6.css("opacity", 0));
            }))), d._k5 = g, d._l5 = d._s3.children(), d.msEnabled && d.st.thumbs.navigation && d._s3.css("-ms-touch-action", d._e3 ? "pan-y" : "pan-x"), 
            d.slider.append(g), d._w3 = !0, d._v6 = h, f.navigation && d._e && d._s3.css(d._g + "transition-property", d._g + "transform"), 
            d._k5.on("click.rs", ".rsNavItem", function(b) {
                d._m5 || d.goTo(a(this).index());
            }), d.ev.off("rsBeforeSizeSet.thumbs").on("rsBeforeSizeSet.thumbs", function() {
                d._w6 = d._e3 ? d._c4 : d._b4, d.updateThumbsSize(!0);
            }), d.ev.off("rsAutoHeightChange.thumbs").on("rsAutoHeightChange.thumbs", function(a, b) {
                d.updateThumbsSize(!0, b);
            });
        },
        updateThumbsSize: function(a, b) {
            var c = this, d = c._l5.first(), e = {}, f = c._l5.length;
            c._t6 = (c._e3 ? d.outerWidth() : d.outerHeight()) + c._v6, c._y3 = f * c._t6 - c._v6, 
            e[c._e3 ? "width" : "height"] = c._y3 + c._v6, c._z3 = c._e3 ? c._k5.width() : void 0 !== b ? b : c._k5.height(), 
            c._w3 && (c.isFullscreen || c.st.thumbs.fitInViewport) && (c._e3 ? c._c4 = c._w6 - c._k5.outerHeight() : c._b4 = c._w6 - c._k5.outerWidth()), 
            c._z3 && (c._o3 = -(c._y3 - c._z3) - c.st.thumbs.firstMargin, c._n3 = c.st.thumbs.firstMargin, 
            c._u6 = Math.floor(c._z3 / c._t6), c._y3 < c._z3 ? (c.st.thumbs.autoCenter && c._q3((c._z3 - c._y3) / 2), 
            c.st.thumbs.arrows && c._r6 && (c._r6.addClass("rsThumbsArrowDisabled"), c._s6.addClass("rsThumbsArrowDisabled")), 
            c._l6 = !1, c._m5 = !1, c._k5.off(c._j1)) : c.st.thumbs.navigation && !c._l6 && (c._l6 = !0, 
            !c.hasTouch && c.st.thumbs.drag || c.hasTouch && c.st.thumbs.touch) && (c._m5 = !0, 
            c._k5.on(c._j1, function(a) {
                c._g2(a, !0);
            })), c._s3.css(e), a && b && c._m6(c.currSlideId), c._e && (e[c._g + "transition-duration"] = "0ms"));
        },
        setThumbsOrientation: function(a, b) {
            this._w3 && (this.st.thumbs.orientation = a, this._k5.remove(), this.slider.removeClass("rsWithThumbsHor rsWithThumbsVer"), 
            this._k6(), this._k5.off(this._j1), b || this.updateSliderSize(!0));
        },
        _q3: function(a) {
            this._i3 = a, this._e ? this._s3.css(this._x1, this._y1 + (this._e3 ? a + this._z1 + 0 : 0 + this._z1 + a) + this._a2) : this._s3.css(this._e3 ? this._x1 : this._w1, a);
        },
        _a4: function(b, c, d, e, f) {
            var g = this;
            if (g._l6) {
                c || (c = g.st.thumbs.transitionSpeed), g._i3 = b, g._x6 && clearTimeout(g._x6), 
                g._p6 && (g._e || g._s3.stop(), d = !0);
                var h = {};
                g._p6 = !0, g._e ? (h[g._g + "transition-duration"] = c + "ms", h[g._g + "transition-timing-function"] = d ? a.rsCSS3Easing[g.st.easeOut] : a.rsCSS3Easing[g.st.easeInOut], 
                g._s3.css(h), g._q3(b)) : (h[g._e3 ? g._x1 : g._w1] = b + "px", g._s3.animate(h, c, d ? "easeOutCubic" : g.st.easeInOut)), 
                e && (g._i3 = e), g._y6(), g._x6 = setTimeout(function() {
                    g._p6 = !1, f && (g._a4(e, f, !0), f = null);
                }, c);
            }
        },
        _y6: function() {
            this._q6 && (this._i3 === this._n3 ? this._r6.addClass("rsThumbsArrowDisabled") : this._r6.removeClass("rsThumbsArrowDisabled"), 
            this._i3 === this._o3 ? this._s6.addClass("rsThumbsArrowDisabled") : this._s6.removeClass("rsThumbsArrowDisabled"));
        },
        _m6: function(a, b) {
            var c, d = 0, e = a * this._t6 + 2 * this._t6 - this._v6 + this._n3, f = Math.floor(this._i3 / this._t6);
            this._l6 && (this._j6 && (b = !0, this._j6 = !1), e + this._i3 > this._z3 ? (a === this.numSlides - 1 && (d = 1), 
            f = -a + this._u6 - 2 + d, c = f * this._t6 + this._z3 % this._t6 + this._v6 - this._n3) : 0 !== a ? (a - 1) * this._t6 <= -this._i3 + this._n3 && a - 1 <= this.numSlides - this._u6 && (c = (1 - a) * this._t6 + this._n3) : c = this._n3, 
            c !== this._i3 && (d = void 0 === c ? this._i3 : c, d > this._n3 ? this._q3(this._n3) : d < this._o3 ? this._q3(this._o3) : void 0 !== c && (b ? this._q3(c) : this._a4(c))), 
            this._y6());
        }
    }), a.rsModules.thumbnails = a.rsProto._h6;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _f6: function() {
            var b = this;
            "tabs" === b.st.controlNavigation && (b.ev.on("rsBeforeParseNode", function(b, c, d) {
                c = a(c), d.thumbnail = c.find(".rsTmb").remove(), d.thumbnail.length ? d.thumbnail = a(document.createElement("div")).append(d.thumbnail).html() : (d.thumbnail = c.attr("data-rsTmb"), 
                d.thumbnail || (d.thumbnail = c.find(".rsImg").attr("data-rsTmb")), d.thumbnail = d.thumbnail ? '<img src="' + d.thumbnail + '"/>' : "");
            }), b.ev.one("rsAfterPropsSetup", function() {
                b._g6();
            }), b.ev.on("rsOnAppendSlide", function(a, c, d) {
                d >= b.numSlides ? b._k5.append('<div class="rsNavItem rsTab">' + c.thumbnail + "</div>") : b._l5.eq(d).before('<div class="rsNavItem rsTab">' + item.thumbnail + "</div>"), 
                b._l5 = b._k5.children();
            }), b.ev.on("rsOnRemoveSlide", function(a, c) {
                var d = b._l5.eq(c);
                d && (d.remove(), b._l5 = b._k5.children());
            }), b.ev.on("rsOnUpdateNav", function() {
                var a = b.currSlideId;
                b._n5 && b._n5.removeClass("rsNavSelected"), a = b._l5.eq(a), a.addClass("rsNavSelected"), 
                b._n5 = a;
            }));
        },
        _g6: function() {
            var b, c = this;
            c._j5 = !0, b = '<div class="rsNav rsTabs">';
            for (var d = 0; d < c.numSlides; d++) b += '<div class="rsNavItem rsTab">' + c.slides[d].thumbnail + "</div>";
            b = a(b + "</div>"), c._k5 = b, c._l5 = b.children(".rsNavItem"), c.slider.append(b), 
            c._k5.click(function(b) {
                b = a(b.target).closest(".rsNavItem"), b.length && c.goTo(b.index());
            });
        }
    }), a.rsModules.tabs = a.rsProto._f6;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _q5: function() {
            var b = this;
            b._r5 = {
                enabled: !1,
                keyboardNav: !0,
                buttonFS: !0,
                nativeFS: !1,
                doubleTap: !0
            }, b.st.fullscreen = a.extend({}, b._r5, b.st.fullscreen), b.st.fullscreen.enabled && b.ev.one("rsBeforeSizeSet", function() {
                b._s5();
            });
        },
        _s5: function() {
            var b = this;
            if (b._t5 = !b.st.keyboardNavEnabled && b.st.fullscreen.keyboardNav, b.st.fullscreen.nativeFS) {
                b._u5 = {
                    supportsFullScreen: !1,
                    isFullScreen: function() {
                        return !1;
                    },
                    requestFullScreen: function() {},
                    cancelFullScreen: function() {},
                    fullScreenEventName: "",
                    prefix: ""
                };
                var c = [ "webkit", "moz", "o", "ms", "khtml" ];
                if (!b.isAndroid) if (void 0 !== document.cancelFullScreen) b._u5.supportsFullScreen = !0; else for (var d = 0; d < c.length; d++) if (b._u5.prefix = c[d], 
                void 0 !== document[b._u5.prefix + "CancelFullScreen"]) {
                    b._u5.supportsFullScreen = !0;
                    break;
                }
                b._u5.supportsFullScreen ? (b.nativeFS = !0, b._u5.fullScreenEventName = b._u5.prefix + "fullscreenchange" + b.ns, 
                b._u5.isFullScreen = function() {
                    switch (this.prefix) {
                      case "":
                        return document.fullScreen;

                      case "webkit":
                        return document.webkitIsFullScreen;

                      default:
                        return document[this.prefix + "FullScreen"];
                    }
                }, b._u5.requestFullScreen = function(a) {
                    return "" === this.prefix ? a.requestFullScreen() : a[this.prefix + "RequestFullScreen"]();
                }, b._u5.cancelFullScreen = function(a) {
                    return "" === this.prefix ? document.cancelFullScreen() : document[this.prefix + "CancelFullScreen"]();
                }) : b._u5 = !1;
            }
            b.st.fullscreen.buttonFS && (b._v5 = a('<div class="rsFullscreenBtn"><div class="rsFullscreenIcn"></div></div>').appendTo(b._o1).on("click.rs", function() {
                b.isFullscreen ? b.exitFullscreen() : b.enterFullscreen();
            }));
        },
        enterFullscreen: function(b) {
            var c = this;
            if (c._u5) {
                if (!b) return c._b.on(c._u5.fullScreenEventName, function(a) {
                    c._u5.isFullScreen() ? c.enterFullscreen(!0) : c.exitFullscreen(!0);
                }), void c._u5.requestFullScreen(a("html")[0]);
                c._u5.requestFullScreen(a("html")[0]);
            }
            if (!c._w5) {
                c._w5 = !0, c._b.on("keyup" + c.ns + "fullscreen", function(a) {
                    27 === a.keyCode && c.exitFullscreen();
                }), c._t5 && c._b2(), b = a(window), c._x5 = b.scrollTop(), c._y5 = b.scrollLeft(), 
                c._z5 = a("html").attr("style"), c._a6 = a("body").attr("style"), c._b6 = c.slider.attr("style"), 
                a("body, html").css({
                    overflow: "hidden",
                    height: "100%",
                    width: "100%",
                    margin: "0",
                    padding: "0"
                }), c.slider.addClass("rsFullscreen");
                var d;
                for (d = 0; d < c.numSlides; d++) b = c.slides[d], b.isRendered = !1, b.bigImage && (b.isBig = !0, 
                b.isMedLoaded = b.isLoaded, b.isMedLoading = b.isLoading, b.medImage = b.image, 
                b.medIW = b.iW, b.medIH = b.iH, b.slideId = -99, b.bigImage !== b.medImage && (b.sizeType = "big"), 
                b.isLoaded = b.isBigLoaded, b.isLoading = !1, b.image = b.bigImage, b.images[0] = b.bigImage, 
                b.iW = b.bigIW, b.iH = b.bigIH, b.isAppended = b.contentAdded = !1, c._c6(b));
                c.isFullscreen = !0, c._w5 = !1, c.updateSliderSize(), c.ev.trigger("rsEnterFullscreen");
            }
        },
        exitFullscreen: function(b) {
            var c = this;
            if (c._u5) {
                if (!b) return void c._u5.cancelFullScreen(a("html")[0]);
                c._b.off(c._u5.fullScreenEventName);
            }
            if (!c._w5) {
                c._w5 = !0, c._b.off("keyup" + c.ns + "fullscreen"), c._t5 && c._b.off("keydown" + c.ns), 
                a("html").attr("style", c._z5 || ""), a("body").attr("style", c._a6 || "");
                var d;
                for (d = 0; d < c.numSlides; d++) b = c.slides[d], b.isRendered = !1, b.bigImage && (b.isBig = !1, 
                b.slideId = -99, b.isBigLoaded = b.isLoaded, b.isBigLoading = b.isLoading, b.bigImage = b.image, 
                b.bigIW = b.iW, b.bigIH = b.iH, b.isLoaded = b.isMedLoaded, b.isLoading = !1, b.image = b.medImage, 
                b.images[0] = b.medImage, b.iW = b.medIW, b.iH = b.medIH, b.isAppended = b.contentAdded = !1, 
                c._c6(b, !0), b.bigImage !== b.medImage && (b.sizeType = "med"));
                c.isFullscreen = !1, b = a(window), b.scrollTop(c._x5), b.scrollLeft(c._y5), c._w5 = !1, 
                c.slider.removeClass("rsFullscreen"), c.updateSliderSize(), setTimeout(function() {
                    c.updateSliderSize();
                }, 1), c.ev.trigger("rsExitFullscreen");
            }
        },
        _c6: function(b, c) {
            var d = b.isLoaded || b.isLoading ? '<img class="rsImg rsMainSlideImage" src="' + b.image + '"/>' : '<a class="rsImg rsMainSlideImage" href="' + b.image + '"></a>';
            b.content.hasClass("rsImg") ? b.content = a(d) : b.content.find(".rsImg").eq(0).replaceWith(d), 
            b.isLoaded || b.isLoading || !b.holder || b.holder.html(b.content);
        }
    }), a.rsModules.fullscreen = a.rsProto._q5;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _x4: function() {
            var b, c = this;
            c._y4 = {
                enabled: !1,
                stopAtAction: !0,
                pauseOnHover: !0,
                delay: 2e3
            }, !c.st.autoPlay && c.st.autoplay && (c.st.autoPlay = c.st.autoplay), c.st.autoPlay = a.extend({}, c._y4, c.st.autoPlay), 
            c.st.autoPlay.enabled && (c.ev.on("rsBeforeParseNode", function(c, d, e) {
                d = a(d), (b = d.attr("data-rsDelay")) && (e.customDelay = parseInt(b, 10));
            }), c.ev.one("rsAfterInit", function() {
                c._z4();
            }), c.ev.on("rsBeforeDestroy", function() {
                c.stopAutoPlay(), c.slider.off("mouseenter mouseleave"), a(window).off("blur" + c.ns + " focus" + c.ns);
            }));
        },
        _z4: function() {
            var b = this;
            b.startAutoPlay(), b.ev.on("rsAfterContentSet", function(a, c) {
                b._l2 || b._r2 || !b._a5 || c !== b.currSlide || b._b5();
            }), b.ev.on("rsDragRelease", function() {
                b._a5 && b._c5 && (b._c5 = !1, b._b5());
            }), b.ev.on("rsAfterSlideChange", function() {
                b._a5 && b._c5 && (b._c5 = !1, b.currSlide.isLoaded && b._b5());
            }), b.ev.on("rsDragStart", function() {
                b._a5 && (b.st.autoPlay.stopAtAction ? b.stopAutoPlay() : (b._c5 = !0, b._d5()));
            }), b.ev.on("rsBeforeMove", function(a, c, d) {
                b._a5 && (d && b.st.autoPlay.stopAtAction ? b.stopAutoPlay() : (b._c5 = !0, b._d5()));
            }), b._e5 = !1, b.ev.on("rsVideoStop", function() {
                b._a5 && (b._e5 = !1, b._b5());
            }), b.ev.on("rsVideoPlay", function() {
                b._a5 && (b._c5 = !1, b._d5(), b._e5 = !0);
            }), a(window).on("blur" + b.ns, function() {
                b._a5 && (b._c5 = !0, b._d5());
            }).on("focus" + b.ns, function() {
                b._a5 && b._c5 && (b._c5 = !1, b._b5());
            }), b.st.autoPlay.pauseOnHover && (b._f5 = !1, b.slider.hover(function() {
                b._a5 && (b._c5 = !1, b._d5(), b._f5 = !0);
            }, function() {
                b._a5 && (b._f5 = !1, b._b5());
            }));
        },
        toggleAutoPlay: function() {
            this._a5 ? this.stopAutoPlay() : this.startAutoPlay();
        },
        startAutoPlay: function() {
            this._a5 = !0, this.currSlide.isLoaded && this._b5();
        },
        stopAutoPlay: function() {
            this._e5 = this._f5 = this._c5 = this._a5 = !1, this._d5();
        },
        _b5: function() {
            var a = this;
            a._f5 || a._e5 || (a._g5 = !0, a._h5 && clearTimeout(a._h5), a._h5 = setTimeout(function() {
                var b;
                a._z || a.st.loopRewind || (b = !0, a.st.loopRewind = !0), a.next(!0), b && (a.st.loopRewind = !1);
            }, a.currSlide.customDelay ? a.currSlide.customDelay : a.st.autoPlay.delay));
        },
        _d5: function() {
            this._f5 || this._e5 || (this._g5 = !1, this._h5 && (clearTimeout(this._h5), this._h5 = null));
        }
    }), a.rsModules.autoplay = a.rsProto._x4;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _z6: function() {
            var b = this;
            b._a7 = {
                autoHideArrows: !0,
                autoHideControlNav: !1,
                autoHideBlocks: !1,
                autoHideCaption: !1,
                disableCSS3inFF: !0,
                youTubeCode: '<iframe src="http://www.youtube.com/embed/%id%?rel=1&showinfo=0&autoplay=1&wmode=transparent" frameborder="no"></iframe>',
                vimeoCode: '<iframe src="http://player.vimeo.com/video/%id%?byline=0&portrait=0&autoplay=1" frameborder="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
            }, b.st.video = a.extend({}, b._a7, b.st.video), b.ev.on("rsBeforeSizeSet", function() {
                b._b7 && setTimeout(function() {
                    var a = b._r1, a = a.hasClass("rsVideoContainer") ? a : a.find(".rsVideoContainer");
                    b._c7 && b._c7.css({
                        width: a.width(),
                        height: a.height()
                    });
                }, 32);
            });
            var c = b._a.mozilla;
            b.ev.on("rsAfterParseNode", function(d, e, f) {
                if (d = a(e), f.videoURL) {
                    b.st.video.disableCSS3inFF && c && (b._e = b._f = !1), e = a('<div class="rsVideoContainer"></div>');
                    var g = a('<div class="rsBtnCenterer"><div class="rsPlayBtn"><div class="rsPlayBtnIcon"></div></div></div>');
                    d.hasClass("rsImg") ? f.content = e.append(d).append(g) : f.content.find(".rsImg").wrap(e).after(g);
                }
            }), b.ev.on("rsAfterSlideChange", function() {
                b.stopVideo();
            });
        },
        toggleVideo: function() {
            return this._b7 ? this.stopVideo() : this.playVideo();
        },
        playVideo: function() {
            var b = this;
            if (!b._b7) {
                var c = b.currSlide;
                if (!c.videoURL) return !1;
                b._d7 = c;
                var d, e, f = b._e7 = c.content, c = c.videoURL;
                return c.match(/youtu\.be/i) || c.match(/youtube\.com/i) ? (e = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/, 
                (e = c.match(e)) && 11 == e[7].length && (d = e[7]), void 0 !== d && (b._c7 = b.st.video.youTubeCode.replace("%id%", d))) : c.match(/vimeo\.com/i) && (e = /(www\.)?vimeo.com\/(\d+)($|\/)/, 
                (e = c.match(e)) && (d = e[2]), void 0 !== d && (b._c7 = b.st.video.vimeoCode.replace("%id%", d))), 
                b.videoObj = a(b._c7), b.ev.trigger("rsOnCreateVideoElement", [ c ]), b.videoObj.length && (b._c7 = a('<div class="rsVideoFrameHolder"><div class="rsPreloader"></div><div class="rsCloseVideoBtn"><div class="rsCloseVideoIcn"></div></div></div>'), 
                b._c7.find(".rsPreloader").after(b.videoObj), f = f.hasClass("rsVideoContainer") ? f : f.find(".rsVideoContainer"), 
                b._c7.css({
                    width: f.width(),
                    height: f.height()
                }).find(".rsCloseVideoBtn").off("click.rsv").on("click.rsv", function(a) {
                    return b.stopVideo(), a.preventDefault(), a.stopPropagation(), !1;
                }), f.append(b._c7), b.isIPAD && f.addClass("rsIOSVideo"), b._f7(!1), setTimeout(function() {
                    b._c7.addClass("rsVideoActive");
                }, 10), b.ev.trigger("rsVideoPlay"), b._b7 = !0), !0;
            }
            return !1;
        },
        stopVideo: function() {
            var a = this;
            return !!a._b7 && (a.isIPAD && a.slider.find(".rsCloseVideoBtn").remove(), a._f7(!0), 
            setTimeout(function() {
                a.ev.trigger("rsOnDestroyVideoElement", [ a.videoObj ]);
                var b = a._c7.find("iframe");
                if (b.length) try {
                    b.attr("src", "");
                } catch (a) {}
                a._c7.remove(), a._c7 = null;
            }, 16), a.ev.trigger("rsVideoStop"), a._b7 = !1, !0);
        },
        _f7: function(a, b) {
            var c = [], d = this.st.video;
            if (d.autoHideArrows && (this._c2 && (c.push(this._c2, this._d2), this._e2 = !a), 
            this._v5 && c.push(this._v5)), d.autoHideControlNav && this._k5 && c.push(this._k5), 
            d.autoHideBlocks && this._d7.animBlocks && c.push(this._d7.animBlocks), d.autoHideCaption && this.globalCaption && c.push(this.globalCaption), 
            this.slider[a ? "removeClass" : "addClass"]("rsVideoPlaying"), c.length) for (d = 0; d < c.length; d++) a ? c[d].removeClass("rsHidden") : c[d].addClass("rsHidden");
        }
    }), a.rsModules.video = a.rsProto._z6;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _p4: function() {
            function b() {
                var a = d.currSlide;
                if (d.currSlide && d.currSlide.isLoaded && d._t4 !== a) {
                    if (0 < d._s4.length) {
                        for (c = 0; c < d._s4.length; c++) clearTimeout(d._s4[c]);
                        d._s4 = [];
                    }
                    if (0 < d._r4.length) {
                        var b;
                        for (c = 0; c < d._r4.length; c++) (b = d._r4[c]) && (d._e ? (b.block.css(d._g + d._u1, "0s"), 
                        b.block.css(b.css)) : b.block.stop(!0).css(b.css), d._t4 = null, a.animBlocksDisplayed = !1);
                        d._r4 = [];
                    }
                    a.animBlocks && (a.animBlocksDisplayed = !0, d._t4 = a, d._u4(a.animBlocks));
                }
            }
            var c, d = this;
            d._q4 = {
                fadeEffect: !0,
                moveEffect: "top",
                moveOffset: 20,
                speed: 400,
                easing: "easeOutSine",
                delay: 200
            }, d.st.block = a.extend({}, d._q4, d.st.block), d._r4 = [], d._s4 = [], d.ev.on("rsAfterInit", function() {
                b();
            }), d.ev.on("rsBeforeParseNode", function(b, c, d) {
                c = a(c), d.animBlocks = c.find(".rsABlock").css("display", "none"), d.animBlocks.length || (c.hasClass("rsABlock") ? d.animBlocks = c.css("display", "none") : d.animBlocks = !1);
            }), d.ev.on("rsAfterContentSet", function(a, c) {
                c.id === d.slides[d.currSlideId].id && setTimeout(function() {
                    b();
                }, d.st.fadeinLoadedSlide ? 300 : 0);
            }), d.ev.on("rsAfterSlideChange", function() {
                b();
            });
        },
        _v4: function(a, b) {
            setTimeout(function() {
                a.css(b);
            }, 6);
        },
        _u4: function(b) {
            var c, d, e, f, g, h, i, j = this;
            j._s4 = [], b.each(function(b) {
                c = a(this), d = {}, e = {}, f = null;
                var k = c.attr("data-move-offset"), k = k ? parseInt(k, 10) : j.st.block.moveOffset;
                if (0 < k && ((h = c.data("move-effect")) ? (h = h.toLowerCase(), "none" === h ? h = !1 : "left" !== h && "top" !== h && "bottom" !== h && "right" !== h && "none" === (h = j.st.block.moveEffect) && (h = !1)) : h = j.st.block.moveEffect, 
                h && "none" !== h)) {
                    var l;
                    l = "right" === h || "left" === h;
                    var m;
                    i = !1, j._e ? (m = 0, g = j._x1) : (l ? isNaN(parseInt(c.css("right"), 10)) ? g = "left" : (g = "right", 
                    i = !0) : isNaN(parseInt(c.css("bottom"), 10)) ? g = "top" : (g = "bottom", i = !0), 
                    g = "margin-" + g, i && (k = -k), j._e ? m = parseInt(c.css(g), 10) : void 0 === (m = c.data("rs-start-move-prop")) && (m = parseInt(c.css(g), 10), 
                    isNaN(m) && (m = 0), c.data("rs-start-move-prop", m))), e[g] = j._m4("top" === h || "left" === h ? m - k : m + k, l), 
                    d[g] = j._m4(m, l);
                }
                k = c.attr("data-fade-effect"), k ? "none" !== k.toLowerCase() && "false" !== k.toLowerCase() || (k = !1) : k = j.st.block.fadeEffect, 
                k && (e.opacity = 0, d.opacity = 1), (k || h) && (f = {}, f.hasFade = Boolean(k), 
                Boolean(h) && (f.moveProp = g, f.hasMove = !0), f.speed = c.data("speed"), isNaN(f.speed) && (f.speed = j.st.block.speed), 
                f.easing = c.data("easing"), f.easing || (f.easing = j.st.block.easing), f.css3Easing = a.rsCSS3Easing[f.easing], 
                f.delay = c.data("delay"), isNaN(f.delay) && (f.delay = j.st.block.delay * b)), 
                k = {}, j._e && (k[j._g + j._u1] = "0ms"), k.moveProp = d.moveProp, k.opacity = d.opacity, 
                k.display = "none", j._r4.push({
                    block: c,
                    css: k
                }), j._v4(c, e), j._s4.push(setTimeout(function(a, b, c, d) {
                    return function() {
                        if (a.css("display", "block"), c) {
                            var e = {};
                            if (j._e) {
                                var f = "";
                                c.hasMove && (f += c.moveProp), c.hasFade && (c.hasMove && (f += ", "), f += "opacity"), 
                                e[j._g + j._t1] = f, e[j._g + j._u1] = c.speed + "ms", e[j._g + j._v1] = c.css3Easing, 
                                a.css(e), setTimeout(function() {
                                    a.css(b);
                                }, 24);
                            } else setTimeout(function() {
                                a.animate(b, c.speed, c.easing);
                            }, 16);
                        }
                        delete j._s4[d];
                    };
                }(c, d, f, b), 6 >= f.delay ? 12 : f.delay));
            });
        }
    }), a.rsModules.animatedBlocks = a.rsProto._p4;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _w4: function() {
            var a = this;
            if (a.st.autoHeight) {
                var b, c, d, e = !0, f = function(f) {
                    d = a.slides[a.currSlideId], (b = d.holder) && (c = b.height()) && void 0 !== c && c > (a.st.minAutoHeight || 30) && (a._c4 = c, 
                    a._e || !f ? a._e1.css("height", c) : a._e1.stop(!0, !0).animate({
                        height: c
                    }, a.st.transitionSpeed), a.ev.trigger("rsAutoHeightChange", c), e && (a._e && setTimeout(function() {
                        a._e1.css(a._g + "transition", "height " + a.st.transitionSpeed + "ms ease-in-out");
                    }, 16), e = !1));
                };
                a.ev.on("rsMaybeSizeReady.rsAutoHeight", function(a, b) {
                    d === b && f();
                }), a.ev.on("rsAfterContentSet.rsAutoHeight", function(a, b) {
                    d === b && f();
                }), a.slider.addClass("rsAutoHeight"), a.ev.one("rsAfterInit", function() {
                    setTimeout(function() {
                        f(!1), setTimeout(function() {
                            a.slider.append('<div style="clear:both; float: none;"></div>');
                        }, 16);
                    }, 16);
                }), a.ev.on("rsBeforeAnimStart", function() {
                    f(!0);
                }), a.ev.on("rsBeforeSizeSet", function() {
                    setTimeout(function() {
                        f(!1);
                    }, 16);
                });
            }
        }
    }), a.rsModules.autoHeight = a.rsProto._w4;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _d6: function() {
            var b = this;
            b.st.globalCaption && (b.ev.on("rsAfterInit", function() {
                b.globalCaption = a('<div class="rsGCaption"></div>').appendTo(b.st.globalCaptionInside ? b._e1 : b.slider), 
                b.globalCaption.html(b.currSlide.caption);
            }), b.ev.on("rsBeforeAnimStart", function() {
                b.globalCaption.html(b.currSlide.caption);
            }));
        }
    }), a.rsModules.globalCaption = a.rsProto._d6;
}(jQuery), function(a) {
    a.rsProto._o4 = function() {
        var a, b = this;
        b.st.addActiveClass && b.ev.on("rsOnUpdateNav", function() {
            a && clearTimeout(a), a = setTimeout(function() {
                b._g4 && b._g4.removeClass("rsActiveSlide"), b._r1 && b._r1.addClass("rsActiveSlide"), 
                a = null;
            }, 50);
        });
    }, a.rsModules.activeClass = a.rsProto._o4;
}(jQuery), function(a) {
    a.extend(a.rsProto, {
        _o5: function() {
            var b, c, d, e = this;
            if (e._p5 = {
                enabled: !1,
                change: !1,
                prefix: ""
            }, e.st.deeplinking = a.extend({}, e._p5, e.st.deeplinking), e.st.deeplinking.enabled) {
                var f = e.st.deeplinking.change, g = e.st.deeplinking.prefix, h = "#" + g, i = function() {
                    var a = window.location.hash;
                    return a && 0 < a.indexOf(g) && 0 <= (a = parseInt(a.substring(h.length), 10)) ? a - 1 : -1;
                }, j = i();
                -1 !== j && (e.st.startSlideId = j), f && (a(window).on("hashchange" + e.ns, function(a) {
                    b || 0 > (a = i()) || (a > e.numSlides - 1 && (a = e.numSlides - 1), e.goTo(a));
                }), e.ev.on("rsBeforeAnimStart", function() {
                    c && clearTimeout(c), d && clearTimeout(d);
                }), e.ev.on("rsAfterSlideChange", function() {
                    c && clearTimeout(c), d && clearTimeout(d), d = setTimeout(function() {
                        b = !0, window.location.replace(("" + window.location).split("#")[0] + h + (e.currSlideId + 1)), 
                        c = setTimeout(function() {
                            b = !1, c = null;
                        }, 60);
                    }, 400);
                })), e.ev.on("rsBeforeDestroy", function() {
                    c = d = null, f && a(window).off("hashchange" + e.ns);
                });
            }
        }
    }), a.rsModules.deeplinking = a.rsProto._o5;
}(jQuery), function(a, b, c) {
    function d(a) {
        return a = a || location.href, "#" + a.replace(/^[^#]*#?(.*)$/, "$1");
    }
    var e, f = "hashchange", g = document, h = a.event.special, i = g.documentMode, j = "on" + f in b && (i === c || 7 < i);
    a.fn[f] = function(a) {
        return a ? this.bind(f, a) : this.trigger(f);
    }, a.fn[f].delay = 50, h[f] = a.extend(h[f], {
        setup: function() {
            if (j) return !1;
            a(e.start);
        },
        teardown: function() {
            if (j) return !1;
            a(e.stop);
        }
    }), e = function() {
        function e() {
            var c = d(), g = n(k);
            c !== k ? (m(k = c, g), a(b).trigger(f)) : g !== k && (location.href = location.href.replace(/#.*/, "") + g), 
            h = setTimeout(e, a.fn[f].delay);
        }
        var h, i = {}, k = d(), l = function(a) {
            return a;
        }, m = l, n = l;
        return i.start = function() {
            h || e();
        }, i.stop = function() {
            h && clearTimeout(h), h = c;
        }, b.attachEvent && !b.addEventListener && !j && function() {
            var b, c;
            i.start = function() {
                b || (c = (c = a.fn[f].src) && c + d(), b = a('<iframe tabindex="-1" title="empty"/>').hide().one("load", function() {
                    c || m(d()), e();
                }).attr("src", c || "javascript:0").insertAfter("body")[0].contentWindow, g.onpropertychange = function() {
                    try {
                        "title" === event.propertyName && (b.document.title = g.title);
                    } catch (a) {}
                });
            }, i.stop = l, n = function() {
                return d(b.location.href);
            }, m = function(c, d) {
                var e = b.document, h = a.fn[f].domain;
                c !== d && (e.title = g.title, e.open(), h && e.write('<script>document.domain="' + h + '"<\/script>'), 
                e.close(), b.location.hash = c);
            };
        }(), i;
    }();
}(jQuery, this), function(a) {
    a.rsProto._g7 = function() {
        var b = this;
        b.st.visibleNearby && b.st.visibleNearby.enabled && (b._h7 = {
            enabled: !0,
            centerArea: .6,
            center: !0,
            breakpoint: 0,
            breakpointCenterArea: .8,
            hiddenOverflow: !0,
            navigateByCenterClick: !1
        }, b.st.visibleNearby = a.extend({}, b._h7, b.st.visibleNearby), b.ev.one("rsAfterPropsSetup", function() {
            b._i7 = b._e1.css("overflow", "visible").wrap('<div class="rsVisibleNearbyWrap"></div>').parent(), 
            b.st.visibleNearby.hiddenOverflow || b._i7.css("overflow", "visible"), b._o1 = b.st.controlsInside ? b._i7 : b.slider;
        }), b.ev.on("rsAfterSizePropSet", function() {
            var a, c = b.st.visibleNearby;
            a = c.breakpoint && b.width < c.breakpoint ? c.breakpointCenterArea : c.centerArea, 
            b._h ? (b._b4 *= a, b._i7.css({
                height: b._c4,
                width: b._b4 / a
            }), b._d = b._b4 * (1 - a) / 2 / a) : (b._c4 *= a, b._i7.css({
                height: b._c4 / a,
                width: b._b4
            }), b._d = b._c4 * (1 - a) / 2 / a), c.navigateByCenterClick || (b._q = b._h ? b._b4 : b._c4), 
            c.center && b._e1.css("margin-" + (b._h ? "left" : "top"), b._d);
        }));
    }, a.rsModules.visibleNearby = a.rsProto._g7;
}(jQuery), function(a) {
    var b = !1;
    if ("function" == typeof define && define.amd && (define(a), b = !0), "object" == typeof exports && (module.exports = a(), 
    b = !0), !b) {
        var c = window.Cookies, d = window.Cookies = a();
        d.noConflict = function() {
            return window.Cookies = c, d;
        };
    }
}(function() {
    function a() {
        for (var a = 0, b = {}; a < arguments.length; a++) {
            var c = arguments[a];
            for (var d in c) b[d] = c[d];
        }
        return b;
    }
    function b(c) {
        function d(b, e, f) {
            var g;
            if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                    if (f = a({
                        path: "/"
                    }, d.defaults, f), "number" == typeof f.expires) {
                        var h = new Date();
                        h.setMilliseconds(h.getMilliseconds() + 864e5 * f.expires), f.expires = h;
                    }
                    try {
                        g = JSON.stringify(e), /^[\{\[]/.test(g) && (e = g);
                    } catch (a) {}
                    return e = c.write ? c.write(e, b) : encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), 
                    b = encodeURIComponent(String(b)), b = b.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), 
                    b = b.replace(/[\(\)]/g, escape), document.cookie = [ b, "=", e, f.expires ? "; expires=" + f.expires.toUTCString() : "", f.path ? "; path=" + f.path : "", f.domain ? "; domain=" + f.domain : "", f.secure ? "; secure" : "" ].join("");
                }
                b || (g = {});
                for (var i = document.cookie ? document.cookie.split("; ") : [], j = /(%[0-9A-Z]{2})+/g, k = 0; k < i.length; k++) {
                    var l = i[k].split("="), m = l.slice(1).join("=");
                    '"' === m.charAt(0) && (m = m.slice(1, -1));
                    try {
                        var n = l[0].replace(j, decodeURIComponent);
                        if (m = c.read ? c.read(m, n) : c(m, n) || m.replace(j, decodeURIComponent), this.json) try {
                            m = JSON.parse(m);
                        } catch (a) {}
                        if (b === n) {
                            g = m;
                            break;
                        }
                        b || (g[n] = m);
                    } catch (a) {}
                }
                return g;
            }
        }
        return d.set = d, d.get = function(a) {
            return d.call(d, a);
        }, d.getJSON = function() {
            return d.apply({
                json: !0
            }, [].slice.call(arguments));
        }, d.defaults = {}, d.remove = function(b, c) {
            d(b, "", a(c, {
                expires: -1
            }));
        }, d.withConverter = b, d;
    }
    return b(function() {});
}), function(a, b) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", [ "jquery" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("jquery")) : a.jQueryBridget = b(a, a.jQuery);
}(window, function(a, b) {
    "use strict";
    function c(c, f, h) {
        function i(a, b, d) {
            var e, f = "$()." + c + '("' + b + '")';
            return a.each(function(a, i) {
                var j = h.data(i, c);
                if (!j) return void g(c + " not initialized. Cannot call methods, i.e. " + f);
                var k = j[b];
                if (!k || "_" == b.charAt(0)) return void g(f + " is not a valid method");
                var l = k.apply(j, d);
                e = void 0 === e ? l : e;
            }), void 0 !== e ? e : a;
        }
        function j(a, b) {
            a.each(function(a, d) {
                var e = h.data(d, c);
                e ? (e.option(b), e._init()) : (e = new f(d, b), h.data(d, c, e));
            });
        }
        (h = h || b || a.jQuery) && (f.prototype.option || (f.prototype.option = function(a) {
            h.isPlainObject(a) && (this.options = h.extend(!0, this.options, a));
        }), h.fn[c] = function(a) {
            if ("string" == typeof a) {
                return i(this, a, e.call(arguments, 1));
            }
            return j(this, a), this;
        }, d(h));
    }
    function d(a) {
        !a || a && a.bridget || (a.bridget = c);
    }
    var e = Array.prototype.slice, f = a.console, g = void 0 === f ? function() {} : function(a) {
        f.error(a);
    };
    return d(b || a.jQuery), c;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? module.exports = b() : a.EvEmitter = b();
}("undefined" != typeof window ? window : this, function() {
    function a() {}
    var b = a.prototype;
    return b.on = function(a, b) {
        if (a && b) {
            var c = this._events = this._events || {}, d = c[a] = c[a] || [];
            return -1 == d.indexOf(b) && d.push(b), this;
        }
    }, b.once = function(a, b) {
        if (a && b) {
            this.on(a, b);
            var c = this._onceEvents = this._onceEvents || {};
            return (c[a] = c[a] || {})[b] = !0, this;
        }
    }, b.off = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            var d = c.indexOf(b);
            return -1 != d && c.splice(d, 1), this;
        }
    }, b.emitEvent = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            var d = 0, e = c[d];
            b = b || [];
            for (var f = this._onceEvents && this._onceEvents[a]; e; ) {
                var g = f && f[e];
                g && (this.off(a, e), delete f[e]), e.apply(this, b), d += g ? 0 : 1, e = c[d];
            }
            return this;
        }
    }, a;
}), function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define("get-size/get-size", [], function() {
        return b();
    }) : "object" == typeof module && module.exports ? module.exports = b() : a.getSize = b();
}(window, function() {
    "use strict";
    function a(a) {
        var b = parseFloat(a);
        return -1 == a.indexOf("%") && !isNaN(b) && b;
    }
    function b() {}
    function c() {
        for (var a = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, b = 0; b < j; b++) {
            a[i[b]] = 0;
        }
        return a;
    }
    function d(a) {
        var b = getComputedStyle(a);
        return b || h("Style returned " + b + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), 
        b;
    }
    function e() {
        if (!k) {
            k = !0;
            var b = document.createElement("div");
            b.style.width = "200px", b.style.padding = "1px 2px 3px 4px", b.style.borderStyle = "solid", 
            b.style.borderWidth = "1px 2px 3px 4px", b.style.boxSizing = "border-box";
            var c = document.body || document.documentElement;
            c.appendChild(b);
            var e = d(b);
            f.isBoxSizeOuter = g = 200 == a(e.width), c.removeChild(b);
        }
    }
    function f(b) {
        if (e(), "string" == typeof b && (b = document.querySelector(b)), b && "object" == typeof b && b.nodeType) {
            var f = d(b);
            if ("none" == f.display) return c();
            var h = {};
            h.width = b.offsetWidth, h.height = b.offsetHeight;
            for (var k = h.isBorderBox = "border-box" == f.boxSizing, l = 0; l < j; l++) {
                var m = i[l], n = f[m], o = parseFloat(n);
                h[m] = isNaN(o) ? 0 : o;
            }
            var p = h.paddingLeft + h.paddingRight, q = h.paddingTop + h.paddingBottom, r = h.marginLeft + h.marginRight, s = h.marginTop + h.marginBottom, t = h.borderLeftWidth + h.borderRightWidth, u = h.borderTopWidth + h.borderBottomWidth, v = k && g, w = a(f.width);
            !1 !== w && (h.width = w + (v ? 0 : p + t));
            var x = a(f.height);
            return !1 !== x && (h.height = x + (v ? 0 : q + u)), h.innerWidth = h.width - (p + t), 
            h.innerHeight = h.height - (q + u), h.outerWidth = h.width + r, h.outerHeight = h.height + s, 
            h;
        }
    }
    var g, h = "undefined" == typeof console ? b : function(a) {
        console.error(a);
    }, i = [ "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth" ], j = i.length, k = !1;
    return f;
}), function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", b) : "object" == typeof module && module.exports ? module.exports = b() : a.matchesSelector = b();
}(window, function() {
    "use strict";
    var a = function() {
        var a = Element.prototype;
        if (a.matches) return "matches";
        if (a.matchesSelector) return "matchesSelector";
        for (var b = [ "webkit", "moz", "ms", "o" ], c = 0; c < b.length; c++) {
            var d = b[c], e = d + "MatchesSelector";
            if (a[e]) return e;
        }
    }();
    return function(b, c) {
        return b[a](c);
    };
}), function(a, b) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", [ "desandro-matches-selector/matches-selector" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("desandro-matches-selector")) : a.fizzyUIUtils = b(a, a.matchesSelector);
}(window, function(a, b) {
    var c = {};
    c.extend = function(a, b) {
        for (var c in b) a[c] = b[c];
        return a;
    }, c.modulo = function(a, b) {
        return (a % b + b) % b;
    }, c.makeArray = function(a) {
        var b = [];
        if (Array.isArray(a)) b = a; else if (a && "number" == typeof a.length) for (var c = 0; c < a.length; c++) b.push(a[c]); else b.push(a);
        return b;
    }, c.removeFrom = function(a, b) {
        var c = a.indexOf(b);
        -1 != c && a.splice(c, 1);
    }, c.getParent = function(a, c) {
        for (;a != document.body; ) if (a = a.parentNode, b(a, c)) return a;
    }, c.getQueryElement = function(a) {
        return "string" == typeof a ? document.querySelector(a) : a;
    }, c.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a);
    }, c.filterFindElements = function(a, d) {
        a = c.makeArray(a);
        var e = [];
        return a.forEach(function(a) {
            if (a instanceof HTMLElement) {
                if (!d) return void e.push(a);
                b(a, d) && e.push(a);
                for (var c = a.querySelectorAll(d), f = 0; f < c.length; f++) e.push(c[f]);
            }
        }), e;
    }, c.debounceMethod = function(a, b, c) {
        var d = a.prototype[b], e = b + "Timeout";
        a.prototype[b] = function() {
            var a = this[e];
            a && clearTimeout(a);
            var b = arguments, f = this;
            this[e] = setTimeout(function() {
                d.apply(f, b), delete f[e];
            }, c || 100);
        };
    }, c.docReady = function(a) {
        var b = document.readyState;
        "complete" == b || "interactive" == b ? setTimeout(a) : document.addEventListener("DOMContentLoaded", a);
    }, c.toDashed = function(a) {
        return a.replace(/(.)([A-Z])/g, function(a, b, c) {
            return b + "-" + c;
        }).toLowerCase();
    };
    var d = a.console;
    return c.htmlInit = function(b, e) {
        c.docReady(function() {
            var f = c.toDashed(e), g = "data-" + f, h = document.querySelectorAll("[" + g + "]"), i = document.querySelectorAll(".js-" + f), j = c.makeArray(h).concat(c.makeArray(i)), k = g + "-options", l = a.jQuery;
            j.forEach(function(a) {
                var c, f = a.getAttribute(g) || a.getAttribute(k);
                try {
                    c = f && JSON.parse(f);
                } catch (b) {
                    return void (d && d.error("Error parsing " + g + " on " + a.className + ": " + b));
                }
                var h = new b(a, c);
                l && l.data(a, e, h);
            });
        });
    }, c;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/cell", [ "get-size/get-size" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("get-size")) : (a.Flickity = a.Flickity || {}, 
    a.Flickity.Cell = b(a, a.getSize));
}(window, function(a, b) {
    function c(a, b) {
        this.element = a, this.parent = b, this.create();
    }
    var d = c.prototype;
    return d.create = function() {
        this.element.style.position = "absolute", this.x = 0, this.shift = 0;
    }, d.destroy = function() {
        this.element.style.position = "";
        var a = this.parent.originSide;
        this.element.style[a] = "";
    }, d.getSize = function() {
        this.size = b(this.element);
    }, d.setPosition = function(a) {
        this.x = a, this.updateTarget(), this.renderPosition(a);
    }, d.updateTarget = d.setDefaultTarget = function() {
        var a = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[a] + this.size.width * this.parent.cellAlign;
    }, d.renderPosition = function(a) {
        var b = this.parent.originSide;
        this.element.style[b] = this.parent.getPositionValue(a);
    }, d.wrapShift = function(a) {
        this.shift = a, this.renderPosition(this.x + this.parent.slideableWidth * a);
    }, d.remove = function() {
        this.element.parentNode.removeChild(this.element);
    }, c;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/slide", b) : "object" == typeof module && module.exports ? module.exports = b() : (a.Flickity = a.Flickity || {}, 
    a.Flickity.Slide = b());
}(window, function() {
    "use strict";
    function a(a) {
        this.parent = a, this.isOriginLeft = "left" == a.originSide, this.cells = [], this.outerWidth = 0, 
        this.height = 0;
    }
    var b = a.prototype;
    return b.addCell = function(a) {
        if (this.cells.push(a), this.outerWidth += a.size.outerWidth, this.height = Math.max(a.size.outerHeight, this.height), 
        1 == this.cells.length) {
            this.x = a.x;
            var b = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = a.size[b];
        }
    }, b.updateTarget = function() {
        var a = this.isOriginLeft ? "marginRight" : "marginLeft", b = this.getLastCell(), c = b ? b.size[a] : 0, d = this.outerWidth - (this.firstMargin + c);
        this.target = this.x + this.firstMargin + d * this.parent.cellAlign;
    }, b.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    }, b.select = function() {
        this.changeSelectedClass("add");
    }, b.unselect = function() {
        this.changeSelectedClass("remove");
    }, b.changeSelectedClass = function(a) {
        this.cells.forEach(function(b) {
            b.element.classList[a]("is-selected");
        });
    }, b.getCellElements = function() {
        return this.cells.map(function(a) {
            return a.element;
        });
    }, a;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/animate", [ "fizzy-ui-utils/utils" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("fizzy-ui-utils")) : (a.Flickity = a.Flickity || {}, 
    a.Flickity.animatePrototype = b(a, a.fizzyUIUtils));
}(window, function(a, b) {
    var c = a.requestAnimationFrame || a.webkitRequestAnimationFrame, d = 0;
    c || (c = function(a) {
        var b = new Date().getTime(), c = Math.max(0, 16 - (b - d)), e = setTimeout(a, c);
        return d = b + c, e;
    });
    var e = {};
    e.startAnimation = function() {
        this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate());
    }, e.animate = function() {
        this.applyDragForce(), this.applySelectedAttraction();
        var a = this.x;
        if (this.integratePhysics(), this.positionSlider(), this.settle(a), this.isAnimating) {
            var b = this;
            c(function() {
                b.animate();
            });
        }
    };
    var f = function() {
        return "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform";
    }();
    return e.positionSlider = function() {
        var a = this.x;
        this.options.wrapAround && this.cells.length > 1 && (a = b.modulo(a, this.slideableWidth), 
        a -= this.slideableWidth, this.shiftWrapCells(a)), a += this.cursorPosition, a = this.options.rightToLeft && f ? -a : a;
        var c = this.getPositionValue(a);
        this.slider.style[f] = this.isAnimating ? "translate3d(" + c + ",0,0)" : "translateX(" + c + ")";
        var d = this.slides[0];
        if (d) {
            var e = -this.x - d.target, g = e / this.slidesWidth;
            this.dispatchEvent("scroll", null, [ g, e ]);
        }
    }, e.positionSliderAtSelected = function() {
        this.cells.length && (this.x = -this.selectedSlide.target, this.positionSlider());
    }, e.getPositionValue = function(a) {
        return this.options.percentPosition ? .01 * Math.round(a / this.size.innerWidth * 1e4) + "%" : Math.round(a) + "px";
    }, e.settle = function(a) {
        this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * a) || this.restingFrames++, 
        this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), 
        this.dispatchEvent("settle"));
    }, e.shiftWrapCells = function(a) {
        var b = this.cursorPosition + a;
        this._shiftCells(this.beforeShiftCells, b, -1);
        var c = this.size.innerWidth - (a + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, c, 1);
    }, e._shiftCells = function(a, b, c) {
        for (var d = 0; d < a.length; d++) {
            var e = a[d], f = b > 0 ? c : 0;
            e.wrapShift(f), b -= e.size.outerWidth;
        }
    }, e._unshiftCells = function(a) {
        if (a && a.length) for (var b = 0; b < a.length; b++) a[b].wrapShift(0);
    }, e.integratePhysics = function() {
        this.x += this.velocity, this.velocity *= this.getFrictionFactor();
    }, e.applyForce = function(a) {
        this.velocity += a;
    }, e.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
    }, e.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    }, e.applyDragForce = function() {
        if (this.isPointerDown) {
            var a = this.dragX - this.x, b = a - this.velocity;
            this.applyForce(b);
        }
    }, e.applySelectedAttraction = function() {
        if (!this.isPointerDown && !this.isFreeScrolling && this.cells.length) {
            var a = -1 * this.selectedSlide.target - this.x, b = a * this.options.selectedAttraction;
            this.applyForce(b);
        }
    }, e;
}), function(a, b) {
    if ("function" == typeof define && define.amd) define("flickity/js/flickity", [ "ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate" ], function(c, d, e, f, g, h) {
        return b(a, c, d, e, f, g, h);
    }); else if ("object" == typeof module && module.exports) module.exports = b(a, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate")); else {
        var c = a.Flickity;
        a.Flickity = b(a, a.EvEmitter, a.getSize, a.fizzyUIUtils, c.Cell, c.Slide, c.animatePrototype);
    }
}(window, function(a, b, c, d, e, f, g) {
    function h(a, b) {
        for (a = d.makeArray(a); a.length; ) b.appendChild(a.shift());
    }
    function i(a, b) {
        var c = d.getQueryElement(a);
        if (!c) return void (l && l.error("Bad element for Flickity: " + (c || a)));
        if (this.element = c, this.element.flickityGUID) {
            var e = n[this.element.flickityGUID];
            return e.option(b), e;
        }
        j && (this.$element = j(this.element)), this.options = d.extend({}, this.constructor.defaults), 
        this.option(b), this._create();
    }
    var j = a.jQuery, k = a.getComputedStyle, l = a.console, m = 0, n = {};
    i.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    }, i.createMethods = [];
    var o = i.prototype;
    d.extend(o, b.prototype), o._create = function() {
        var b = this.guid = ++m;
        this.element.flickityGUID = b, n[b] = this, this.selectedIndex = 0, this.restingFrames = 0, 
        this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", 
        this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", 
        this._createSlider(), (this.options.resize || this.options.watchCSS) && a.addEventListener("resize", this), 
        i.createMethods.forEach(function(a) {
            this[a]();
        }, this), this.options.watchCSS ? this.watchCSS() : this.activate();
    }, o.option = function(a) {
        d.extend(this.options, a);
    }, o.activate = function() {
        if (!this.isActive) {
            this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), 
            this.getSize();
            h(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), 
            this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, 
            this.element.addEventListener("keydown", this)), this.emitEvent("activate");
            var a, b = this.options.initialIndex;
            a = this.isInitActivated ? this.selectedIndex : void 0 !== b && this.cells[b] ? b : 0, 
            this.select(a, !1, !0), this.isInitActivated = !0;
        }
    }, o._createSlider = function() {
        var a = document.createElement("div");
        a.className = "flickity-slider", a.style[this.originSide] = 0, this.slider = a;
    }, o._filterFindCellElements = function(a) {
        return d.filterFindElements(a, this.options.cellSelector);
    }, o.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), 
        this.setGallerySize();
    }, o._makeCells = function(a) {
        return this._filterFindCellElements(a).map(function(a) {
            return new e(a, this);
        }, this);
    }, o.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    }, o.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    }, o.positionCells = function() {
        this._sizeCells(this.cells), this._positionCells(0);
    }, o._positionCells = function(a) {
        a = a || 0, this.maxCellHeight = a ? this.maxCellHeight || 0 : 0;
        var b = 0;
        if (a > 0) {
            var c = this.cells[a - 1];
            b = c.x + c.size.outerWidth;
        }
        for (var d = this.cells.length, e = a; e < d; e++) {
            var f = this.cells[e];
            f.setPosition(b), b += f.size.outerWidth, this.maxCellHeight = Math.max(f.size.outerHeight, this.maxCellHeight);
        }
        this.slideableWidth = b, this.updateSlides(), this._containSlides(), this.slidesWidth = d ? this.getLastSlide().target - this.slides[0].target : 0;
    }, o._sizeCells = function(a) {
        a.forEach(function(a) {
            a.getSize();
        });
    }, o.updateSlides = function() {
        if (this.slides = [], this.cells.length) {
            var a = new f(this);
            this.slides.push(a);
            var b = "left" == this.originSide, c = b ? "marginRight" : "marginLeft", d = this._getCanCellFit();
            this.cells.forEach(function(b, e) {
                if (!a.cells.length) return void a.addCell(b);
                var g = a.outerWidth - a.firstMargin + (b.size.outerWidth - b.size[c]);
                d.call(this, e, g) ? a.addCell(b) : (a.updateTarget(), a = new f(this), this.slides.push(a), 
                a.addCell(b));
            }, this), a.updateTarget(), this.updateSelectedSlide();
        }
    }, o._getCanCellFit = function() {
        var a = this.options.groupCells;
        if (!a) return function() {
            return !1;
        };
        if ("number" == typeof a) {
            var b = parseInt(a, 10);
            return function(a) {
                return a % b != 0;
            };
        }
        var c = "string" == typeof a && a.match(/^(\d+)%$/), d = c ? parseInt(c[1], 10) / 100 : 1;
        return function(a, b) {
            return b <= (this.size.innerWidth + 1) * d;
        };
    }, o._init = o.reposition = function() {
        this.positionCells(), this.positionSliderAtSelected();
    }, o.getSize = function() {
        this.size = c(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var p = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    return o.setCellAlign = function() {
        var a = p[this.options.cellAlign];
        this.cellAlign = a ? a[this.originSide] : this.options.cellAlign;
    }, o.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var a = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = a + "px";
        }
    }, o._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
            var a = this.cursorPosition, b = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(a, b, -1), a = this.size.innerWidth - this.cursorPosition, 
            this.afterShiftCells = this._getGapCells(a, 0, 1);
        }
    }, o._getGapCells = function(a, b, c) {
        for (var d = []; a > 0; ) {
            var e = this.cells[b];
            if (!e) break;
            d.push(e), b += c, a -= e.size.outerWidth;
        }
        return d;
    }, o._containSlides = function() {
        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
            var a = this.options.rightToLeft, b = a ? "marginRight" : "marginLeft", c = a ? "marginLeft" : "marginRight", d = this.slideableWidth - this.getLastCell().size[c], e = d < this.size.innerWidth, f = this.cursorPosition + this.cells[0].size[b], g = d - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach(function(a) {
                e ? a.target = d * this.cellAlign : (a.target = Math.max(a.target, f), a.target = Math.min(a.target, g));
            }, this);
        }
    }, o.dispatchEvent = function(a, b, c) {
        var d = b ? [ b ].concat(c) : c;
        if (this.emitEvent(a, d), j && this.$element) {
            a += this.options.namespaceJQueryEvents ? ".flickity" : "";
            var e = a;
            if (b) {
                var f = j.Event(b);
                f.type = a, e = f;
            }
            this.$element.trigger(e, c);
        }
    }, o.select = function(a, b, c) {
        this.isActive && (a = parseInt(a, 10), this._wrapSelect(a), (this.options.wrapAround || b) && (a = d.modulo(a, this.slides.length)), 
        this.slides[a] && (this.selectedIndex = a, this.updateSelectedSlide(), c ? this.positionSliderAtSelected() : this.startAnimation(), 
        this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select"), 
        this.dispatchEvent("cellSelect")));
    }, o._wrapSelect = function(a) {
        var b = this.slides.length;
        if (!(this.options.wrapAround && b > 1)) return a;
        var c = d.modulo(a, b), e = Math.abs(c - this.selectedIndex), f = Math.abs(c + b - this.selectedIndex), g = Math.abs(c - b - this.selectedIndex);
        !this.isDragSelect && f < e ? a += b : !this.isDragSelect && g < e && (a -= b), 
        a < 0 ? this.x -= this.slideableWidth : a >= b && (this.x += this.slideableWidth);
    }, o.previous = function(a, b) {
        this.select(this.selectedIndex - 1, a, b);
    }, o.next = function(a, b) {
        this.select(this.selectedIndex + 1, a, b);
    }, o.updateSelectedSlide = function() {
        var a = this.slides[this.selectedIndex];
        a && (this.unselectSelectedSlide(), this.selectedSlide = a, a.select(), this.selectedCells = a.cells, 
        this.selectedElements = a.getCellElements(), this.selectedCell = a.cells[0], this.selectedElement = this.selectedElements[0]);
    }, o.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect();
    }, o.selectCell = function(a, b, c) {
        var d;
        "number" == typeof a ? d = this.cells[a] : ("string" == typeof a && (a = this.element.querySelector(a)), 
        d = this.getCell(a));
        for (var e = 0; d && e < this.slides.length; e++) {
            if (-1 != this.slides[e].cells.indexOf(d)) return void this.select(e, b, c);
        }
    }, o.getCell = function(a) {
        for (var b = 0; b < this.cells.length; b++) {
            var c = this.cells[b];
            if (c.element == a) return c;
        }
    }, o.getCells = function(a) {
        a = d.makeArray(a);
        var b = [];
        return a.forEach(function(a) {
            var c = this.getCell(a);
            c && b.push(c);
        }, this), b;
    }, o.getCellElements = function() {
        return this.cells.map(function(a) {
            return a.element;
        });
    }, o.getParentCell = function(a) {
        var b = this.getCell(a);
        return b || (a = d.getParent(a, ".flickity-slider > *"), this.getCell(a));
    }, o.getAdjacentCellElements = function(a, b) {
        if (!a) return this.selectedSlide.getCellElements();
        b = void 0 === b ? this.selectedIndex : b;
        var c = this.slides.length;
        if (1 + 2 * a >= c) return this.getCellElements();
        for (var e = [], f = b - a; f <= b + a; f++) {
            var g = this.options.wrapAround ? d.modulo(f, c) : f, h = this.slides[g];
            h && (e = e.concat(h.getCellElements()));
        }
        return e;
    }, o.uiChange = function() {
        this.emitEvent("uiChange");
    }, o.childUIPointerDown = function(a) {
        this.emitEvent("childUIPointerDown", [ a ]);
    }, o.onresize = function() {
        this.watchCSS(), this.resize();
    }, d.debounceMethod(i, "onresize", 150), o.resize = function() {
        if (this.isActive) {
            this.getSize(), this.options.wrapAround && (this.x = d.modulo(this.x, this.slideableWidth)), 
            this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
            var a = this.selectedElements && this.selectedElements[0];
            this.selectCell(a, !1, !0);
        }
    }, o.watchCSS = function() {
        this.options.watchCSS && (-1 != k(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate());
    }, o.onkeydown = function(a) {
        if (this.options.accessibility && (!document.activeElement || document.activeElement == this.element)) if (37 == a.keyCode) {
            var b = this.options.rightToLeft ? "next" : "previous";
            this.uiChange(), this[b]();
        } else if (39 == a.keyCode) {
            var c = this.options.rightToLeft ? "previous" : "next";
            this.uiChange(), this[c]();
        }
    }, o.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), 
        this.cells.forEach(function(a) {
            a.destroy();
        }), this.unselectSelectedSlide(), this.element.removeChild(this.viewport), h(this.slider.children, this.element), 
        this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), 
        this.isActive = !1, this.emitEvent("deactivate"));
    }, o.destroy = function() {
        this.deactivate(), a.removeEventListener("resize", this), this.emitEvent("destroy"), 
        j && this.$element && j.removeData(this.element, "flickity"), delete this.element.flickityGUID, 
        delete n[this.guid];
    }, d.extend(o, g), i.data = function(a) {
        a = d.getQueryElement(a);
        var b = a && a.flickityGUID;
        return b && n[b];
    }, d.htmlInit(i, "flickity"), j && j.bridget && j.bridget("flickity", i), i.Cell = e, 
    i;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("unipointer/unipointer", [ "ev-emitter/ev-emitter" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("ev-emitter")) : a.Unipointer = b(a, a.EvEmitter);
}(window, function(a, b) {
    function c() {}
    function d() {}
    var e = d.prototype = Object.create(b.prototype);
    e.bindStartEvent = function(a) {
        this._bindStartEvent(a, !0);
    }, e.unbindStartEvent = function(a) {
        this._bindStartEvent(a, !1);
    }, e._bindStartEvent = function(b, c) {
        c = void 0 === c || !!c;
        var d = c ? "addEventListener" : "removeEventListener";
        a.navigator.pointerEnabled ? b[d]("pointerdown", this) : a.navigator.msPointerEnabled ? b[d]("MSPointerDown", this) : (b[d]("mousedown", this), 
        b[d]("touchstart", this));
    }, e.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a);
    }, e.getTouch = function(a) {
        for (var b = 0; b < a.length; b++) {
            var c = a[b];
            if (c.identifier == this.pointerIdentifier) return c;
        }
    }, e.onmousedown = function(a) {
        var b = a.button;
        b && 0 !== b && 1 !== b || this._pointerDown(a, a);
    }, e.ontouchstart = function(a) {
        this._pointerDown(a, a.changedTouches[0]);
    }, e.onMSPointerDown = e.onpointerdown = function(a) {
        this._pointerDown(a, a);
    }, e._pointerDown = function(a, b) {
        this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== b.pointerId ? b.pointerId : b.identifier, 
        this.pointerDown(a, b));
    }, e.pointerDown = function(a, b) {
        this._bindPostStartEvents(a), this.emitEvent("pointerDown", [ a, b ]);
    };
    var f = {
        mousedown: [ "mousemove", "mouseup" ],
        touchstart: [ "touchmove", "touchend", "touchcancel" ],
        pointerdown: [ "pointermove", "pointerup", "pointercancel" ],
        MSPointerDown: [ "MSPointerMove", "MSPointerUp", "MSPointerCancel" ]
    };
    return e._bindPostStartEvents = function(b) {
        if (b) {
            var c = f[b.type];
            c.forEach(function(b) {
                a.addEventListener(b, this);
            }, this), this._boundPointerEvents = c;
        }
    }, e._unbindPostStartEvents = function() {
        this._boundPointerEvents && (this._boundPointerEvents.forEach(function(b) {
            a.removeEventListener(b, this);
        }, this), delete this._boundPointerEvents);
    }, e.onmousemove = function(a) {
        this._pointerMove(a, a);
    }, e.onMSPointerMove = e.onpointermove = function(a) {
        a.pointerId == this.pointerIdentifier && this._pointerMove(a, a);
    }, e.ontouchmove = function(a) {
        var b = this.getTouch(a.changedTouches);
        b && this._pointerMove(a, b);
    }, e._pointerMove = function(a, b) {
        this.pointerMove(a, b);
    }, e.pointerMove = function(a, b) {
        this.emitEvent("pointerMove", [ a, b ]);
    }, e.onmouseup = function(a) {
        this._pointerUp(a, a);
    }, e.onMSPointerUp = e.onpointerup = function(a) {
        a.pointerId == this.pointerIdentifier && this._pointerUp(a, a);
    }, e.ontouchend = function(a) {
        var b = this.getTouch(a.changedTouches);
        b && this._pointerUp(a, b);
    }, e._pointerUp = function(a, b) {
        this._pointerDone(), this.pointerUp(a, b);
    }, e.pointerUp = function(a, b) {
        this.emitEvent("pointerUp", [ a, b ]);
    }, e._pointerDone = function() {
        this.isPointerDown = !1, delete this.pointerIdentifier, this._unbindPostStartEvents(), 
        this.pointerDone();
    }, e.pointerDone = c, e.onMSPointerCancel = e.onpointercancel = function(a) {
        a.pointerId == this.pointerIdentifier && this._pointerCancel(a, a);
    }, e.ontouchcancel = function(a) {
        var b = this.getTouch(a.changedTouches);
        b && this._pointerCancel(a, b);
    }, e._pointerCancel = function(a, b) {
        this._pointerDone(), this.pointerCancel(a, b);
    }, e.pointerCancel = function(a, b) {
        this.emitEvent("pointerCancel", [ a, b ]);
    }, d.getPointerPoint = function(a) {
        return {
            x: a.pageX,
            y: a.pageY
        };
    }, d;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("unidragger/unidragger", [ "unipointer/unipointer" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("unipointer")) : a.Unidragger = b(a, a.Unipointer);
}(window, function(a, b) {
    function c() {}
    function d() {}
    var e = d.prototype = Object.create(b.prototype);
    e.bindHandles = function() {
        this._bindHandles(!0);
    }, e.unbindHandles = function() {
        this._bindHandles(!1);
    };
    var f = a.navigator;
    return e._bindHandles = function(a) {
        a = void 0 === a || !!a;
        var b;
        b = f.pointerEnabled ? function(b) {
            b.style.touchAction = a ? "none" : "";
        } : f.msPointerEnabled ? function(b) {
            b.style.msTouchAction = a ? "none" : "";
        } : c;
        for (var d = a ? "addEventListener" : "removeEventListener", e = 0; e < this.handles.length; e++) {
            var g = this.handles[e];
            this._bindStartEvent(g, a), b(g), g[d]("click", this);
        }
    }, e.pointerDown = function(a, b) {
        if ("INPUT" == a.target.nodeName && "range" == a.target.type) return this.isPointerDown = !1, 
        void delete this.pointerIdentifier;
        this._dragPointerDown(a, b);
        var c = document.activeElement;
        c && c.blur && c.blur(), this._bindPostStartEvents(a), this.emitEvent("pointerDown", [ a, b ]);
    }, e._dragPointerDown = function(a, c) {
        this.pointerDownPoint = b.getPointerPoint(c), this.canPreventDefaultOnPointerDown(a, c) && a.preventDefault();
    }, e.canPreventDefaultOnPointerDown = function(a) {
        return "SELECT" != a.target.nodeName;
    }, e.pointerMove = function(a, b) {
        var c = this._dragPointerMove(a, b);
        this.emitEvent("pointerMove", [ a, b, c ]), this._dragMove(a, b, c);
    }, e._dragPointerMove = function(a, c) {
        var d = b.getPointerPoint(c), e = {
            x: d.x - this.pointerDownPoint.x,
            y: d.y - this.pointerDownPoint.y
        };
        return !this.isDragging && this.hasDragStarted(e) && this._dragStart(a, c), e;
    }, e.hasDragStarted = function(a) {
        return Math.abs(a.x) > 3 || Math.abs(a.y) > 3;
    }, e.pointerUp = function(a, b) {
        this.emitEvent("pointerUp", [ a, b ]), this._dragPointerUp(a, b);
    }, e._dragPointerUp = function(a, b) {
        this.isDragging ? this._dragEnd(a, b) : this._staticClick(a, b);
    }, e._dragStart = function(a, c) {
        this.isDragging = !0, this.dragStartPoint = b.getPointerPoint(c), this.isPreventingClicks = !0, 
        this.dragStart(a, c);
    }, e.dragStart = function(a, b) {
        this.emitEvent("dragStart", [ a, b ]);
    }, e._dragMove = function(a, b, c) {
        this.isDragging && this.dragMove(a, b, c);
    }, e.dragMove = function(a, b, c) {
        a.preventDefault(), this.emitEvent("dragMove", [ a, b, c ]);
    }, e._dragEnd = function(a, b) {
        this.isDragging = !1, setTimeout(function() {
            delete this.isPreventingClicks;
        }.bind(this)), this.dragEnd(a, b);
    }, e.dragEnd = function(a, b) {
        this.emitEvent("dragEnd", [ a, b ]);
    }, e.onclick = function(a) {
        this.isPreventingClicks && a.preventDefault();
    }, e._staticClick = function(a, b) {
        if (!this.isIgnoringMouseUp || "mouseup" != a.type) {
            var c = a.target.nodeName;
            "INPUT" != c && "TEXTAREA" != c || a.target.focus(), this.staticClick(a, b), "mouseup" != a.type && (this.isIgnoringMouseUp = !0, 
            setTimeout(function() {
                delete this.isIgnoringMouseUp;
            }.bind(this), 400));
        }
    }, e.staticClick = function(a, b) {
        this.emitEvent("staticClick", [ a, b ]);
    }, d.getPointerPoint = b.getPointerPoint, d;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/drag", [ "./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils" ], function(c, d, e) {
        return b(a, c, d, e);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : a.Flickity = b(a, a.Flickity, a.Unidragger, a.fizzyUIUtils);
}(window, function(a, b, c, d) {
    function e() {
        return {
            x: a.pageXOffset,
            y: a.pageYOffset
        };
    }
    d.extend(b.defaults, {
        draggable: !0,
        dragThreshold: 3
    }), b.createMethods.push("_createDrag");
    var f = b.prototype;
    d.extend(f, c.prototype);
    var g = "createTouch" in document, h = !1;
    f._createDrag = function() {
        this.on("activate", this.bindDrag), this.on("uiChange", this._uiChangeDrag), this.on("childUIPointerDown", this._childUIPointerDownDrag), 
        this.on("deactivate", this.unbindDrag), g && !h && (a.addEventListener("touchmove", function() {}), 
        h = !0);
    }, f.bindDrag = function() {
        this.options.draggable && !this.isDragBound && (this.element.classList.add("is-draggable"), 
        this.handles = [ this.viewport ], this.bindHandles(), this.isDragBound = !0);
    }, f.unbindDrag = function() {
        this.isDragBound && (this.element.classList.remove("is-draggable"), this.unbindHandles(), 
        delete this.isDragBound);
    }, f._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    }, f._childUIPointerDownDrag = function(a) {
        a.preventDefault(), this.pointerDownFocus(a);
    };
    var i = {
        TEXTAREA: !0,
        INPUT: !0,
        OPTION: !0
    }, j = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0
    };
    f.pointerDown = function(b, c) {
        if (i[b.target.nodeName] && !j[b.target.type]) return this.isPointerDown = !1, void delete this.pointerIdentifier;
        this._dragPointerDown(b, c);
        var d = document.activeElement;
        d && d.blur && d != this.element && d != document.body && d.blur(), this.pointerDownFocus(b), 
        this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this._bindPostStartEvents(b), 
        this.pointerDownScroll = e(), a.addEventListener("scroll", this), this.dispatchEvent("pointerDown", b, [ c ]);
    };
    var k = {
        touchstart: !0,
        MSPointerDown: !0
    }, l = {
        INPUT: !0,
        SELECT: !0
    };
    return f.pointerDownFocus = function(b) {
        if (this.options.accessibility && !k[b.type] && !l[b.target.nodeName]) {
            var c = a.pageYOffset;
            this.element.focus(), a.pageYOffset != c && a.scrollTo(a.pageXOffset, c);
        }
    }, f.canPreventDefaultOnPointerDown = function(a) {
        var b = "touchstart" == a.type, c = a.target.nodeName;
        return !b && "SELECT" != c;
    }, f.hasDragStarted = function(a) {
        return Math.abs(a.x) > this.options.dragThreshold;
    }, f.pointerUp = function(a, b) {
        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), 
        this.dispatchEvent("pointerUp", a, [ b ]), this._dragPointerUp(a, b);
    }, f.pointerDone = function() {
        a.removeEventListener("scroll", this), delete this.pointerDownScroll;
    }, f.dragStart = function(b, c) {
        this.dragStartPosition = this.x, this.startAnimation(), a.removeEventListener("scroll", this), 
        this.dispatchEvent("dragStart", b, [ c ]);
    }, f.pointerMove = function(a, b) {
        var c = this._dragPointerMove(a, b);
        this.dispatchEvent("pointerMove", a, [ b, c ]), this._dragMove(a, b, c);
    }, f.dragMove = function(a, b, c) {
        a.preventDefault(), this.previousDragX = this.dragX;
        var d = this.options.rightToLeft ? -1 : 1, e = this.dragStartPosition + c.x * d;
        if (!this.options.wrapAround && this.slides.length) {
            var f = Math.max(-this.slides[0].target, this.dragStartPosition);
            e = e > f ? .5 * (e + f) : e;
            var g = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            e = e < g ? .5 * (e + g) : e;
        }
        this.dragX = e, this.dragMoveTime = new Date(), this.dispatchEvent("dragMove", a, [ b, c ]);
    }, f.dragEnd = function(a, b) {
        this.options.freeScroll && (this.isFreeScrolling = !0);
        var c = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            var d = this.getRestingPosition();
            this.isFreeScrolling = -d > this.slides[0].target && -d < this.getLastSlide().target;
        } else this.options.freeScroll || c != this.selectedIndex || (c += this.dragEndBoostSelect());
        delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(c), 
        delete this.isDragSelect, this.dispatchEvent("dragEnd", a, [ b ]);
    }, f.dragEndRestingSelect = function() {
        var a = this.getRestingPosition(), b = Math.abs(this.getSlideDistance(-a, this.selectedIndex)), c = this._getClosestResting(a, b, 1), d = this._getClosestResting(a, b, -1);
        return c.distance < d.distance ? c.index : d.index;
    }, f._getClosestResting = function(a, b, c) {
        for (var d = this.selectedIndex, e = 1 / 0, f = this.options.contain && !this.options.wrapAround ? function(a, b) {
            return a <= b;
        } : function(a, b) {
            return a < b;
        }; f(b, e) && (d += c, e = b, null !== (b = this.getSlideDistance(-a, d))); ) b = Math.abs(b);
        return {
            distance: e,
            index: d - c
        };
    }, f.getSlideDistance = function(a, b) {
        var c = this.slides.length, e = this.options.wrapAround && c > 1, f = e ? d.modulo(b, c) : b, g = this.slides[f];
        if (!g) return null;
        var h = e ? this.slideableWidth * Math.floor(b / c) : 0;
        return a - (g.target + h);
    }, f.dragEndBoostSelect = function() {
        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
        var a = this.getSlideDistance(-this.dragX, this.selectedIndex), b = this.previousDragX - this.dragX;
        return a > 0 && b > 0 ? 1 : a < 0 && b < 0 ? -1 : 0;
    }, f.staticClick = function(a, b) {
        var c = this.getParentCell(a.target), d = c && c.element, e = c && this.cells.indexOf(c);
        this.dispatchEvent("staticClick", a, [ b, d, e ]);
    }, f.onscroll = function() {
        var a = e(), b = this.pointerDownScroll.x - a.x, c = this.pointerDownScroll.y - a.y;
        (Math.abs(b) > 3 || Math.abs(c) > 3) && this._pointerDone();
    }, b;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("tap-listener/tap-listener", [ "unipointer/unipointer" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("unipointer")) : a.TapListener = b(a, a.Unipointer);
}(window, function(a, b) {
    function c(a) {
        this.bindTap(a);
    }
    var d = c.prototype = Object.create(b.prototype);
    return d.bindTap = function(a) {
        a && (this.unbindTap(), this.tapElement = a, this._bindStartEvent(a, !0));
    }, d.unbindTap = function() {
        this.tapElement && (this._bindStartEvent(this.tapElement, !0), delete this.tapElement);
    }, d.pointerUp = function(c, d) {
        if (!this.isIgnoringMouseUp || "mouseup" != c.type) {
            var e = b.getPointerPoint(d), f = this.tapElement.getBoundingClientRect(), g = a.pageXOffset, h = a.pageYOffset;
            if (e.x >= f.left + g && e.x <= f.right + g && e.y >= f.top + h && e.y <= f.bottom + h && this.emitEvent("tap", [ c, d ]), 
            "mouseup" != c.type) {
                this.isIgnoringMouseUp = !0;
                var i = this;
                setTimeout(function() {
                    delete i.isIgnoringMouseUp;
                }, 400);
            }
        }
    }, d.destroy = function() {
        this.pointerDone(), this.unbindTap();
    }, c;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", [ "./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils" ], function(c, d, e) {
        return b(a, c, d, e);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : b(a, a.Flickity, a.TapListener, a.fizzyUIUtils);
}(window, function(a, b, c, d) {
    "use strict";
    function e(a, b) {
        this.direction = a, this.parent = b, this._create();
    }
    function f(a) {
        return "string" == typeof a ? a : "M " + a.x0 + ",50 L " + a.x1 + "," + (a.y1 + 50) + " L " + a.x2 + "," + (a.y2 + 50) + " L " + a.x3 + ",50  L " + a.x2 + "," + (50 - a.y2) + " L " + a.x1 + "," + (50 - a.y1) + " Z";
    }
    var g = "http://www.w3.org/2000/svg";
    e.prototype = new c(), e.prototype._create = function() {
        this.isEnabled = !0, this.isPrevious = -1 == this.direction;
        var a = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == a;
        var b = this.element = document.createElement("button");
        b.className = "flickity-prev-next-button", b.className += this.isPrevious ? " previous" : " next", 
        b.setAttribute("type", "button"), this.disable(), b.setAttribute("aria-label", this.isPrevious ? "previous" : "next");
        var c = this.createSVG();
        b.appendChild(c), this.on("tap", this.onTap), this.parent.on("select", this.update.bind(this)), 
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    }, e.prototype.activate = function() {
        this.bindTap(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
    }, e.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element), c.prototype.destroy.call(this), this.element.removeEventListener("click", this);
    }, e.prototype.createSVG = function() {
        var a = document.createElementNS(g, "svg");
        a.setAttribute("viewBox", "0 0 100 100");
        var b = document.createElementNS(g, "path"), c = f(this.parent.options.arrowShape);
        return b.setAttribute("d", c), b.setAttribute("class", "arrow"), this.isLeft || b.setAttribute("transform", "translate(100, 100) rotate(180) "), 
        a.appendChild(b), a;
    }, e.prototype.onTap = function() {
        if (this.isEnabled) {
            this.parent.uiChange();
            var a = this.isPrevious ? "previous" : "next";
            this.parent[a]();
        }
    }, e.prototype.handleEvent = d.handleEvent, e.prototype.onclick = function() {
        var a = document.activeElement;
        a && a == this.element && this.onTap();
    }, e.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0);
    }, e.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1);
    }, e.prototype.update = function() {
        var a = this.parent.slides;
        if (this.parent.options.wrapAround && a.length > 1) return void this.enable();
        var b = a.length ? a.length - 1 : 0, c = this.isPrevious ? 0 : b;
        this[this.parent.selectedIndex == c ? "disable" : "enable"]();
    }, e.prototype.destroy = function() {
        this.deactivate();
    }, d.extend(b.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }), b.createMethods.push("_createPrevNextButtons");
    var h = b.prototype;
    return h._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new e(-1, this), this.nextButton = new e(1, this), 
        this.on("activate", this.activatePrevNextButtons));
    }, h.activatePrevNextButtons = function() {
        this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
    }, h.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
    }, b.PrevNextButton = e, b;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/page-dots", [ "./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils" ], function(c, d, e) {
        return b(a, c, d, e);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : b(a, a.Flickity, a.TapListener, a.fizzyUIUtils);
}(window, function(a, b, c, d) {
    function e(a) {
        this.parent = a, this._create();
    }
    e.prototype = new c(), e.prototype._create = function() {
        this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", 
        this.dots = [], this.on("tap", this.onTap), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    }, e.prototype.activate = function() {
        this.setDots(), this.bindTap(this.holder), this.parent.element.appendChild(this.holder);
    }, e.prototype.deactivate = function() {
        this.parent.element.removeChild(this.holder), c.prototype.destroy.call(this);
    }, e.prototype.setDots = function() {
        var a = this.parent.slides.length - this.dots.length;
        a > 0 ? this.addDots(a) : a < 0 && this.removeDots(-a);
    }, e.prototype.addDots = function(a) {
        for (var b = document.createDocumentFragment(), c = []; a; ) {
            var d = document.createElement("li");
            d.className = "dot", b.appendChild(d), c.push(d), a--;
        }
        this.holder.appendChild(b), this.dots = this.dots.concat(c);
    }, e.prototype.removeDots = function(a) {
        this.dots.splice(this.dots.length - a, a).forEach(function(a) {
            this.holder.removeChild(a);
        }, this);
    }, e.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot"), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], 
        this.selectedDot.className = "dot is-selected");
    }, e.prototype.onTap = function(a) {
        var b = a.target;
        if ("LI" == b.nodeName) {
            this.parent.uiChange();
            var c = this.dots.indexOf(b);
            this.parent.select(c);
        }
    }, e.prototype.destroy = function() {
        this.deactivate();
    }, b.PageDots = e, d.extend(b.defaults, {
        pageDots: !0
    }), b.createMethods.push("_createPageDots");
    var f = b.prototype;
    return f._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new e(this), this.on("activate", this.activatePageDots), 
        this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), 
        this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots));
    }, f.activatePageDots = function() {
        this.pageDots.activate();
    }, f.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    }, f.updatePageDots = function() {
        this.pageDots.setDots();
    }, f.deactivatePageDots = function() {
        this.pageDots.deactivate();
    }, b.PageDots = e, b;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/player", [ "ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity" ], function(a, c, d) {
        return b(a, c, d);
    }) : "object" == typeof module && module.exports ? module.exports = b(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : b(a.EvEmitter, a.fizzyUIUtils, a.Flickity);
}(window, function(a, b, c) {
    function d(a) {
        this.parent = a, this.state = "stopped", f && (this.onVisibilityChange = function() {
            this.visibilityChange();
        }.bind(this), this.onVisibilityPlay = function() {
            this.visibilityPlay();
        }.bind(this));
    }
    var e, f;
    "hidden" in document ? (e = "hidden", f = "visibilitychange") : "webkitHidden" in document && (e = "webkitHidden", 
    f = "webkitvisibilitychange"), d.prototype = Object.create(a.prototype), d.prototype.play = function() {
        if ("playing" != this.state) {
            var a = document[e];
            if (f && a) return void document.addEventListener(f, this.onVisibilityPlay);
            this.state = "playing", f && document.addEventListener(f, this.onVisibilityChange), 
            this.tick();
        }
    }, d.prototype.tick = function() {
        if ("playing" == this.state) {
            var a = this.parent.options.autoPlay;
            a = "number" == typeof a ? a : 3e3;
            var b = this;
            this.clear(), this.timeout = setTimeout(function() {
                b.parent.next(!0), b.tick();
            }, a);
        }
    }, d.prototype.stop = function() {
        this.state = "stopped", this.clear(), f && document.removeEventListener(f, this.onVisibilityChange);
    }, d.prototype.clear = function() {
        clearTimeout(this.timeout);
    }, d.prototype.pause = function() {
        "playing" == this.state && (this.state = "paused", this.clear());
    }, d.prototype.unpause = function() {
        "paused" == this.state && this.play();
    }, d.prototype.visibilityChange = function() {
        this[document[e] ? "pause" : "unpause"]();
    }, d.prototype.visibilityPlay = function() {
        this.play(), document.removeEventListener(f, this.onVisibilityPlay);
    }, b.extend(c.defaults, {
        pauseAutoPlayOnHover: !0
    }), c.createMethods.push("_createPlayer");
    var g = c.prototype;
    return g._createPlayer = function() {
        this.player = new d(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), 
        this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
    }, g.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
    }, g.playPlayer = function() {
        this.player.play();
    }, g.stopPlayer = function() {
        this.player.stop();
    }, g.pausePlayer = function() {
        this.player.pause();
    }, g.unpausePlayer = function() {
        this.player.unpause();
    }, g.deactivatePlayer = function() {
        this.player.stop(), this.element.removeEventListener("mouseenter", this);
    }, g.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
    }, g.onmouseleave = function() {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this);
    }, c.Player = d, c;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", [ "./flickity", "fizzy-ui-utils/utils" ], function(c, d) {
        return b(a, c, d);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("./flickity"), require("fizzy-ui-utils")) : b(a, a.Flickity, a.fizzyUIUtils);
}(window, function(a, b, c) {
    function d(a) {
        var b = document.createDocumentFragment();
        return a.forEach(function(a) {
            b.appendChild(a.element);
        }), b;
    }
    var e = b.prototype;
    return e.insert = function(a, b) {
        var c = this._makeCells(a);
        if (c && c.length) {
            var e = this.cells.length;
            b = void 0 === b ? e : b;
            var f = d(c), g = b == e;
            if (g) this.slider.appendChild(f); else {
                var h = this.cells[b].element;
                this.slider.insertBefore(f, h);
            }
            if (0 === b) this.cells = c.concat(this.cells); else if (g) this.cells = this.cells.concat(c); else {
                var i = this.cells.splice(b, e - b);
                this.cells = this.cells.concat(c).concat(i);
            }
            this._sizeCells(c);
            var j = b > this.selectedIndex ? 0 : c.length;
            this._cellAddedRemoved(b, j);
        }
    }, e.append = function(a) {
        this.insert(a, this.cells.length);
    }, e.prepend = function(a) {
        this.insert(a, 0);
    }, e.remove = function(a) {
        var b, d, e = this.getCells(a), f = 0, g = e.length;
        for (b = 0; b < g; b++) {
            d = e[b];
            f -= this.cells.indexOf(d) < this.selectedIndex ? 1 : 0;
        }
        for (b = 0; b < g; b++) d = e[b], d.remove(), c.removeFrom(this.cells, d);
        e.length && this._cellAddedRemoved(0, f);
    }, e._cellAddedRemoved = function(a, b) {
        b = b || 0, this.selectedIndex += b, this.selectedIndex = Math.max(0, Math.min(this.slides.length - 1, this.selectedIndex)), 
        this.cellChange(a, !0), this.emitEvent("cellAddedRemoved", [ a, b ]);
    }, e.cellSizeChange = function(a) {
        var b = this.getCell(a);
        if (b) {
            b.getSize();
            var c = this.cells.indexOf(b);
            this.cellChange(c);
        }
    }, e.cellChange = function(a, b) {
        var c = this.slideableWidth;
        if (this._positionCells(a), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("cellChange", [ a ]), 
        this.options.freeScroll) {
            var d = c - this.slideableWidth;
            this.x += d * this.cellAlign, this.positionSlider();
        } else b && this.positionSliderAtSelected(), this.select(this.selectedIndex);
    }, b;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/lazyload", [ "./flickity", "fizzy-ui-utils/utils" ], function(c, d) {
        return b(a, c, d);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("./flickity"), require("fizzy-ui-utils")) : b(a, a.Flickity, a.fizzyUIUtils);
}(window, function(a, b, c) {
    "use strict";
    function d(a) {
        if ("IMG" == a.nodeName && a.getAttribute("data-flickity-lazyload")) return [ a ];
        var b = a.querySelectorAll("img[data-flickity-lazyload]");
        return c.makeArray(b);
    }
    function e(a, b) {
        this.img = a, this.flickity = b, this.load();
    }
    b.createMethods.push("_createLazyload");
    var f = b.prototype;
    return f._createLazyload = function() {
        this.on("select", this.lazyLoad);
    }, f.lazyLoad = function() {
        var a = this.options.lazyLoad;
        if (a) {
            var b = "number" == typeof a ? a : 0, c = this.getAdjacentCellElements(b), f = [];
            c.forEach(function(a) {
                var b = d(a);
                f = f.concat(b);
            }), f.forEach(function(a) {
                new e(a, this);
            }, this);
        }
    }, e.prototype.handleEvent = c.handleEvent, e.prototype.load = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        this.img.src = this.img.getAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload");
    }, e.prototype.onload = function(a) {
        this.complete(a, "flickity-lazyloaded");
    }, e.prototype.onerror = function(a) {
        this.complete(a, "flickity-lazyerror");
    }, e.prototype.complete = function(a, b) {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        var c = this.flickity.getParentCell(this.img), d = c && c.element;
        this.flickity.cellSizeChange(d), this.img.classList.add(b), this.flickity.dispatchEvent("lazyLoad", a, d);
    }, b.LazyLoader = e, b;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity/js/index", [ "./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload" ], b) : "object" == typeof module && module.exports && (module.exports = b(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
}(window, function(a) {
    return a;
}), function(a, b) {
    "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", [ "flickity/js/index", "fizzy-ui-utils/utils" ], b) : "object" == typeof module && module.exports ? module.exports = b(require("flickity"), require("fizzy-ui-utils")) : a.Flickity = b(a.Flickity, a.fizzyUIUtils);
}(window, function(a, b) {
    function c(a, b, c) {
        return (b - a) * c + a;
    }
    a.createMethods.push("_createAsNavFor");
    var d = a.prototype;
    return d._createAsNavFor = function() {
        this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), 
        this.on("destroy", this.destroyAsNavFor);
        var a = this.options.asNavFor;
        if (a) {
            var b = this;
            setTimeout(function() {
                b.setNavCompanion(a);
            });
        }
    }, d.setNavCompanion = function(c) {
        c = b.getQueryElement(c);
        var d = a.data(c);
        if (d && d != this) {
            this.navCompanion = d;
            var e = this;
            this.onNavCompanionSelect = function() {
                e.navCompanionSelect();
            }, d.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), 
            this.navCompanionSelect(!0);
        }
    }, d.navCompanionSelect = function(a) {
        if (this.navCompanion) {
            var b = this.navCompanion.selectedCells[0], d = this.navCompanion.cells.indexOf(b), e = d + this.navCompanion.selectedCells.length - 1, f = Math.floor(c(d, e, this.navCompanion.cellAlign));
            if (this.selectCell(f, !1, a), this.removeNavSelectedElements(), !(f >= this.cells.length)) {
                var g = this.cells.slice(d, e + 1);
                this.navSelectedElements = g.map(function(a) {
                    return a.element;
                }), this.changeNavSelectedClass("add");
            }
        }
    }, d.changeNavSelectedClass = function(a) {
        this.navSelectedElements.forEach(function(b) {
            b.classList[a]("is-nav-selected");
        });
    }, d.activateAsNavFor = function() {
        this.navCompanionSelect(!0);
    }, d.removeNavSelectedElements = function() {
        this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
    }, d.onNavStaticClick = function(a, b, c, d) {
        "number" == typeof d && this.navCompanion.selectCell(d);
    }, d.deactivateAsNavFor = function() {
        this.removeNavSelectedElements();
    }, d.destroyAsNavFor = function() {
        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), 
        this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
    }, a;
}), function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", [ "ev-emitter/ev-emitter" ], function(c) {
        return b(a, c);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("ev-emitter")) : a.imagesLoaded = b(a, a.EvEmitter);
}(window, function(a, b) {
    function c(a, b) {
        for (var c in b) a[c] = b[c];
        return a;
    }
    function d(a) {
        var b = [];
        if (Array.isArray(a)) b = a; else if ("number" == typeof a.length) for (var c = 0; c < a.length; c++) b.push(a[c]); else b.push(a);
        return b;
    }
    function e(a, b, f) {
        return this instanceof e ? ("string" == typeof a && (a = document.querySelectorAll(a)), 
        this.elements = d(a), this.options = c({}, this.options), "function" == typeof b ? f = b : c(this.options, b), 
        f && this.on("always", f), this.getImages(), h && (this.jqDeferred = new h.Deferred()), 
        void setTimeout(function() {
            this.check();
        }.bind(this))) : new e(a, b, f);
    }
    function f(a) {
        this.img = a;
    }
    function g(a, b) {
        this.url = a, this.element = b, this.img = new Image();
    }
    var h = a.jQuery, i = a.console;
    e.prototype = Object.create(b.prototype), e.prototype.options = {}, e.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this);
    }, e.prototype.addElementImages = function(a) {
        "IMG" == a.nodeName && this.addImage(a), !0 === this.options.background && this.addElementBackgroundImages(a);
        var b = a.nodeType;
        if (b && j[b]) {
            for (var c = a.querySelectorAll("img"), d = 0; d < c.length; d++) {
                var e = c[d];
                this.addImage(e);
            }
            if ("string" == typeof this.options.background) {
                var f = a.querySelectorAll(this.options.background);
                for (d = 0; d < f.length; d++) {
                    var g = f[d];
                    this.addElementBackgroundImages(g);
                }
            }
        }
    };
    var j = {
        1: !0,
        9: !0,
        11: !0
    };
    return e.prototype.addElementBackgroundImages = function(a) {
        var b = getComputedStyle(a);
        if (b) for (var c = /url\((['"])?(.*?)\1\)/gi, d = c.exec(b.backgroundImage); null !== d; ) {
            var e = d && d[2];
            e && this.addBackground(e, a), d = c.exec(b.backgroundImage);
        }
    }, e.prototype.addImage = function(a) {
        var b = new f(a);
        this.images.push(b);
    }, e.prototype.addBackground = function(a, b) {
        var c = new g(a, b);
        this.images.push(c);
    }, e.prototype.check = function() {
        function a(a, c, d) {
            setTimeout(function() {
                b.progress(a, c, d);
            });
        }
        var b = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(b) {
            b.once("progress", a), b.check();
        }) : void this.complete();
    }, e.prototype.progress = function(a, b, c) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !a.isLoaded, this.emitEvent("progress", [ this, a, b ]), 
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, a), this.progressedCount == this.images.length && this.complete(), 
        this.options.debug && i && i.log("progress: " + c, a, b);
    }, e.prototype.complete = function() {
        var a = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(a, [ this ]), this.emitEvent("always", [ this ]), 
        this.jqDeferred) {
            var b = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[b](this);
        }
    }, f.prototype = Object.create(b.prototype), f.prototype.check = function() {
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), 
        this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), 
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        void (this.proxyImage.src = this.img.src));
    }, f.prototype.getIsImageComplete = function() {
        return this.img.complete && void 0 !== this.img.naturalWidth;
    }, f.prototype.confirm = function(a, b) {
        this.isLoaded = a, this.emitEvent("progress", [ this, this.img, b ]);
    }, f.prototype.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a);
    }, f.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents();
    }, f.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents();
    }, f.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), 
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, g.prototype = Object.create(f.prototype), g.prototype.check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), 
        this.unbindEvents());
    }, g.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, g.prototype.confirm = function(a, b) {
        this.isLoaded = a, this.emitEvent("progress", [ this, this.element, b ]);
    }, e.makeJQueryPlugin = function(b) {
        (b = b || a.jQuery) && (h = b, h.fn.imagesLoaded = function(a, b) {
            return new e(this, a, b).jqDeferred.promise(h(this));
        });
    }, e.makeJQueryPlugin(), e;
}), function(a, b) {
    "function" == typeof define && define.amd ? define([ "flickity/js/index", "imagesloaded/imagesloaded" ], function(c, d) {
        return b(a, c, d);
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("flickity"), require("imagesloaded")) : a.Flickity = b(a, a.Flickity, a.imagesLoaded);
}(window, function(a, b, c) {
    "use strict";
    b.createMethods.push("_createImagesLoaded");
    var d = b.prototype;
    return d._createImagesLoaded = function() {
        this.on("activate", this.imagesLoaded);
    }, d.imagesLoaded = function() {
        function a(a, c) {
            var d = b.getParentCell(c.img);
            b.cellSizeChange(d && d.element), b.options.freeScroll || b.positionSliderAtSelected();
        }
        if (this.options.imagesLoaded) {
            var b = this;
            c(this.slider).on("progress", a);
        }
    }, b;
}), function(a, b) {
    var c = b(a, a.document);
    a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c);
}(window, function(a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d = b.documentElement, e = a.Date, f = a.HTMLPictureElement, g = "addEventListener", h = "getAttribute", i = a[g], j = a.setTimeout, k = a.requestAnimationFrame || j, l = a.requestIdleCallback, m = /^picture$/i, n = [ "load", "error", "lazyincluded", "_lazyloaded" ], o = {}, p = Array.prototype.forEach, q = function(a, b) {
            return o[b] || (o[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), o[b].test(a[h]("class") || "") && o[b];
        }, r = function(a, b) {
            q(a, b) || a.setAttribute("class", (a[h]("class") || "").trim() + " " + b);
        }, s = function(a, b) {
            var c;
            (c = q(a, b)) && a.setAttribute("class", (a[h]("class") || "").replace(c, " "));
        }, t = function(a, b, c) {
            var d = c ? g : "removeEventListener";
            c && t(a, b), n.forEach(function(c) {
                a[d](c, b);
            });
        }, u = function(a, c, d, e, f) {
            var g = b.createEvent("CustomEvent");
            return g.initCustomEvent(c, !e, !f, d || {}), a.dispatchEvent(g), g;
        }, v = function(b, d) {
            var e;
            !f && (e = a.picturefill || c.pf) ? e({
                reevaluate: !0,
                elements: [ b ]
            }) : d && d.src && (b.src = d.src);
        }, w = function(a, b) {
            return (getComputedStyle(a, null) || {})[b];
        }, x = function(a, b, d) {
            for (d = d || a.offsetWidth; d < c.minSize && b && !a._lazysizesWidth; ) d = b.offsetWidth, 
            b = b.parentNode;
            return d;
        }, y = function() {
            var a, c, d = [], e = [], f = d, g = function() {
                var b = f;
                for (f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
                a = !1;
            }, h = function(d, e) {
                a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? j : k)(g)));
            };
            return h._lsFlush = g, h;
        }(), z = function(a, b) {
            return b ? function() {
                y(a);
            } : function() {
                var b = this, c = arguments;
                y(function() {
                    a.apply(b, c);
                });
            };
        }, A = function(a) {
            var b, c = 0, d = 666, f = d, g = function() {
                b = !1, c = e.now(), a();
            }, h = l ? function() {
                l(g, {
                    timeout: f
                }), f !== d && (f = d);
            } : z(function() {
                j(g);
            }, !0);
            return function(a) {
                var d;
                (a = !0 === a) && (f = 44), b || (b = !0, d = 125 - (e.now() - c), 0 > d && (d = 0), 
                a || 9 > d && l ? h() : j(h, d));
            };
        }, B = function(a) {
            var b, c, d = 99, f = function() {
                b = null, a();
            }, g = function() {
                var a = e.now() - c;
                d > a ? j(g, d - a) : (l || f)(f);
            };
            return function() {
                c = e.now(), b || (b = j(g, d));
            };
        }, C = function() {
            var f, k, l, n, o, x, C, E, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i, O = "onscroll" in a && !/glebot/.test(navigator.userAgent), P = 0, Q = 0, R = 0, S = -1, T = function(a) {
                R--, a && a.target && t(a.target, T), (!a || 0 > R || !a.target) && (R = 0);
            }, U = function(a, c) {
                var e, f = a, g = "hidden" == w(b.body, "visibility") || "hidden" != w(a, "visibility");
                for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != d; ) (g = (w(f, "opacity") || 1) > 0) && "visible" != w(f, "overflow") && (e = f.getBoundingClientRect(), 
                g = H > e.left && G < e.right && I > e.top - 1 && F < e.bottom + 1);
                return g;
            }, V = function() {
                var a, e, g, i, j, m, n, p, q;
                if ((o = c.loadMode) && 8 > R && (a = f.length)) {
                    e = 0, S++, null == K && ("expand" in c || (c.expand = d.clientHeight > 500 && d.clientWidth > 500 ? 500 : 370), 
                    J = c.expand, K = J * c.expFactor), K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K, 
                    S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
                    for (;a > e; e++) if (f[e] && !f[e]._lazyRace) if (O) if ((p = f[e][h]("data-expand")) && (m = 1 * p) || (m = Q), 
                    q !== m && (C = innerWidth + m * L, E = innerHeight + m, n = -1 * m, q = m), g = f[e].getBoundingClientRect(), 
                    (I = g.bottom) >= n && (F = g.top) <= E && (H = g.right) >= n * L && (G = g.left) <= C && (I || H || G || F) && (l && 3 > R && !p && (3 > o || 4 > S) || U(f[e], m))) {
                        if (ba(f[e]), j = !0, R > 9) break;
                    } else !j && l && !i && 4 > R && 4 > S && o > 2 && (k[0] || c.preloadAfterLoad) && (k[0] || !p && (I || H || G || F || "auto" != f[e][h](c.sizesAttr))) && (i = k[0] || f[e]); else ba(f[e]);
                    i && !j && ba(i);
                }
            }, W = A(V), X = function(a) {
                r(a.target, c.loadedClass), s(a.target, c.loadingClass), t(a.target, Z);
            }, Y = z(X), Z = function(a) {
                Y({
                    target: a.target
                });
            }, $ = function(a, b) {
                try {
                    a.contentWindow.location.replace(b);
                } catch (c) {
                    a.src = b;
                }
            }, _ = function(a) {
                var b, d, e = a[h](c.srcsetAttr);
                (b = c.customMedia[a[h]("data-media") || a[h]("media")]) && a.setAttribute("media", b), 
                e && a.setAttribute("srcset", e), b && (d = a.parentNode, d.insertBefore(a.cloneNode(), a), 
                d.removeChild(a));
            }, aa = z(function(a, b, d, e, f) {
                var g, i, k, l, o, q;
                (o = u(a, "lazybeforeunveil", b)).defaultPrevented || (e && (d ? r(a, c.autosizesClass) : a.setAttribute("sizes", e)), 
                i = a[h](c.srcsetAttr), g = a[h](c.srcAttr), f && (k = a.parentNode, l = k && m.test(k.nodeName || "")), 
                q = b.firesLoad || "src" in a && (i || g || l), o = {
                    target: a
                }, q && (t(a, T, !0), clearTimeout(n), n = j(T, 2500), r(a, c.loadingClass), t(a, Z, !0)), 
                l && p.call(k.getElementsByTagName("source"), _), i ? a.setAttribute("srcset", i) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g), 
                (i || l) && v(a, {
                    src: g
                })), a._lazyRace && delete a._lazyRace, s(a, c.lazyClass), y(function() {
                    (!q || a.complete && a.naturalWidth > 1) && (q ? T(o) : R--, X(o));
                }, !0);
            }), ba = function(a) {
                var b, d = M.test(a.nodeName), e = d && (a[h](c.sizesAttr) || a[h]("sizes")), f = "auto" == e;
                (!f && l || !d || !a.src && !a.srcset || a.complete || q(a, c.errorClass)) && (b = u(a, "lazyunveilread").detail, 
                f && D.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, R++, aa(a, b, f, e, d));
            }, ca = function() {
                if (!l) {
                    if (e.now() - x < 999) return void j(ca, 999);
                    var a = B(function() {
                        c.loadMode = 3, W();
                    });
                    l = !0, c.loadMode = 3, W(), i("scroll", function() {
                        3 == c.loadMode && (c.loadMode = 2), a();
                    }, !0);
                }
            };
            return {
                _: function() {
                    x = e.now(), f = b.getElementsByClassName(c.lazyClass), k = b.getElementsByClassName(c.lazyClass + " " + c.preloadClass), 
                    L = c.hFac, i("scroll", W, !0), i("resize", W, !0), a.MutationObserver ? new MutationObserver(W).observe(d, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (d[g]("DOMNodeInserted", W, !0), d[g]("DOMAttrModified", W, !0), setInterval(W, 999)), 
                    i("hashchange", W, !0), [ "focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd" ].forEach(function(a) {
                        b[g](a, W, !0);
                    }), /d$|^c/.test(b.readyState) ? ca() : (i("load", ca), b[g]("DOMContentLoaded", W), 
                    j(ca, 2e4)), f.length ? (V(), y._lsFlush()) : W();
                },
                checkElems: W,
                unveil: ba
            };
        }(), D = function() {
            var a, d = z(function(a, b, c, d) {
                var e, f, g;
                if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), m.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), 
                f = 0, g = e.length; g > f; f++) e[f].setAttribute("sizes", d);
                c.detail.dataAttr || v(a, c.detail);
            }), e = function(a, b, c) {
                var e, f = a.parentNode;
                f && (c = x(a, f, c), e = u(a, "lazybeforesizes", {
                    width: c,
                    dataAttr: !!b
                }), e.defaultPrevented || (c = e.detail.width) && c !== a._lazysizesWidth && d(a, f, e, c));
            }, f = function() {
                var b, c = a.length;
                if (c) for (b = 0; c > b; b++) e(a[b]);
            }, g = B(f);
            return {
                _: function() {
                    a = b.getElementsByClassName(c.autosizesClass), i("resize", g);
                },
                checkElems: g,
                updateElem: e
            };
        }(), E = function() {
            E.i || (E.i = !0, D._(), C._());
        };
        return function() {
            var b, d = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2
            };
            c = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in d) b in c || (c[b] = d[b]);
            a.lazySizesConfig = c, j(function() {
                c.init && E();
            });
        }(), {
            cfg: c,
            autoSizer: D,
            loader: C,
            init: E,
            uP: v,
            aC: r,
            rC: s,
            hC: q,
            fire: u,
            gW: x,
            rAF: y
        };
    }
});

var IASCallbacks = function(a) {
    return this.list = [], this.fireStack = [], this.isFiring = !1, this.isDisabled = !1, 
    this.fire = function(a) {
        var b = a[0], c = a[1], d = a[2];
        this.isFiring = !0;
        for (var e = 0, f = this.list.length; f > e; e++) if (void 0 != this.list[e] && !1 === this.list[e].fn.apply(b, d)) {
            c.reject();
            break;
        }
        this.isFiring = !1, c.resolve(), this.fireStack.length && this.fire(this.fireStack.shift());
    }, this.inList = function(a, b) {
        b = b || 0;
        for (var c = b, d = this.list.length; d > c; c++) if (this.list[c].fn === a || a.guid && this.list[c].fn.guid && a.guid === this.list[c].fn.guid) return c;
        return -1;
    }, this;
};

IASCallbacks.prototype = {
    add: function(a, b) {
        var c = {
            fn: a,
            priority: b
        };
        b = b || 0;
        for (var d = 0, e = this.list.length; e > d; d++) if (b > this.list[d].priority) return this.list.splice(d, 0, c), 
        this;
        return this.list.push(c), this;
    },
    remove: function(a) {
        for (var b = 0; (b = this.inList(a, b)) > -1; ) this.list.splice(b, 1);
        return this;
    },
    has: function(a) {
        return this.inList(a) > -1;
    },
    fireWith: function(a, b) {
        var c = $.Deferred();
        return this.isDisabled ? c.reject() : (b = b || [], b = [ a, c, b.slice ? b.slice() : b ], 
        this.isFiring ? this.fireStack.push(b) : this.fire(b), c);
    },
    disable: function() {
        this.isDisabled = !0;
    },
    enable: function() {
        this.isDisabled = !1;
    }
}, function(a) {
    "use strict";
    var b = -1, c = function(c, d) {
        return this.itemsContainerSelector = d.container, this.itemSelector = d.item, this.nextSelector = d.next, 
        this.paginationSelector = d.pagination, this.$scrollContainer = c, this.$container = window === c.get(0) ? a(document) : c, 
        this.defaultDelay = d.delay, this.negativeMargin = d.negativeMargin, this.nextUrl = null, 
        this.isBound = !1, this.isPaused = !1, this.isInitialized = !1, this.jsXhr = !1, 
        this.listeners = {
            next: new IASCallbacks(a),
            load: new IASCallbacks(a),
            loaded: new IASCallbacks(a),
            render: new IASCallbacks(a),
            rendered: new IASCallbacks(a),
            scroll: new IASCallbacks(a),
            noneLeft: new IASCallbacks(a),
            ready: new IASCallbacks(a)
        }, this.extensions = [], this.scrollHandler = function() {
            if (this.isBound && !this.isPaused) {
                var a = this.getCurrentScrollOffset(this.$scrollContainer), c = this.getScrollThreshold();
                b != c && (this.fire("scroll", [ a, c ]), a >= c && this.next());
            }
        }, this.getItemsContainer = function() {
            return a(this.itemsContainerSelector, this.$container);
        }, this.getLastItem = function() {
            return a(this.itemSelector, this.getItemsContainer().get(0)).last();
        }, this.getFirstItem = function() {
            return a(this.itemSelector, this.getItemsContainer().get(0)).first();
        }, this.getScrollThreshold = function(a) {
            var c;
            return a = a || this.negativeMargin, a = a >= 0 ? -1 * a : a, c = this.getLastItem(), 
            0 === c.length ? b : c.offset().top + c.height() + a;
        }, this.getCurrentScrollOffset = function(a) {
            var b = 0, c = a.height();
            return b = window === a.get(0) ? a.scrollTop() : a.offset().top, (-1 != navigator.platform.indexOf("iPhone") || -1 != navigator.platform.indexOf("iPod")) && (c += 80), 
            b + c;
        }, this.getNextUrl = function(b) {
            return b = b || this.$container, a(this.nextSelector, b).last().attr("href");
        }, this.load = function(b, c, d) {
            var e, f, g = this, h = [], i = +new Date();
            d = d || this.defaultDelay;
            var j = {
                url: b
            };
            return g.fire("load", [ j ]), this.jsXhr = a.get(j.url, null, a.proxy(function(b) {
                e = a(this.itemsContainerSelector, b).eq(0), 0 === e.length && (e = a(b).filter(this.itemsContainerSelector).eq(0)), 
                e && e.find(this.itemSelector).each(function() {
                    h.push(this);
                }), g.fire("loaded", [ b, h ]), c && (f = +new Date() - i, d > f ? setTimeout(function() {
                    c.call(g, b, h);
                }, d - f) : c.call(g, b, h));
            }, g), "html"), this.jsXhr;
        }, this.render = function(b, c) {
            var d = this, e = this.getLastItem(), f = 0, g = this.fire("render", [ b ]);
            g.done(function() {
                a(b).hide(), e.after(b), a(b).fadeIn(400, function() {
                    ++f < b.length || (d.fire("rendered", [ b ]), c && c());
                });
            }), g.fail(function() {
                c && c();
            });
        }, this.hidePagination = function() {
            this.paginationSelector && a(this.paginationSelector, this.$container).hide();
        }, this.restorePagination = function() {
            this.paginationSelector && a(this.paginationSelector, this.$container).show();
        }, this.throttle = function(b, c) {
            var d, e, f = 0;
            return d = function() {
                function a() {
                    f = +new Date(), b.apply(d, g);
                }
                var d = this, g = arguments, h = +new Date() - f;
                e ? clearTimeout(e) : a(), h > c ? a() : e = setTimeout(a, c);
            }, a.guid && (d.guid = b.guid = b.guid || a.guid++), d;
        }, this.fire = function(a, b) {
            return this.listeners[a].fireWith(this, b);
        }, this.pause = function() {
            this.isPaused = !0;
        }, this.resume = function() {
            this.isPaused = !1;
        }, this;
    };
    c.prototype.initialize = function() {
        if (this.isInitialized) return !1;
        var a = !!("onscroll" in this.$scrollContainer.get(0)), b = this.getCurrentScrollOffset(this.$scrollContainer), c = this.getScrollThreshold();
        return !!a && (this.hidePagination(), this.bind(), this.fire("ready"), this.nextUrl = this.getNextUrl(), 
        b >= c ? (this.next(), this.one("rendered", function() {
            this.isInitialized = !0;
        })) : this.isInitialized = !0, this);
    }, c.prototype.reinitialize = function() {
        this.isInitialized = !1, this.unbind(), this.initialize();
    }, c.prototype.bind = function() {
        if (!this.isBound) {
            this.$scrollContainer.on("scroll", a.proxy(this.throttle(this.scrollHandler, 150), this));
            for (var b = 0, c = this.extensions.length; c > b; b++) this.extensions[b].bind(this);
            this.isBound = !0, this.resume();
        }
    }, c.prototype.unbind = function() {
        if (this.isBound) {
            this.$scrollContainer.off("scroll", this.scrollHandler);
            for (var a = 0, b = this.extensions.length; b > a; a++) void 0 !== this.extensions[a].unbind && this.extensions[a].unbind(this);
            this.isBound = !1;
        }
    }, c.prototype.destroy = function() {
        try {
            this.jsXhr.abort();
        } catch (a) {}
        this.unbind(), this.$scrollContainer.data("ias", null);
    }, c.prototype.on = function(b, c, d) {
        if (void 0 === this.listeners[b]) throw new Error('There is no event called "' + b + '"');
        return d = d || 0, this.listeners[b].add(a.proxy(c, this), d), this;
    }, c.prototype.one = function(a, b) {
        var c = this, d = function() {
            c.off(a, b), c.off(a, d);
        };
        return this.on(a, b), this.on(a, d), this;
    }, c.prototype.off = function(a, b) {
        if (void 0 === this.listeners[a]) throw new Error('There is no event called "' + a + '"');
        return this.listeners[a].remove(b), this;
    }, c.prototype.next = function() {
        var a = this.nextUrl, b = this;
        if (this.pause(), !a) return this.fire("noneLeft", [ this.getLastItem() ]), this.listeners.noneLeft.disable(), 
        b.resume(), !1;
        var c = this.fire("next", [ a ]);
        return c.done(function() {
            b.load(a, function(a, c) {
                b.render(c, function() {
                    b.nextUrl = b.getNextUrl(a), b.resume();
                });
            });
        }), c.fail(function() {
            b.resume();
        }), !0;
    }, c.prototype.extension = function(a) {
        if (void 0 === a.bind) throw new Error('Extension doesn\'t have required method "bind"');
        return void 0 !== a.initialize && a.initialize(this), this.extensions.push(a), this.isInitialized && this.reinitialize(), 
        this;
    }, a.ias = function(b) {
        var c = a(window);
        return c.ias.apply(c, arguments);
    }, a.fn.ias = function(b) {
        var d = Array.prototype.slice.call(arguments), e = this;
        return this.each(function() {
            var f = a(this), g = f.data("ias"), h = a.extend({}, a.fn.ias.defaults, f.data(), "object" == typeof b && b);
            if (g || (f.data("ias", g = new c(f, h)), a(document).ready(a.proxy(g.initialize, g))), 
            "string" == typeof b) {
                if ("function" != typeof g[b]) throw new Error('There is no method called "' + b + '"');
                d.shift(), g[b].apply(g, d);
            }
            e = g;
        }), e;
    }, a.fn.ias.defaults = {
        item: ".item",
        container: ".listing",
        next: ".next",
        pagination: !1,
        delay: 600,
        negativeMargin: 10
    };
}(jQuery);

var IASHistoryExtension = function(a) {
    return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.prevSelector = a.prev, 
    this.prevUrl = null, this.listeners = {
        prev: new IASCallbacks()
    }, this.onPageChange = function(a, b, c) {
        if (window.history && window.history.replaceState) {
            var d = history.state;
            history.replaceState(d, document.title, c);
        }
    }, this.onScroll = function(a, b) {
        var c = this.getScrollThresholdFirstItem();
        this.prevUrl && (a -= this.ias.$scrollContainer.height(), c >= a && this.prev());
    }, this.onReady = function() {
        var a = this.ias.getCurrentScrollOffset(this.ias.$scrollContainer), b = this.getScrollThresholdFirstItem();
        a -= this.ias.$scrollContainer.height(), b >= a && this.prev();
    }, this.getPrevUrl = function(a) {
        return a || (a = this.ias.$container), jQuery(this.prevSelector, a).last().attr("href");
    }, this.getScrollThresholdFirstItem = function() {
        var a;
        return a = this.ias.getFirstItem(), 0 === a.length ? -1 : a.offset().top;
    }, this.renderBefore = function(a, b) {
        var c = this.ias, d = c.getFirstItem(), e = 0;
        c.fire("render", [ a ]), jQuery(a).hide(), d.before(a), jQuery(a).fadeIn(400, function() {
            ++e < a.length || (c.fire("rendered", [ a ]), b && b());
        });
    }, this;
};

IASHistoryExtension.prototype.initialize = function(a) {
    var b = this;
    this.ias = a, jQuery.extend(a.listeners, this.listeners), a.prev = function() {
        return b.prev();
    }, this.prevUrl = this.getPrevUrl();
}, IASHistoryExtension.prototype.bind = function(a) {
    a.on("pageChange", jQuery.proxy(this.onPageChange, this)), a.on("scroll", jQuery.proxy(this.onScroll, this)), 
    a.on("ready", jQuery.proxy(this.onReady, this));
}, IASHistoryExtension.prototype.unbind = function(a) {
    a.off("pageChange", this.onPageChange), a.off("scroll", this.onScroll), a.off("ready", this.onReady);
}, IASHistoryExtension.prototype.prev = function() {
    var a = this.prevUrl, b = this, c = this.ias;
    if (!a) return !1;
    c.pause();
    var d = c.fire("prev", [ a ]);
    return d.done(function() {
        c.load(a, function(a, d) {
            b.renderBefore(d, function() {
                b.prevUrl = b.getPrevUrl(a), c.resume(), b.prevUrl && b.prev();
            });
        });
    }), d.fail(function() {
        c.resume();
    }), !0;
}, IASHistoryExtension.prototype.defaults = {
    prev: ".prev"
};

var IASNoneLeftExtension = function(a) {
    return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.uid = new Date().getTime(), 
    this.html = a.html.replace("{text}", a.text), this.showNoneLeft = function() {
        var a = jQuery(this.html).attr("id", "ias_noneleft_" + this.uid);
        this.ias.getLastItem().after(a), a.fadeIn();
    }, this;
};

IASNoneLeftExtension.prototype.bind = function(a) {
    this.ias = a, a.on("noneLeft", jQuery.proxy(this.showNoneLeft, this));
}, IASNoneLeftExtension.prototype.unbind = function(a) {
    a.off("noneLeft", this.showNoneLeft);
}, IASNoneLeftExtension.prototype.defaults = {
    text: "You reached the end.",
    html: '<div class="ias-noneleft" style="text-align: center;">{text}</div>'
};

var IASPagingExtension = function() {
    return this.ias = null, this.pagebreaks = [ [ 0, document.location.toString() ] ], 
    this.lastPageNum = 1, this.enabled = !0, this.listeners = {
        pageChange: new IASCallbacks()
    }, this.onScroll = function(a, b) {
        if (this.enabled) {
            var c, d = this.ias, e = this.getCurrentPageNum(a), f = this.getCurrentPagebreak(a);
            this.lastPageNum !== e && (c = f[1], d.fire("pageChange", [ e, a, c ])), this.lastPageNum = e;
        }
    }, this.onNext = function(a) {
        var b = this.ias.getCurrentScrollOffset(this.ias.$scrollContainer);
        this.pagebreaks.push([ b, a ]);
        var c = this.getCurrentPageNum(b) + 1;
        this.ias.fire("pageChange", [ c, b, a ]), this.lastPageNum = c;
    }, this.onPrev = function(a) {
        var b = this, c = b.ias, d = c.getCurrentScrollOffset(c.$scrollContainer), e = d - c.$scrollContainer.height(), f = c.getFirstItem();
        this.enabled = !1, this.pagebreaks.unshift([ 0, a ]), c.one("rendered", function() {
            for (var d = 1, g = b.pagebreaks.length; g > d; d++) b.pagebreaks[d][0] = b.pagebreaks[d][0] + f.offset().top;
            var h = b.getCurrentPageNum(e) + 1;
            c.fire("pageChange", [ h, e, a ]), b.lastPageNum = h, b.enabled = !0;
        });
    }, this;
};

IASPagingExtension.prototype.initialize = function(a) {
    this.ias = a, jQuery.extend(a.listeners, this.listeners);
}, IASPagingExtension.prototype.bind = function(a) {
    try {
        a.on("prev", jQuery.proxy(this.onPrev, this), this.priority);
    } catch (a) {}
    a.on("next", jQuery.proxy(this.onNext, this), this.priority), a.on("scroll", jQuery.proxy(this.onScroll, this), this.priority);
}, IASPagingExtension.prototype.unbind = function(a) {
    try {
        a.off("prev", this.onPrev);
    } catch (a) {}
    a.off("next", this.onNext), a.off("scroll", this.onScroll);
}, IASPagingExtension.prototype.getCurrentPageNum = function(a) {
    for (var b = this.pagebreaks.length - 1; b > 0; b--) if (a > this.pagebreaks[b][0]) return b + 1;
    return 1;
}, IASPagingExtension.prototype.getCurrentPagebreak = function(a) {
    for (var b = this.pagebreaks.length - 1; b >= 0; b--) if (a > this.pagebreaks[b][0]) return this.pagebreaks[b];
    return null;
}, IASPagingExtension.prototype.priority = 500;

var IASSpinnerExtension = function(a) {
    return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.uid = new Date().getTime(), 
    this.src = a.src, this.html = a.html.replace("{src}", this.src), this.showSpinner = function() {
        var a = this.getSpinner() || this.createSpinner();
        this.ias.getLastItem().after(a), a.fadeIn();
    }, this.showSpinnerBefore = function() {
        var a = this.getSpinner() || this.createSpinner();
        this.ias.getFirstItem().before(a), a.fadeIn();
    }, this.removeSpinner = function() {
        this.hasSpinner() && this.getSpinner().remove();
    }, this.getSpinner = function() {
        var a = jQuery("#ias_spinner_" + this.uid);
        return a.length > 0 && a;
    }, this.hasSpinner = function() {
        return jQuery("#ias_spinner_" + this.uid).length > 0;
    }, this.createSpinner = function() {
        var a = jQuery(this.html).attr("id", "ias_spinner_" + this.uid);
        return a.hide(), a;
    }, this;
};

IASSpinnerExtension.prototype.bind = function(a) {
    this.ias = a, a.on("next", jQuery.proxy(this.showSpinner, this)), a.on("render", jQuery.proxy(this.removeSpinner, this));
    try {
        a.on("prev", jQuery.proxy(this.showSpinnerBefore, this));
    } catch (a) {}
}, IASSpinnerExtension.prototype.unbind = function(a) {
    a.off("next", this.showSpinner), a.off("render", this.removeSpinner);
    try {
        a.off("prev", this.showSpinnerBefore);
    } catch (a) {}
}, IASSpinnerExtension.prototype.defaults = {
    src: "data:image/gif;base64,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",
    html: '<div class="ias-spinner" style="text-align: center;"><img src="{src}"/></div>'
};

var IASTriggerExtension = function(a) {
    return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.html = a.html.replace("{text}", a.text), 
    this.htmlPrev = a.htmlPrev.replace("{text}", a.textPrev), this.enabled = !0, this.count = 0, 
    this.offset = a.offset, this.$triggerNext = null, this.$triggerPrev = null, this.showTriggerNext = function() {
        if (!this.enabled) return !0;
        if (!1 === this.offset || ++this.count < this.offset) return !0;
        var a = this.$triggerNext || (this.$triggerNext = this.createTrigger(this.next, this.html));
        return this.ias.getLastItem().after(a), a.fadeIn(), !1;
    }, this.showTriggerPrev = function() {
        if (!this.enabled) return !0;
        var a = this.$triggerPrev || (this.$triggerPrev = this.createTrigger(this.prev, this.htmlPrev));
        return this.ias.getFirstItem().before(a), a.fadeIn(), !1;
    }, this.onRendered = function() {
        this.enabled = !0;
    }, this.createTrigger = function(a, b) {
        var c, d = new Date().getTime();
        return b = b || this.html, c = jQuery(b).attr("id", "ias_trigger_" + d), c.hide(), 
        c.on("click", jQuery.proxy(a, this)), c;
    }, this;
};

IASTriggerExtension.prototype.bind = function(a) {
    this.ias = a, a.on("next", jQuery.proxy(this.showTriggerNext, this), this.priority), 
    a.on("rendered", jQuery.proxy(this.onRendered, this), this.priority);
    try {
        a.on("prev", jQuery.proxy(this.showTriggerPrev, this), this.priority);
    } catch (a) {}
}, IASTriggerExtension.prototype.unbind = function(a) {
    a.off("next", this.showTriggerNext), a.off("rendered", this.onRendered);
    try {
        a.off("prev", this.showTriggerPrev);
    } catch (a) {}
}, IASTriggerExtension.prototype.next = function() {
    this.enabled = !1, this.ias.pause(), this.$triggerNext && (this.$triggerNext.remove(), 
    this.$triggerNext = null), this.ias.next();
}, IASTriggerExtension.prototype.prev = function() {
    this.enabled = !1, this.ias.pause(), this.$triggerPrev && (this.$triggerPrev.remove(), 
    this.$triggerPrev = null), this.ias.prev();
}, IASTriggerExtension.prototype.defaults = {
    text: "Load more items",
    html: '<div class="ias-trigger ias-trigger-next" style="text-align: center; cursor: pointer;"><a>{text}</a></div>',
    textPrev: "Load previous items",
    htmlPrev: '<div class="ias-trigger ias-trigger-prev" style="text-align: center; cursor: pointer;"><a>{text}</a></div>',
    offset: 0
}, IASTriggerExtension.prototype.priority = 1e3, function() {
    "use strict";
    function a(a) {
        a.fn.swiper = function(b) {
            var d;
            return a(this).each(function() {
                var a = new c(this, b);
                d || (d = a);
            }), d;
        };
    }
    var b, c = function(a, d) {
        function e(a) {
            return Math.floor(a);
        }
        function f() {
            var a = v.params.autoplay, b = v.slides.eq(v.activeIndex);
            b.attr("data-swiper-autoplay") && (a = b.attr("data-swiper-autoplay") || v.params.autoplay), 
            v.autoplayTimeoutId = setTimeout(function() {
                v.params.loop ? (v.fixLoop(), v._slideNext(), v.emit("onAutoplay", v)) : v.isEnd ? d.autoplayStopOnLast ? v.stopAutoplay() : (v._slideTo(0), 
                v.emit("onAutoplay", v)) : (v._slideNext(), v.emit("onAutoplay", v));
            }, a);
        }
        function g(a, c) {
            var d = b(a.target);
            if (!d.is(c)) if ("string" == typeof c) d = d.parents(c); else if (c.nodeType) {
                var e;
                return d.parents().each(function(a, b) {
                    b === c && (e = c);
                }), e ? c : void 0;
            }
            if (0 !== d.length) return d[0];
        }
        function h(a, b) {
            b = b || {};
            var c = window.MutationObserver || window.WebkitMutationObserver, d = new c(function(a) {
                a.forEach(function(a) {
                    v.onResize(!0), v.emit("onObserverUpdate", v, a);
                });
            });
            d.observe(a, {
                attributes: void 0 === b.attributes || b.attributes,
                childList: void 0 === b.childList || b.childList,
                characterData: void 0 === b.characterData || b.characterData
            }), v.observers.push(d);
        }
        function i(a) {
            a.originalEvent && (a = a.originalEvent);
            var b = a.keyCode || a.charCode;
            if (!v.params.allowSwipeToNext && (v.isHorizontal() && 39 === b || !v.isHorizontal() && 40 === b)) return !1;
            if (!v.params.allowSwipeToPrev && (v.isHorizontal() && 37 === b || !v.isHorizontal() && 38 === b)) return !1;
            if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || document.activeElement && document.activeElement.nodeName && ("input" === document.activeElement.nodeName.toLowerCase() || "textarea" === document.activeElement.nodeName.toLowerCase()))) {
                if (37 === b || 39 === b || 38 === b || 40 === b) {
                    var c = !1;
                    if (v.container.parents("." + v.params.slideClass).length > 0 && 0 === v.container.parents("." + v.params.slideActiveClass).length) return;
                    var d = {
                        left: window.pageXOffset,
                        top: window.pageYOffset
                    }, e = window.innerWidth, f = window.innerHeight, g = v.container.offset();
                    v.rtl && (g.left = g.left - v.container[0].scrollLeft);
                    for (var h = [ [ g.left, g.top ], [ g.left + v.width, g.top ], [ g.left, g.top + v.height ], [ g.left + v.width, g.top + v.height ] ], i = 0; i < h.length; i++) {
                        var j = h[i];
                        j[0] >= d.left && j[0] <= d.left + e && j[1] >= d.top && j[1] <= d.top + f && (c = !0);
                    }
                    if (!c) return;
                }
                v.isHorizontal() ? (37 !== b && 39 !== b || (a.preventDefault ? a.preventDefault() : a.returnValue = !1), 
                (39 === b && !v.rtl || 37 === b && v.rtl) && v.slideNext(), (37 === b && !v.rtl || 39 === b && v.rtl) && v.slidePrev()) : (38 !== b && 40 !== b || (a.preventDefault ? a.preventDefault() : a.returnValue = !1), 
                40 === b && v.slideNext(), 38 === b && v.slidePrev()), v.emit("onKeyPress", v, b);
            }
        }
        function j() {
            var a = "onwheel", b = a in document;
            if (!b) {
                var c = document.createElement("div");
                c.setAttribute(a, "return;"), b = "function" == typeof c[a];
            }
            return !b && document.implementation && document.implementation.hasFeature && !0 !== document.implementation.hasFeature("", "") && (b = document.implementation.hasFeature("Events.wheel", "3.0")), 
            b;
        }
        function k(a) {
            var b = 10, c = 40, d = 800, e = 0, f = 0, g = 0, h = 0;
            return "detail" in a && (f = a.detail), "wheelDelta" in a && (f = -a.wheelDelta / 120), 
            "wheelDeltaY" in a && (f = -a.wheelDeltaY / 120), "wheelDeltaX" in a && (e = -a.wheelDeltaX / 120), 
            "axis" in a && a.axis === a.HORIZONTAL_AXIS && (e = f, f = 0), g = e * b, h = f * b, 
            "deltaY" in a && (h = a.deltaY), "deltaX" in a && (g = a.deltaX), (g || h) && a.deltaMode && (1 === a.deltaMode ? (g *= c, 
            h *= c) : (g *= d, h *= d)), g && !e && (e = g < 1 ? -1 : 1), h && !f && (f = h < 1 ? -1 : 1), 
            {
                spinX: e,
                spinY: f,
                pixelX: g,
                pixelY: h
            };
        }
        function l(a) {
            a.originalEvent && (a = a.originalEvent);
            var b = 0, c = v.rtl ? -1 : 1, d = k(a);
            if (v.params.mousewheelForceToAxis) if (v.isHorizontal()) {
                if (!(Math.abs(d.pixelX) > Math.abs(d.pixelY))) return;
                b = d.pixelX * c;
            } else {
                if (!(Math.abs(d.pixelY) > Math.abs(d.pixelX))) return;
                b = d.pixelY;
            } else b = Math.abs(d.pixelX) > Math.abs(d.pixelY) ? -d.pixelX * c : -d.pixelY;
            if (0 !== b) {
                if (v.params.mousewheelInvert && (b = -b), v.params.freeMode) {
                    var e = v.getWrapperTranslate() + b * v.params.mousewheelSensitivity, f = v.isBeginning, g = v.isEnd;
                    if (e >= v.minTranslate() && (e = v.minTranslate()), e <= v.maxTranslate() && (e = v.maxTranslate()), 
                    v.setWrapperTransition(0), v.setWrapperTranslate(e), v.updateProgress(), v.updateActiveIndex(), 
                    (!f && v.isBeginning || !g && v.isEnd) && v.updateClasses(), v.params.freeModeSticky ? (clearTimeout(v.mousewheel.timeout), 
                    v.mousewheel.timeout = setTimeout(function() {
                        v.slideReset();
                    }, 300)) : v.params.lazyLoading && v.lazy && v.lazy.load(), v.emit("onScroll", v, a), 
                    v.params.autoplay && v.params.autoplayDisableOnInteraction && v.stopAutoplay(), 
                    0 === e || e === v.maxTranslate()) return;
                } else {
                    if (new window.Date().getTime() - v.mousewheel.lastScrollTime > 60) if (b < 0) if (v.isEnd && !v.params.loop || v.animating) {
                        if (v.params.mousewheelReleaseOnEdges) return !0;
                    } else v.slideNext(), v.emit("onScroll", v, a); else if (v.isBeginning && !v.params.loop || v.animating) {
                        if (v.params.mousewheelReleaseOnEdges) return !0;
                    } else v.slidePrev(), v.emit("onScroll", v, a);
                    v.mousewheel.lastScrollTime = new window.Date().getTime();
                }
                return a.preventDefault ? a.preventDefault() : a.returnValue = !1, !1;
            }
        }
        function m(a, c) {
            a = b(a);
            var d, e, f, g = v.rtl ? -1 : 1;
            d = a.attr("data-swiper-parallax") || "0", e = a.attr("data-swiper-parallax-x"), 
            f = a.attr("data-swiper-parallax-y"), e || f ? (e = e || "0", f = f || "0") : v.isHorizontal() ? (e = d, 
            f = "0") : (f = d, e = "0"), e = e.indexOf("%") >= 0 ? parseInt(e, 10) * c * g + "%" : e * c * g + "px", 
            f = f.indexOf("%") >= 0 ? parseInt(f, 10) * c + "%" : f * c + "px", a.transform("translate3d(" + e + ", " + f + ",0px)");
        }
        function n(a) {
            return 0 !== a.indexOf("on") && (a = a[0] !== a[0].toUpperCase() ? "on" + a[0].toUpperCase() + a.substring(1) : "on" + a), 
            a;
        }
        if (!(this instanceof c)) return new c(a, d);
        var o = {
            direction: "horizontal",
            touchEventsTarget: "container",
            initialSlide: 0,
            speed: 300,
            autoplay: !1,
            autoplayDisableOnInteraction: !0,
            autoplayStopOnLast: !1,
            iOSEdgeSwipeDetection: !1,
            iOSEdgeSwipeThreshold: 20,
            freeMode: !1,
            freeModeMomentum: !0,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: !0,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: !1,
            freeModeMinimumVelocity: .02,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: !0
            },
            flip: {
                slideShadows: !0,
                limitRotation: !0
            },
            cube: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: .94
            },
            fade: {
                crossFade: !1
            },
            parallax: !1,
            zoom: !1,
            zoomMax: 3,
            zoomMin: 1,
            zoomToggle: !0,
            scrollbar: null,
            scrollbarHide: !0,
            scrollbarDraggable: !1,
            scrollbarSnapOnRelease: !1,
            keyboardControl: !1,
            mousewheelControl: !1,
            mousewheelReleaseOnEdges: !1,
            mousewheelInvert: !1,
            mousewheelForceToAxis: !1,
            mousewheelSensitivity: 1,
            mousewheelEventsTarged: "container",
            hashnav: !1,
            hashnavWatchState: !1,
            history: !1,
            replaceState: !1,
            breakpoints: void 0,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: "column",
            slidesPerGroup: 1,
            centeredSlides: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: .5,
            longSwipesMs: 300,
            followFinger: !0,
            onlyExternal: !1,
            threshold: 0,
            touchMoveStopPropagation: !0,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            pagination: null,
            paginationElement: "span",
            paginationClickable: !1,
            paginationHide: !1,
            paginationBulletRender: null,
            paginationProgressRender: null,
            paginationFractionRender: null,
            paginationCustomRender: null,
            paginationType: "bullets",
            resistance: !0,
            resistanceRatio: .85,
            nextButton: null,
            prevButton: null,
            watchSlidesProgress: !1,
            watchSlidesVisibility: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            lazyLoading: !1,
            lazyLoadingInPrevNext: !1,
            lazyLoadingInPrevNextAmount: 1,
            lazyLoadingOnTransitionStart: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            control: void 0,
            controlInverse: !1,
            controlBy: "slide",
            normalizeSlideIndex: !0,
            allowSwipeToPrev: !0,
            allowSwipeToNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            passiveListeners: !0,
            containerModifierClass: "swiper-container-",
            slideClass: "swiper-slide",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            buttonDisabledClass: "swiper-button-disabled",
            paginationCurrentClass: "swiper-pagination-current",
            paginationTotalClass: "swiper-pagination-total",
            paginationHiddenClass: "swiper-pagination-hidden",
            paginationProgressbarClass: "swiper-pagination-progressbar",
            paginationClickableClass: "swiper-pagination-clickable",
            paginationModifierClass: "swiper-pagination-",
            lazyLoadingClass: "swiper-lazy",
            lazyStatusLoadingClass: "swiper-lazy-loading",
            lazyStatusLoadedClass: "swiper-lazy-loaded",
            lazyPreloaderClass: "swiper-lazy-preloader",
            notificationClass: "swiper-notification",
            preloaderClass: "preloader",
            zoomContainerClass: "swiper-zoom-container",
            observer: !1,
            observeParents: !1,
            a11y: !1,
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            runCallbacksOnInit: !0
        }, p = d && d.virtualTranslate;
        d = d || {};
        var q = {};
        for (var r in d) if ("object" != typeof d[r] || null === d[r] || (d[r].nodeType || d[r] === window || d[r] === document || "undefined" != typeof Dom7 && d[r] instanceof Dom7 || "undefined" != typeof jQuery && d[r] instanceof jQuery)) q[r] = d[r]; else {
            q[r] = {};
            for (var s in d[r]) q[r][s] = d[r][s];
        }
        for (var t in o) if (void 0 === d[t]) d[t] = o[t]; else if ("object" == typeof d[t]) for (var u in o[t]) void 0 === d[t][u] && (d[t][u] = o[t][u]);
        var v = this;
        if (v.params = d, v.originalParams = q, v.classNames = [], void 0 !== b && "undefined" != typeof Dom7 && (b = Dom7), 
        (void 0 !== b || (b = "undefined" == typeof Dom7 ? window.Dom7 || window.Zepto || window.jQuery : Dom7)) && (v.$ = b, 
        v.currentBreakpoint = void 0, v.getActiveBreakpoint = function() {
            if (!v.params.breakpoints) return !1;
            var a, b = !1, c = [];
            for (a in v.params.breakpoints) v.params.breakpoints.hasOwnProperty(a) && c.push(a);
            c.sort(function(a, b) {
                return parseInt(a, 10) > parseInt(b, 10);
            });
            for (var d = 0; d < c.length; d++) (a = c[d]) >= window.innerWidth && !b && (b = a);
            return b || "max";
        }, v.setBreakpoint = function() {
            var a = v.getActiveBreakpoint();
            if (a && v.currentBreakpoint !== a) {
                var b = a in v.params.breakpoints ? v.params.breakpoints[a] : v.originalParams, c = v.params.loop && b.slidesPerView !== v.params.slidesPerView;
                for (var d in b) v.params[d] = b[d];
                v.currentBreakpoint = a, c && v.destroyLoop && v.reLoop(!0);
            }
        }, v.params.breakpoints && v.setBreakpoint(), v.container = b(a), 0 !== v.container.length)) {
            if (v.container.length > 1) {
                var w = [];
                return v.container.each(function() {
                    w.push(new c(this, d));
                }), w;
            }
            v.container[0].swiper = v, v.container.data("swiper", v), v.classNames.push(v.params.containerModifierClass + v.params.direction), 
            v.params.freeMode && v.classNames.push(v.params.containerModifierClass + "free-mode"), 
            v.support.flexbox || (v.classNames.push(v.params.containerModifierClass + "no-flexbox"), 
            v.params.slidesPerColumn = 1), v.params.autoHeight && v.classNames.push(v.params.containerModifierClass + "autoheight"), 
            (v.params.parallax || v.params.watchSlidesVisibility) && (v.params.watchSlidesProgress = !0), 
            v.params.touchReleaseOnEdges && (v.params.resistanceRatio = 0), [ "cube", "coverflow", "flip" ].indexOf(v.params.effect) >= 0 && (v.support.transforms3d ? (v.params.watchSlidesProgress = !0, 
            v.classNames.push(v.params.containerModifierClass + "3d")) : v.params.effect = "slide"), 
            "slide" !== v.params.effect && v.classNames.push(v.params.containerModifierClass + v.params.effect), 
            "cube" === v.params.effect && (v.params.resistanceRatio = 0, v.params.slidesPerView = 1, 
            v.params.slidesPerColumn = 1, v.params.slidesPerGroup = 1, v.params.centeredSlides = !1, 
            v.params.spaceBetween = 0, v.params.virtualTranslate = !0), "fade" !== v.params.effect && "flip" !== v.params.effect || (v.params.slidesPerView = 1, 
            v.params.slidesPerColumn = 1, v.params.slidesPerGroup = 1, v.params.watchSlidesProgress = !0, 
            v.params.spaceBetween = 0, void 0 === p && (v.params.virtualTranslate = !0)), v.params.grabCursor && v.support.touch && (v.params.grabCursor = !1), 
            v.wrapper = v.container.children("." + v.params.wrapperClass), v.params.pagination && (v.paginationContainer = b(v.params.pagination), 
            v.params.uniqueNavElements && "string" == typeof v.params.pagination && v.paginationContainer.length > 1 && 1 === v.container.find(v.params.pagination).length && (v.paginationContainer = v.container.find(v.params.pagination)), 
            "bullets" === v.params.paginationType && v.params.paginationClickable ? v.paginationContainer.addClass(v.params.paginationModifierClass + "clickable") : v.params.paginationClickable = !1, 
            v.paginationContainer.addClass(v.params.paginationModifierClass + v.params.paginationType)), 
            (v.params.nextButton || v.params.prevButton) && (v.params.nextButton && (v.nextButton = b(v.params.nextButton), 
            v.params.uniqueNavElements && "string" == typeof v.params.nextButton && v.nextButton.length > 1 && 1 === v.container.find(v.params.nextButton).length && (v.nextButton = v.container.find(v.params.nextButton))), 
            v.params.prevButton && (v.prevButton = b(v.params.prevButton), v.params.uniqueNavElements && "string" == typeof v.params.prevButton && v.prevButton.length > 1 && 1 === v.container.find(v.params.prevButton).length && (v.prevButton = v.container.find(v.params.prevButton)))), 
            v.isHorizontal = function() {
                return "horizontal" === v.params.direction;
            }, v.rtl = v.isHorizontal() && ("rtl" === v.container[0].dir.toLowerCase() || "rtl" === v.container.css("direction")), 
            v.rtl && v.classNames.push(v.params.containerModifierClass + "rtl"), v.rtl && (v.wrongRTL = "-webkit-box" === v.wrapper.css("display")), 
            v.params.slidesPerColumn > 1 && v.classNames.push(v.params.containerModifierClass + "multirow"), 
            v.device.android && v.classNames.push(v.params.containerModifierClass + "android"), 
            v.container.addClass(v.classNames.join(" ")), v.translate = 0, v.progress = 0, v.velocity = 0, 
            v.lockSwipeToNext = function() {
                v.params.allowSwipeToNext = !1, !1 === v.params.allowSwipeToPrev && v.params.grabCursor && v.unsetGrabCursor();
            }, v.lockSwipeToPrev = function() {
                v.params.allowSwipeToPrev = !1, !1 === v.params.allowSwipeToNext && v.params.grabCursor && v.unsetGrabCursor();
            }, v.lockSwipes = function() {
                v.params.allowSwipeToNext = v.params.allowSwipeToPrev = !1, v.params.grabCursor && v.unsetGrabCursor();
            }, v.unlockSwipeToNext = function() {
                v.params.allowSwipeToNext = !0, !0 === v.params.allowSwipeToPrev && v.params.grabCursor && v.setGrabCursor();
            }, v.unlockSwipeToPrev = function() {
                v.params.allowSwipeToPrev = !0, !0 === v.params.allowSwipeToNext && v.params.grabCursor && v.setGrabCursor();
            }, v.unlockSwipes = function() {
                v.params.allowSwipeToNext = v.params.allowSwipeToPrev = !0, v.params.grabCursor && v.setGrabCursor();
            }, v.setGrabCursor = function(a) {
                v.container[0].style.cursor = "move", v.container[0].style.cursor = a ? "-webkit-grabbing" : "-webkit-grab", 
                v.container[0].style.cursor = a ? "-moz-grabbin" : "-moz-grab", v.container[0].style.cursor = a ? "grabbing" : "grab";
            }, v.unsetGrabCursor = function() {
                v.container[0].style.cursor = "";
            }, v.params.grabCursor && v.setGrabCursor(), v.imagesToLoad = [], v.imagesLoaded = 0, 
            v.loadImage = function(a, b, c, d, e, f) {
                function g() {
                    f && f();
                }
                var h;
                a.complete && e ? g() : b ? (h = new window.Image(), h.onload = g, h.onerror = g, 
                d && (h.sizes = d), c && (h.srcset = c), b && (h.src = b)) : g();
            }, v.preloadImages = function() {
                function a() {
                    void 0 !== v && null !== v && v && (void 0 !== v.imagesLoaded && v.imagesLoaded++, 
                    v.imagesLoaded === v.imagesToLoad.length && (v.params.updateOnImagesReady && v.update(), 
                    v.emit("onImagesReady", v)));
                }
                v.imagesToLoad = v.container.find("img");
                for (var b = 0; b < v.imagesToLoad.length; b++) v.loadImage(v.imagesToLoad[b], v.imagesToLoad[b].currentSrc || v.imagesToLoad[b].getAttribute("src"), v.imagesToLoad[b].srcset || v.imagesToLoad[b].getAttribute("srcset"), v.imagesToLoad[b].sizes || v.imagesToLoad[b].getAttribute("sizes"), !0, a);
            }, v.autoplayTimeoutId = void 0, v.autoplaying = !1, v.autoplayPaused = !1, v.startAutoplay = function() {
                return void 0 === v.autoplayTimeoutId && (!!v.params.autoplay && (!v.autoplaying && (v.autoplaying = !0, 
                v.emit("onAutoplayStart", v), void f())));
            }, v.stopAutoplay = function(a) {
                v.autoplayTimeoutId && (v.autoplayTimeoutId && clearTimeout(v.autoplayTimeoutId), 
                v.autoplaying = !1, v.autoplayTimeoutId = void 0, v.emit("onAutoplayStop", v));
            }, v.pauseAutoplay = function(a) {
                v.autoplayPaused || (v.autoplayTimeoutId && clearTimeout(v.autoplayTimeoutId), v.autoplayPaused = !0, 
                0 === a ? (v.autoplayPaused = !1, f()) : v.wrapper.transitionEnd(function() {
                    v && (v.autoplayPaused = !1, v.autoplaying ? f() : v.stopAutoplay());
                }));
            }, v.minTranslate = function() {
                return -v.snapGrid[0];
            }, v.maxTranslate = function() {
                return -v.snapGrid[v.snapGrid.length - 1];
            }, v.updateAutoHeight = function() {
                var a, b = [], c = 0;
                if ("auto" !== v.params.slidesPerView && v.params.slidesPerView > 1) for (a = 0; a < Math.ceil(v.params.slidesPerView); a++) {
                    var d = v.activeIndex + a;
                    if (d > v.slides.length) break;
                    b.push(v.slides.eq(d)[0]);
                } else b.push(v.slides.eq(v.activeIndex)[0]);
                for (a = 0; a < b.length; a++) if (void 0 !== b[a]) {
                    var e = b[a].offsetHeight;
                    c = e > c ? e : c;
                }
                c && v.wrapper.css("height", c + "px");
            }, v.updateContainerSize = function() {
                var a, b;
                a = void 0 !== v.params.width ? v.params.width : v.container[0].clientWidth, b = void 0 !== v.params.height ? v.params.height : v.container[0].clientHeight, 
                0 === a && v.isHorizontal() || 0 === b && !v.isHorizontal() || (a = a - parseInt(v.container.css("padding-left"), 10) - parseInt(v.container.css("padding-right"), 10), 
                b = b - parseInt(v.container.css("padding-top"), 10) - parseInt(v.container.css("padding-bottom"), 10), 
                v.width = a, v.height = b, v.size = v.isHorizontal() ? v.width : v.height);
            }, v.updateSlidesSize = function() {
                v.slides = v.wrapper.children("." + v.params.slideClass), v.snapGrid = [], v.slidesGrid = [], 
                v.slidesSizesGrid = [];
                var a, b = v.params.spaceBetween, c = -v.params.slidesOffsetBefore, d = 0, f = 0;
                if (void 0 !== v.size) {
                    "string" == typeof b && b.indexOf("%") >= 0 && (b = parseFloat(b.replace("%", "")) / 100 * v.size), 
                    v.virtualSize = -b, v.rtl ? v.slides.css({
                        marginLeft: "",
                        marginTop: ""
                    }) : v.slides.css({
                        marginRight: "",
                        marginBottom: ""
                    });
                    var g;
                    v.params.slidesPerColumn > 1 && (g = Math.floor(v.slides.length / v.params.slidesPerColumn) === v.slides.length / v.params.slidesPerColumn ? v.slides.length : Math.ceil(v.slides.length / v.params.slidesPerColumn) * v.params.slidesPerColumn, 
                    "auto" !== v.params.slidesPerView && "row" === v.params.slidesPerColumnFill && (g = Math.max(g, v.params.slidesPerView * v.params.slidesPerColumn)));
                    var h, i = v.params.slidesPerColumn, j = g / i, k = j - (v.params.slidesPerColumn * j - v.slides.length);
                    for (a = 0; a < v.slides.length; a++) {
                        h = 0;
                        var l = v.slides.eq(a);
                        if (v.params.slidesPerColumn > 1) {
                            var m, n, o;
                            "column" === v.params.slidesPerColumnFill ? (n = Math.floor(a / i), o = a - n * i, 
                            (n > k || n === k && o === i - 1) && ++o >= i && (o = 0, n++), m = n + o * g / i, 
                            l.css({
                                "-webkit-box-ordinal-group": m,
                                "-moz-box-ordinal-group": m,
                                "-ms-flex-order": m,
                                "-webkit-order": m,
                                order: m
                            })) : (o = Math.floor(a / j), n = a - o * j), l.css("margin-" + (v.isHorizontal() ? "top" : "left"), 0 !== o && v.params.spaceBetween && v.params.spaceBetween + "px").attr("data-swiper-column", n).attr("data-swiper-row", o);
                        }
                        "none" !== l.css("display") && ("auto" === v.params.slidesPerView ? (h = v.isHorizontal() ? l.outerWidth(!0) : l.outerHeight(!0), 
                        v.params.roundLengths && (h = e(h))) : (h = (v.size - (v.params.slidesPerView - 1) * b) / v.params.slidesPerView, 
                        v.params.roundLengths && (h = e(h)), v.isHorizontal() ? v.slides[a].style.width = h + "px" : v.slides[a].style.height = h + "px"), 
                        v.slides[a].swiperSlideSize = h, v.slidesSizesGrid.push(h), v.params.centeredSlides ? (c = c + h / 2 + d / 2 + b, 
                        0 === d && 0 !== a && (c = c - v.size / 2 - b), 0 === a && (c = c - v.size / 2 - b), 
                        Math.abs(c) < .001 && (c = 0), f % v.params.slidesPerGroup == 0 && v.snapGrid.push(c), 
                        v.slidesGrid.push(c)) : (f % v.params.slidesPerGroup == 0 && v.snapGrid.push(c), 
                        v.slidesGrid.push(c), c = c + h + b), v.virtualSize += h + b, d = h, f++);
                    }
                    v.virtualSize = Math.max(v.virtualSize, v.size) + v.params.slidesOffsetAfter;
                    var p;
                    if (v.rtl && v.wrongRTL && ("slide" === v.params.effect || "coverflow" === v.params.effect) && v.wrapper.css({
                        width: v.virtualSize + v.params.spaceBetween + "px"
                    }), v.support.flexbox && !v.params.setWrapperSize || (v.isHorizontal() ? v.wrapper.css({
                        width: v.virtualSize + v.params.spaceBetween + "px"
                    }) : v.wrapper.css({
                        height: v.virtualSize + v.params.spaceBetween + "px"
                    })), v.params.slidesPerColumn > 1 && (v.virtualSize = (h + v.params.spaceBetween) * g, 
                    v.virtualSize = Math.ceil(v.virtualSize / v.params.slidesPerColumn) - v.params.spaceBetween, 
                    v.isHorizontal() ? v.wrapper.css({
                        width: v.virtualSize + v.params.spaceBetween + "px"
                    }) : v.wrapper.css({
                        height: v.virtualSize + v.params.spaceBetween + "px"
                    }), v.params.centeredSlides)) {
                        for (p = [], a = 0; a < v.snapGrid.length; a++) v.snapGrid[a] < v.virtualSize + v.snapGrid[0] && p.push(v.snapGrid[a]);
                        v.snapGrid = p;
                    }
                    if (!v.params.centeredSlides) {
                        for (p = [], a = 0; a < v.snapGrid.length; a++) v.snapGrid[a] <= v.virtualSize - v.size && p.push(v.snapGrid[a]);
                        v.snapGrid = p, Math.floor(v.virtualSize - v.size) - Math.floor(v.snapGrid[v.snapGrid.length - 1]) > 1 && v.snapGrid.push(v.virtualSize - v.size);
                    }
                    0 === v.snapGrid.length && (v.snapGrid = [ 0 ]), 0 !== v.params.spaceBetween && (v.isHorizontal() ? v.rtl ? v.slides.css({
                        marginLeft: b + "px"
                    }) : v.slides.css({
                        marginRight: b + "px"
                    }) : v.slides.css({
                        marginBottom: b + "px"
                    })), v.params.watchSlidesProgress && v.updateSlidesOffset();
                }
            }, v.updateSlidesOffset = function() {
                for (var a = 0; a < v.slides.length; a++) v.slides[a].swiperSlideOffset = v.isHorizontal() ? v.slides[a].offsetLeft : v.slides[a].offsetTop;
            }, v.currentSlidesPerView = function() {
                var a, b, c = 1;
                if (v.params.centeredSlides) {
                    var d, e = v.slides[v.activeIndex].swiperSlideSize;
                    for (a = v.activeIndex + 1; a < v.slides.length; a++) v.slides[a] && !d && (e += v.slides[a].swiperSlideSize, 
                    c++, e > v.size && (d = !0));
                    for (b = v.activeIndex - 1; b >= 0; b--) v.slides[b] && !d && (e += v.slides[b].swiperSlideSize, 
                    c++, e > v.size && (d = !0));
                } else for (a = v.activeIndex + 1; a < v.slides.length; a++) v.slidesGrid[a] - v.slidesGrid[v.activeIndex] < v.size && c++;
                return c;
            }, v.updateSlidesProgress = function(a) {
                if (void 0 === a && (a = v.translate || 0), 0 !== v.slides.length) {
                    void 0 === v.slides[0].swiperSlideOffset && v.updateSlidesOffset();
                    var b = -a;
                    v.rtl && (b = a), v.slides.removeClass(v.params.slideVisibleClass);
                    for (var c = 0; c < v.slides.length; c++) {
                        var d = v.slides[c], e = (b + (v.params.centeredSlides ? v.minTranslate() : 0) - d.swiperSlideOffset) / (d.swiperSlideSize + v.params.spaceBetween);
                        if (v.params.watchSlidesVisibility) {
                            var f = -(b - d.swiperSlideOffset), g = f + v.slidesSizesGrid[c];
                            (f >= 0 && f < v.size || g > 0 && g <= v.size || f <= 0 && g >= v.size) && v.slides.eq(c).addClass(v.params.slideVisibleClass);
                        }
                        d.progress = v.rtl ? -e : e;
                    }
                }
            }, v.updateProgress = function(a) {
                void 0 === a && (a = v.translate || 0);
                var b = v.maxTranslate() - v.minTranslate(), c = v.isBeginning, d = v.isEnd;
                0 === b ? (v.progress = 0, v.isBeginning = v.isEnd = !0) : (v.progress = (a - v.minTranslate()) / b, 
                v.isBeginning = v.progress <= 0, v.isEnd = v.progress >= 1), v.isBeginning && !c && v.emit("onReachBeginning", v), 
                v.isEnd && !d && v.emit("onReachEnd", v), v.params.watchSlidesProgress && v.updateSlidesProgress(a), 
                v.emit("onProgress", v, v.progress);
            }, v.updateActiveIndex = function() {
                var a, b, c, d = v.rtl ? v.translate : -v.translate;
                for (b = 0; b < v.slidesGrid.length; b++) void 0 !== v.slidesGrid[b + 1] ? d >= v.slidesGrid[b] && d < v.slidesGrid[b + 1] - (v.slidesGrid[b + 1] - v.slidesGrid[b]) / 2 ? a = b : d >= v.slidesGrid[b] && d < v.slidesGrid[b + 1] && (a = b + 1) : d >= v.slidesGrid[b] && (a = b);
                v.params.normalizeSlideIndex && (a < 0 || void 0 === a) && (a = 0), c = Math.floor(a / v.params.slidesPerGroup), 
                c >= v.snapGrid.length && (c = v.snapGrid.length - 1), a !== v.activeIndex && (v.snapIndex = c, 
                v.previousIndex = v.activeIndex, v.activeIndex = a, v.updateClasses(), v.updateRealIndex());
            }, v.updateRealIndex = function() {
                v.realIndex = parseInt(v.slides.eq(v.activeIndex).attr("data-swiper-slide-index") || v.activeIndex, 10);
            }, v.updateClasses = function() {
                v.slides.removeClass(v.params.slideActiveClass + " " + v.params.slideNextClass + " " + v.params.slidePrevClass + " " + v.params.slideDuplicateActiveClass + " " + v.params.slideDuplicateNextClass + " " + v.params.slideDuplicatePrevClass);
                var a = v.slides.eq(v.activeIndex);
                a.addClass(v.params.slideActiveClass), d.loop && (a.hasClass(v.params.slideDuplicateClass) ? v.wrapper.children("." + v.params.slideClass + ":not(." + v.params.slideDuplicateClass + ')[data-swiper-slide-index="' + v.realIndex + '"]').addClass(v.params.slideDuplicateActiveClass) : v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + v.realIndex + '"]').addClass(v.params.slideDuplicateActiveClass));
                var c = a.next("." + v.params.slideClass).addClass(v.params.slideNextClass);
                v.params.loop && 0 === c.length && (c = v.slides.eq(0), c.addClass(v.params.slideNextClass));
                var e = a.prev("." + v.params.slideClass).addClass(v.params.slidePrevClass);
                if (v.params.loop && 0 === e.length && (e = v.slides.eq(-1), e.addClass(v.params.slidePrevClass)), 
                d.loop && (c.hasClass(v.params.slideDuplicateClass) ? v.wrapper.children("." + v.params.slideClass + ":not(." + v.params.slideDuplicateClass + ')[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicateNextClass) : v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicateNextClass), 
                e.hasClass(v.params.slideDuplicateClass) ? v.wrapper.children("." + v.params.slideClass + ":not(." + v.params.slideDuplicateClass + ')[data-swiper-slide-index="' + e.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicatePrevClass) : v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + e.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicatePrevClass)), 
                v.paginationContainer && v.paginationContainer.length > 0) {
                    var f, g = v.params.loop ? Math.ceil((v.slides.length - 2 * v.loopedSlides) / v.params.slidesPerGroup) : v.snapGrid.length;
                    if (v.params.loop ? (f = Math.ceil((v.activeIndex - v.loopedSlides) / v.params.slidesPerGroup), 
                    f > v.slides.length - 1 - 2 * v.loopedSlides && (f -= v.slides.length - 2 * v.loopedSlides), 
                    f > g - 1 && (f -= g), f < 0 && "bullets" !== v.params.paginationType && (f = g + f)) : f = void 0 !== v.snapIndex ? v.snapIndex : v.activeIndex || 0, 
                    "bullets" === v.params.paginationType && v.bullets && v.bullets.length > 0 && (v.bullets.removeClass(v.params.bulletActiveClass), 
                    v.paginationContainer.length > 1 ? v.bullets.each(function() {
                        b(this).index() === f && b(this).addClass(v.params.bulletActiveClass);
                    }) : v.bullets.eq(f).addClass(v.params.bulletActiveClass)), "fraction" === v.params.paginationType && (v.paginationContainer.find("." + v.params.paginationCurrentClass).text(f + 1), 
                    v.paginationContainer.find("." + v.params.paginationTotalClass).text(g)), "progress" === v.params.paginationType) {
                        var h = (f + 1) / g, i = h, j = 1;
                        v.isHorizontal() || (j = h, i = 1), v.paginationContainer.find("." + v.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX(" + i + ") scaleY(" + j + ")").transition(v.params.speed);
                    }
                    "custom" === v.params.paginationType && v.params.paginationCustomRender && (v.paginationContainer.html(v.params.paginationCustomRender(v, f + 1, g)), 
                    v.emit("onPaginationRendered", v, v.paginationContainer[0]));
                }
                v.params.loop || (v.params.prevButton && v.prevButton && v.prevButton.length > 0 && (v.isBeginning ? (v.prevButton.addClass(v.params.buttonDisabledClass), 
                v.params.a11y && v.a11y && v.a11y.disable(v.prevButton)) : (v.prevButton.removeClass(v.params.buttonDisabledClass), 
                v.params.a11y && v.a11y && v.a11y.enable(v.prevButton))), v.params.nextButton && v.nextButton && v.nextButton.length > 0 && (v.isEnd ? (v.nextButton.addClass(v.params.buttonDisabledClass), 
                v.params.a11y && v.a11y && v.a11y.disable(v.nextButton)) : (v.nextButton.removeClass(v.params.buttonDisabledClass), 
                v.params.a11y && v.a11y && v.a11y.enable(v.nextButton))));
            }, v.updatePagination = function() {
                if (v.params.pagination && v.paginationContainer && v.paginationContainer.length > 0) {
                    var a = "";
                    if ("bullets" === v.params.paginationType) {
                        for (var b = v.params.loop ? Math.ceil((v.slides.length - 2 * v.loopedSlides) / v.params.slidesPerGroup) : v.snapGrid.length, c = 0; c < b; c++) v.params.paginationBulletRender ? a += v.params.paginationBulletRender(v, c, v.params.bulletClass) : a += "<" + v.params.paginationElement + ' class="' + v.params.bulletClass + '"></' + v.params.paginationElement + ">";
                        v.paginationContainer.html(a), v.bullets = v.paginationContainer.find("." + v.params.bulletClass), 
                        v.params.paginationClickable && v.params.a11y && v.a11y && v.a11y.initPagination();
                    }
                    "fraction" === v.params.paginationType && (a = v.params.paginationFractionRender ? v.params.paginationFractionRender(v, v.params.paginationCurrentClass, v.params.paginationTotalClass) : '<span class="' + v.params.paginationCurrentClass + '"></span> / <span class="' + v.params.paginationTotalClass + '"></span>', 
                    v.paginationContainer.html(a)), "progress" === v.params.paginationType && (a = v.params.paginationProgressRender ? v.params.paginationProgressRender(v, v.params.paginationProgressbarClass) : '<span class="' + v.params.paginationProgressbarClass + '"></span>', 
                    v.paginationContainer.html(a)), "custom" !== v.params.paginationType && v.emit("onPaginationRendered", v, v.paginationContainer[0]);
                }
            }, v.update = function(a) {
                function b() {
                    v.rtl, v.translate;
                    c = Math.min(Math.max(v.translate, v.maxTranslate()), v.minTranslate()), v.setWrapperTranslate(c), 
                    v.updateActiveIndex(), v.updateClasses();
                }
                if (v) {
                    v.updateContainerSize(), v.updateSlidesSize(), v.updateProgress(), v.updatePagination(), 
                    v.updateClasses(), v.params.scrollbar && v.scrollbar && v.scrollbar.set();
                    var c;
                    if (a) {
                        v.controller && v.controller.spline && (v.controller.spline = void 0), v.params.freeMode ? (b(), 
                        v.params.autoHeight && v.updateAutoHeight()) : (("auto" === v.params.slidesPerView || v.params.slidesPerView > 1) && v.isEnd && !v.params.centeredSlides ? v.slideTo(v.slides.length - 1, 0, !1, !0) : v.slideTo(v.activeIndex, 0, !1, !0)) || b();
                    } else v.params.autoHeight && v.updateAutoHeight();
                }
            }, v.onResize = function(a) {
                v.params.onBeforeResize && v.params.onBeforeResize(v), v.params.breakpoints && v.setBreakpoint();
                var b = v.params.allowSwipeToPrev, c = v.params.allowSwipeToNext;
                v.params.allowSwipeToPrev = v.params.allowSwipeToNext = !0, v.updateContainerSize(), 
                v.updateSlidesSize(), ("auto" === v.params.slidesPerView || v.params.freeMode || a) && v.updatePagination(), 
                v.params.scrollbar && v.scrollbar && v.scrollbar.set(), v.controller && v.controller.spline && (v.controller.spline = void 0);
                var d = !1;
                if (v.params.freeMode) {
                    var e = Math.min(Math.max(v.translate, v.maxTranslate()), v.minTranslate());
                    v.setWrapperTranslate(e), v.updateActiveIndex(), v.updateClasses(), v.params.autoHeight && v.updateAutoHeight();
                } else v.updateClasses(), d = ("auto" === v.params.slidesPerView || v.params.slidesPerView > 1) && v.isEnd && !v.params.centeredSlides ? v.slideTo(v.slides.length - 1, 0, !1, !0) : v.slideTo(v.activeIndex, 0, !1, !0);
                v.params.lazyLoading && !d && v.lazy && v.lazy.load(), v.params.allowSwipeToPrev = b, 
                v.params.allowSwipeToNext = c, v.params.onAfterResize && v.params.onAfterResize(v);
            }, v.touchEventsDesktop = {
                start: "mousedown",
                move: "mousemove",
                end: "mouseup"
            }, window.navigator.pointerEnabled ? v.touchEventsDesktop = {
                start: "pointerdown",
                move: "pointermove",
                end: "pointerup"
            } : window.navigator.msPointerEnabled && (v.touchEventsDesktop = {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp"
            }), v.touchEvents = {
                start: v.support.touch || !v.params.simulateTouch ? "touchstart" : v.touchEventsDesktop.start,
                move: v.support.touch || !v.params.simulateTouch ? "touchmove" : v.touchEventsDesktop.move,
                end: v.support.touch || !v.params.simulateTouch ? "touchend" : v.touchEventsDesktop.end
            }, (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && ("container" === v.params.touchEventsTarget ? v.container : v.wrapper).addClass("swiper-wp8-" + v.params.direction), 
            v.initEvents = function(a) {
                var b = a ? "off" : "on", c = a ? "removeEventListener" : "addEventListener", e = "container" === v.params.touchEventsTarget ? v.container[0] : v.wrapper[0], f = v.support.touch ? e : document, g = !!v.params.nested;
                if (v.browser.ie) e[c](v.touchEvents.start, v.onTouchStart, !1), f[c](v.touchEvents.move, v.onTouchMove, g), 
                f[c](v.touchEvents.end, v.onTouchEnd, !1); else {
                    if (v.support.touch) {
                        var h = !("touchstart" !== v.touchEvents.start || !v.support.passiveListener || !v.params.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        e[c](v.touchEvents.start, v.onTouchStart, h), e[c](v.touchEvents.move, v.onTouchMove, g), 
                        e[c](v.touchEvents.end, v.onTouchEnd, h);
                    }
                    (d.simulateTouch && !v.device.ios && !v.device.android || d.simulateTouch && !v.support.touch && v.device.ios) && (e[c]("mousedown", v.onTouchStart, !1), 
                    document[c]("mousemove", v.onTouchMove, g), document[c]("mouseup", v.onTouchEnd, !1));
                }
                window[c]("resize", v.onResize), v.params.nextButton && v.nextButton && v.nextButton.length > 0 && (v.nextButton[b]("click", v.onClickNext), 
                v.params.a11y && v.a11y && v.nextButton[b]("keydown", v.a11y.onEnterKey)), v.params.prevButton && v.prevButton && v.prevButton.length > 0 && (v.prevButton[b]("click", v.onClickPrev), 
                v.params.a11y && v.a11y && v.prevButton[b]("keydown", v.a11y.onEnterKey)), v.params.pagination && v.params.paginationClickable && (v.paginationContainer[b]("click", "." + v.params.bulletClass, v.onClickIndex), 
                v.params.a11y && v.a11y && v.paginationContainer[b]("keydown", "." + v.params.bulletClass, v.a11y.onEnterKey)), 
                (v.params.preventClicks || v.params.preventClicksPropagation) && e[c]("click", v.preventClicks, !0);
            }, v.attachEvents = function() {
                v.initEvents();
            }, v.detachEvents = function() {
                v.initEvents(!0);
            }, v.allowClick = !0, v.preventClicks = function(a) {
                v.allowClick || (v.params.preventClicks && a.preventDefault(), v.params.preventClicksPropagation && v.animating && (a.stopPropagation(), 
                a.stopImmediatePropagation()));
            }, v.onClickNext = function(a) {
                a.preventDefault(), v.isEnd && !v.params.loop || v.slideNext();
            }, v.onClickPrev = function(a) {
                a.preventDefault(), v.isBeginning && !v.params.loop || v.slidePrev();
            }, v.onClickIndex = function(a) {
                a.preventDefault();
                var c = b(this).index() * v.params.slidesPerGroup;
                v.params.loop && (c += v.loopedSlides), v.slideTo(c);
            }, v.updateClickedSlide = function(a) {
                var c = g(a, "." + v.params.slideClass), d = !1;
                if (c) for (var e = 0; e < v.slides.length; e++) v.slides[e] === c && (d = !0);
                if (!c || !d) return v.clickedSlide = void 0, void (v.clickedIndex = void 0);
                if (v.clickedSlide = c, v.clickedIndex = b(c).index(), v.params.slideToClickedSlide && void 0 !== v.clickedIndex && v.clickedIndex !== v.activeIndex) {
                    var f, h = v.clickedIndex, i = "auto" === v.params.slidesPerView ? v.currentSlidesPerView() : v.params.slidesPerView;
                    if (v.params.loop) {
                        if (v.animating) return;
                        f = parseInt(b(v.clickedSlide).attr("data-swiper-slide-index"), 10), v.params.centeredSlides ? h < v.loopedSlides - i / 2 || h > v.slides.length - v.loopedSlides + i / 2 ? (v.fixLoop(), 
                        h = v.wrapper.children("." + v.params.slideClass + '[data-swiper-slide-index="' + f + '"]:not(.' + v.params.slideDuplicateClass + ")").eq(0).index(), 
                        setTimeout(function() {
                            v.slideTo(h);
                        }, 0)) : v.slideTo(h) : h > v.slides.length - i ? (v.fixLoop(), h = v.wrapper.children("." + v.params.slideClass + '[data-swiper-slide-index="' + f + '"]:not(.' + v.params.slideDuplicateClass + ")").eq(0).index(), 
                        setTimeout(function() {
                            v.slideTo(h);
                        }, 0)) : v.slideTo(h);
                    } else v.slideTo(h);
                }
            };
            var x, y, z, A, B, C, D, E, F, G, H = "input, select, textarea, button, video", I = Date.now(), J = [];
            v.animating = !1, v.touches = {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            };
            var K, L;
            v.onTouchStart = function(a) {
                if (a.originalEvent && (a = a.originalEvent), (K = "touchstart" === a.type) || !("which" in a) || 3 !== a.which) {
                    if (v.params.noSwiping && g(a, "." + v.params.noSwipingClass)) return void (v.allowClick = !0);
                    if (!v.params.swipeHandler || g(a, v.params.swipeHandler)) {
                        var c = v.touches.currentX = "touchstart" === a.type ? a.targetTouches[0].pageX : a.pageX, d = v.touches.currentY = "touchstart" === a.type ? a.targetTouches[0].pageY : a.pageY;
                        if (!(v.device.ios && v.params.iOSEdgeSwipeDetection && c <= v.params.iOSEdgeSwipeThreshold)) {
                            if (x = !0, y = !1, z = !0, B = void 0, L = void 0, v.touches.startX = c, v.touches.startY = d, 
                            A = Date.now(), v.allowClick = !0, v.updateContainerSize(), v.swipeDirection = void 0, 
                            v.params.threshold > 0 && (E = !1), "touchstart" !== a.type) {
                                var e = !0;
                                b(a.target).is(H) && (e = !1), document.activeElement && b(document.activeElement).is(H) && document.activeElement.blur(), 
                                e && a.preventDefault();
                            }
                            v.emit("onTouchStart", v, a);
                        }
                    }
                }
            }, v.onTouchMove = function(a) {
                if (a.originalEvent && (a = a.originalEvent), !K || "mousemove" !== a.type) {
                    if (a.preventedByNestedSwiper) return v.touches.startX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, 
                    void (v.touches.startY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY);
                    if (v.params.onlyExternal) return v.allowClick = !1, void (x && (v.touches.startX = v.touches.currentX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, 
                    v.touches.startY = v.touches.currentY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, 
                    A = Date.now()));
                    if (K && v.params.touchReleaseOnEdges && !v.params.loop) if (v.isHorizontal()) {
                        if (v.touches.currentX < v.touches.startX && v.translate <= v.maxTranslate() || v.touches.currentX > v.touches.startX && v.translate >= v.minTranslate()) return;
                    } else if (v.touches.currentY < v.touches.startY && v.translate <= v.maxTranslate() || v.touches.currentY > v.touches.startY && v.translate >= v.minTranslate()) return;
                    if (K && document.activeElement && a.target === document.activeElement && b(a.target).is(H)) return y = !0, 
                    void (v.allowClick = !1);
                    if (z && v.emit("onTouchMove", v, a), !(a.targetTouches && a.targetTouches.length > 1)) {
                        if (v.touches.currentX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, 
                        v.touches.currentY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, 
                        void 0 === B) {
                            var c;
                            v.isHorizontal() && v.touches.currentY === v.touches.startY || !v.isHorizontal() && v.touches.currentX === v.touches.startX ? B = !1 : (c = 180 * Math.atan2(Math.abs(v.touches.currentY - v.touches.startY), Math.abs(v.touches.currentX - v.touches.startX)) / Math.PI, 
                            B = v.isHorizontal() ? c > v.params.touchAngle : 90 - c > v.params.touchAngle);
                        }
                        if (B && v.emit("onTouchMoveOpposite", v, a), void 0 === L && (v.touches.currentX === v.touches.startX && v.touches.currentY === v.touches.startY || (L = !0)), 
                        x) {
                            if (B) return void (x = !1);
                            if (L) {
                                v.allowClick = !1, v.emit("onSliderMove", v, a), a.preventDefault(), v.params.touchMoveStopPropagation && !v.params.nested && a.stopPropagation(), 
                                y || (d.loop && v.fixLoop(), D = v.getWrapperTranslate(), v.setWrapperTransition(0), 
                                v.animating && v.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"), 
                                v.params.autoplay && v.autoplaying && (v.params.autoplayDisableOnInteraction ? v.stopAutoplay() : v.pauseAutoplay()), 
                                G = !1, !v.params.grabCursor || !0 !== v.params.allowSwipeToNext && !0 !== v.params.allowSwipeToPrev || v.setGrabCursor(!0)), 
                                y = !0;
                                var e = v.touches.diff = v.isHorizontal() ? v.touches.currentX - v.touches.startX : v.touches.currentY - v.touches.startY;
                                e *= v.params.touchRatio, v.rtl && (e = -e), v.swipeDirection = e > 0 ? "prev" : "next", 
                                C = e + D;
                                var f = !0;
                                if (e > 0 && C > v.minTranslate() ? (f = !1, v.params.resistance && (C = v.minTranslate() - 1 + Math.pow(-v.minTranslate() + D + e, v.params.resistanceRatio))) : e < 0 && C < v.maxTranslate() && (f = !1, 
                                v.params.resistance && (C = v.maxTranslate() + 1 - Math.pow(v.maxTranslate() - D - e, v.params.resistanceRatio))), 
                                f && (a.preventedByNestedSwiper = !0), !v.params.allowSwipeToNext && "next" === v.swipeDirection && C < D && (C = D), 
                                !v.params.allowSwipeToPrev && "prev" === v.swipeDirection && C > D && (C = D), v.params.threshold > 0) {
                                    if (!(Math.abs(e) > v.params.threshold || E)) return void (C = D);
                                    if (!E) return E = !0, v.touches.startX = v.touches.currentX, v.touches.startY = v.touches.currentY, 
                                    C = D, void (v.touches.diff = v.isHorizontal() ? v.touches.currentX - v.touches.startX : v.touches.currentY - v.touches.startY);
                                }
                                v.params.followFinger && ((v.params.freeMode || v.params.watchSlidesProgress) && v.updateActiveIndex(), 
                                v.params.freeMode && (0 === J.length && J.push({
                                    position: v.touches[v.isHorizontal() ? "startX" : "startY"],
                                    time: A
                                }), J.push({
                                    position: v.touches[v.isHorizontal() ? "currentX" : "currentY"],
                                    time: new window.Date().getTime()
                                })), v.updateProgress(C), v.setWrapperTranslate(C));
                            }
                        }
                    }
                }
            }, v.onTouchEnd = function(a) {
                if (a.originalEvent && (a = a.originalEvent), z && v.emit("onTouchEnd", v, a), z = !1, 
                x) {
                    v.params.grabCursor && y && x && (!0 === v.params.allowSwipeToNext || !0 === v.params.allowSwipeToPrev) && v.setGrabCursor(!1);
                    var c = Date.now(), d = c - A;
                    if (v.allowClick && (v.updateClickedSlide(a), v.emit("onTap", v, a), d < 300 && c - I > 300 && (F && clearTimeout(F), 
                    F = setTimeout(function() {
                        v && (v.params.paginationHide && v.paginationContainer.length > 0 && !b(a.target).hasClass(v.params.bulletClass) && v.paginationContainer.toggleClass(v.params.paginationHiddenClass), 
                        v.emit("onClick", v, a));
                    }, 300)), d < 300 && c - I < 300 && (F && clearTimeout(F), v.emit("onDoubleTap", v, a))), 
                    I = Date.now(), setTimeout(function() {
                        v && (v.allowClick = !0);
                    }, 0), !x || !y || !v.swipeDirection || 0 === v.touches.diff || C === D) return void (x = y = !1);
                    x = y = !1;
                    var e;
                    if (e = v.params.followFinger ? v.rtl ? v.translate : -v.translate : -C, v.params.freeMode) {
                        if (e < -v.minTranslate()) return void v.slideTo(v.activeIndex);
                        if (e > -v.maxTranslate()) return void (v.slides.length < v.snapGrid.length ? v.slideTo(v.snapGrid.length - 1) : v.slideTo(v.slides.length - 1));
                        if (v.params.freeModeMomentum) {
                            if (J.length > 1) {
                                var f = J.pop(), g = J.pop(), h = f.position - g.position, i = f.time - g.time;
                                v.velocity = h / i, v.velocity = v.velocity / 2, Math.abs(v.velocity) < v.params.freeModeMinimumVelocity && (v.velocity = 0), 
                                (i > 150 || new window.Date().getTime() - f.time > 300) && (v.velocity = 0);
                            } else v.velocity = 0;
                            v.velocity = v.velocity * v.params.freeModeMomentumVelocityRatio, J.length = 0;
                            var j = 1e3 * v.params.freeModeMomentumRatio, k = v.velocity * j, l = v.translate + k;
                            v.rtl && (l = -l);
                            var m, n = !1, o = 20 * Math.abs(v.velocity) * v.params.freeModeMomentumBounceRatio;
                            if (l < v.maxTranslate()) v.params.freeModeMomentumBounce ? (l + v.maxTranslate() < -o && (l = v.maxTranslate() - o), 
                            m = v.maxTranslate(), n = !0, G = !0) : l = v.maxTranslate(); else if (l > v.minTranslate()) v.params.freeModeMomentumBounce ? (l - v.minTranslate() > o && (l = v.minTranslate() + o), 
                            m = v.minTranslate(), n = !0, G = !0) : l = v.minTranslate(); else if (v.params.freeModeSticky) {
                                var p, q = 0;
                                for (q = 0; q < v.snapGrid.length; q += 1) if (v.snapGrid[q] > -l) {
                                    p = q;
                                    break;
                                }
                                l = Math.abs(v.snapGrid[p] - l) < Math.abs(v.snapGrid[p - 1] - l) || "next" === v.swipeDirection ? v.snapGrid[p] : v.snapGrid[p - 1], 
                                v.rtl || (l = -l);
                            }
                            if (0 !== v.velocity) j = v.rtl ? Math.abs((-l - v.translate) / v.velocity) : Math.abs((l - v.translate) / v.velocity); else if (v.params.freeModeSticky) return void v.slideReset();
                            v.params.freeModeMomentumBounce && n ? (v.updateProgress(m), v.setWrapperTransition(j), 
                            v.setWrapperTranslate(l), v.onTransitionStart(), v.animating = !0, v.wrapper.transitionEnd(function() {
                                v && G && (v.emit("onMomentumBounce", v), v.setWrapperTransition(v.params.speed), 
                                v.setWrapperTranslate(m), v.wrapper.transitionEnd(function() {
                                    v && v.onTransitionEnd();
                                }));
                            })) : v.velocity ? (v.updateProgress(l), v.setWrapperTransition(j), v.setWrapperTranslate(l), 
                            v.onTransitionStart(), v.animating || (v.animating = !0, v.wrapper.transitionEnd(function() {
                                v && v.onTransitionEnd();
                            }))) : v.updateProgress(l), v.updateActiveIndex();
                        }
                        return void ((!v.params.freeModeMomentum || d >= v.params.longSwipesMs) && (v.updateProgress(), 
                        v.updateActiveIndex()));
                    }
                    var r, s = 0, t = v.slidesSizesGrid[0];
                    for (r = 0; r < v.slidesGrid.length; r += v.params.slidesPerGroup) void 0 !== v.slidesGrid[r + v.params.slidesPerGroup] ? e >= v.slidesGrid[r] && e < v.slidesGrid[r + v.params.slidesPerGroup] && (s = r, 
                    t = v.slidesGrid[r + v.params.slidesPerGroup] - v.slidesGrid[r]) : e >= v.slidesGrid[r] && (s = r, 
                    t = v.slidesGrid[v.slidesGrid.length - 1] - v.slidesGrid[v.slidesGrid.length - 2]);
                    var u = (e - v.slidesGrid[s]) / t;
                    if (d > v.params.longSwipesMs) {
                        if (!v.params.longSwipes) return void v.slideTo(v.activeIndex);
                        "next" === v.swipeDirection && (u >= v.params.longSwipesRatio ? v.slideTo(s + v.params.slidesPerGroup) : v.slideTo(s)), 
                        "prev" === v.swipeDirection && (u > 1 - v.params.longSwipesRatio ? v.slideTo(s + v.params.slidesPerGroup) : v.slideTo(s));
                    } else {
                        if (!v.params.shortSwipes) return void v.slideTo(v.activeIndex);
                        "next" === v.swipeDirection && v.slideTo(s + v.params.slidesPerGroup), "prev" === v.swipeDirection && v.slideTo(s);
                    }
                }
            }, v._slideTo = function(a, b) {
                return v.slideTo(a, b, !0, !0);
            }, v.slideTo = function(a, b, c, d) {
                void 0 === c && (c = !0), void 0 === a && (a = 0), a < 0 && (a = 0), v.snapIndex = Math.floor(a / v.params.slidesPerGroup), 
                v.snapIndex >= v.snapGrid.length && (v.snapIndex = v.snapGrid.length - 1);
                var e = -v.snapGrid[v.snapIndex];
                if (v.params.autoplay && v.autoplaying && (d || !v.params.autoplayDisableOnInteraction ? v.pauseAutoplay(b) : v.stopAutoplay()), 
                v.updateProgress(e), v.params.normalizeSlideIndex) for (var f = 0; f < v.slidesGrid.length; f++) -Math.floor(100 * e) >= Math.floor(100 * v.slidesGrid[f]) && (a = f);
                return !(!v.params.allowSwipeToNext && e < v.translate && e < v.minTranslate()) && (!(!v.params.allowSwipeToPrev && e > v.translate && e > v.maxTranslate() && (v.activeIndex || 0) !== a) && (void 0 === b && (b = v.params.speed), 
                v.previousIndex = v.activeIndex || 0, v.activeIndex = a, v.updateRealIndex(), v.rtl && -e === v.translate || !v.rtl && e === v.translate ? (v.params.autoHeight && v.updateAutoHeight(), 
                v.updateClasses(), "slide" !== v.params.effect && v.setWrapperTranslate(e), !1) : (v.updateClasses(), 
                v.onTransitionStart(c), 0 === b || v.browser.lteIE9 ? (v.setWrapperTranslate(e), 
                v.setWrapperTransition(0), v.onTransitionEnd(c)) : (v.setWrapperTranslate(e), v.setWrapperTransition(b), 
                v.animating || (v.animating = !0, v.wrapper.transitionEnd(function() {
                    v && v.onTransitionEnd(c);
                }))), !0)));
            }, v.onTransitionStart = function(a) {
                void 0 === a && (a = !0), v.params.autoHeight && v.updateAutoHeight(), v.lazy && v.lazy.onTransitionStart(), 
                a && (v.emit("onTransitionStart", v), v.activeIndex !== v.previousIndex && (v.emit("onSlideChangeStart", v), 
                v.activeIndex > v.previousIndex ? v.emit("onSlideNextStart", v) : v.emit("onSlidePrevStart", v)));
            }, v.onTransitionEnd = function(a) {
                v.animating = !1, v.setWrapperTransition(0), void 0 === a && (a = !0), v.lazy && v.lazy.onTransitionEnd(), 
                a && (v.emit("onTransitionEnd", v), v.activeIndex !== v.previousIndex && (v.emit("onSlideChangeEnd", v), 
                v.activeIndex > v.previousIndex ? v.emit("onSlideNextEnd", v) : v.emit("onSlidePrevEnd", v))), 
                v.params.history && v.history && v.history.setHistory(v.params.history, v.activeIndex), 
                v.params.hashnav && v.hashnav && v.hashnav.setHash();
            }, v.slideNext = function(a, b, c) {
                if (v.params.loop) {
                    if (v.animating) return !1;
                    v.fixLoop();
                    v.container[0].clientLeft;
                    return v.slideTo(v.activeIndex + v.params.slidesPerGroup, b, a, c);
                }
                return v.slideTo(v.activeIndex + v.params.slidesPerGroup, b, a, c);
            }, v._slideNext = function(a) {
                return v.slideNext(!0, a, !0);
            }, v.slidePrev = function(a, b, c) {
                if (v.params.loop) {
                    if (v.animating) return !1;
                    v.fixLoop();
                    v.container[0].clientLeft;
                    return v.slideTo(v.activeIndex - 1, b, a, c);
                }
                return v.slideTo(v.activeIndex - 1, b, a, c);
            }, v._slidePrev = function(a) {
                return v.slidePrev(!0, a, !0);
            }, v.slideReset = function(a, b, c) {
                return v.slideTo(v.activeIndex, b, a);
            }, v.disableTouchControl = function() {
                return v.params.onlyExternal = !0, !0;
            }, v.enableTouchControl = function() {
                return v.params.onlyExternal = !1, !0;
            }, v.setWrapperTransition = function(a, b) {
                v.wrapper.transition(a), "slide" !== v.params.effect && v.effects[v.params.effect] && v.effects[v.params.effect].setTransition(a), 
                v.params.parallax && v.parallax && v.parallax.setTransition(a), v.params.scrollbar && v.scrollbar && v.scrollbar.setTransition(a), 
                v.params.control && v.controller && v.controller.setTransition(a, b), v.emit("onSetTransition", v, a);
            }, v.setWrapperTranslate = function(a, b, c) {
                var d = 0, f = 0;
                v.isHorizontal() ? d = v.rtl ? -a : a : f = a, v.params.roundLengths && (d = e(d), 
                f = e(f)), v.params.virtualTranslate || (v.support.transforms3d ? v.wrapper.transform("translate3d(" + d + "px, " + f + "px, 0px)") : v.wrapper.transform("translate(" + d + "px, " + f + "px)")), 
                v.translate = v.isHorizontal() ? d : f;
                var g, h = v.maxTranslate() - v.minTranslate();
                g = 0 === h ? 0 : (a - v.minTranslate()) / h, g !== v.progress && v.updateProgress(a), 
                b && v.updateActiveIndex(), "slide" !== v.params.effect && v.effects[v.params.effect] && v.effects[v.params.effect].setTranslate(v.translate), 
                v.params.parallax && v.parallax && v.parallax.setTranslate(v.translate), v.params.scrollbar && v.scrollbar && v.scrollbar.setTranslate(v.translate), 
                v.params.control && v.controller && v.controller.setTranslate(v.translate, c), v.emit("onSetTranslate", v, v.translate);
            }, v.getTranslate = function(a, b) {
                var c, d, e, f;
                return void 0 === b && (b = "x"), v.params.virtualTranslate ? v.rtl ? -v.translate : v.translate : (e = window.getComputedStyle(a, null), 
                window.WebKitCSSMatrix ? (d = e.transform || e.webkitTransform, d.split(",").length > 6 && (d = d.split(", ").map(function(a) {
                    return a.replace(",", ".");
                }).join(", ")), f = new window.WebKitCSSMatrix("none" === d ? "" : d)) : (f = e.MozTransform || e.OTransform || e.MsTransform || e.msTransform || e.transform || e.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), 
                c = f.toString().split(",")), "x" === b && (d = window.WebKitCSSMatrix ? f.m41 : 16 === c.length ? parseFloat(c[12]) : parseFloat(c[4])), 
                "y" === b && (d = window.WebKitCSSMatrix ? f.m42 : 16 === c.length ? parseFloat(c[13]) : parseFloat(c[5])), 
                v.rtl && d && (d = -d), d || 0);
            }, v.getWrapperTranslate = function(a) {
                return void 0 === a && (a = v.isHorizontal() ? "x" : "y"), v.getTranslate(v.wrapper[0], a);
            }, v.observers = [], v.initObservers = function() {
                if (v.params.observeParents) for (var a = v.container.parents(), b = 0; b < a.length; b++) h(a[b]);
                h(v.container[0], {
                    childList: !1
                }), h(v.wrapper[0], {
                    attributes: !1
                });
            }, v.disconnectObservers = function() {
                for (var a = 0; a < v.observers.length; a++) v.observers[a].disconnect();
                v.observers = [];
            }, v.createLoop = function() {
                v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass).remove();
                var a = v.wrapper.children("." + v.params.slideClass);
                "auto" !== v.params.slidesPerView || v.params.loopedSlides || (v.params.loopedSlides = a.length), 
                v.loopedSlides = parseInt(v.params.loopedSlides || v.params.slidesPerView, 10), 
                v.loopedSlides = v.loopedSlides + v.params.loopAdditionalSlides, v.loopedSlides > a.length && (v.loopedSlides = a.length);
                var c, d = [], e = [];
                for (a.each(function(c, f) {
                    var g = b(this);
                    c < v.loopedSlides && e.push(f), c < a.length && c >= a.length - v.loopedSlides && d.push(f), 
                    g.attr("data-swiper-slide-index", c);
                }), c = 0; c < e.length; c++) v.wrapper.append(b(e[c].cloneNode(!0)).addClass(v.params.slideDuplicateClass));
                for (c = d.length - 1; c >= 0; c--) v.wrapper.prepend(b(d[c].cloneNode(!0)).addClass(v.params.slideDuplicateClass));
            }, v.destroyLoop = function() {
                v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass).remove(), 
                v.slides.removeAttr("data-swiper-slide-index");
            }, v.reLoop = function(a) {
                var b = v.activeIndex - v.loopedSlides;
                v.destroyLoop(), v.createLoop(), v.updateSlidesSize(), a && v.slideTo(b + v.loopedSlides, 0, !1);
            }, v.fixLoop = function() {
                var a;
                v.activeIndex < v.loopedSlides ? (a = v.slides.length - 3 * v.loopedSlides + v.activeIndex, 
                a += v.loopedSlides, v.slideTo(a, 0, !1, !0)) : ("auto" === v.params.slidesPerView && v.activeIndex >= 2 * v.loopedSlides || v.activeIndex > v.slides.length - 2 * v.params.slidesPerView) && (a = -v.slides.length + v.activeIndex + v.loopedSlides, 
                a += v.loopedSlides, v.slideTo(a, 0, !1, !0));
            }, v.appendSlide = function(a) {
                if (v.params.loop && v.destroyLoop(), "object" == typeof a && a.length) for (var b = 0; b < a.length; b++) a[b] && v.wrapper.append(a[b]); else v.wrapper.append(a);
                v.params.loop && v.createLoop(), v.params.observer && v.support.observer || v.update(!0);
            }, v.prependSlide = function(a) {
                v.params.loop && v.destroyLoop();
                var b = v.activeIndex + 1;
                if ("object" == typeof a && a.length) {
                    for (var c = 0; c < a.length; c++) a[c] && v.wrapper.prepend(a[c]);
                    b = v.activeIndex + a.length;
                } else v.wrapper.prepend(a);
                v.params.loop && v.createLoop(), v.params.observer && v.support.observer || v.update(!0), 
                v.slideTo(b, 0, !1);
            }, v.removeSlide = function(a) {
                v.params.loop && (v.destroyLoop(), v.slides = v.wrapper.children("." + v.params.slideClass));
                var b, c = v.activeIndex;
                if ("object" == typeof a && a.length) {
                    for (var d = 0; d < a.length; d++) b = a[d], v.slides[b] && v.slides.eq(b).remove(), 
                    b < c && c--;
                    c = Math.max(c, 0);
                } else b = a, v.slides[b] && v.slides.eq(b).remove(), b < c && c--, c = Math.max(c, 0);
                v.params.loop && v.createLoop(), v.params.observer && v.support.observer || v.update(!0), 
                v.params.loop ? v.slideTo(c + v.loopedSlides, 0, !1) : v.slideTo(c, 0, !1);
            }, v.removeAllSlides = function() {
                for (var a = [], b = 0; b < v.slides.length; b++) a.push(b);
                v.removeSlide(a);
            }, v.effects = {
                fade: {
                    setTranslate: function() {
                        for (var a = 0; a < v.slides.length; a++) {
                            var b = v.slides.eq(a), c = b[0].swiperSlideOffset, d = -c;
                            v.params.virtualTranslate || (d -= v.translate);
                            var e = 0;
                            v.isHorizontal() || (e = d, d = 0);
                            var f = v.params.fade.crossFade ? Math.max(1 - Math.abs(b[0].progress), 0) : 1 + Math.min(Math.max(b[0].progress, -1), 0);
                            b.css({
                                opacity: f
                            }).transform("translate3d(" + d + "px, " + e + "px, 0px)");
                        }
                    },
                    setTransition: function(a) {
                        if (v.slides.transition(a), v.params.virtualTranslate && 0 !== a) {
                            var b = !1;
                            v.slides.transitionEnd(function() {
                                if (!b && v) {
                                    b = !0, v.animating = !1;
                                    for (var a = [ "webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd" ], c = 0; c < a.length; c++) v.wrapper.trigger(a[c]);
                                }
                            });
                        }
                    }
                },
                flip: {
                    setTranslate: function() {
                        for (var a = 0; a < v.slides.length; a++) {
                            var c = v.slides.eq(a), d = c[0].progress;
                            v.params.flip.limitRotation && (d = Math.max(Math.min(c[0].progress, 1), -1));
                            var e = c[0].swiperSlideOffset, f = -180 * d, g = f, h = 0, i = -e, j = 0;
                            if (v.isHorizontal() ? v.rtl && (g = -g) : (j = i, i = 0, h = -g, g = 0), c[0].style.zIndex = -Math.abs(Math.round(d)) + v.slides.length, 
                            v.params.flip.slideShadows) {
                                var k = v.isHorizontal() ? c.find(".swiper-slide-shadow-left") : c.find(".swiper-slide-shadow-top"), l = v.isHorizontal() ? c.find(".swiper-slide-shadow-right") : c.find(".swiper-slide-shadow-bottom");
                                0 === k.length && (k = b('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "left" : "top") + '"></div>'), 
                                c.append(k)), 0 === l.length && (l = b('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "right" : "bottom") + '"></div>'), 
                                c.append(l)), k.length && (k[0].style.opacity = Math.max(-d, 0)), l.length && (l[0].style.opacity = Math.max(d, 0));
                            }
                            c.transform("translate3d(" + i + "px, " + j + "px, 0px) rotateX(" + h + "deg) rotateY(" + g + "deg)");
                        }
                    },
                    setTransition: function(a) {
                        if (v.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a), 
                        v.params.virtualTranslate && 0 !== a) {
                            var c = !1;
                            v.slides.eq(v.activeIndex).transitionEnd(function() {
                                if (!c && v && b(this).hasClass(v.params.slideActiveClass)) {
                                    c = !0, v.animating = !1;
                                    for (var a = [ "webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd" ], d = 0; d < a.length; d++) v.wrapper.trigger(a[d]);
                                }
                            });
                        }
                    }
                },
                cube: {
                    setTranslate: function() {
                        var a, c = 0;
                        v.params.cube.shadow && (v.isHorizontal() ? (a = v.wrapper.find(".swiper-cube-shadow"), 
                        0 === a.length && (a = b('<div class="swiper-cube-shadow"></div>'), v.wrapper.append(a)), 
                        a.css({
                            height: v.width + "px"
                        })) : (a = v.container.find(".swiper-cube-shadow"), 0 === a.length && (a = b('<div class="swiper-cube-shadow"></div>'), 
                        v.container.append(a))));
                        for (var d = 0; d < v.slides.length; d++) {
                            var e = v.slides.eq(d), f = 90 * d, g = Math.floor(f / 360);
                            v.rtl && (f = -f, g = Math.floor(-f / 360));
                            var h = Math.max(Math.min(e[0].progress, 1), -1), i = 0, j = 0, k = 0;
                            d % 4 == 0 ? (i = 4 * -g * v.size, k = 0) : (d - 1) % 4 == 0 ? (i = 0, k = 4 * -g * v.size) : (d - 2) % 4 == 0 ? (i = v.size + 4 * g * v.size, 
                            k = v.size) : (d - 3) % 4 == 0 && (i = -v.size, k = 3 * v.size + 4 * v.size * g), 
                            v.rtl && (i = -i), v.isHorizontal() || (j = i, i = 0);
                            var l = "rotateX(" + (v.isHorizontal() ? 0 : -f) + "deg) rotateY(" + (v.isHorizontal() ? f : 0) + "deg) translate3d(" + i + "px, " + j + "px, " + k + "px)";
                            if (h <= 1 && h > -1 && (c = 90 * d + 90 * h, v.rtl && (c = 90 * -d - 90 * h)), 
                            e.transform(l), v.params.cube.slideShadows) {
                                var m = v.isHorizontal() ? e.find(".swiper-slide-shadow-left") : e.find(".swiper-slide-shadow-top"), n = v.isHorizontal() ? e.find(".swiper-slide-shadow-right") : e.find(".swiper-slide-shadow-bottom");
                                0 === m.length && (m = b('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "left" : "top") + '"></div>'), 
                                e.append(m)), 0 === n.length && (n = b('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "right" : "bottom") + '"></div>'), 
                                e.append(n)), m.length && (m[0].style.opacity = Math.max(-h, 0)), n.length && (n[0].style.opacity = Math.max(h, 0));
                            }
                        }
                        if (v.wrapper.css({
                            "-webkit-transform-origin": "50% 50% -" + v.size / 2 + "px",
                            "-moz-transform-origin": "50% 50% -" + v.size / 2 + "px",
                            "-ms-transform-origin": "50% 50% -" + v.size / 2 + "px",
                            "transform-origin": "50% 50% -" + v.size / 2 + "px"
                        }), v.params.cube.shadow) if (v.isHorizontal()) a.transform("translate3d(0px, " + (v.width / 2 + v.params.cube.shadowOffset) + "px, " + -v.width / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + v.params.cube.shadowScale + ")"); else {
                            var o = Math.abs(c) - 90 * Math.floor(Math.abs(c) / 90), p = 1.5 - (Math.sin(2 * o * Math.PI / 360) / 2 + Math.cos(2 * o * Math.PI / 360) / 2), q = v.params.cube.shadowScale, r = v.params.cube.shadowScale / p, s = v.params.cube.shadowOffset;
                            a.transform("scale3d(" + q + ", 1, " + r + ") translate3d(0px, " + (v.height / 2 + s) + "px, " + -v.height / 2 / r + "px) rotateX(-90deg)");
                        }
                        var t = v.isSafari || v.isUiWebView ? -v.size / 2 : 0;
                        v.wrapper.transform("translate3d(0px,0," + t + "px) rotateX(" + (v.isHorizontal() ? 0 : c) + "deg) rotateY(" + (v.isHorizontal() ? -c : 0) + "deg)");
                    },
                    setTransition: function(a) {
                        v.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a), 
                        v.params.cube.shadow && !v.isHorizontal() && v.container.find(".swiper-cube-shadow").transition(a);
                    }
                },
                coverflow: {
                    setTranslate: function() {
                        for (var a = v.translate, c = v.isHorizontal() ? -a + v.width / 2 : -a + v.height / 2, d = v.isHorizontal() ? v.params.coverflow.rotate : -v.params.coverflow.rotate, e = v.params.coverflow.depth, f = 0, g = v.slides.length; f < g; f++) {
                            var h = v.slides.eq(f), i = v.slidesSizesGrid[f], j = h[0].swiperSlideOffset, k = (c - j - i / 2) / i * v.params.coverflow.modifier, l = v.isHorizontal() ? d * k : 0, m = v.isHorizontal() ? 0 : d * k, n = -e * Math.abs(k), o = v.isHorizontal() ? 0 : v.params.coverflow.stretch * k, p = v.isHorizontal() ? v.params.coverflow.stretch * k : 0;
                            Math.abs(p) < .001 && (p = 0), Math.abs(o) < .001 && (o = 0), Math.abs(n) < .001 && (n = 0), 
                            Math.abs(l) < .001 && (l = 0), Math.abs(m) < .001 && (m = 0);
                            var q = "translate3d(" + p + "px," + o + "px," + n + "px)  rotateX(" + m + "deg) rotateY(" + l + "deg)";
                            if (h.transform(q), h[0].style.zIndex = 1 - Math.abs(Math.round(k)), v.params.coverflow.slideShadows) {
                                var r = v.isHorizontal() ? h.find(".swiper-slide-shadow-left") : h.find(".swiper-slide-shadow-top"), s = v.isHorizontal() ? h.find(".swiper-slide-shadow-right") : h.find(".swiper-slide-shadow-bottom");
                                0 === r.length && (r = b('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "left" : "top") + '"></div>'), 
                                h.append(r)), 0 === s.length && (s = b('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "right" : "bottom") + '"></div>'), 
                                h.append(s)), r.length && (r[0].style.opacity = k > 0 ? k : 0), s.length && (s[0].style.opacity = -k > 0 ? -k : 0);
                            }
                        }
                        if (v.browser.ie) {
                            v.wrapper[0].style.perspectiveOrigin = c + "px 50%";
                        }
                    },
                    setTransition: function(a) {
                        v.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a);
                    }
                }
            }, v.lazy = {
                initialImageLoaded: !1,
                loadImageInSlide: function(a, c) {
                    if (void 0 !== a && (void 0 === c && (c = !0), 0 !== v.slides.length)) {
                        var d = v.slides.eq(a), e = d.find("." + v.params.lazyLoadingClass + ":not(." + v.params.lazyStatusLoadedClass + "):not(." + v.params.lazyStatusLoadingClass + ")");
                        !d.hasClass(v.params.lazyLoadingClass) || d.hasClass(v.params.lazyStatusLoadedClass) || d.hasClass(v.params.lazyStatusLoadingClass) || (e = e.add(d[0])), 
                        0 !== e.length && e.each(function() {
                            var a = b(this);
                            a.addClass(v.params.lazyStatusLoadingClass);
                            var e = a.attr("data-background"), f = a.attr("data-src"), g = a.attr("data-srcset"), h = a.attr("data-sizes");
                            v.loadImage(a[0], f || e, g, h, !1, function() {
                                if (void 0 !== v && null !== v && v) {
                                    if (e ? (a.css("background-image", 'url("' + e + '")'), a.removeAttr("data-background")) : (g && (a.attr("srcset", g), 
                                    a.removeAttr("data-srcset")), h && (a.attr("sizes", h), a.removeAttr("data-sizes")), 
                                    f && (a.attr("src", f), a.removeAttr("data-src"))), a.addClass(v.params.lazyStatusLoadedClass).removeClass(v.params.lazyStatusLoadingClass), 
                                    d.find("." + v.params.lazyPreloaderClass + ", ." + v.params.preloaderClass).remove(), 
                                    v.params.loop && c) {
                                        var b = d.attr("data-swiper-slide-index");
                                        if (d.hasClass(v.params.slideDuplicateClass)) {
                                            var i = v.wrapper.children('[data-swiper-slide-index="' + b + '"]:not(.' + v.params.slideDuplicateClass + ")");
                                            v.lazy.loadImageInSlide(i.index(), !1);
                                        } else {
                                            var j = v.wrapper.children("." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + b + '"]');
                                            v.lazy.loadImageInSlide(j.index(), !1);
                                        }
                                    }
                                    v.emit("onLazyImageReady", v, d[0], a[0]);
                                }
                            }), v.emit("onLazyImageLoad", v, d[0], a[0]);
                        });
                    }
                },
                load: function() {
                    var a, c = v.params.slidesPerView;
                    if ("auto" === c && (c = 0), v.lazy.initialImageLoaded || (v.lazy.initialImageLoaded = !0), 
                    v.params.watchSlidesVisibility) v.wrapper.children("." + v.params.slideVisibleClass).each(function() {
                        v.lazy.loadImageInSlide(b(this).index());
                    }); else if (c > 1) for (a = v.activeIndex; a < v.activeIndex + c; a++) v.slides[a] && v.lazy.loadImageInSlide(a); else v.lazy.loadImageInSlide(v.activeIndex);
                    if (v.params.lazyLoadingInPrevNext) if (c > 1 || v.params.lazyLoadingInPrevNextAmount && v.params.lazyLoadingInPrevNextAmount > 1) {
                        var d = v.params.lazyLoadingInPrevNextAmount, e = c, f = Math.min(v.activeIndex + e + Math.max(d, e), v.slides.length), g = Math.max(v.activeIndex - Math.max(e, d), 0);
                        for (a = v.activeIndex + c; a < f; a++) v.slides[a] && v.lazy.loadImageInSlide(a);
                        for (a = g; a < v.activeIndex; a++) v.slides[a] && v.lazy.loadImageInSlide(a);
                    } else {
                        var h = v.wrapper.children("." + v.params.slideNextClass);
                        h.length > 0 && v.lazy.loadImageInSlide(h.index());
                        var i = v.wrapper.children("." + v.params.slidePrevClass);
                        i.length > 0 && v.lazy.loadImageInSlide(i.index());
                    }
                },
                onTransitionStart: function() {
                    v.params.lazyLoading && (v.params.lazyLoadingOnTransitionStart || !v.params.lazyLoadingOnTransitionStart && !v.lazy.initialImageLoaded) && v.lazy.load();
                },
                onTransitionEnd: function() {
                    v.params.lazyLoading && !v.params.lazyLoadingOnTransitionStart && v.lazy.load();
                }
            }, v.scrollbar = {
                isTouched: !1,
                setDragPosition: function(a) {
                    var b = v.scrollbar, c = v.isHorizontal() ? "touchstart" === a.type || "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX || a.clientX : "touchstart" === a.type || "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY || a.clientY, d = c - b.track.offset()[v.isHorizontal() ? "left" : "top"] - b.dragSize / 2, e = -v.minTranslate() * b.moveDivider, f = -v.maxTranslate() * b.moveDivider;
                    d < e ? d = e : d > f && (d = f), d = -d / b.moveDivider, v.updateProgress(d), v.setWrapperTranslate(d, !0);
                },
                dragStart: function(a) {
                    var b = v.scrollbar;
                    b.isTouched = !0, a.preventDefault(), a.stopPropagation(), b.setDragPosition(a), 
                    clearTimeout(b.dragTimeout), b.track.transition(0), v.params.scrollbarHide && b.track.css("opacity", 1), 
                    v.wrapper.transition(100), b.drag.transition(100), v.emit("onScrollbarDragStart", v);
                },
                dragMove: function(a) {
                    var b = v.scrollbar;
                    b.isTouched && (a.preventDefault ? a.preventDefault() : a.returnValue = !1, b.setDragPosition(a), 
                    v.wrapper.transition(0), b.track.transition(0), b.drag.transition(0), v.emit("onScrollbarDragMove", v));
                },
                dragEnd: function(a) {
                    var b = v.scrollbar;
                    b.isTouched && (b.isTouched = !1, v.params.scrollbarHide && (clearTimeout(b.dragTimeout), 
                    b.dragTimeout = setTimeout(function() {
                        b.track.css("opacity", 0), b.track.transition(400);
                    }, 1e3)), v.emit("onScrollbarDragEnd", v), v.params.scrollbarSnapOnRelease && v.slideReset());
                },
                draggableEvents: function() {
                    return !1 !== v.params.simulateTouch || v.support.touch ? v.touchEvents : v.touchEventsDesktop;
                }(),
                enableDraggable: function() {
                    var a = v.scrollbar, c = v.support.touch ? a.track : document;
                    b(a.track).on(a.draggableEvents.start, a.dragStart), b(c).on(a.draggableEvents.move, a.dragMove), 
                    b(c).on(a.draggableEvents.end, a.dragEnd);
                },
                disableDraggable: function() {
                    var a = v.scrollbar, c = v.support.touch ? a.track : document;
                    b(a.track).off(a.draggableEvents.start, a.dragStart), b(c).off(a.draggableEvents.move, a.dragMove), 
                    b(c).off(a.draggableEvents.end, a.dragEnd);
                },
                set: function() {
                    if (v.params.scrollbar) {
                        var a = v.scrollbar;
                        a.track = b(v.params.scrollbar), v.params.uniqueNavElements && "string" == typeof v.params.scrollbar && a.track.length > 1 && 1 === v.container.find(v.params.scrollbar).length && (a.track = v.container.find(v.params.scrollbar)), 
                        a.drag = a.track.find(".swiper-scrollbar-drag"), 0 === a.drag.length && (a.drag = b('<div class="swiper-scrollbar-drag"></div>'), 
                        a.track.append(a.drag)), a.drag[0].style.width = "", a.drag[0].style.height = "", 
                        a.trackSize = v.isHorizontal() ? a.track[0].offsetWidth : a.track[0].offsetHeight, 
                        a.divider = v.size / v.virtualSize, a.moveDivider = a.divider * (a.trackSize / v.size), 
                        a.dragSize = a.trackSize * a.divider, v.isHorizontal() ? a.drag[0].style.width = a.dragSize + "px" : a.drag[0].style.height = a.dragSize + "px", 
                        a.divider >= 1 ? a.track[0].style.display = "none" : a.track[0].style.display = "", 
                        v.params.scrollbarHide && (a.track[0].style.opacity = 0);
                    }
                },
                setTranslate: function() {
                    if (v.params.scrollbar) {
                        var a, b = v.scrollbar, c = (v.translate, b.dragSize);
                        a = (b.trackSize - b.dragSize) * v.progress, v.rtl && v.isHorizontal() ? (a = -a, 
                        a > 0 ? (c = b.dragSize - a, a = 0) : -a + b.dragSize > b.trackSize && (c = b.trackSize + a)) : a < 0 ? (c = b.dragSize + a, 
                        a = 0) : a + b.dragSize > b.trackSize && (c = b.trackSize - a), v.isHorizontal() ? (v.support.transforms3d ? b.drag.transform("translate3d(" + a + "px, 0, 0)") : b.drag.transform("translateX(" + a + "px)"), 
                        b.drag[0].style.width = c + "px") : (v.support.transforms3d ? b.drag.transform("translate3d(0px, " + a + "px, 0)") : b.drag.transform("translateY(" + a + "px)"), 
                        b.drag[0].style.height = c + "px"), v.params.scrollbarHide && (clearTimeout(b.timeout), 
                        b.track[0].style.opacity = 1, b.timeout = setTimeout(function() {
                            b.track[0].style.opacity = 0, b.track.transition(400);
                        }, 1e3));
                    }
                },
                setTransition: function(a) {
                    v.params.scrollbar && v.scrollbar.drag.transition(a);
                }
            }, v.controller = {
                LinearSpline: function(a, b) {
                    var c = function() {
                        var a, b, c;
                        return function(d, e) {
                            for (b = -1, a = d.length; a - b > 1; ) d[c = a + b >> 1] <= e ? b = c : a = c;
                            return a;
                        };
                    }();
                    this.x = a, this.y = b, this.lastIndex = a.length - 1;
                    var d, e;
                    this.x.length;
                    this.interpolate = function(a) {
                        return a ? (e = c(this.x, a), d = e - 1, (a - this.x[d]) * (this.y[e] - this.y[d]) / (this.x[e] - this.x[d]) + this.y[d]) : 0;
                    };
                },
                getInterpolateFunction: function(a) {
                    v.controller.spline || (v.controller.spline = v.params.loop ? new v.controller.LinearSpline(v.slidesGrid, a.slidesGrid) : new v.controller.LinearSpline(v.snapGrid, a.snapGrid));
                },
                setTranslate: function(a, b) {
                    function d(b) {
                        a = b.rtl && "horizontal" === b.params.direction ? -v.translate : v.translate, "slide" === v.params.controlBy && (v.controller.getInterpolateFunction(b), 
                        f = -v.controller.spline.interpolate(-a)), f && "container" !== v.params.controlBy || (e = (b.maxTranslate() - b.minTranslate()) / (v.maxTranslate() - v.minTranslate()), 
                        f = (a - v.minTranslate()) * e + b.minTranslate()), v.params.controlInverse && (f = b.maxTranslate() - f), 
                        b.updateProgress(f), b.setWrapperTranslate(f, !1, v), b.updateActiveIndex();
                    }
                    var e, f, g = v.params.control;
                    if (Array.isArray(g)) for (var h = 0; h < g.length; h++) g[h] !== b && g[h] instanceof c && d(g[h]); else g instanceof c && b !== g && d(g);
                },
                setTransition: function(a, b) {
                    function d(b) {
                        b.setWrapperTransition(a, v), 0 !== a && (b.onTransitionStart(), b.wrapper.transitionEnd(function() {
                            f && (b.params.loop && "slide" === v.params.controlBy && b.fixLoop(), b.onTransitionEnd());
                        }));
                    }
                    var e, f = v.params.control;
                    if (Array.isArray(f)) for (e = 0; e < f.length; e++) f[e] !== b && f[e] instanceof c && d(f[e]); else f instanceof c && b !== f && d(f);
                }
            }, v.hashnav = {
                onHashCange: function(a, b) {
                    var c = document.location.hash.replace("#", "");
                    c !== v.slides.eq(v.activeIndex).attr("data-hash") && v.slideTo(v.wrapper.children("." + v.params.slideClass + '[data-hash="' + c + '"]').index());
                },
                attachEvents: function(a) {
                    var c = a ? "off" : "on";
                    b(window)[c]("hashchange", v.hashnav.onHashCange);
                },
                setHash: function() {
                    if (v.hashnav.initialized && v.params.hashnav) if (v.params.replaceState && window.history && window.history.replaceState) window.history.replaceState(null, null, "#" + v.slides.eq(v.activeIndex).attr("data-hash") || ""); else {
                        var a = v.slides.eq(v.activeIndex), b = a.attr("data-hash") || a.attr("data-history");
                        document.location.hash = b || "";
                    }
                },
                init: function() {
                    if (v.params.hashnav && !v.params.history) {
                        v.hashnav.initialized = !0;
                        var a = document.location.hash.replace("#", "");
                        if (a) for (var b = 0, c = 0, d = v.slides.length; c < d; c++) {
                            var e = v.slides.eq(c), f = e.attr("data-hash") || e.attr("data-history");
                            if (f === a && !e.hasClass(v.params.slideDuplicateClass)) {
                                var g = e.index();
                                v.slideTo(g, b, v.params.runCallbacksOnInit, !0);
                            }
                        }
                        v.params.hashnavWatchState && v.hashnav.attachEvents();
                    }
                },
                destroy: function() {
                    v.params.hashnavWatchState && v.hashnav.attachEvents(!0);
                }
            }, v.history = {
                init: function() {
                    if (v.params.history) {
                        if (!window.history || !window.history.pushState) return v.params.history = !1, 
                        void (v.params.hashnav = !0);
                        v.history.initialized = !0, this.paths = this.getPathValues(), (this.paths.key || this.paths.value) && (this.scrollToSlide(0, this.paths.value, v.params.runCallbacksOnInit), 
                        v.params.replaceState || window.addEventListener("popstate", this.setHistoryPopState));
                    }
                },
                setHistoryPopState: function() {
                    v.history.paths = v.history.getPathValues(), v.history.scrollToSlide(v.params.speed, v.history.paths.value, !1);
                },
                getPathValues: function() {
                    var a = window.location.pathname.slice(1).split("/"), b = a.length;
                    return {
                        key: a[b - 2],
                        value: a[b - 1]
                    };
                },
                setHistory: function(a, b) {
                    if (v.history.initialized && v.params.history) {
                        var c = v.slides.eq(b), d = this.slugify(c.attr("data-history"));
                        window.location.pathname.includes(a) || (d = a + "/" + d), v.params.replaceState ? window.history.replaceState(null, null, d) : window.history.pushState(null, null, d);
                    }
                },
                slugify: function(a) {
                    return a.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
                },
                scrollToSlide: function(a, b, c) {
                    if (b) for (var d = 0, e = v.slides.length; d < e; d++) {
                        var f = v.slides.eq(d), g = this.slugify(f.attr("data-history"));
                        if (g === b && !f.hasClass(v.params.slideDuplicateClass)) {
                            var h = f.index();
                            v.slideTo(h, a, c);
                        }
                    } else v.slideTo(0, a, c);
                }
            }, v.disableKeyboardControl = function() {
                v.params.keyboardControl = !1, b(document).off("keydown", i);
            }, v.enableKeyboardControl = function() {
                v.params.keyboardControl = !0, b(document).on("keydown", i);
            }, v.mousewheel = {
                event: !1,
                lastScrollTime: new window.Date().getTime()
            }, v.params.mousewheelControl && (v.mousewheel.event = navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : j() ? "wheel" : "mousewheel"), 
            v.disableMousewheelControl = function() {
                if (!v.mousewheel.event) return !1;
                var a = v.container;
                return "container" !== v.params.mousewheelEventsTarged && (a = b(v.params.mousewheelEventsTarged)), 
                a.off(v.mousewheel.event, l), v.params.mousewheelControl = !1, !0;
            }, v.enableMousewheelControl = function() {
                if (!v.mousewheel.event) return !1;
                var a = v.container;
                return "container" !== v.params.mousewheelEventsTarged && (a = b(v.params.mousewheelEventsTarged)), 
                a.on(v.mousewheel.event, l), v.params.mousewheelControl = !0, !0;
            }, v.parallax = {
                setTranslate: function() {
                    v.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function() {
                        m(this, v.progress);
                    }), v.slides.each(function() {
                        var a = b(this);
                        a.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function() {
                            m(this, Math.min(Math.max(a[0].progress, -1), 1));
                        });
                    });
                },
                setTransition: function(a) {
                    void 0 === a && (a = v.params.speed), v.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function() {
                        var c = b(this), d = parseInt(c.attr("data-swiper-parallax-duration"), 10) || a;
                        0 === a && (d = 0), c.transition(d);
                    });
                }
            }, v.zoom = {
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                    slide: void 0,
                    slideWidth: void 0,
                    slideHeight: void 0,
                    image: void 0,
                    imageWrap: void 0,
                    zoomMax: v.params.zoomMax
                },
                image: {
                    isTouched: void 0,
                    isMoved: void 0,
                    currentX: void 0,
                    currentY: void 0,
                    minX: void 0,
                    minY: void 0,
                    maxX: void 0,
                    maxY: void 0,
                    width: void 0,
                    height: void 0,
                    startX: void 0,
                    startY: void 0,
                    touchesStart: {},
                    touchesCurrent: {}
                },
                velocity: {
                    x: void 0,
                    y: void 0,
                    prevPositionX: void 0,
                    prevPositionY: void 0,
                    prevTime: void 0
                },
                getDistanceBetweenTouches: function(a) {
                    if (a.targetTouches.length < 2) return 1;
                    var b = a.targetTouches[0].pageX, c = a.targetTouches[0].pageY, d = a.targetTouches[1].pageX, e = a.targetTouches[1].pageY;
                    return Math.sqrt(Math.pow(d - b, 2) + Math.pow(e - c, 2));
                },
                onGestureStart: function(a) {
                    var c = v.zoom;
                    if (!v.support.gestures) {
                        if ("touchstart" !== a.type || "touchstart" === a.type && a.targetTouches.length < 2) return;
                        c.gesture.scaleStart = c.getDistanceBetweenTouches(a);
                    }
                    if (!(c.gesture.slide && c.gesture.slide.length || (c.gesture.slide = b(this), 0 === c.gesture.slide.length && (c.gesture.slide = v.slides.eq(v.activeIndex)), 
                    c.gesture.image = c.gesture.slide.find("img, svg, canvas"), c.gesture.imageWrap = c.gesture.image.parent("." + v.params.zoomContainerClass), 
                    c.gesture.zoomMax = c.gesture.imageWrap.attr("data-swiper-zoom") || v.params.zoomMax, 
                    0 !== c.gesture.imageWrap.length))) return void (c.gesture.image = void 0);
                    c.gesture.image.transition(0), c.isScaling = !0;
                },
                onGestureChange: function(a) {
                    var b = v.zoom;
                    if (!v.support.gestures) {
                        if ("touchmove" !== a.type || "touchmove" === a.type && a.targetTouches.length < 2) return;
                        b.gesture.scaleMove = b.getDistanceBetweenTouches(a);
                    }
                    b.gesture.image && 0 !== b.gesture.image.length && (v.support.gestures ? b.scale = a.scale * b.currentScale : b.scale = b.gesture.scaleMove / b.gesture.scaleStart * b.currentScale, 
                    b.scale > b.gesture.zoomMax && (b.scale = b.gesture.zoomMax - 1 + Math.pow(b.scale - b.gesture.zoomMax + 1, .5)), 
                    b.scale < v.params.zoomMin && (b.scale = v.params.zoomMin + 1 - Math.pow(v.params.zoomMin - b.scale + 1, .5)), 
                    b.gesture.image.transform("translate3d(0,0,0) scale(" + b.scale + ")"));
                },
                onGestureEnd: function(a) {
                    var b = v.zoom;
                    !v.support.gestures && ("touchend" !== a.type || "touchend" === a.type && a.changedTouches.length < 2) || b.gesture.image && 0 !== b.gesture.image.length && (b.scale = Math.max(Math.min(b.scale, b.gesture.zoomMax), v.params.zoomMin), 
                    b.gesture.image.transition(v.params.speed).transform("translate3d(0,0,0) scale(" + b.scale + ")"), 
                    b.currentScale = b.scale, b.isScaling = !1, 1 === b.scale && (b.gesture.slide = void 0));
                },
                onTouchStart: function(a, b) {
                    var c = a.zoom;
                    c.gesture.image && 0 !== c.gesture.image.length && (c.image.isTouched || ("android" === a.device.os && b.preventDefault(), 
                    c.image.isTouched = !0, c.image.touchesStart.x = "touchstart" === b.type ? b.targetTouches[0].pageX : b.pageX, 
                    c.image.touchesStart.y = "touchstart" === b.type ? b.targetTouches[0].pageY : b.pageY));
                },
                onTouchMove: function(a) {
                    var b = v.zoom;
                    if (b.gesture.image && 0 !== b.gesture.image.length && (v.allowClick = !1, b.image.isTouched && b.gesture.slide)) {
                        b.image.isMoved || (b.image.width = b.gesture.image[0].offsetWidth, b.image.height = b.gesture.image[0].offsetHeight, 
                        b.image.startX = v.getTranslate(b.gesture.imageWrap[0], "x") || 0, b.image.startY = v.getTranslate(b.gesture.imageWrap[0], "y") || 0, 
                        b.gesture.slideWidth = b.gesture.slide[0].offsetWidth, b.gesture.slideHeight = b.gesture.slide[0].offsetHeight, 
                        b.gesture.imageWrap.transition(0), v.rtl && (b.image.startX = -b.image.startX), 
                        v.rtl && (b.image.startY = -b.image.startY));
                        var c = b.image.width * b.scale, d = b.image.height * b.scale;
                        if (!(c < b.gesture.slideWidth && d < b.gesture.slideHeight)) {
                            if (b.image.minX = Math.min(b.gesture.slideWidth / 2 - c / 2, 0), b.image.maxX = -b.image.minX, 
                            b.image.minY = Math.min(b.gesture.slideHeight / 2 - d / 2, 0), b.image.maxY = -b.image.minY, 
                            b.image.touchesCurrent.x = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, 
                            b.image.touchesCurrent.y = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, 
                            !b.image.isMoved && !b.isScaling) {
                                if (v.isHorizontal() && Math.floor(b.image.minX) === Math.floor(b.image.startX) && b.image.touchesCurrent.x < b.image.touchesStart.x || Math.floor(b.image.maxX) === Math.floor(b.image.startX) && b.image.touchesCurrent.x > b.image.touchesStart.x) return void (b.image.isTouched = !1);
                                if (!v.isHorizontal() && Math.floor(b.image.minY) === Math.floor(b.image.startY) && b.image.touchesCurrent.y < b.image.touchesStart.y || Math.floor(b.image.maxY) === Math.floor(b.image.startY) && b.image.touchesCurrent.y > b.image.touchesStart.y) return void (b.image.isTouched = !1);
                            }
                            a.preventDefault(), a.stopPropagation(), b.image.isMoved = !0, b.image.currentX = b.image.touchesCurrent.x - b.image.touchesStart.x + b.image.startX, 
                            b.image.currentY = b.image.touchesCurrent.y - b.image.touchesStart.y + b.image.startY, 
                            b.image.currentX < b.image.minX && (b.image.currentX = b.image.minX + 1 - Math.pow(b.image.minX - b.image.currentX + 1, .8)), 
                            b.image.currentX > b.image.maxX && (b.image.currentX = b.image.maxX - 1 + Math.pow(b.image.currentX - b.image.maxX + 1, .8)), 
                            b.image.currentY < b.image.minY && (b.image.currentY = b.image.minY + 1 - Math.pow(b.image.minY - b.image.currentY + 1, .8)), 
                            b.image.currentY > b.image.maxY && (b.image.currentY = b.image.maxY - 1 + Math.pow(b.image.currentY - b.image.maxY + 1, .8)), 
                            b.velocity.prevPositionX || (b.velocity.prevPositionX = b.image.touchesCurrent.x), 
                            b.velocity.prevPositionY || (b.velocity.prevPositionY = b.image.touchesCurrent.y), 
                            b.velocity.prevTime || (b.velocity.prevTime = Date.now()), b.velocity.x = (b.image.touchesCurrent.x - b.velocity.prevPositionX) / (Date.now() - b.velocity.prevTime) / 2, 
                            b.velocity.y = (b.image.touchesCurrent.y - b.velocity.prevPositionY) / (Date.now() - b.velocity.prevTime) / 2, 
                            Math.abs(b.image.touchesCurrent.x - b.velocity.prevPositionX) < 2 && (b.velocity.x = 0), 
                            Math.abs(b.image.touchesCurrent.y - b.velocity.prevPositionY) < 2 && (b.velocity.y = 0), 
                            b.velocity.prevPositionX = b.image.touchesCurrent.x, b.velocity.prevPositionY = b.image.touchesCurrent.y, 
                            b.velocity.prevTime = Date.now(), b.gesture.imageWrap.transform("translate3d(" + b.image.currentX + "px, " + b.image.currentY + "px,0)");
                        }
                    }
                },
                onTouchEnd: function(a, b) {
                    var c = a.zoom;
                    if (c.gesture.image && 0 !== c.gesture.image.length) {
                        if (!c.image.isTouched || !c.image.isMoved) return c.image.isTouched = !1, void (c.image.isMoved = !1);
                        c.image.isTouched = !1, c.image.isMoved = !1;
                        var d = 300, e = 300, f = c.velocity.x * d, g = c.image.currentX + f, h = c.velocity.y * e, i = c.image.currentY + h;
                        0 !== c.velocity.x && (d = Math.abs((g - c.image.currentX) / c.velocity.x)), 0 !== c.velocity.y && (e = Math.abs((i - c.image.currentY) / c.velocity.y));
                        var j = Math.max(d, e);
                        c.image.currentX = g, c.image.currentY = i;
                        var k = c.image.width * c.scale, l = c.image.height * c.scale;
                        c.image.minX = Math.min(c.gesture.slideWidth / 2 - k / 2, 0), c.image.maxX = -c.image.minX, 
                        c.image.minY = Math.min(c.gesture.slideHeight / 2 - l / 2, 0), c.image.maxY = -c.image.minY, 
                        c.image.currentX = Math.max(Math.min(c.image.currentX, c.image.maxX), c.image.minX), 
                        c.image.currentY = Math.max(Math.min(c.image.currentY, c.image.maxY), c.image.minY), 
                        c.gesture.imageWrap.transition(j).transform("translate3d(" + c.image.currentX + "px, " + c.image.currentY + "px,0)");
                    }
                },
                onTransitionEnd: function(a) {
                    var b = a.zoom;
                    b.gesture.slide && a.previousIndex !== a.activeIndex && (b.gesture.image.transform("translate3d(0,0,0) scale(1)"), 
                    b.gesture.imageWrap.transform("translate3d(0,0,0)"), b.gesture.slide = b.gesture.image = b.gesture.imageWrap = void 0, 
                    b.scale = b.currentScale = 1);
                },
                toggleZoom: function(a, c) {
                    var d = a.zoom;
                    if (d.gesture.slide || (d.gesture.slide = a.clickedSlide ? b(a.clickedSlide) : a.slides.eq(a.activeIndex), 
                    d.gesture.image = d.gesture.slide.find("img, svg, canvas"), d.gesture.imageWrap = d.gesture.image.parent("." + a.params.zoomContainerClass)), 
                    d.gesture.image && 0 !== d.gesture.image.length) {
                        var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
                        void 0 === d.image.touchesStart.x && c ? (e = "touchend" === c.type ? c.changedTouches[0].pageX : c.pageX, 
                        f = "touchend" === c.type ? c.changedTouches[0].pageY : c.pageY) : (e = d.image.touchesStart.x, 
                        f = d.image.touchesStart.y), d.scale && 1 !== d.scale ? (d.scale = d.currentScale = 1, 
                        d.gesture.imageWrap.transition(300).transform("translate3d(0,0,0)"), d.gesture.image.transition(300).transform("translate3d(0,0,0) scale(1)"), 
                        d.gesture.slide = void 0) : (d.scale = d.currentScale = d.gesture.imageWrap.attr("data-swiper-zoom") || a.params.zoomMax, 
                        c ? (u = d.gesture.slide[0].offsetWidth, v = d.gesture.slide[0].offsetHeight, g = d.gesture.slide.offset().left, 
                        h = d.gesture.slide.offset().top, i = g + u / 2 - e, j = h + v / 2 - f, m = d.gesture.image[0].offsetWidth, 
                        n = d.gesture.image[0].offsetHeight, o = m * d.scale, p = n * d.scale, q = Math.min(u / 2 - o / 2, 0), 
                        r = Math.min(v / 2 - p / 2, 0), s = -q, t = -r, k = i * d.scale, l = j * d.scale, 
                        k < q && (k = q), k > s && (k = s), l < r && (l = r), l > t && (l = t)) : (k = 0, 
                        l = 0), d.gesture.imageWrap.transition(300).transform("translate3d(" + k + "px, " + l + "px,0)"), 
                        d.gesture.image.transition(300).transform("translate3d(0,0,0) scale(" + d.scale + ")"));
                    }
                },
                attachEvents: function(a) {
                    var c = a ? "off" : "on";
                    if (v.params.zoom) {
                        var d = (v.slides, !("touchstart" !== v.touchEvents.start || !v.support.passiveListener || !v.params.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        });
                        v.support.gestures ? (v.slides[c]("gesturestart", v.zoom.onGestureStart, d), v.slides[c]("gesturechange", v.zoom.onGestureChange, d), 
                        v.slides[c]("gestureend", v.zoom.onGestureEnd, d)) : "touchstart" === v.touchEvents.start && (v.slides[c](v.touchEvents.start, v.zoom.onGestureStart, d), 
                        v.slides[c](v.touchEvents.move, v.zoom.onGestureChange, d), v.slides[c](v.touchEvents.end, v.zoom.onGestureEnd, d)), 
                        v[c]("touchStart", v.zoom.onTouchStart), v.slides.each(function(a, d) {
                            b(d).find("." + v.params.zoomContainerClass).length > 0 && b(d)[c](v.touchEvents.move, v.zoom.onTouchMove);
                        }), v[c]("touchEnd", v.zoom.onTouchEnd), v[c]("transitionEnd", v.zoom.onTransitionEnd), 
                        v.params.zoomToggle && v.on("doubleTap", v.zoom.toggleZoom);
                    }
                },
                init: function() {
                    v.zoom.attachEvents();
                },
                destroy: function() {
                    v.zoom.attachEvents(!0);
                }
            }, v._plugins = [];
            for (var M in v.plugins) {
                var N = v.plugins[M](v, v.params[M]);
                N && v._plugins.push(N);
            }
            return v.callPlugins = function(a) {
                for (var b = 0; b < v._plugins.length; b++) a in v._plugins[b] && v._plugins[b][a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }, v.emitterEventListeners = {}, v.emit = function(a) {
                v.params[a] && v.params[a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                var b;
                if (v.emitterEventListeners[a]) for (b = 0; b < v.emitterEventListeners[a].length; b++) v.emitterEventListeners[a][b](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                v.callPlugins && v.callPlugins(a, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }, v.on = function(a, b) {
                return a = n(a), v.emitterEventListeners[a] || (v.emitterEventListeners[a] = []), 
                v.emitterEventListeners[a].push(b), v;
            }, v.off = function(a, b) {
                var c;
                if (a = n(a), void 0 === b) return v.emitterEventListeners[a] = [], v;
                if (v.emitterEventListeners[a] && 0 !== v.emitterEventListeners[a].length) {
                    for (c = 0; c < v.emitterEventListeners[a].length; c++) v.emitterEventListeners[a][c] === b && v.emitterEventListeners[a].splice(c, 1);
                    return v;
                }
            }, v.once = function(a, b) {
                a = n(a);
                var c = function() {
                    b(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]), v.off(a, c);
                };
                return v.on(a, c), v;
            }, v.a11y = {
                makeFocusable: function(a) {
                    return a.attr("tabIndex", "0"), a;
                },
                addRole: function(a, b) {
                    return a.attr("role", b), a;
                },
                addLabel: function(a, b) {
                    return a.attr("aria-label", b), a;
                },
                disable: function(a) {
                    return a.attr("aria-disabled", !0), a;
                },
                enable: function(a) {
                    return a.attr("aria-disabled", !1), a;
                },
                onEnterKey: function(a) {
                    13 === a.keyCode && (b(a.target).is(v.params.nextButton) ? (v.onClickNext(a), v.isEnd ? v.a11y.notify(v.params.lastSlideMessage) : v.a11y.notify(v.params.nextSlideMessage)) : b(a.target).is(v.params.prevButton) && (v.onClickPrev(a), 
                    v.isBeginning ? v.a11y.notify(v.params.firstSlideMessage) : v.a11y.notify(v.params.prevSlideMessage)), 
                    b(a.target).is("." + v.params.bulletClass) && b(a.target)[0].click());
                },
                liveRegion: b('<span class="' + v.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
                notify: function(a) {
                    var b = v.a11y.liveRegion;
                    0 !== b.length && (b.html(""), b.html(a));
                },
                init: function() {
                    v.params.nextButton && v.nextButton && v.nextButton.length > 0 && (v.a11y.makeFocusable(v.nextButton), 
                    v.a11y.addRole(v.nextButton, "button"), v.a11y.addLabel(v.nextButton, v.params.nextSlideMessage)), 
                    v.params.prevButton && v.prevButton && v.prevButton.length > 0 && (v.a11y.makeFocusable(v.prevButton), 
                    v.a11y.addRole(v.prevButton, "button"), v.a11y.addLabel(v.prevButton, v.params.prevSlideMessage)), 
                    b(v.container).append(v.a11y.liveRegion);
                },
                initPagination: function() {
                    v.params.pagination && v.params.paginationClickable && v.bullets && v.bullets.length && v.bullets.each(function() {
                        var a = b(this);
                        v.a11y.makeFocusable(a), v.a11y.addRole(a, "button"), v.a11y.addLabel(a, v.params.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
                    });
                },
                destroy: function() {
                    v.a11y.liveRegion && v.a11y.liveRegion.length > 0 && v.a11y.liveRegion.remove();
                }
            }, v.init = function() {
                v.params.loop && v.createLoop(), v.updateContainerSize(), v.updateSlidesSize(), 
                v.updatePagination(), v.params.scrollbar && v.scrollbar && (v.scrollbar.set(), v.params.scrollbarDraggable && v.scrollbar.enableDraggable()), 
                "slide" !== v.params.effect && v.effects[v.params.effect] && (v.params.loop || v.updateProgress(), 
                v.effects[v.params.effect].setTranslate()), v.params.loop ? v.slideTo(v.params.initialSlide + v.loopedSlides, 0, v.params.runCallbacksOnInit) : (v.slideTo(v.params.initialSlide, 0, v.params.runCallbacksOnInit), 
                0 === v.params.initialSlide && (v.parallax && v.params.parallax && v.parallax.setTranslate(), 
                v.lazy && v.params.lazyLoading && (v.lazy.load(), v.lazy.initialImageLoaded = !0))), 
                v.attachEvents(), v.params.observer && v.support.observer && v.initObservers(), 
                v.params.preloadImages && !v.params.lazyLoading && v.preloadImages(), v.params.zoom && v.zoom && v.zoom.init(), 
                v.params.autoplay && v.startAutoplay(), v.params.keyboardControl && v.enableKeyboardControl && v.enableKeyboardControl(), 
                v.params.mousewheelControl && v.enableMousewheelControl && v.enableMousewheelControl(), 
                v.params.hashnavReplaceState && (v.params.replaceState = v.params.hashnavReplaceState), 
                v.params.history && v.history && v.history.init(), v.params.hashnav && v.hashnav && v.hashnav.init(), 
                v.params.a11y && v.a11y && v.a11y.init(), v.emit("onInit", v);
            }, v.cleanupStyles = function() {
                v.container.removeClass(v.classNames.join(" ")).removeAttr("style"), v.wrapper.removeAttr("style"), 
                v.slides && v.slides.length && v.slides.removeClass([ v.params.slideVisibleClass, v.params.slideActiveClass, v.params.slideNextClass, v.params.slidePrevClass ].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"), 
                v.paginationContainer && v.paginationContainer.length && v.paginationContainer.removeClass(v.params.paginationHiddenClass), 
                v.bullets && v.bullets.length && v.bullets.removeClass(v.params.bulletActiveClass), 
                v.params.prevButton && b(v.params.prevButton).removeClass(v.params.buttonDisabledClass), 
                v.params.nextButton && b(v.params.nextButton).removeClass(v.params.buttonDisabledClass), 
                v.params.scrollbar && v.scrollbar && (v.scrollbar.track && v.scrollbar.track.length && v.scrollbar.track.removeAttr("style"), 
                v.scrollbar.drag && v.scrollbar.drag.length && v.scrollbar.drag.removeAttr("style"));
            }, v.destroy = function(a, b) {
                v.detachEvents(), v.stopAutoplay(), v.params.scrollbar && v.scrollbar && v.params.scrollbarDraggable && v.scrollbar.disableDraggable(), 
                v.params.loop && v.destroyLoop(), b && v.cleanupStyles(), v.disconnectObservers(), 
                v.params.zoom && v.zoom && v.zoom.destroy(), v.params.keyboardControl && v.disableKeyboardControl && v.disableKeyboardControl(), 
                v.params.mousewheelControl && v.disableMousewheelControl && v.disableMousewheelControl(), 
                v.params.a11y && v.a11y && v.a11y.destroy(), v.params.history && !v.params.replaceState && window.removeEventListener("popstate", v.history.setHistoryPopState), 
                v.params.hashnav && v.hashnav && v.hashnav.destroy(), v.emit("onDestroy"), !1 !== a && (v = null);
            }, v.init(), v;
        }
    };
    c.prototype = {
        isSafari: function() {
            var a = window.navigator.userAgent.toLowerCase();
            return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0;
        }(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
        isArray: function(a) {
            return "[object Array]" === Object.prototype.toString.apply(a);
        },
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1 || window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1,
            lteIE9: function() {
                var a = document.createElement("div");
                return a.innerHTML = "\x3c!--[if lte IE 9]><i></i><![endif]--\x3e", 1 === a.getElementsByTagName("i").length;
            }()
        },
        device: function() {
            var a = window.navigator.userAgent, b = a.match(/(Android);?[\s\/]+([\d.]+)?/), c = a.match(/(iPad).*OS\s([\d_]+)/), d = a.match(/(iPod)(.*OS\s([\d_]+))?/), e = !c && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            return {
                ios: c || e || d,
                android: b
            };
        }(),
        support: {
            touch: window.Modernizr && !0 === Modernizr.touch || function() {
                return !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
            }(),
            transforms3d: window.Modernizr && !0 === Modernizr.csstransforms3d || function() {
                var a = document.createElement("div").style;
                return "webkitPerspective" in a || "MozPerspective" in a || "OPerspective" in a || "MsPerspective" in a || "perspective" in a;
            }(),
            flexbox: function() {
                for (var a = document.createElement("div").style, b = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), c = 0; c < b.length; c++) if (b[c] in a) return !0;
            }(),
            observer: function() {
                return "MutationObserver" in window || "WebkitMutationObserver" in window;
            }(),
            passiveListener: function() {
                var a = !1;
                try {
                    var b = Object.defineProperty({}, "passive", {
                        get: function() {
                            a = !0;
                        }
                    });
                    window.addEventListener("testPassiveListener", null, b);
                } catch (a) {}
                return a;
            }(),
            gestures: function() {
                return "ongesturestart" in window;
            }()
        },
        plugins: {}
    };
    for (var d = [ "jQuery", "Zepto", "Dom7" ], e = 0; e < d.length; e++) window[d[e]] && a(window[d[e]]);
    var f;
    f = "undefined" == typeof Dom7 ? window.Dom7 || window.Zepto || window.jQuery : Dom7, 
    f && ("transitionEnd" in f.fn || (f.fn.transitionEnd = function(a) {
        function b(f) {
            if (f.target === this) for (a.call(this, f), c = 0; c < d.length; c++) e.off(d[c], b);
        }
        var c, d = [ "webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd" ], e = this;
        if (a) for (c = 0; c < d.length; c++) e.on(d[c], b);
        return this;
    }), "transform" in f.fn || (f.fn.transform = function(a) {
        for (var b = 0; b < this.length; b++) {
            var c = this[b].style;
            c.webkitTransform = c.MsTransform = c.msTransform = c.MozTransform = c.OTransform = c.transform = a;
        }
        return this;
    }), "transition" in f.fn || (f.fn.transition = function(a) {
        "string" != typeof a && (a += "ms");
        for (var b = 0; b < this.length; b++) {
            var c = this[b].style;
            c.webkitTransitionDuration = c.MsTransitionDuration = c.msTransitionDuration = c.MozTransitionDuration = c.OTransitionDuration = c.transitionDuration = a;
        }
        return this;
    }), "outerWidth" in f.fn || (f.fn.outerWidth = function(a) {
        return this.length > 0 ? a ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null;
    })), window.Swiper = c;
}(), "undefined" != typeof module ? module.exports = window.Swiper : "function" == typeof define && define.amd && define([], function() {
    "use strict";
    return window.Swiper;
}), function(a, b) {
    var c = b.jQuery;
    "object" == typeof exports ? module.exports = c ? a(b, c) : function(c) {
        if (c && !c.fn) throw "Provide jQuery or null";
        return a(b, c);
    } : "function" == typeof define && define.amd ? define(function() {
        return a(b);
    }) : a(b, !1);
}(function(a, b) {
    "use strict";
    function c(a, b) {
        return function() {
            var c, d = this, e = d.base;
            return d.base = a, c = b.apply(d, arguments), d.base = e, c;
        };
    }
    function d(a, b) {
        return da(b) && (b = c(a ? a._d ? a : c(g, a) : g, b), b._d = 1), b;
    }
    function e(a, b) {
        for (var c in b.props) !Fa.test(c) || a[c] && a[c].fix || (a[c] = d(a.constructor.prototype[c], b.props[c]));
    }
    function f(a) {
        return a;
    }
    function g() {
        return "";
    }
    function h(a) {
        try {
            throw console.log("JsRender dbg breakpoint: " + a), "dbg breakpoint";
        } catch (a) {}
        return this.base ? this.baseApply(arguments) : a;
    }
    function i(a) {
        this.name = (b.link ? "JsViews" : "JsRender") + " Error", this.message = a || this.name;
    }
    function j(a, b) {
        for (var c in b) a[c] = b[c];
        return a;
    }
    function k(a, b, c) {
        return a ? ea(a) ? k.apply(ba, a) : (ka.delimiters = [ a, b, ra = c ? c.charAt(0) : ra ], 
        na = a.charAt(0), oa = a.charAt(1), pa = b.charAt(0), qa = b.charAt(1), a = "\\" + na + "(\\" + ra + ")?\\" + oa, 
        b = "\\" + pa + "\\" + qa, _ = "(?:(\\w+(?=[\\/\\s\\" + pa + "]))|(\\w+)?(:)|(>)|(\\*))\\s*((?:[^\\" + pa + "]|\\" + pa + "(?!\\" + qa + "))*?)", 
        ja.rTag = "(?:" + _ + ")", _ = new RegExp("(?:" + a + _ + "(\\/)?|\\" + na + "(\\" + ra + ")?\\" + oa + "(?:(?:\\/(\\w+))\\s*|!--[\\s\\S]*?--))" + b, "g"), 
        ja.rTmpl = new RegExp("^\\s|\\s$|<.*>|([^\\\\]|^)[{}]|" + a + ".*" + b), ma) : ka.delimiters;
    }
    function l(a, b) {
        b || !0 === a || (b = a, a = void 0);
        var c, d, e, f, g = this, h = !b || "root" === b;
        if (a) {
            if (!(f = b && g.type === b && g)) if (c = g.views, g._.useKey) {
                for (d in c) if (f = b ? c[d].get(a, b) : c[d]) break;
            } else for (d = 0, e = c.length; !f && d < e; d++) f = b ? c[d].get(a, b) : c[d];
        } else if (h) for (;g.parent; ) f = g, g = g.parent; else for (;g && !f; ) f = g.type === b ? g : void 0, 
        g = g.parent;
        return f;
    }
    function m() {
        var a = this.get("item");
        return a ? a.index : void 0;
    }
    function n() {
        return this.index;
    }
    function o(b, c) {
        var d, e, f = this, g = f.ctx;
        if (g && (g = g[b]), void 0 === g && (g = ha[b]), g && g._cp) {
            if (c) return e = g[1] ? ja._ceo(g[1].deps) : [ "_jsvCp" ], e.unshift(g[0]), e._cp = g._cp, 
            e;
            g = ba.getCtx(g);
        }
        return g && da(g) && !g._wrp && (d = function() {
            return g.apply(this && this !== a ? this : f, arguments);
        }, d._wrp = f, j(d, g)), d || g;
    }
    function p(a) {
        return a && (a.fn ? a : this.getRsc("templates", a) || fa(a));
    }
    function q(a, b, c, d) {
        var f, g, h = "number" == typeof c && b.tmpl.bnds[c - 1], i = b.linkCtx;
        return void 0 === d && h && h._lr && (d = ""), void 0 !== d ? c = d = {
            props: {},
            args: [ d ]
        } : h && (c = h(b.data, b, ja)), h = h._bd && h, g = c.args[0], (a || h) && (f = i && i.tag, 
        c.view = b, f || (f = j(new ja._tg(), {
            _: {
                inline: !i,
                bnd: h,
                unlinked: !0
            },
            tagName: ":",
            cvt: a,
            flow: !0,
            tagCtx: c
        }), i && (i.tag = f, f.linkCtx = i), c.ctx = U(c.ctx, (i ? i.view : b).ctx), e(f, c)), 
        f._er = d && g, f.ctx = c.ctx || f.ctx || {}, c.ctx = void 0, g = f.cvtArgs("true" !== a && a)[0]), 
        g = h && b._.onRender ? b._.onRender(g, b, f) : g, void 0 != g ? g : "";
    }
    function r(a, b) {
        var c, d, e, f = this, g = f.tagCtx, h = g.args, i = f.bindTo;
        if (a = a || f.convert, "" + a === a && (a = g.view.getRsc("converters", a) || M("Unknown converter: '" + a + "'")), 
        h.length || !1 === f.argDefault || g.index ? a && !b && (h = h.slice()) : h = [ g.view.data ], 
        i) {
            for (e = [], c = i.length; c--; ) d = i[c], e.unshift(s(g, d));
            b && (h = e);
        }
        if (a) if (i = i || [ 0 ], a = a.apply(f, e || h), c = i.length, c < 2 && (a = [ a ]), 
        b) h = a; else for (;c--; ) +(d = i[c]) === d && (h[d] = a ? a[c] : void 0);
        return h;
    }
    function s(a, b) {
        return (a = a[+b === b ? "args" : "props"]) && a[b];
    }
    function t() {
        return this.cvtArgs(void 0, !0);
    }
    function u(a, b) {
        for (var c, d, e = this; void 0 === c && e; ) d = e.tmpl && e.tmpl[a], c = d && d[b], 
        e = e.parent;
        return c || ba[a][b];
    }
    function v(a, b, c, d) {
        a.ctx[c] = ja._cp(s(a, b), s(a.params, b), a.view, d);
    }
    function w(a, c, d, f, g, h) {
        c = c || aa;
        var i, j, k, l, m, n, o, p, q, r, s, t, u, w, x, y, z, A, B, C, D, E = 0, F = "", G = c.linkCtx || 0, H = c.ctx, I = d || c.tmpl, L = "number" == typeof f && c.tmpl.bnds[f - 1];
        for ("tag" === a._is ? (i = a, a = i.tagName, f = i.tagCtxs, i.template) : (j = c.getRsc("tags", a) || M("Unknown tag: {{" + a + "}} "), 
        j.template), void 0 === h && L && L._lr && (h = ""), void 0 !== h ? (F += h, f = h = [ {
            props: {},
            args: []
        } ]) : L && (f = L(c.data, c, ja)), n = f.length; E < n; E++) q = f[E], (!G || !G.tag || E && !G.tag._.inline || i._er) && ((u = I.tmpls && q.tmpl) && (u = q.content = I.tmpls[u - 1]), 
        q.index = E, q.tmpl = u, q.render = J, q.view = c, q.ctx = U(q.ctx, H)), (d = q.props.tmpl) && (q.tmpl = c.getTmpl(d)), 
        i || (i = new j._ctr(), w = !!i.init, i.parent = m = H && H.tag, i.tagCtxs = f, 
        B = i.dataMap, G && (i._.inline = !1, G.tag = i, i.linkCtx = G), (i._.bnd = L || G.fn) ? i._.arrVws = {} : i.dataBoundOnly && M("{^{" + a + "}} tag must be data-bound")), 
        t = i.bindTo || [ 0 ], f = i.tagCtxs, B = i.dataMap, q.tag = i, B && f && (q.map = f[E].map), 
        i.flow || (r = q.ctx = q.ctx || {}, k = i.parents = r.parentTags = H && U(r.parentTags, H.parentTags) || {}, 
        m && (k[m.tagName] = m), k[i.tagName] = r.tag = i);
        if (!(i._er = h)) {
            for (e(i, f[0]), i.rendering = {}, E = 0; E < n; E++) {
                if (q = i.tagCtx = f[E], A = q.props, i.ctx = q.ctx, E || (w && (i.template, i.init(q, G, i.ctx), 
                w = void 0), G && (G.attr = i.attr = G.attr || i.attr), l = i.attr, i._.noVws = l && l !== Ka), 
                z = i.cvtArgs(), i.linkedCtxParam) for (o = t.length; o--; ) (s = i.linkedCtxParam[o]) && (D = t[o], 
                v(q, D, s, {
                    tag: i,
                    ind: o
                }));
                (x = A.dataMap || B) && (z.length || A.dataMap) && (y = q.map, y && y.src === z[0] && !g || (y && y.src && y.unmap(), 
                y = q.map = x.map(z[0], A, void 0, !i._.bnd)), z = [ y.tgt ]), p = void 0, i.render && (p = i.render.apply(i, z), 
                c.linked && p && i.linkedElem && !Ga.test(p) && (p = K(b.templates(p), z[0], void 0, void 0, c, void 0, void 0, i))), 
                z.length || (z = [ c ]), void 0 === p && (C = z[0], i.contentCtx && (C = !0 === i.contentCtx ? c : i.contentCtx(C)), 
                p = q.render(C, !0) || (g ? void 0 : "")), F = F ? F + (p || "") : p;
            }
            i.rendering = void 0;
        }
        return i.tagCtx = f[0], i.ctx = i.tagCtx.ctx, i._.noVws && i._.inline && (F = "text" === l ? ga.html(F) : ""), 
        L && c._.onRender ? c._.onRender(F, c, i) : F;
    }
    function x(a, b, c, d, e, f, g, h) {
        var i, j, k, l = this, n = "array" === b;
        l.content = h, l.views = n ? [] : {}, l.parent = c, l.type = b || "top", l.data = d, 
        l.tmpl = e, k = l._ = {
            key: 0,
            useKey: n ? 0 : 1,
            id: "" + Ia++,
            onRender: g,
            bnds: {}
        }, l.linked = !!g, c ? (i = c.views, j = c._, j.useKey ? (i[k.key = "_" + j.useKey++] = l, 
        l.index = Oa, l.getIndex = m) : i.length === (k.key = l.index = f) ? i.push(l) : i.splice(f, 0, l), 
        l.ctx = a || c.ctx) : l.ctx = a;
    }
    function y(a) {
        var b, c, d;
        for (b in Sa) c = b + "s", a[c] && (d = a[c], a[c] = {}, ba[c](d, a));
    }
    function z(a, b, c) {
        function e() {
            var b = this;
            b._ = {
                inline: !0,
                unlinked: !0
            }, b.tagName = a;
        }
        function f(a) {
            var c;
            (c = b[a]) && (b[a] = c = ea(c) ? c : [ c ], (m || 1) !== c.length && M(a + " length not same as bindTo "));
        }
        var g, h, i, k, l, m, n = b.bindTo, o = new ja._tg();
        if (da(b) ? b = {
            depends: b.depends,
            render: b
        } : "" + b === b && (b = {
            template: b
        }), void 0 !== n) for (n = b.bindTo = ea(n) ? n : [ n ], k = m = n.length; k--; ) l = n[k], 
        isNaN(parseInt(l)) || (l = parseInt(l)), n[k] = l;
        if (f("linkedElement"), f("linkedCtxParam"), h = b.baseTag) {
            b.flow = !!b.flow, b.baseTag = h = "" + h === h ? c && c.tags[h] || ia[h] : h, o = j(o, h);
            for (i in b) o[i] = d(h[i], b[i]);
        } else o = j(o, b);
        return void 0 !== (g = o.template) && (o.template = "" + g === g ? fa[g] || fa(g) : g), 
        (e.prototype = o).constructor = o._ctr = e, c && (o._parentTmpl = c), o;
    }
    function A(a) {
        return this.base.apply(this, a);
    }
    function B(a, c, d, e) {
        function f(c) {
            var f, h;
            if ("" + c === c || c.nodeType > 0 && (g = c)) {
                if (!g) if (/^\.\/[^\\:*?"<>]*$/.test(c)) (h = fa[a = a || c]) ? c = h : g = document.getElementById(c); else if (b.fn && !ja.rTmpl.test(c)) try {
                    g = b(c, document)[0];
                } catch (a) {}
                g && (e ? c = g.innerHTML : (f = g.getAttribute(Ma), f && (f !== Na ? (c = fa[f], 
                delete fa[f]) : b.fn && (c = b.data(g)[Na])), f && c || (a = a || (b.fn ? Na : c), 
                c = B(a, g.innerHTML, d, e)), c.tmplName = a = a || f, a !== Na && (fa[a] = c), 
                g.setAttribute(Ma, a), b.fn && b.data(g, Na, c))), g = void 0;
            } else c.fn || (c = void 0);
            return c;
        }
        var g, h, i = c = c || "";
        if (0 === e && (e = void 0, i = f(i)), e = e || (c.markup ? c : {}), e.tmplName = a, 
        d && (e._parentTmpl = d), !i && c.markup && (i = f(c.markup)) && i.fn && (i = i.markup), 
        void 0 !== i) return i.fn || c.fn ? i.fn && (h = i) : (c = F(i, e), O(i.replace(za, "\\$&"), c)), 
        h || (h = j(function() {
            return h.render.apply(h, arguments);
        }, c), y(h)), h;
    }
    function C(a, b) {
        return da(a) ? a.call(b) : a;
    }
    function D(a) {
        for (var b = [], c = 0, d = a.length; c < d; c++) b.push(a[c].unmap());
        return b;
    }
    function E(a, c) {
        function d(a) {
            k.apply(this, a);
        }
        function e() {
            return new d(arguments);
        }
        function f(a, b) {
            for (var c, d, e, f, g = 0; g < s; g++) e = m[g], c = void 0, e + "" !== e && (c = e, 
            e = c.getter), void 0 === (f = a[e]) && c && void 0 !== (d = c.defaultVal) && (f = C(d, a)), 
            b(f, c && l[c.type], e);
        }
        function g(b) {
            b = b + "" === b ? JSON.parse(b) : b;
            var c, d, e = 0, g = b, j = [];
            if (ea(b)) {
                for (b = b || [], c = b.length; e < c; e++) j.push(this.map(b[e]));
                return j._is = a, j.unmap = i, j.merge = h, j;
            }
            if (b) {
                f(b, function(a, b) {
                    b && (a = b.map(a)), j.push(a);
                }), g = this.apply(this, j);
                for (d in b) d === ca || u[d] || (g[d] = b[d]);
            }
            return g;
        }
        function h(a) {
            a = a + "" === a ? JSON.parse(a) : a;
            var b, c, d, g, h, i, j, k, l, m = 0, n = this;
            if (ea(n)) {
                for (j = {}, l = [], c = a.length, d = n.length; m < c; m++) {
                    for (k = a[m], i = !1, b = 0; b < d && !i; b++) j[b] || (h = n[b], o && (j[b] = i = o + "" === o ? k[o] && (u[o] ? h[o]() : h[o]) === k[o] : o(h, k)));
                    i ? (h.merge(k), l.push(h)) : l.push(e.map(k));
                }
                return void (t ? t(n).refresh(l, !0) : n.splice.apply(n, [ 0, n.length ].concat(l)));
            }
            f(a, function(a, b, c) {
                b ? n[c]().merge(a) : n[c](a);
            });
            for (g in a) g === ca || u[g] || (n[g] = a[g]);
        }
        function i() {
            var a, b, c, d, e = 0, f = this;
            if (ea(f)) return D(f);
            for (a = {}; e < s; e++) b = m[e], c = void 0, b + "" !== b && (c = b, b = c.getter), 
            d = f[b](), a[b] = c && d && l[c.type] ? ea(d) ? D(d) : d.unmap() : d;
            for (b in f) "_is" === b || u[b] || b === ca || "_" === b.charAt(0) && u[b.slice(1)] || da(f[b]) || (a[b] = f[b]);
            return a;
        }
        var j, k, l = this, m = c.getters, n = c.extend, o = c.id, p = b.extend({
            _is: a || "unnamed",
            unmap: i,
            merge: h
        }, n), q = "", r = "", s = m ? m.length : 0, t = b.observable, u = {};
        for (d.prototype = p, j = 0; j < s; j++) !function(a) {
            a = a.getter || a, u[a] = j + 1;
            var b = "_" + a;
            q += (q ? "," : "") + a, r += "this." + b + " = " + a + ";\n", p[a] = p[a] || function(c) {
                if (!arguments.length) return this[b];
                t ? t(this).setProperty(a, c) : this[b] = c;
            }, t && (p[a].set = p[a].set || function(a) {
                this[b] = a;
            });
        }(m[j]);
        return k = new Function(q, r.slice(0, -1)), k.prototype = p, p.constructor = k, 
        e.map = g, e.getters = m, e.extend = n, e.id = o, e;
    }
    function F(a, c) {
        var d, e = la._wm || {}, f = j({
            tmpls: [],
            links: {},
            bnds: [],
            _is: "template",
            render: J
        }, c);
        return f.markup = a, c.htmlTag || (d = Ca.exec(a), f.htmlTag = d ? d[1].toLowerCase() : ""), 
        d = e[f.htmlTag], d && d !== e.div && (f.markup = b.trim(f.markup)), f;
    }
    function G(a, b) {
        function c(e, f, g) {
            var h, i, j, k = ja.onStore[a];
            if (e && typeof e === La && !e.nodeType && !e.markup && !e.getTgt && !("viewModel" === a && e.getters || e.extend)) {
                for (i in e) c(i, e[i], f);
                return f || ba;
            }
            return void 0 === f && (f = e, e = void 0), e && "" + e !== e && (g = f, f = e, 
            e = void 0), j = g ? "viewModel" === a ? g : g[d] = g[d] || {} : c, h = b.compile, 
            null === f ? e && delete j[e] : (h && (f = h.call(j, e, f, g, 0), f._is = a), e && (j[e] = f)), 
            k && k(e, f, g, h), f;
        }
        var d = a + "s";
        ba[d] = c;
    }
    function H(a) {
        ma[a] = function(b) {
            return arguments.length ? (ka[a] = b, ma) : ka[a];
        };
    }
    function I(a) {
        function b(b, c) {
            this.tgt = a.getTgt(b, c);
        }
        return da(a) && (a = {
            getTgt: a
        }), a.baseMap && (a = j(j({}, a.baseMap), a)), a.map = function(a, c) {
            return new b(a, c);
        }, a;
    }
    function J(a, b, c, d, e, f) {
        var g, h, i, j, k, l, m, n, o = d, p = "";
        if (!0 === b ? (c = b, b = void 0) : typeof b !== La && (b = void 0), (i = this.tag) ? (k = this, 
        o = o || k.view, j = o.getTmpl(i.template || k.tmpl), arguments.length || (a = o)) : j = this, 
        j) {
            if (!d && a && "view" === a._is && (o = a), o && a === o && (a = o.data), l = !o, 
            ta = ta || l, o || ((b = b || {}).root = a), !ta || la.useViews || j.useViews || o && o !== aa) p = K(j, a, b, c, o, e, f, i); else {
                if (o ? (m = o.data, n = o.index, o.index = Oa) : (o = aa, o.data = a, o.ctx = b), 
                ea(a) && !c) for (g = 0, h = a.length; g < h; g++) o.index = g, o.data = a[g], p += j.fn(a[g], o, ja); else o.data = a, 
                p += j.fn(a, o, ja);
                o.data = m, o.index = n;
            }
            l && (ta = void 0);
        }
        return p;
    }
    function K(a, b, c, d, e, f, g, h) {
        function i(a) {
            u = j({}, c), u[t] = a;
        }
        var k, l, m, n, o, p, q, r, s, t, u, v, w = "";
        if (h && (s = h.tagName, v = h.tagCtx, c = c ? U(c, h.ctx) : h.ctx, a === e.content ? q = a !== e.ctx._wrp ? e.ctx._wrp : void 0 : a !== v.content ? a === h.template ? (q = v.tmpl, 
        c._wrp = v.content) : q = v.content || e.content : q = e.content, !1 === v.props.link && (c = c || {}, 
        c.link = !1), (t = v.props.itemVar) && ("~" !== t.charAt(0) && N("Use itemVar='~myItem'"), 
        t = t.slice(1))), e && (g = g || e._.onRender, c = U(c, e.ctx)), !0 === f && (p = !0, 
        f = 0), g && (c && !1 === c.link || h && h._.noVws) && (g = void 0), r = g, !0 === g && (r = void 0, 
        g = e._.onRender), c = a.helpers ? U(a.helpers, c) : c, u = c, ea(b) && !d) for (m = p ? e : void 0 !== f && e || new x(c, "array", e, b, a, f, g, q), 
        e && e._.useKey && (m._.bnd = !h || h._.bnd && h), t && (m.it = t), t = m.it, k = 0, 
        l = b.length; k < l; k++) t && i(b[k]), n = new x(u, "item", m, b[k], a, (f || 0) + k, g, m.content), 
        o = a.fn(b[k], n, ja), w += m._.onRender ? m._.onRender(o, n) : o; else t && i(b), 
        m = p ? e : new x(u, s || "data", e, b, a, f, g, q), h && !h.flow && (m.tag = h, 
        h.view = m), w += a.fn(b, m, ja);
        return r ? r(w, m) : w;
    }
    function L(a, b, c) {
        var d = void 0 !== c ? da(c) ? c.call(b.data, a, b) : c || "" : "{Error: " + (a.message || a) + "}";
        return ka.onError && void 0 !== (c = ka.onError.call(b.data, a, c && d, b)) && (d = c), 
        b && !b.linkCtx ? ga.html(d) : d;
    }
    function M(a) {
        throw new ja.Err(a);
    }
    function N(a) {
        M("Syntax error\n" + a);
    }
    function O(a, b, c, d, e) {
        function f(b) {
            (b -= p) && r.push(a.substr(p, b).replace(xa, "\\n"));
        }
        function g(b, c) {
            b && (b += "}}", N((c ? "{{" + c + "}} block has {{/" + b + " without {{" + b : "Unmatched or missing {{/" + b) + ", in template:\n" + a));
        }
        function h(h, i, j, m, o, t, u, v, w, x, y, z) {
            (u && i || w && !j || v && ":" === v.slice(-1) || x) && N(h), t && (o = ":", m = Ka), 
            w = w || c && !e;
            var A, B = (i || c) && [ [] ], C = "", D = "", E = "", F = "", G = "", H = "", I = "", J = "", K = !w && !o;
            j = j || (v = v || "#data", o), f(z), p = z + h.length, u ? n && r.push([ "*", "\n" + v.replace(/^:/, "ret+= ").replace(ya, "$1") + ";\n" ]) : j ? ("else" === j && (Ba.test(v) && N('for "{{else if expr}}" use "{{else expr}}"'), 
            B = s[8] && [ [] ], s[9] = a.substring(s[9], z), s = q.pop(), r = s[2], K = !0), 
            v && S(v.replace(xa, " "), B, b).replace(Aa, function(a, b, c, d, e, f, g, h) {
                return d = "'" + e + "':", g ? (D += f + ",", F += "'" + h + "',") : c ? (E += d + "j._cp(" + f + ',"' + h + '",view),', 
                H += d + "'" + h + "',") : b ? I += f : ("trigger" === e && (J += f), "lateRender" === e && (A = 1), 
                C += d + f + ",", G += d + "'" + h + "',", l = l || Fa.test(e)), "";
            }).slice(0, -1), B && B[0] && B.pop(), k = [ j, m || !!d || l || "", K && [], Q(F || (":" === j ? "'#data'," : ""), G, H), Q(D || (":" === j ? "data," : ""), C, E), I, J, A, B || 0 ], 
            r.push(k), K && (q.push(s), s = k, s[9] = p)) : y && (g(y !== s[0] && "else" !== s[0] && y, s[0]), 
            s[9] = a.substring(s[9], z), s = q.pop()), g(!s && y), r = s[2];
        }
        var i, j, k, l, m, n = ka.allowCode || b && b.allowCode || !0 === ma.allowCode, o = [], p = 0, q = [], r = o, s = [ , , o ];
        if (n && b._is && (b.allowCode = n), c && (void 0 !== d && (a = a.slice(0, -d.length - 2) + pa), 
        a = na + a + qa), g(q[0] && q[0][2].pop()[0]), a.replace(_, h), f(a.length), (p = o[o.length - 1]) && g("" + p !== p && +p[9] === p[9] && p[0]), 
        c) {
            for (j = T(o, a, c), m = [], i = o.length; i--; ) m.unshift(o[i][8]);
            P(j, m);
        } else j = T(o, b);
        return j;
    }
    function P(a, b) {
        var c, d, e = 0, f = b.length;
        for (a.deps = [], a.paths = []; e < f; e++) {
            a.paths.push(d = b[e]);
            for (c in d) "_jsvto" !== c && d.hasOwnProperty(c) && d[c].length && !d[c].skp && (a.deps = a.deps.concat(d[c]));
        }
    }
    function Q(a, b, c) {
        return [ a.slice(0, -1), b.slice(0, -1), c.slice(0, -1) ];
    }
    function R(a, b) {
        return "\n\t" + (b ? b + ":{" : "") + "args:[" + a[0] + "]" + (a[1] || !b ? ",\n\tprops:{" + a[1] + "}" : "") + (a[2] ? ",\n\tctx:{" + a[2] + "}" : "");
    }
    function S(a, b, c) {
        function d(d, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G, H, I, J) {
            function K(a, c, d, g, h, i, l, m) {
                var n = "." === d;
                if (d && (u = u.slice(c.length), /^\.?constructor$/.test(m || u) && N(a), n || (a = (g ? 'view.hlp("' + g + '")' : h ? "view" : "data") + (m ? (i ? "." + i : g ? "" : h ? "" : "." + d) + (l || "") : (m = g ? "" : h ? i || "" : d, 
                "")), a += m ? "." + m : "", a = c + ("view.data" === a.slice(0, 9) ? a.slice(5) : a)), 
                j)) {
                    if (P = "linkTo" === e ? f = b._jsvto = b._jsvto || [] : k.bd, Q = n && P[P.length - 1]) {
                        if (Q._jsv) {
                            for (;Q.sb; ) Q = Q.sb;
                            Q.bnd && (u = "^" + u.slice(1)), Q.sb = u, Q.bnd = Q.bnd || "^" === u.charAt(0);
                        }
                    } else P.push(u);
                    q[o] = I + (n ? 1 : 0);
                }
                return a;
            }
            t && !x && (u = t + u), v = v || "", s = s || r || B, u = u || y, z = z || G || "";
            var L, M, P, Q, R, S = ")";
            if ("[" === z && (z = "[j._sq(", S = ")]"), !w || i || h) {
                if (j && F && !i && !h && (!e || g || f) && (L = q[o - 1], J.length - 1 > I - (L || 0))) {
                    if (L = J.slice(L, I + d.length), !0 !== M) if (P = f || l[o - 1].bd, (Q = P[P.length - 1]) && Q.prm) {
                        for (;Q.sb && Q.sb.prm; ) Q = Q.sb;
                        R = Q.sb = {
                            path: Q.sb,
                            bnd: Q.bnd
                        };
                    } else P.push(R = {
                        path: P.pop()
                    });
                    F = oa + ":" + L + " onerror=''" + pa, M = n[F], M || (n[F] = !0, n[F] = M = O(F, c, !0)), 
                    !0 !== M && R && (R._jsv = M, R.prm = k.bd, R.bnd = R.bnd || R.path && R.path.indexOf("^") >= 0);
                }
                return i ? (i = !C, i ? d : B + '"') : h ? (h = !D, h ? d : B + '"') : (s ? (q[o] = I++, 
                k = l[++o] = {
                    bd: []
                }, s) : "") + (H ? o ? "" : (m = J.slice(m, I), (e ? (e = g = f = !1, "\b") : "\b,") + m + (m = I + d.length, 
                j && b.push(k.bd = []), "\b")) : x ? (o && N(a), j && b.pop(), e = u, g = t, m = I + d.length, 
                j && (j = k.bd = b[e] = [], j.skp = !t), u + ":") : u ? u.split("^").join(".").replace(va, K) + (z ? (k = l[++o] = {
                    bd: []
                }, p[o] = S, z) : v) : v || (E ? (E = p[o] || E, p[o] = !1, k = l[--o], E + (z ? (k = l[++o], 
                p[o] = S, z) : "")) : A ? (p[o] || N(a), ",") : r ? "" : (i = C, h = D, '"')));
            }
            N(a);
        }
        var e, f, g, h, i, j = b && b[0], k = {
            bd: j
        }, l = {
            0: k
        }, m = 0, n = (c ? c.links : j && (j.links = j.links || {})) || aa.tmpl.links, o = 0, p = {}, q = {}, r = (a + (c ? " " : "")).replace(wa, d);
        return !o && r || N(a);
    }
    function T(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, G, H, I = 0, J = la.useViews || b.useViews || b.tags || b.templates || b.helpers || b.converters, K = "", L = {}, M = a.length;
        for ("" + b === b ? (t = c ? 'data-link="' + b.replace(xa, " ").slice(1, -1) + '"' : b, 
        b = 0) : (t = b.tmplName || "unnamed", b.allowCode && (L.allowCode = !0), b.debug && (L.debug = !0), 
        m = b.bnds, s = b.tmpls), d = 0; d < M; d++) if ("" + (e = a[d]) === e) K += '\n+"' + e + '"'; else if ("*" === (f = e[0])) K += ";\n" + e[1] + "\nret=ret"; else {
            if (g = e[1], w = !c && e[2], h = R(e[3], "params") + "}," + R(o = e[4]), D = e[5], 
            G = e[6], H = e[7], x = e[9] && e[9].replace(ya, "$1"), (A = "else" === f) ? n && n.push(e[8]) : m && (n = e[8]) && (n = [ n ], 
            I = m.push(1)), J = J || o[1] || o[2] || n || /view.(?!index)/.test(o[0]), (B = ":" === f) ? g && (f = g === Ka ? ">" : g + f) : (w && (u = F(x, L), 
            u.tmplName = t + "/" + f, u.useViews = u.useViews || J, T(w, u), J = u.useViews, 
            s.push(u)), A || (v = f, J = J || f && (!ia[f] || !ia[f].flow), z = K, K = ""), 
            y = a[d + 1], y = y && "else" === y[0]), E = D ? ";\ntry{\nret+=" : "\n+", p = "", 
            q = "", B && (n || G || g && g !== Ka || H)) {
                if (C = new Function("data,view,j,u", "// " + t + " " + ++I + " " + f + "\nreturn {" + h + "};"), 
                C._er = D, C._tag = f, C._bd = !!n, C._lr = H, c) return C;
                P(C, n), r = 'c("' + g + '",view,', l = !0, p = r + I + ",", q = ")";
            }
            if (K += B ? (c ? (D ? "try{\n" : "") + "return " : E) + (l ? (l = void 0, J = k = !0, 
            r + (C ? (m[I - 1] = C, I) : "{" + h + "}") + ")") : ">" === f ? (j = !0, "h(" + o[0] + ")") : (!0, 
            "((v=" + o[0] + ")!=null?v:" + (c ? "null)" : '"")'))) : (i = !0, "\n{view:view,tmpl:" + (w ? s.length : "0") + "," + h + "},"), 
            v && !y) {
                if (K = "[" + K.slice(0, -1) + "]", r = 't("' + v + '",view,this,', c || n) {
                    if (K = new Function("data,view,j,u", " // " + t + " " + I + " " + v + "\nreturn " + K + ";"), 
                    K._er = D, K._tag = v, n && P(m[I - 1] = K, n), K._lr = H, c) return K;
                    p = r + I + ",undefined,", q = ")";
                }
                K = z + E + r + (K.deps && I || K) + ")", n = 0, v = 0;
            }
            D && (J = !0, K += ";\n}catch(e){ret" + (c ? "urn " : "+=") + p + "j._err(e,view," + D + ")" + q + ";}" + (c ? "" : "ret=ret"));
        }
        K = "// " + t + "\nvar v" + (i ? ",t=j._tag" : "") + (k ? ",c=j._cnvt" : "") + (j ? ",h=j._html" : "") + (c ? ";\n" : ',ret=""\n') + (L.debug ? "debugger;" : "") + K + (c ? "\n" : ";\nreturn ret;"), 
        !1 !== ka.debugMode && (K = "try {\n" + K + "\n}catch(e){\nreturn j._err(e, view);\n}");
        try {
            K = new Function("data,view,j,u", K);
        } catch (a) {
            N("Compiled template code:\n\n" + K + '\n: "' + (a.message || a) + '"');
        }
        return b && (b.fn = K, b.useViews = !!J), K;
    }
    function U(a, b) {
        return a && a !== b ? b ? j(j({}, b), a) : a : b && j({}, b);
    }
    function V(a) {
        return Ja[a] || (Ja[a] = "&#" + a.charCodeAt(0) + ";");
    }
    function W(a) {
        var b, c, d = [];
        if (typeof a === La) for (b in a) c = a[b], b !== ca && a.hasOwnProperty(b) && !da(c) && d.push({
            key: b,
            prop: c
        });
        return d;
    }
    function X(a, c, d) {
        var e = this.jquery && (this[0] || M("Unknown template")), f = e.getAttribute(Ma);
        return J.call(f && b.data(e)[Na] || fa(e), a, c, d);
    }
    function Y(a) {
        return void 0 != a ? Ea.test(a) && ("" + a).replace(Ha, V) || a : "";
    }
    var Z = !1 === b;
    b = b && b.fn ? b : a.jQuery;
    var $, _, aa, ba, ca, da, ea, fa, ga, ha, ia, ja, ka, la, ma, na, oa, pa, qa, ra, sa, ta, ua = "v0.9.85", va = /^(!*?)(?:null|true|false|\d[\d.]*|([\w$]+|\.|~([\w$]+)|#(view|([\w$]+))?)([\w$.^]*?)(?:[.[^]([\w$]+)\]?)?)$/g, wa = /(\()(?=\s*\()|(?:([([])\s*)?(?:(\^?)(!*?[#~]?[\w$.^]+)?\s*((\+\+|--)|\+|-|&&|\|\||===|!==|==|!=|<=|>=|[<>%*:?\/]|(=))\s*|(!*?[#~]?[\w$.^]+)([([])?)|(,\s*)|(\(?)\\?(?:(')|("))|(?:\s*(([)\]])(?=\s*[.^]|\s*$|[^([])|[)\]])([([]?))|(\s+)/g, xa = /[ \t]*(\r\n|\n|\r)/g, ya = /\\(['"])/g, za = /['"\\]/g, Aa = /(?:\x08|^)(onerror:)?(?:(~?)(([\w$_\.]+):)?([^\x08]+))\x08(,)?([^\x08]+)/gi, Ba = /^if\s/, Ca = /<(\w+)[>\s]/, Da = /[\x00`><"'&=]/g, Ea = /[\x00`><\"'&=]/, Fa = /^on[A-Z]|^convert(Back)?$/, Ga = /^\#\d+_`[\s\S]*\/\d+_`$/, Ha = Da, Ia = 0, Ja = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\0": "&#0;",
        "'": "&#39;",
        '"': "&#34;",
        "`": "&#96;",
        "=": "&#61;"
    }, Ka = "html", La = "object", Ma = "data-jsv-tmpl", Na = "jsvTmpl", Oa = "For #index in nested block use #getIndex().", Pa = {}, Qa = a.jsrender, Ra = Qa && b && !b.render, Sa = {
        template: {
            compile: B
        },
        tag: {
            compile: z
        },
        viewModel: {
            compile: E
        },
        helper: {},
        converter: {}
    };
    if (ba = {
        jsviews: ua,
        sub: {
            View: x,
            Err: i,
            tmplFn: O,
            parse: S,
            extend: j,
            extendCtx: U,
            syntaxErr: N,
            onStore: {
                template: function(a, b) {
                    null === b ? delete Pa[a] : Pa[a] = b;
                }
            },
            addSetting: H,
            settings: {
                allowCode: !1
            },
            advSet: g,
            _ths: e,
            _gm: d,
            _tg: function() {},
            _cnvt: q,
            _tag: w,
            _er: M,
            _err: L,
            _html: Y,
            _cp: f,
            _sq: function(a) {
                return "constructor" === a && N(""), a;
            }
        },
        settings: {
            delimiters: k,
            advanced: function(a) {
                return a ? (j(la, a), ja.advSet(), ma) : la;
            }
        },
        getCtx: f,
        map: I
    }, (i.prototype = new Error()).constructor = i, m.depends = function() {
        return [ this.get("item"), "index" ];
    }, n.depends = "index", x.prototype = {
        get: l,
        getIndex: n,
        getRsc: u,
        getTmpl: p,
        hlp: o,
        _is: "view"
    }, ja = ba.sub, ma = ba.settings, !(Qa || b && b.render)) {
        for ($ in Sa) G($, Sa[$]);
        ga = ba.converters, ha = ba.helpers, ia = ba.tags, ja._tg.prototype = {
            baseApply: A,
            cvtArgs: r,
            bndArgs: t
        }, aa = ja.topView = new x(), b ? (b.fn.render = X, ca = b.expando, b.observable && (j(ja, b.views.sub), 
        ba.map = b.views.map)) : (b = {}, Z && (a.jsrender = b), b.renderFile = b.__express = b.compile = function() {
            throw "Node.js: use npm jsrender, or jsrender-node.js";
        }, b.isFunction = function(a) {
            return "function" == typeof a;
        }, b.isArray = Array.isArray || function(a) {
            return "[object Array]" === {}.toString.call(a);
        }, ja._jq = function(a) {
            a !== b && (j(a, b), b = a, b.fn.render = X, delete b.jsrender, ca = b.expando);
        }, b.jsrender = ua), ka = ja.settings, ka.allowCode = !1, da = b.isFunction, b.render = Pa, 
        b.views = ba, b.templates = fa = ba.templates;
        for (sa in ka) H(sa);
        (ma.debugMode = function(a) {
            return void 0 === a ? ka.debugMode : (ka.debugMode = a, ka.onError = a + "" === a ? new Function("", "return '" + a + "';") : da(a) ? a : void 0, 
            ma);
        })(!1), la = ka.advanced = {
            useViews: !1,
            _jsv: !1
        }, ia({
            if: {
                render: function(a) {
                    var b = this, c = b.tagCtx;
                    return b.rendering.done || !a && (arguments.length || !c.index) ? "" : (b.rendering.done = !0, 
                    b.selected = c.index, c.render(c.view, !0));
                },
                flow: !0
            },
            for: {
                render: function(a) {
                    var b, c = !arguments.length, d = this, e = d.tagCtx, f = "", g = 0;
                    return d.rendering.done || (b = c ? e.view.data : a, void 0 !== b && (f += e.render(b, c), 
                    g += ea(b) ? b.length : 1), (d.rendering.done = g) && (d.selected = e.index)), f;
                },
                flow: !0
            },
            props: {
                baseTag: "for",
                dataMap: I(W),
                flow: !0
            },
            include: {
                flow: !0
            },
            "*": {
                render: f,
                flow: !0
            },
            ":*": {
                render: f,
                flow: !0
            },
            dbg: ha.dbg = ga.dbg = h
        }), ga({
            html: Y,
            attr: Y,
            url: function(a) {
                return void 0 != a ? encodeURI("" + a) : null === a ? a : "";
            }
        });
    }
    return ka = ja.settings, ea = (b || Qa).isArray, ma.delimiters("{{", "}}", "^"), 
    Ra && Qa.views.sub._jq(b), b || Qa;
}, window), function(a) {
    a.fn.haversine = function(a, b, c, d, e) {
        e = e || "km", void 0 === Number.prototype.toRad && (Number.prototype.toRad = function() {
            return this * Math.PI / 180;
        });
        var f = "";
        f = "km" == e ? 6371 : 3959;
        var g = (parseFloat(c) - parseFloat(a)).toRad(), h = (parseFloat(d) - parseFloat(b)).toRad(), a = parseFloat(a).toRad(), c = parseFloat(c).toRad(), i = Math.sin(g / 2) * Math.sin(g / 2) + Math.sin(h / 2) * Math.sin(h / 2) * Math.cos(a) * Math.cos(c);
        return f * (2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)));
    };
}(jQuery), function() {
    var a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    f = {
        dev: !1,
        mailChimpUrl: "//brooklynsmallbatch.us2.list-manage.com/subscribe/post-json?u=a85d253124c4b29235954420a&amp;id=7f07860092",
        addBodyClassOnScroll: !0,
        mobile: !1,
        ajaxInfiniteScroll: !1,
        noticeActive: !1
    }, $(document).ready(function() {
        if ($(".notice-active").length) return f.noticeActive = !0;
    }), j = function() {
        var a, b;
        return b = "/pages/size-guide #sg-table", a = $("#sg-ajax-target"), a.load(b);
    }, k = function() {
        var a;
        return a = $(this), a.hasClass("open") ? (a.removeClass("open"), a.next().removeAttr("style")) : ($(".product-description table tr").removeClass("open").removeAttr("style"), 
        a.addClass("open"), a.next().show());
    }, m = function(a) {
        var b, c, d;
        return d = $(a.target).data("scrollto-year"), b = $(".history-col[data-year=" + d + "]"), 
        c = f.noticeActive ? parseInt(b.offset().top - 106) : parseInt(b.offset().top - 66), 
        $("html, body").animate({
            scrollTop: c
        }, 1e3);
    }, $("body").on("click", ".win-wardrobe__close, body:not(.win-wardrobe__wrapper)", function(a) {
        return s($(".win-wardrobe__wrapper"), "open"), n("subscribe", "dismissed", 1);
    }), $("body").on("click", ".toggle-search", function(a) {
        return a.preventDefault(), s($(".search-modal"), "open");
    }), $(".product-description table tr").on("click", k), $("body").on("click", ".toggle-size-guide, .size-guide-wrapper > .close", function(a) {
        return a.preventDefault(), s($(".size-guide-wrapper"), "open"), j();
    }), $("body").on("click", ".main-nav--hamburger", function(a) {
        return a.preventDefault(), s($("body"), "nav-open");
    }), $("body").on("click", '.main-nav--top-level a[data-id="shop"]', function(a) {
        return a.preventDefault(), s($(".main-nav"), "open");
    }), $("body").on("click", "#mobile-back-btn, #shop", function(a) {
        return a.preventDefault(), s($(".main-nav--links-wrap"), "main-nav--slide-in");
    }), $("body").on("click", ".article-share--toggle", function(a) {
        return a.preventDefault(), s($(".article-share-wrapper"), "open");
    }), $("body").on("click", ".nav-year", m), $("body").on("click", ".scroll-to-top", function() {
        return $("html, body").animate({
            scrollTop: 0
        }, 1e3);
    }), $(document).on("click", "#enter_to_win_submit", function(a) {
        var b, c, d, e, g, h;
        return a.preventDefault(), e = $("#enter_to_win_email").val(), "" === e ? (alert("Email required"), 
        !1) : (f.dev && console.log("about to submit to Mailchimp"), c = $("#enter_to_win_form"), 
        d = "//hardwick.us15.list-manage.com/subscribe/post-json?u=f0ed80b790cd4c2700acce371&amp;id=3ab69d6254", 
        g = $("#win-wardrobe__response"), h = "Thank you for entering", b = !0, l(c, d, g, h, b));
    }), $(document).on("click", "#new_email_lead input[type=submit]", function(a) {
        var b, c, d, e, g, h;
        return a.preventDefault(), e = $("#new_email_lead > #email").val(), "" === e ? (alert("Email required"), 
        !1) : (f.dev && console.log("about to submit to Mailchimp"), c = $("#new_email_lead"), 
        d = "//hardwick.us15.list-manage.com/subscribe/post-json?u=f0ed80b790cd4c2700acce371&amp;id=3ab69d6254", 
        g = $("#new_email_lead > .success-text"), h = "Thank you for subscribing", b = !1, 
        l(c, d, g, h, b));
    }), l = function(a, b, c, d, e) {
        return $.ajax({
            type: a.attr("method"),
            url: b,
            data: a.serialize(),
            cache: !1,
            dataType: "jsonp",
            jsonp: "c",
            error: function(a) {
                return alert("Could not connect to the server. Please try again later.");
            },
            success: function(a) {
                var b;
                return console.log(a), "error" === a.result ? (b = a.msg, b.indexOf("already") >= 0 ? (b = "This email is already subscribed", 
                c.show().text(b)) : (b = "Something went wrong. Please try again later.", c.show().text(b))) : (c.show().text(d), 
                !0 === e ? setTimeout(function() {
                    return $(".win-wardrobe__close").trigger("click");
                }, 2200) : void 0);
            }
        });
    }, i = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return i.Android() || i.BlackBerry() || i.iOS() || i.Opera() || i.Windows();
        }
    }, $(window).on("resize", function() {
        return o($(".homepage--carousel"));
    }), a = function(a) {
        var b, c;
        if (f.addBodyClassOnScroll) return c = $(window), b = a, c.scrollTop() > b ? $("body").addClass("scrolled") : $("body").removeClass("scrolled");
    }, e = function() {
        var a, b, c;
        return b = $(".search-bar-wrapper__bar, .search-results-row "), c = $(window), a = 106, 
        c.scrollTop() > a ? b.addClass("fixed") : b.removeClass("fixed");
    }, $(window).on("scroll", function() {
        if (e(), !($(this).width() <= 768)) return a(2 * $(".main-header").outerHeight());
    }), n = function(a, b, c) {
        if (!Cookies.get(a)) return Cookies.set(a, b, {
            expires: c
        });
    }, Cookies.get("subscribe") ? f.dev && console.log("the cookie exists") : $(".win-wardrobe__wrapper").addClass("open"), 
    s = function(a, b) {
        return a.toggleClass(b);
    }, t = $(".zoom-wrapper"), h = $(".zoom-wrapper > .inner"), r = "#ProductPhotoImg", 
    d = function(a) {
        var b, c;
        return $("body").addClass("zoom-open"), a.attr("src"), c = a.data("zoom"), b = $('<img src="' + c + '" class="img-100 img-fluid">'), 
        t.addClass("open"), h.append(b), h.imagesLoaded(function() {
            return b.addClass("loaded");
        });
    }, $(document).on("keyup", function(a) {
        if (27 === a.keyCode) return b();
    }), $(document).on("click", ".zoom-wrapper img, .zoom-wrapper > .close", function(a) {
        return b();
    }), b = function() {
        if ($("body").removeAttr("style").removeClass("zoom-open"), t.hasClass("open")) return t.removeClass("open"), 
        h.empty();
    }, $(document).on("click", r, function(a) {
        return a.preventDefault(), d($(this));
    }), f.dev && console.log("Cart JS has been called lib/js/cart.coffee"), f.ajaxInfiniteScroll && (g = jQuery.ias({
        container: ".collection-items",
        item: ".plp-item",
        pagination: ".pagination",
        next: ".next"
    }), g.extension(new IASPagingExtension()), g.extension(new IASHistoryExtension({
        prev: ".previous"
    })), f.dev && console.log("next page loaded 2")), o = function(a) {
        var b, c;
        return c = $(window).width(), b = c / 2.3, a.height(b);
    }, c = function() {
        var a;
        if (a = $(".homepage--carousel"), o(a), a.length) return a.royalSlider({
            imageScaleMode: "fill",
            controlNavigation: "bullets",
            keyboardNavEnabled: !0,
            imageScalePadding: 0,
            slidesSpacing: 0,
            loopRewind: !0,
            autoPlay: {
                enabled: !0,
                delay: 5e3,
                pauseOnHover: !1
            }
        });
    }, c(), $(document).on("click", ".artists-gallery-thumb", function() {
        var a, b;
        return b = $(this).data("index"), a = $(".pdp-main-image").find(".pdp-main-image--img#" + b), 
        console.log(a), $(".pdp-main-image--img").removeClass("active"), a.addClass("active"), 
        $("body, html").animate({
            scrollTop: 0
        }, 300);
    }), p = function() {
        var a;
        if (a = $(".swiper-container"), a.length) return a.imagesLoaded(function() {
            return q(a), a.addClass("loaded"), new Swiper(".swiper-container", {
                slidesPerView: 4,
                paginationClickable: !0,
                loop: !1,
                spaceBetween: 55,
                centeredSlides: !1,
                nextButton: ".swiper-button-next",
                prevButton: ".swiper-button-prev",
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    }
                }
            });
        });
    }, q = function(a) {
        return a.imagesLoaded(function() {
            var a;
            return a = $(".swiper-container img:first").height(), $(".swiper-container").height(a);
        });
    }, $(window).on("resize", function() {
        return q($(".swiper-container"));
    }), p(), $(".product-description table td:first").trigger("click"), $(document).on("click", ".plp-filter--list li", function(a) {
        var b, c, d;
        return a.preventDefault(), c = $(location).prop("pathname").split("/")[1], d = $(location).prop("pathname").split("/")[2], 
        $(location).prop("pathname").split("/")[3], $(this).hasClass("active") ? window.location = "/" + c + "/" + d : ($(".plp-filter--list li").removeClass("active"), 
        $(this).addClass("active"), b = $(this).data("value"), history.pushState("", "", b), 
        $(".collection-container").load(b + " .collections-grid", function(a) {}));
    });
}.call(this);